(() => {

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kdaJp", function(module, exports) {
function _asyncIterator(t) {
    var e, r1, i, s = 2;
    for("undefined" != typeof Symbol && (r1 = Symbol.asyncIterator, i = Symbol.iterator); s--;){
        if (r1 && null != (e = t[r1])) return e.call(t);
        if (i && null != (e = t[i])) return new AsyncFromSyncIterator(e.call(t));
        r1 = "@@asyncIterator", i = "@@iterator";
    }
    throw new TypeError("Object is not async iterable");
}
function AsyncFromSyncIterator(t) {
    function e(t) {
        if (Object(t) !== t) return Promise.reject(new TypeError(t + " is not an object."));
        var e = t.done;
        return Promise.resolve(t.value).then(function(t) {
            return {
                value: t,
                done: e
            };
        });
    }
    return AsyncFromSyncIterator = function(t) {
        this.s = t, this.n = t.next;
    }, AsyncFromSyncIterator.prototype = {
        s: null,
        n: null,
        next: function() {
            return e(this.n.apply(this.s, arguments));
        },
        return: function(t) {
            var r1 = this.s.return;
            return void 0 === r1 ? Promise.resolve({
                value: t,
                done: !0
            }) : e(r1.apply(this.s, arguments));
        },
        throw: function(t) {
            var r1 = this.s.return;
            return void 0 === r1 ? Promise.reject(t) : e(r1.apply(this.s, arguments));
        }
    }, new AsyncFromSyncIterator(t);
}
var REACT_ELEMENT_TYPE;
function _jsx(t, e, r1, i) {
    REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);
    var s = t && t.defaultProps, a = arguments.length - 3;
    if (e || 0 === a || (e = {
        children: void 0
    }), 1 === a) e.children = i;
    else if (a > 1) {
        for(var n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o + 3];
        e.children = n;
    }
    if (e && s) for(var h in s)void 0 === e[h] && (e[h] = s[h]);
    else e || (e = s || {});
    return {
        $$typeof: REACT_ELEMENT_TYPE,
        type: t,
        key: void 0 === r1 ? null : "" + r1,
        ref: null,
        props: e,
        _owner: null
    };
}
function ownKeys(t, e) {
    var r1 = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(t);
        e && (i = i.filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), r1.push.apply(r1, i);
    }
    return r1;
}
function _objectSpread2(t) {
    for(var e = 1; e < arguments.length; e++){
        var r1 = null != arguments[e] ? arguments[e] : {};
        e % 2 ? ownKeys(Object(r1), !0).forEach(function(e) {
            _defineProperty(t, e, r1[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r1)) : ownKeys(Object(r1)).forEach(function(e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(r1, e));
        });
    }
    return t;
}
function _typeof(t) {
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
        return typeof t;
    } : function(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, _typeof(t);
}
function _wrapRegExp() {
    _wrapRegExp = function(t, e) {
        return new r1(t, void 0, e);
    };
    var t = RegExp.prototype, e = new WeakMap;
    function r1(t, i, s) {
        var a = new RegExp(t, i);
        return e.set(a, s || e.get(t)), _setPrototypeOf(a, r1.prototype);
    }
    function i(t, r1) {
        var i = e.get(r1);
        return Object.keys(i).reduce(function(e, r1) {
            return e[r1] = t[i[r1]], e;
        }, Object.create(null));
    }
    return _inherits(r1, RegExp), r1.prototype.exec = function(e) {
        var r1 = t.exec.call(this, e);
        return r1 && (r1.groups = i(r1, this)), r1;
    }, r1.prototype[Symbol.replace] = function(r1, s) {
        if ("string" == typeof s) {
            var a = e.get(this);
            return t[Symbol.replace].call(this, r1, s.replace(/\$<([^>]+)>/g, function(t, e) {
                return "$" + a[e];
            }));
        }
        if ("function" == typeof s) {
            var n = this;
            return t[Symbol.replace].call(this, r1, function() {
                var t = arguments;
                return "object" != typeof t[t.length - 1] && (t = [].slice.call(t)).push(i(t, n)), s.apply(this, t);
            });
        }
        return t[Symbol.replace].call(this, r1, s);
    }, _wrapRegExp.apply(this, arguments);
}
function _AwaitValue(t) {
    this.wrapped = t;
}
function _AsyncGenerator(t) {
    var e, r1;
    function i(e, r1) {
        try {
            var a = t[e](r1), n = a.value, o = n instanceof _AwaitValue;
            Promise.resolve(o ? n.wrapped : n).then(function(t) {
                o ? i("return" === e ? "return" : "next", t) : s(a.done ? "return" : "normal", t);
            }, function(t) {
                i("throw", t);
            });
        } catch (t) {
            s("throw", t);
        }
    }
    function s(t, s) {
        switch(t){
            case "return":
                e.resolve({
                    value: s,
                    done: !0
                });
                break;
            case "throw":
                e.reject(s);
                break;
            default:
                e.resolve({
                    value: s,
                    done: !1
                });
        }
        (e = e.next) ? i(e.key, e.arg) : r1 = null;
    }
    this._invoke = function(t, s) {
        return new Promise(function(a, n) {
            var o = {
                key: t,
                arg: s,
                resolve: a,
                reject: n,
                next: null
            };
            r1 ? r1 = r1.next = o : (e = r1 = o, i(t, s));
        });
    }, "function" != typeof t.return && (this.return = void 0);
}
function _wrapAsyncGenerator(t) {
    return function() {
        return new _AsyncGenerator(t.apply(this, arguments));
    };
}
function _awaitAsyncGenerator(t) {
    return new _AwaitValue(t);
}
function _asyncGeneratorDelegate(t, e) {
    var r1 = {}, i = !1;
    function s(r1, s) {
        return i = !0, s = new Promise(function(e) {
            e(t[r1](s));
        }), {
            done: !1,
            value: e(s)
        };
    }
    return r1["undefined" != typeof Symbol && Symbol.iterator || "@@iterator"] = function() {
        return this;
    }, r1.next = function(t) {
        return i ? (i = !1, t) : s("next", t);
    }, "function" == typeof t.throw && (r1.throw = function(t) {
        if (i) throw i = !1, t;
        return s("throw", t);
    }), "function" == typeof t.return && (r1.return = function(t) {
        return i ? (i = !1, t) : s("return", t);
    }), r1;
}
function asyncGeneratorStep(t, e, r1, i, s, a, n) {
    try {
        var o = t[a](n), h = o.value;
    } catch (t) {
        return void r1(t);
    }
    o.done ? e(h) : Promise.resolve(h).then(i, s);
}
function _asyncToGenerator(t) {
    return function() {
        var e = this, r1 = arguments;
        return new Promise(function(i, s) {
            var a = t.apply(e, r1);
            function n(t) {
                asyncGeneratorStep(a, i, s, n, o, "next", t);
            }
            function o(t) {
                asyncGeneratorStep(a, i, s, n, o, "throw", t);
            }
            n(void 0);
        });
    };
}
function _classCallCheck(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(t, e) {
    for(var r1 = 0; r1 < e.length; r1++){
        var i = e[r1];
        i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
    }
}
function _createClass(t, e, r1) {
    return e && _defineProperties(t.prototype, e), r1 && _defineProperties(t, r1), Object.defineProperty(t, "prototype", {
        writable: !1
    }), t;
}
function _defineEnumerableProperties(t, e) {
    for(var r1 in e)(a = e[r1]).configurable = a.enumerable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, r1, a);
    if (Object.getOwnPropertySymbols) for(var i = Object.getOwnPropertySymbols(e), s = 0; s < i.length; s++){
        var a, n = i[s];
        (a = e[n]).configurable = a.enumerable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, n, a);
    }
    return t;
}
function _defaults(t, e) {
    for(var r1 = Object.getOwnPropertyNames(e), i = 0; i < r1.length; i++){
        var s = r1[i], a = Object.getOwnPropertyDescriptor(e, s);
        a && a.configurable && void 0 === t[s] && Object.defineProperty(t, s, a);
    }
    return t;
}
function _defineProperty(t, e, r1) {
    return e in t ? Object.defineProperty(t, e, {
        value: r1,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : t[e] = r1, t;
}
function _extends() {
    return _extends = Object.assign || function(t) {
        for(var e = 1; e < arguments.length; e++){
            var r1 = arguments[e];
            for(var i in r1)Object.prototype.hasOwnProperty.call(r1, i) && (t[i] = r1[i]);
        }
        return t;
    }, _extends.apply(this, arguments);
}
function _objectSpread(t) {
    for(var e = 1; e < arguments.length; e++){
        var r1 = null != arguments[e] ? Object(arguments[e]) : {}, i = Object.keys(r1);
        "function" == typeof Object.getOwnPropertySymbols && i.push.apply(i, Object.getOwnPropertySymbols(r1).filter(function(t) {
            return Object.getOwnPropertyDescriptor(r1, t).enumerable;
        })), i.forEach(function(e) {
            _defineProperty(t, e, r1[e]);
        });
    }
    return t;
}
function _inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && _setPrototypeOf(t, e);
}
function _inheritsLoose(t, e) {
    t.prototype = Object.create(e.prototype), t.prototype.constructor = t, _setPrototypeOf(t, e);
}
function _getPrototypeOf(t) {
    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, _getPrototypeOf(t);
}
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf || function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}
function _isNativeReflectConstruct() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
    } catch (t) {
        return !1;
    }
}
function _construct(t, e, r1) {
    return _construct = _isNativeReflectConstruct() ? Reflect.construct : function(t, e, r1) {
        var i = [
            null
        ];
        i.push.apply(i, e);
        var s = new (Function.bind.apply(t, i));
        return r1 && _setPrototypeOf(s, r1.prototype), s;
    }, _construct.apply(null, arguments);
}
function _isNativeFunction(t) {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
}
function _wrapNativeSuper(t) {
    var e = "function" == typeof Map ? new Map : void 0;
    return _wrapNativeSuper = function(t) {
        if (null === t || !_isNativeFunction(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== e) {
            if (e.has(t)) return e.get(t);
            e.set(t, r1);
        }
        function r1() {
            return _construct(t, arguments, _getPrototypeOf(this).constructor);
        }
        return r1.prototype = Object.create(t.prototype, {
            constructor: {
                value: r1,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), _setPrototypeOf(r1, t);
    }, _wrapNativeSuper(t);
}
function _instanceof(t, e) {
    return null != e && "undefined" != typeof Symbol && e[Symbol.hasInstance] ? !!e[Symbol.hasInstance](t) : t instanceof e;
}
function _interopRequireDefault(t) {
    return t && t.__esModule ? t : {
        default: t
    };
}
function _getRequireWildcardCache(t) {
    if ("function" != typeof WeakMap) return null;
    var e = new WeakMap, r1 = new WeakMap;
    return (_getRequireWildcardCache = function(t) {
        return t ? r1 : e;
    })(t);
}
function _interopRequireWildcard(t, e) {
    if (!e && t && t.__esModule) return t;
    if (null === t || "object" != typeof t && "function" != typeof t) return {
        default: t
    };
    var r1 = _getRequireWildcardCache(e);
    if (r1 && r1.has(t)) return r1.get(t);
    var i = {}, s = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var a in t)if ("default" !== a && Object.prototype.hasOwnProperty.call(t, a)) {
        var n = s ? Object.getOwnPropertyDescriptor(t, a) : null;
        n && (n.get || n.set) ? Object.defineProperty(i, a, n) : i[a] = t[a];
    }
    return i.default = t, r1 && r1.set(t, i), i;
}
function _newArrowCheck(t, e) {
    if (t !== e) throw new TypeError("Cannot instantiate an arrow function");
}
function _objectDestructuringEmpty(t) {
    if (null == t) throw new TypeError("Cannot destructure undefined");
}
function _objectWithoutPropertiesLoose(t, e) {
    if (null == t) return {};
    var r1, i, s = {}, a = Object.keys(t);
    for(i = 0; i < a.length; i++)r1 = a[i], e.indexOf(r1) >= 0 || (s[r1] = t[r1]);
    return s;
}
function _objectWithoutProperties(t, e) {
    if (null == t) return {};
    var r1, i, s = _objectWithoutPropertiesLoose(t, e);
    if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(t);
        for(i = 0; i < a.length; i++)r1 = a[i], e.indexOf(r1) >= 0 || Object.prototype.propertyIsEnumerable.call(t, r1) && (s[r1] = t[r1]);
    }
    return s;
}
function _assertThisInitialized(t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
}
function _possibleConstructorReturn(t, e) {
    if (e && ("object" == typeof e || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(t);
}
function _createSuper(t) {
    var e = _isNativeReflectConstruct();
    return function() {
        var r1, i = _getPrototypeOf(t);
        if (e) {
            var s = _getPrototypeOf(this).constructor;
            r1 = Reflect.construct(i, arguments, s);
        } else r1 = i.apply(this, arguments);
        return _possibleConstructorReturn(this, r1);
    };
}
function _superPropBase(t, e) {
    for(; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = _getPrototypeOf(t)););
    return t;
}
function _get() {
    return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(t, e, r1) {
        var i = _superPropBase(t, e);
        if (i) {
            var s = Object.getOwnPropertyDescriptor(i, e);
            return s.get ? s.get.call(arguments.length < 3 ? t : r1) : s.value;
        }
    }, _get.apply(this, arguments);
}
function set(t, e, r1, i) {
    return set = "undefined" != typeof Reflect && Reflect.set ? Reflect.set : function(t, e, r1, i) {
        var s, a = _superPropBase(t, e);
        if (a) {
            if ((s = Object.getOwnPropertyDescriptor(a, e)).set) return s.set.call(i, r1), !0;
            if (!s.writable) return !1;
        }
        if (s = Object.getOwnPropertyDescriptor(i, e)) {
            if (!s.writable) return !1;
            s.value = r1, Object.defineProperty(i, e, s);
        } else _defineProperty(i, e, r1);
        return !0;
    }, set(t, e, r1, i);
}
function _set(t, e, r1, i, s) {
    if (!set(t, e, r1, i || t) && s) throw new Error("failed to set property");
    return r1;
}
function _taggedTemplateLiteral(t, e) {
    return e || (e = t.slice(0)), Object.freeze(Object.defineProperties(t, {
        raw: {
            value: Object.freeze(e)
        }
    }));
}
function _taggedTemplateLiteralLoose(t, e) {
    return e || (e = t.slice(0)), t.raw = e, t;
}
function _readOnlyError(t) {
    throw new TypeError('"' + t + '" is read-only');
}
function _writeOnlyError(t) {
    throw new TypeError('"' + t + '" is write-only');
}
function _classNameTDZError(t) {
    throw new Error('Class "' + t + '" cannot be referenced in computed property keys.');
}
function _temporalUndefined() {}
function _tdz(t) {
    throw new ReferenceError(t + " is not defined - temporal dead zone");
}
function _temporalRef(t, e) {
    return t === _temporalUndefined ? _tdz(e) : t;
}
function _slicedToArray(t, e) {
    return _arrayWithHoles(t) || _iterableToArrayLimit(t, e) || _unsupportedIterableToArray(t, e) || _nonIterableRest();
}
function _slicedToArrayLoose(t, e) {
    return _arrayWithHoles(t) || _iterableToArrayLimitLoose(t, e) || _unsupportedIterableToArray(t, e) || _nonIterableRest();
}
function _toArray(t) {
    return _arrayWithHoles(t) || _iterableToArray(t) || _unsupportedIterableToArray(t) || _nonIterableRest();
}
function _toConsumableArray(t) {
    return _arrayWithoutHoles(t) || _iterableToArray(t) || _unsupportedIterableToArray(t) || _nonIterableSpread();
}
function _arrayWithoutHoles(t) {
    if (Array.isArray(t)) return _arrayLikeToArray(t);
}
function _arrayWithHoles(t) {
    if (Array.isArray(t)) return t;
}
function _maybeArrayLike(t, e, r1) {
    if (e && !Array.isArray(e) && "number" == typeof e.length) {
        var i = e.length;
        return _arrayLikeToArray(e, void 0 !== r1 && r1 < i ? r1 : i);
    }
    return t(e, r1);
}
function _iterableToArray(t) {
    if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
}
function _iterableToArrayLimit(t, e) {
    var r1 = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
    if (null != r1) {
        var i, s, a = [], n = !0, o = !1;
        try {
            for(r1 = r1.call(t); !(n = (i = r1.next()).done) && (a.push(i.value), !e || a.length !== e); n = !0);
        } catch (t) {
            o = !0, s = t;
        } finally{
            try {
                n || null == r1.return || r1.return();
            } finally{
                if (o) throw s;
            }
        }
        return a;
    }
}
function _iterableToArrayLimitLoose(t, e) {
    var r1 = t && ("undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"]);
    if (null != r1) {
        var i = [];
        for(r1 = r1.call(t), _step; !(_step = r1.next()).done && (i.push(_step.value), !e || i.length !== e););
        return i;
    }
}
function _unsupportedIterableToArray(t, e) {
    if (t) {
        if ("string" == typeof t) return _arrayLikeToArray(t, e);
        var r1 = Object.prototype.toString.call(t).slice(8, -1);
        return "Object" === r1 && t.constructor && (r1 = t.constructor.name), "Map" === r1 || "Set" === r1 ? Array.from(t) : "Arguments" === r1 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r1) ? _arrayLikeToArray(t, e) : void 0;
    }
}
function _arrayLikeToArray(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for(var r1 = 0, i = new Array(e); r1 < e; r1++)i[r1] = t[r1];
    return i;
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _createForOfIteratorHelper(t, e) {
    var r1 = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
    if (!r1) {
        if (Array.isArray(t) || (r1 = _unsupportedIterableToArray(t)) || e && t && "number" == typeof t.length) {
            r1 && (t = r1);
            var i = 0, s = function() {};
            return {
                s: s,
                n: function() {
                    return i >= t.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: t[i++]
                    };
                },
                e: function(t) {
                    throw t;
                },
                f: s
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var a, n = !0, o = !1;
    return {
        s: function() {
            r1 = r1.call(t);
        },
        n: function() {
            var t = r1.next();
            return n = t.done, t;
        },
        e: function(t) {
            o = !0, a = t;
        },
        f: function() {
            try {
                n || null == r1.return || r1.return();
            } finally{
                if (o) throw a;
            }
        }
    };
}
function _createForOfIteratorHelperLoose(t, e) {
    var r1 = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
    if (r1) return (r1 = r1.call(t)).next.bind(r1);
    if (Array.isArray(t) || (r1 = _unsupportedIterableToArray(t)) || e && t && "number" == typeof t.length) {
        r1 && (t = r1);
        var i = 0;
        return function() {
            return i >= t.length ? {
                done: !0
            } : {
                done: !1,
                value: t[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _skipFirstGeneratorNext(t) {
    return function() {
        var e = t.apply(this, arguments);
        return e.next(), e;
    };
}
function _toPrimitive(t, e) {
    if ("object" != typeof t || null === t) return t;
    var r1 = t[Symbol.toPrimitive];
    if (void 0 !== r1) {
        var i = r1.call(t, e || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === e ? String : Number)(t);
}
function _toPropertyKey(t) {
    var e = _toPrimitive(t, "string");
    return "symbol" == typeof e ? e : String(e);
}
function _initializerWarningHelper(t, e) {
    throw new Error("Decorating class property failed. Please ensure that proposal-class-properties is enabled and runs after the decorators transform.");
}
function _initializerDefineProperty(t, e, r1, i) {
    r1 && Object.defineProperty(t, e, {
        enumerable: r1.enumerable,
        configurable: r1.configurable,
        writable: r1.writable,
        value: r1.initializer ? r1.initializer.call(i) : void 0
    });
}
function _applyDecoratedDescriptor(t, e, r1, i, s) {
    var a = {};
    return Object.keys(i).forEach(function(t) {
        a[t] = i[t];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r1.slice().reverse().reduce(function(r1, i) {
        return i(t, e, r1) || r1;
    }, a), s && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(s) : void 0, a.initializer = void 0), void 0 === a.initializer && (Object.defineProperty(t, e, a), a = null), a;
}
_AsyncGenerator.prototype["function" == typeof Symbol && Symbol.asyncIterator || "@@asyncIterator"] = function() {
    return this;
}, _AsyncGenerator.prototype.next = function(t) {
    return this._invoke("next", t);
}, _AsyncGenerator.prototype.throw = function(t) {
    return this._invoke("throw", t);
}, _AsyncGenerator.prototype.return = function(t) {
    return this._invoke("return", t);
};
var id = 0;
function _classPrivateFieldLooseKey(t) {
    return "__private_" + id++ + "_" + t;
}
function _classPrivateFieldLooseBase(t, e) {
    if (!Object.prototype.hasOwnProperty.call(t, e)) throw new TypeError("attempted to use private field on non-instance");
    return t;
}
function _classPrivateFieldGet(t, e) {
    return _classApplyDescriptorGet(t, _classExtractFieldDescriptor(t, e, "get"));
}
function _classPrivateFieldSet(t, e, r1) {
    return _classApplyDescriptorSet(t, _classExtractFieldDescriptor(t, e, "set"), r1), r1;
}
function _classPrivateFieldDestructureSet(t, e) {
    return _classApplyDescriptorDestructureSet(t, _classExtractFieldDescriptor(t, e, "set"));
}
function _classExtractFieldDescriptor(t, e, r1) {
    if (!e.has(t)) throw new TypeError("attempted to " + r1 + " private field on non-instance");
    return e.get(t);
}
function _classStaticPrivateFieldSpecGet(t, e, r1) {
    return _classCheckPrivateStaticAccess(t, e), _classCheckPrivateStaticFieldDescriptor(r1, "get"), _classApplyDescriptorGet(t, r1);
}
function _classStaticPrivateFieldSpecSet(t, e, r1, i) {
    return _classCheckPrivateStaticAccess(t, e), _classCheckPrivateStaticFieldDescriptor(r1, "set"), _classApplyDescriptorSet(t, r1, i), i;
}
function _classStaticPrivateMethodGet(t, e, r1) {
    return _classCheckPrivateStaticAccess(t, e), r1;
}
function _classStaticPrivateMethodSet() {
    throw new TypeError("attempted to set read only static private field");
}
function _classApplyDescriptorGet(t, e) {
    return e.get ? e.get.call(t) : e.value;
}
function _classApplyDescriptorSet(t, e, r1) {
    if (e.set) e.set.call(t, r1);
    else {
        if (!e.writable) throw new TypeError("attempted to set read only private field");
        e.value = r1;
    }
}
function _classApplyDescriptorDestructureSet(t, e) {
    if (e.set) return "__destrObj" in e || (e.__destrObj = {
        set value (r){
            e.set.call(t, r);
        }
    }), e.__destrObj;
    if (!e.writable) throw new TypeError("attempted to set read only private field");
    return e;
}
function _classStaticPrivateFieldDestructureSet(t, e, r1) {
    return _classCheckPrivateStaticAccess(t, e), _classCheckPrivateStaticFieldDescriptor(r1, "set"), _classApplyDescriptorDestructureSet(t, r1);
}
function _classCheckPrivateStaticAccess(t, e) {
    if (t !== e) throw new TypeError("Private static access of wrong provenance");
}
function _classCheckPrivateStaticFieldDescriptor(t, e) {
    if (void 0 === t) throw new TypeError("attempted to " + e + " private static field before its declaration");
}
function _decorate(t, e, r1, i) {
    var s = _getDecoratorsApi();
    if (i) for(var a = 0; a < i.length; a++)s = i[a](s);
    var n = e(function(t) {
        s.initializeInstanceElements(t, o.elements);
    }, r1), o = s.decorateClass(_coalesceClassElements(n.d.map(_createElementDescriptor)), t);
    return s.initializeClassElements(n.F, o.elements), s.runClassFinishers(n.F, o.finishers);
}
function _getDecoratorsApi() {
    _getDecoratorsApi = function() {
        return t;
    };
    var t = {
        elementsDefinitionOrder: [
            [
                "method"
            ],
            [
                "field"
            ]
        ],
        initializeInstanceElements: function(t, e) {
            [
                "method",
                "field"
            ].forEach(function(r1) {
                e.forEach(function(e) {
                    e.kind === r1 && "own" === e.placement && this.defineClassElement(t, e);
                }, this);
            }, this);
        },
        initializeClassElements: function(t, e) {
            var r1 = t.prototype;
            [
                "method",
                "field"
            ].forEach(function(i) {
                e.forEach(function(e) {
                    var s = e.placement;
                    if (e.kind === i && ("static" === s || "prototype" === s)) {
                        var a = "static" === s ? t : r1;
                        this.defineClassElement(a, e);
                    }
                }, this);
            }, this);
        },
        defineClassElement: function(t, e) {
            var r1 = e.descriptor;
            if ("field" === e.kind) {
                var i = e.initializer;
                r1 = {
                    enumerable: r1.enumerable,
                    writable: r1.writable,
                    configurable: r1.configurable,
                    value: void 0 === i ? void 0 : i.call(t)
                };
            }
            Object.defineProperty(t, e.key, r1);
        },
        decorateClass: function(t, e) {
            var r1 = [], i = [], s = {
                static: [],
                prototype: [],
                own: []
            };
            if (t.forEach(function(t) {
                this.addElementPlacement(t, s);
            }, this), t.forEach(function(t) {
                if (!_hasDecorators(t)) return r1.push(t);
                var e = this.decorateElement(t, s);
                r1.push(e.element), r1.push.apply(r1, e.extras), i.push.apply(i, e.finishers);
            }, this), !e) return {
                elements: r1,
                finishers: i
            };
            var a = this.decorateConstructor(r1, e);
            return i.push.apply(i, a.finishers), a.finishers = i, a;
        },
        addElementPlacement: function(t, e, r1) {
            var i = e[t.placement];
            if (!r1 && -1 !== i.indexOf(t.key)) throw new TypeError("Duplicated element (" + t.key + ")");
            i.push(t.key);
        },
        decorateElement: function(t, e) {
            for(var r1 = [], i = [], s = t.decorators, a = s.length - 1; a >= 0; a--){
                var n = e[t.placement];
                n.splice(n.indexOf(t.key), 1);
                var o = this.fromElementDescriptor(t), h = this.toElementFinisherExtras((0, s[a])(o) || o);
                t = h.element, this.addElementPlacement(t, e), h.finisher && i.push(h.finisher);
                var l = h.extras;
                if (l) {
                    for(var p = 0; p < l.length; p++)this.addElementPlacement(l[p], e);
                    r1.push.apply(r1, l);
                }
            }
            return {
                element: t,
                finishers: i,
                extras: r1
            };
        },
        decorateConstructor: function(t, e) {
            for(var r1 = [], i = e.length - 1; i >= 0; i--){
                var s = this.fromClassDescriptor(t), a = this.toClassDescriptor((0, e[i])(s) || s);
                if (void 0 !== a.finisher && r1.push(a.finisher), void 0 !== a.elements) {
                    t = a.elements;
                    for(var n = 0; n < t.length - 1; n++)for(var o = n + 1; o < t.length; o++)if (t[n].key === t[o].key && t[n].placement === t[o].placement) throw new TypeError("Duplicated element (" + t[n].key + ")");
                }
            }
            return {
                elements: t,
                finishers: r1
            };
        },
        fromElementDescriptor: function(t) {
            var e = {
                kind: t.kind,
                key: t.key,
                placement: t.placement,
                descriptor: t.descriptor
            };
            return Object.defineProperty(e, Symbol.toStringTag, {
                value: "Descriptor",
                configurable: !0
            }), "field" === t.kind && (e.initializer = t.initializer), e;
        },
        toElementDescriptors: function(t) {
            if (void 0 !== t) return _toArray(t).map(function(t) {
                var e = this.toElementDescriptor(t);
                return this.disallowProperty(t, "finisher", "An element descriptor"), this.disallowProperty(t, "extras", "An element descriptor"), e;
            }, this);
        },
        toElementDescriptor: function(t) {
            var e = String(t.kind);
            if ("method" !== e && "field" !== e) throw new TypeError('An element descriptor\'s .kind property must be either "method" or "field", but a decorator created an element descriptor with .kind "' + e + '"');
            var r1 = _toPropertyKey(t.key), i = String(t.placement);
            if ("static" !== i && "prototype" !== i && "own" !== i) throw new TypeError('An element descriptor\'s .placement property must be one of "static", "prototype" or "own", but a decorator created an element descriptor with .placement "' + i + '"');
            var s = t.descriptor;
            this.disallowProperty(t, "elements", "An element descriptor");
            var a = {
                kind: e,
                key: r1,
                placement: i,
                descriptor: Object.assign({}, s)
            };
            return "field" !== e ? this.disallowProperty(t, "initializer", "A method descriptor") : (this.disallowProperty(s, "get", "The property descriptor of a field descriptor"), this.disallowProperty(s, "set", "The property descriptor of a field descriptor"), this.disallowProperty(s, "value", "The property descriptor of a field descriptor"), a.initializer = t.initializer), a;
        },
        toElementFinisherExtras: function(t) {
            return {
                element: this.toElementDescriptor(t),
                finisher: _optionalCallableProperty(t, "finisher"),
                extras: this.toElementDescriptors(t.extras)
            };
        },
        fromClassDescriptor: function(t) {
            var e = {
                kind: "class",
                elements: t.map(this.fromElementDescriptor, this)
            };
            return Object.defineProperty(e, Symbol.toStringTag, {
                value: "Descriptor",
                configurable: !0
            }), e;
        },
        toClassDescriptor: function(t) {
            var e = String(t.kind);
            if ("class" !== e) throw new TypeError('A class descriptor\'s .kind property must be "class", but a decorator created a class descriptor with .kind "' + e + '"');
            this.disallowProperty(t, "key", "A class descriptor"), this.disallowProperty(t, "placement", "A class descriptor"), this.disallowProperty(t, "descriptor", "A class descriptor"), this.disallowProperty(t, "initializer", "A class descriptor"), this.disallowProperty(t, "extras", "A class descriptor");
            var r1 = _optionalCallableProperty(t, "finisher");
            return {
                elements: this.toElementDescriptors(t.elements),
                finisher: r1
            };
        },
        runClassFinishers: function(t, e) {
            for(var r1 = 0; r1 < e.length; r1++){
                var i = (0, e[r1])(t);
                if (void 0 !== i) {
                    if ("function" != typeof i) throw new TypeError("Finishers must return a constructor.");
                    t = i;
                }
            }
            return t;
        },
        disallowProperty: function(t, e, r1) {
            if (void 0 !== t[e]) throw new TypeError(r1 + " can't have a ." + e + " property.");
        }
    };
    return t;
}
function _createElementDescriptor(t) {
    var e, r1 = _toPropertyKey(t.key);
    "method" === t.kind ? e = {
        value: t.value,
        writable: !0,
        configurable: !0,
        enumerable: !1
    } : "get" === t.kind ? e = {
        get: t.value,
        configurable: !0,
        enumerable: !1
    } : "set" === t.kind ? e = {
        set: t.value,
        configurable: !0,
        enumerable: !1
    } : "field" === t.kind && (e = {
        configurable: !0,
        writable: !0,
        enumerable: !0
    });
    var i = {
        kind: "field" === t.kind ? "field" : "method",
        key: r1,
        placement: t.static ? "static" : "field" === t.kind ? "own" : "prototype",
        descriptor: e
    };
    return t.decorators && (i.decorators = t.decorators), "field" === t.kind && (i.initializer = t.value), i;
}
function _coalesceGetterSetter(t, e) {
    void 0 !== t.descriptor.get ? e.descriptor.get = t.descriptor.get : e.descriptor.set = t.descriptor.set;
}
function _coalesceClassElements(t) {
    for(var e = [], r1 = function(t) {
        return "method" === t.kind && t.key === a.key && t.placement === a.placement;
    }, i = 0; i < t.length; i++){
        var s, a = t[i];
        if ("method" === a.kind && (s = e.find(r1))) {
            if (_isDataDescriptor(a.descriptor) || _isDataDescriptor(s.descriptor)) {
                if (_hasDecorators(a) || _hasDecorators(s)) throw new ReferenceError("Duplicated methods (" + a.key + ") can't be decorated.");
                s.descriptor = a.descriptor;
            } else {
                if (_hasDecorators(a)) {
                    if (_hasDecorators(s)) throw new ReferenceError("Decorators can't be placed on different accessors with for the same property (" + a.key + ").");
                    s.decorators = a.decorators;
                }
                _coalesceGetterSetter(a, s);
            }
        } else e.push(a);
    }
    return e;
}
function _hasDecorators(t) {
    return t.decorators && t.decorators.length;
}
function _isDataDescriptor(t) {
    return void 0 !== t && !(void 0 === t.value && void 0 === t.writable);
}
function _optionalCallableProperty(t, e) {
    var r1 = t[e];
    if (void 0 !== r1 && "function" != typeof r1) throw new TypeError("Expected '" + e + "' to be a function");
    return r1;
}
function _classPrivateMethodGet(t, e, r1) {
    if (!e.has(t)) throw new TypeError("attempted to get private field on non-instance");
    return r1;
}
function _checkPrivateRedeclaration(t, e) {
    if (e.has(t)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function _classPrivateFieldInitSpec(t, e, r1) {
    _checkPrivateRedeclaration(t, e), e.set(t, r1);
}
function _classPrivateMethodInitSpec(t, e) {
    _checkPrivateRedeclaration(t, e), e.add(t);
}
function _classPrivateMethodSet() {
    throw new TypeError("attempted to reassign private method");
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var _extendStatics = function(t, e) {
    return _extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(t, e) {
        t.__proto__ = e;
    } || function(t, e) {
        for(var r1 in e)Object.prototype.hasOwnProperty.call(e, r1) && (t[r1] = e[r1]);
    }, _extendStatics(t, e);
};
function __extends(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
    function r1() {
        this.constructor = t;
    }
    _extendStatics(t, e), t.prototype = null === e ? Object.create(e) : (r1.prototype = e.prototype, new r1);
}
var _assign = function() {
    return _assign = Object.assign || function(t) {
        for(var e, r1 = 1, i = arguments.length; r1 < i; r1++)for(var s in e = arguments[r1])Object.prototype.hasOwnProperty.call(e, s) && (t[s] = e[s]);
        return t;
    }, _assign.apply(this, arguments);
};
function __rest(t, e) {
    var r1 = {};
    for(var i in t)Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (r1[i] = t[i]);
    if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
        var s = 0;
        for(i = Object.getOwnPropertySymbols(t); s < i.length; s++)e.indexOf(i[s]) < 0 && Object.prototype.propertyIsEnumerable.call(t, i[s]) && (r1[i[s]] = t[i[s]]);
    }
    return r1;
}
function __decorate(t, e, r1, i) {
    var s, a = arguments.length, n = a < 3 ? e : null === i ? i = Object.getOwnPropertyDescriptor(e, r1) : i;
    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) n = Reflect.decorate(t, e, r1, i);
    else for(var o = t.length - 1; o >= 0; o--)(s = t[o]) && (n = (a < 3 ? s(n) : a > 3 ? s(e, r1, n) : s(e, r1)) || n);
    return a > 3 && n && Object.defineProperty(e, r1, n), n;
}
function __param(t, e) {
    return function(r1, i) {
        e(r1, i, t);
    };
}
function __metadata(t, e) {
    if ("object" == typeof Reflect && "function" == typeof Reflect.metadata) return Reflect.metadata(t, e);
}
function __awaiter(t, e, r1, i) {
    return new (r1 || (r1 = Promise))(function(s, a) {
        function n(t) {
            try {
                h(i.next(t));
            } catch (t) {
                a(t);
            }
        }
        function o(t) {
            try {
                h(i.throw(t));
            } catch (t) {
                a(t);
            }
        }
        function h(t) {
            var e;
            t.done ? s(t.value) : (e = t.value, e instanceof r1 ? e : new r1(function(t) {
                t(e);
            })).then(n, o);
        }
        h((i = i.apply(t, e || [])).next());
    });
}
function __generator(t, e) {
    var r1, i, s, a, n = {
        label: 0,
        sent: function() {
            if (1 & s[0]) throw s[1];
            return s[1];
        },
        trys: [],
        ops: []
    };
    return a = {
        next: o(0),
        throw: o(1),
        return: o(2)
    }, "function" == typeof Symbol && (a[Symbol.iterator] = function() {
        return this;
    }), a;
    function o(a) {
        return function(o) {
            return function(a) {
                if (r1) throw new TypeError("Generator is already executing.");
                for(; n;)try {
                    if (r1 = 1, i && (s = 2 & a[0] ? i.return : a[0] ? i.throw || ((s = i.return) && s.call(i), 0) : i.next) && !(s = s.call(i, a[1])).done) return s;
                    switch(i = 0, s && (a = [
                        2 & a[0],
                        s.value
                    ]), a[0]){
                        case 0:
                        case 1:
                            s = a;
                            break;
                        case 4:
                            return n.label++, {
                                value: a[1],
                                done: !1
                            };
                        case 5:
                            n.label++, i = a[1], a = [
                                0
                            ];
                            continue;
                        case 7:
                            a = n.ops.pop(), n.trys.pop();
                            continue;
                        default:
                            if (!(s = n.trys, (s = s.length > 0 && s[s.length - 1]) || 6 !== a[0] && 2 !== a[0])) {
                                n = 0;
                                continue;
                            }
                            if (3 === a[0] && (!s || a[1] > s[0] && a[1] < s[3])) {
                                n.label = a[1];
                                break;
                            }
                            if (6 === a[0] && n.label < s[1]) {
                                n.label = s[1], s = a;
                                break;
                            }
                            if (s && n.label < s[2]) {
                                n.label = s[2], n.ops.push(a);
                                break;
                            }
                            s[2] && n.ops.pop(), n.trys.pop();
                            continue;
                    }
                    a = e.call(t, n);
                } catch (t) {
                    a = [
                        6,
                        t
                    ], i = 0;
                } finally{
                    r1 = s = 0;
                }
                if (5 & a[0]) throw a[1];
                return {
                    value: a[0] ? a[1] : void 0,
                    done: !0
                };
            }([
                a,
                o
            ]);
        };
    }
}
var __createBinding = Object.create ? function(t, e, r1, i) {
    void 0 === i && (i = r1), Object.defineProperty(t, i, {
        enumerable: !0,
        get: function() {
            return e[r1];
        }
    });
} : function(t, e, r1, i) {
    void 0 === i && (i = r1), t[i] = e[r1];
};
function __exportStar(t, e) {
    for(var r1 in t)"default" === r1 || Object.prototype.hasOwnProperty.call(e, r1) || __createBinding(e, t, r1);
}
function __values(t) {
    var e = "function" == typeof Symbol && Symbol.iterator, r1 = e && t[e], i = 0;
    if (r1) return r1.call(t);
    if (t && "number" == typeof t.length) return {
        next: function() {
            return t && i >= t.length && (t = void 0), {
                value: t && t[i++],
                done: !t
            };
        }
    };
    throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(t, e) {
    var r1 = "function" == typeof Symbol && t[Symbol.iterator];
    if (!r1) return t;
    var i, s, a = r1.call(t), n = [];
    try {
        for(; (void 0 === e || e-- > 0) && !(i = a.next()).done;)n.push(i.value);
    } catch (t) {
        s = {
            error: t
        };
    } finally{
        try {
            i && !i.done && (r1 = a.return) && r1.call(a);
        } finally{
            if (s) throw s.error;
        }
    }
    return n;
}
function __spread() {
    for(var t = [], e = 0; e < arguments.length; e++)t = t.concat(__read(arguments[e]));
    return t;
}
function __spreadArrays() {
    for(var t = 0, e = 0, r1 = arguments.length; e < r1; e++)t += arguments[e].length;
    var i = Array(t), s = 0;
    for(e = 0; e < r1; e++)for(var a = arguments[e], n = 0, o = a.length; n < o; n++, s++)i[s] = a[n];
    return i;
}
function __spreadArray(t, e, r1) {
    if (r1 || 2 === arguments.length) for(var i, s = 0, a = e.length; s < a; s++)!i && s in e || (i || (i = Array.prototype.slice.call(e, 0, s)), i[s] = e[s]);
    return t.concat(i || Array.prototype.slice.call(e));
}
function __await(t) {
    return this instanceof __await ? (this.v = t, this) : new __await(t);
}
function __asyncGenerator(t, e, r1) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var i, s = r1.apply(t, e || []), a = [];
    return i = {}, n("next"), n("throw"), n("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function n(t) {
        s[t] && (i[t] = function(e) {
            return new Promise(function(r1, i) {
                a.push([
                    t,
                    e,
                    r1,
                    i
                ]) > 1 || o(t, e);
            });
        });
    }
    function o(t, e) {
        try {
            !function(t) {
                t.value instanceof __await ? Promise.resolve(t.value.v).then(h, l) : p(a[0][2], t);
            }(s[t](e));
        } catch (t) {
            p(a[0][3], t);
        }
    }
    function h(t) {
        o("next", t);
    }
    function l(t) {
        o("throw", t);
    }
    function p(t, e) {
        t(e), a.shift(), a.length && o(a[0][0], a[0][1]);
    }
}
function __asyncDelegator(t) {
    var e, r1;
    return e = {}, i("next"), i("throw", function(t) {
        throw t;
    }), i("return"), e[Symbol.iterator] = function() {
        return this;
    }, e;
    function i(i, s) {
        e[i] = t[i] ? function(e) {
            return (r1 = !r1) ? {
                value: __await(t[i](e)),
                done: "return" === i
            } : s ? s(e) : e;
        } : s;
    }
}
function __asyncValues(t) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var e, r1 = t[Symbol.asyncIterator];
    return r1 ? r1.call(t) : (t = "function" == typeof __values ? __values(t) : t[Symbol.iterator](), e = {}, i("next"), i("throw"), i("return"), e[Symbol.asyncIterator] = function() {
        return this;
    }, e);
    function i(r1) {
        e[r1] = t[r1] && function(e) {
            return new Promise(function(i, s) {
                (function(t, e, r1, i) {
                    Promise.resolve(i).then(function(e) {
                        t({
                            value: e,
                            done: r1
                        });
                    }, e);
                })(i, s, (e = t[r1](e)).done, e.value);
            });
        };
    }
}
function __makeTemplateObject(t, e) {
    return Object.defineProperty ? Object.defineProperty(t, "raw", {
        value: e
    }) : t.raw = e, t;
}
var __setModuleDefault = Object.create ? function(t, e) {
    Object.defineProperty(t, "default", {
        enumerable: !0,
        value: e
    });
} : function(t, e) {
    t.default = e;
};
function __importStar(t) {
    if (t && t.__esModule) return t;
    var e = {};
    if (null != t) for(var r1 in t)"default" !== r1 && Object.prototype.hasOwnProperty.call(t, r1) && __createBinding(e, t, r1);
    return __setModuleDefault(e, t), e;
}
function __importDefault(t) {
    return t && t.__esModule ? t : {
        default: t
    };
}
function __classPrivateFieldGet(t, e, r1, i) {
    if ("a" === r1 && !i) throw new TypeError("Private accessor was defined without a getter");
    if ("function" == typeof e ? t !== e || !i : !e.has(t)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r1 ? i : "a" === r1 ? i.call(t) : i ? i.value : e.get(t);
}
function __classPrivateFieldSet(t, e, r1, i, s) {
    if ("m" === i) throw new TypeError("Private method is not writable");
    if ("a" === i && !s) throw new TypeError("Private accessor was defined without a setter");
    if ("function" == typeof e ? t !== e || !s : !e.has(t)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === i ? s.call(t, r1) : s ? s.value = r1 : e.set(t, r1), r1;
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ }
var t$3 = window.ShadowRoot && (void 0 === window.ShadyCSS || window.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, e$8 = Symbol(), n$5 = new Map;
class s$3 {
    constructor(t, e){
        if (this._$cssResult$ = !0, e !== e$8) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t;
    }
    get styleSheet() {
        var t = n$5.get(this.cssText);
        return t$3 && void 0 === t && (n$5.set(this.cssText, t = new CSSStyleSheet), t.replaceSync(this.cssText)), t;
    }
    toString() {
        return this.cssText;
    }
}
var o$5 = (t)=>new s$3("string" == typeof t ? t : t + "", e$8), r$3 = function(t) {
    for(var e = arguments.length, r1 = new Array(e > 1 ? e - 1 : 0), i = 1; i < e; i++)r1[i - 1] = arguments[i];
    var s = 1 === t.length ? t[0] : r1.reduce((e, r1, i)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(r1) + t[i + 1], t[0]);
    return new s$3(s, e$8);
}, i$3 = (t, e)=>{
    t$3 ? t.adoptedStyleSheets = e.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet) : e.forEach((e)=>{
        var r1 = document.createElement("style"), i = window.litNonce;
        void 0 !== i && r1.setAttribute("nonce", i), r1.textContent = e.cssText, t.appendChild(r1);
    });
}, S$1 = t$3 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        var e = "";
        for (var r1 of t.cssRules)e += r1.cssText;
        return o$5(e);
    })(t) : t, s$2, e$7 = window.trustedTypes, r$2 = e$7 ? e$7.emptyScript : "", h$2 = window.reactiveElementPolyfillSupport, o$4 = {
    toAttribute (t, e) {
        switch(e){
            case Boolean:
                t = t ? r$2 : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, e) {
        var r1 = t;
        switch(e){
            case Boolean:
                r1 = null !== t;
                break;
            case Number:
                r1 = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    r1 = JSON.parse(t);
                } catch (t) {
                    r1 = null;
                }
        }
        return r1;
    }
}, n$4 = (t, e)=>e !== t && (e == e || t == t), l$3 = {
    attribute: !0,
    type: String,
    converter: o$4,
    reflect: !1,
    hasChanged: n$4
}, t$2;
class a$1 extends HTMLElement {
    constructor(){
        super(), this._$Et = new Map, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Ei = null, this.o();
    }
    static addInitializer(t) {
        var e;
        null !== (e = this.l) && void 0 !== e || (this.l = []), this.l.push(t);
    }
    static get observedAttributes() {
        this.finalize();
        var t = [];
        return this.elementProperties.forEach((e, r1)=>{
            var i = this._$Eh(r1, e);
            void 0 !== i && (this._$Eu.set(i, r1), t.push(i));
        }), t;
    }
    static createProperty(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : l$3;
        if (e.state && (e.attribute = !1), this.finalize(), this.elementProperties.set(t, e), !e.noAccessor && !this.prototype.hasOwnProperty(t)) {
            var r1 = "symbol" == typeof t ? Symbol() : "__" + t, i = this.getPropertyDescriptor(t, r1, e);
            void 0 !== i && Object.defineProperty(this.prototype, t, i);
        }
    }
    static getPropertyDescriptor(t, e, r1) {
        return {
            get () {
                return this[e];
            },
            set (i) {
                var s = this[t];
                this[e] = i, this.requestUpdate(t, s, r1);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) || l$3;
    }
    static finalize() {
        if (this.hasOwnProperty("finalized")) return !1;
        this.finalized = !0;
        var t = Object.getPrototypeOf(this);
        if (t.finalize(), this.elementProperties = new Map(t.elementProperties), this._$Eu = new Map, this.hasOwnProperty("properties")) {
            var e = this.properties, r1 = [
                ...Object.getOwnPropertyNames(e),
                ...Object.getOwnPropertySymbols(e)
            ];
            for (var i of r1)this.createProperty(i, e[i]);
        }
        return this.elementStyles = this.finalizeStyles(this.styles), !0;
    }
    static finalizeStyles(t) {
        var e = [];
        if (Array.isArray(t)) {
            var r1 = new Set(t.flat(1 / 0).reverse());
            for (var i of r1)e.unshift(S$1(i));
        } else void 0 !== t && e.push(S$1(t));
        return e;
    }
    static _$Eh(t, e) {
        var r1 = e.attribute;
        return !1 === r1 ? void 0 : "string" == typeof r1 ? r1 : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    o() {
        var t;
        this._$Ep = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$Em(), this.requestUpdate(), null === (t = this.constructor.l) || void 0 === t || t.forEach((t)=>t(this));
    }
    addController(t) {
        var e, r1;
        (null !== (e = this._$Eg) && void 0 !== e ? e : this._$Eg = []).push(t), void 0 !== this.renderRoot && this.isConnected && (null === (r1 = t.hostConnected) || void 0 === r1 || r1.call(t));
    }
    removeController(t) {
        var e;
        null === (e = this._$Eg) || void 0 === e || e.splice(this._$Eg.indexOf(t) >>> 0, 1);
    }
    _$Em() {
        this.constructor.elementProperties.forEach((t, e)=>{
            this.hasOwnProperty(e) && (this._$Et.set(e, this[e]), delete this[e]);
        });
    }
    createRenderRoot() {
        var t, e = null !== (t = this.shadowRoot) && void 0 !== t ? t : this.attachShadow(this.constructor.shadowRootOptions);
        return i$3(e, this.constructor.elementStyles), e;
    }
    connectedCallback() {
        var t;
        void 0 === this.renderRoot && (this.renderRoot = this.createRenderRoot()), this.enableUpdating(!0), null === (t = this._$Eg) || void 0 === t || t.forEach((t)=>{
            var e;
            return null === (e = t.hostConnected) || void 0 === e ? void 0 : e.call(t);
        });
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        var t;
        null === (t = this._$Eg) || void 0 === t || t.forEach((t)=>{
            var e;
            return null === (e = t.hostDisconnected) || void 0 === e ? void 0 : e.call(t);
        });
    }
    attributeChangedCallback(t, e, r1) {
        this._$AK(t, r1);
    }
    _$ES(t, e) {
        var r1, i, s = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : l$3, a = this.constructor._$Eh(t, s);
        if (void 0 !== a && !0 === s.reflect) {
            var n = (null !== (i = null === (r1 = s.converter) || void 0 === r1 ? void 0 : r1.toAttribute) && void 0 !== i ? i : o$4.toAttribute)(e, s.type);
            this._$Ei = t, null == n ? this.removeAttribute(a) : this.setAttribute(a, n), this._$Ei = null;
        }
    }
    _$AK(t, e) {
        var r1, i, s, a = this.constructor, n = a._$Eu.get(t);
        if (void 0 !== n && this._$Ei !== n) {
            var o = a.getPropertyOptions(n), h = o.converter, l = null !== (s = null !== (i = null === (r1 = h) || void 0 === r1 ? void 0 : r1.fromAttribute) && void 0 !== i ? i : "function" == typeof h ? h : null) && void 0 !== s ? s : o$4.fromAttribute;
            this._$Ei = n, this[n] = l(e, o.type), this._$Ei = null;
        }
    }
    requestUpdate(t, e, r1) {
        var i = !0;
        void 0 !== t && (((r1 = r1 || this.constructor.getPropertyOptions(t)).hasChanged || n$4)(this[t], e) ? (this._$AL.has(t) || this._$AL.set(t, e), !0 === r1.reflect && this._$Ei !== t && (void 0 === this._$E_ && (this._$E_ = new Map), this._$E_.set(t, r1))) : i = !1), !this.isUpdatePending && i && (this._$Ep = this._$EC());
    }
    _$EC() {
        var t = this;
        return _asyncToGenerator(function*() {
            t.isUpdatePending = !0;
            try {
                yield t._$Ep;
            } catch (e) {
                Promise.reject(e);
            }
            var e = t.scheduleUpdate();
            return null != e && (yield e), !t.isUpdatePending;
        })();
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        var t;
        if (this.isUpdatePending) {
            this.hasUpdated, this._$Et && (this._$Et.forEach((t, e)=>this[e] = t), this._$Et = void 0);
            var e = !1, r1 = this._$AL;
            try {
                (e = this.shouldUpdate(r1)) ? (this.willUpdate(r1), null === (t = this._$Eg) || void 0 === t || t.forEach((t)=>{
                    var e;
                    return null === (e = t.hostUpdate) || void 0 === e ? void 0 : e.call(t);
                }), this.update(r1)) : this._$EU();
            } catch (t) {
                throw e = !1, this._$EU(), t;
            }
            e && this._$AE(r1);
        }
    }
    willUpdate(t) {}
    _$AE(t) {
        var e;
        null === (e = this._$Eg) || void 0 === e || e.forEach((t)=>{
            var e;
            return null === (e = t.hostUpdated) || void 0 === e ? void 0 : e.call(t);
        }), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$EU() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$Ep;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        void 0 !== this._$E_ && (this._$E_.forEach((t, e)=>this._$ES(e, this[e], t)), this._$E_ = void 0), this._$EU();
    }
    updated(t) {}
    firstUpdated(t) {}
}
a$1.finalized = !0, a$1.elementProperties = new Map, a$1.elementStyles = [], a$1.shadowRootOptions = {
    mode: "open"
}, null == h$2 || h$2({
    ReactiveElement: a$1
}), (null !== (s$2 = globalThis.reactiveElementVersions) && void 0 !== s$2 ? s$2 : globalThis.reactiveElementVersions = []).push("1.2.1");
var i$2 = globalThis.trustedTypes, s$1 = i$2 ? i$2.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, e$6 = "lit$".concat((Math.random() + "").slice(9), "$"), o$3 = "?" + e$6, n$3 = "<".concat(o$3, ">"), l$2 = document, h$1 = function() {
    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
    return l$2.createComment(t);
}, r$1 = (t)=>null === t || "object" != typeof t && "function" != typeof t, d = Array.isArray, u = (t)=>{
    var e;
    return d(t) || "function" == typeof (null === (e = t) || void 0 === e ? void 0 : e[Symbol.iterator]);
}, c = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, v = /-->/g, a = />/g, f = />|[ 	\n\r](?:([^\s"'>=/]+)([ 	\n\r]*=[ 	\n\r]*(?:[^ 	\n\r"'`<>=]|("|')|))|$)/g, _ = /'/g, m = /"/g, g = /^(?:script|style|textarea)$/i, p = (t)=>function(e) {
        for(var r1 = arguments.length, i = new Array(r1 > 1 ? r1 - 1 : 0), s = 1; s < r1; s++)i[s - 1] = arguments[s];
        return {
            _$litType$: t,
            strings: e,
            values: i
        };
    }, $ = p(1), y = p(2), b = Symbol.for("lit-noChange"), w = Symbol.for("lit-nothing"), T = new WeakMap, x = (t, e, r1)=>{
    var i, s, a = null !== (i = null == r1 ? void 0 : r1.renderBefore) && void 0 !== i ? i : e, n = a._$litPart$;
    if (void 0 === n) {
        var o = null !== (s = null == r1 ? void 0 : r1.renderBefore) && void 0 !== s ? s : null;
        a._$litPart$ = n = new N(e.insertBefore(h$1(), o), o, void 0, null != r1 ? r1 : {});
    }
    return n._$AI(t), n;
}, A = l$2.createTreeWalker(l$2, 129, null, !1), C = (t, e)=>{
    for(var r1, i = t.length - 1, s = [], n = 2 === e ? "<svg>" : "", o = c, h = 0; h < i; h++){
        for(var l = t[h], p = void 0, u = void 0, d = -1, y = 0; y < l.length && (o.lastIndex = y, null !== (u = o.exec(l)));)y = o.lastIndex, o === c ? "!--" === u[1] ? o = v : void 0 !== u[1] ? o = a : void 0 !== u[2] ? (g.test(u[2]) && (r1 = RegExp("</" + u[2], "g")), o = f) : void 0 !== u[3] && (o = f) : o === f ? ">" === u[0] ? (o = null != r1 ? r1 : c, d = -1) : void 0 === u[1] ? d = -2 : (d = o.lastIndex - u[2].length, p = u[1], o = void 0 === u[3] ? f : '"' === u[3] ? m : _) : o === m || o === _ ? o = f : o === v || o === a ? o = c : (o = f, r1 = void 0);
        var b = o === f && t[h + 1].startsWith("/>") ? " " : "";
        n += o === c ? l + n$3 : d >= 0 ? (s.push(p), l.slice(0, d) + "$lit$" + l.slice(d) + e$6 + b) : l + e$6 + (-2 === d ? (s.push(void 0), h) : b);
    }
    var P = n + (t[i] || "<?>") + (2 === e ? "</svg>" : "");
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return [
        void 0 !== s$1 ? s$1.createHTML(P) : P,
        s
    ];
};
class E {
    constructor(t, e){
        var r1, { strings: i, _$litType$: s } = t;
        this.parts = [];
        var a = 0, n = 0, o = i.length - 1, h = this.parts, [l, p] = C(i, s);
        if (this.el = E.createElement(l, e), A.currentNode = this.el.content, 2 === s) {
            var c = this.el.content, f = c.firstChild;
            f.remove(), c.append(...f.childNodes);
        }
        for(; null !== (r1 = A.nextNode()) && h.length < o;){
            if (1 === r1.nodeType) {
                if (r1.hasAttributes()) {
                    var u = [];
                    for (var d of r1.getAttributeNames())if (d.endsWith("$lit$") || d.startsWith(e$6)) {
                        var m = p[n++];
                        if (u.push(d), void 0 !== m) {
                            var y = r1.getAttribute(m.toLowerCase() + "$lit$").split(e$6), v = /([.?@])?(.*)/.exec(m);
                            h.push({
                                type: 1,
                                index: a,
                                name: v[2],
                                strings: y,
                                ctor: "." === v[1] ? M : "?" === v[1] ? H : "@" === v[1] ? I : S
                            });
                        } else h.push({
                            type: 6,
                            index: a
                        });
                    }
                    for (var b of u)r1.removeAttribute(b);
                }
                if (g.test(r1.tagName)) {
                    var _ = r1.textContent.split(e$6), P = _.length - 1;
                    if (P > 0) {
                        r1.textContent = i$2 ? i$2.emptyScript : "";
                        for(var x = 0; x < P; x++)r1.append(_[x], h$1()), A.nextNode(), h.push({
                            type: 2,
                            index: ++a
                        });
                        r1.append(_[P], h$1());
                    }
                }
            } else if (8 === r1.nodeType) {
                if (r1.data === o$3) h.push({
                    type: 2,
                    index: a
                });
                else for(var w = -1; -1 !== (w = r1.data.indexOf(e$6, w + 1));)h.push({
                    type: 7,
                    index: a
                }), w += e$6.length - 1;
            }
            a++;
        }
    }
    static createElement(t, e) {
        var r1 = l$2.createElement("template");
        return r1.innerHTML = t, r1;
    }
}
function P(t, e) {
    var r1, i, s, a, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : t, o = arguments.length > 3 ? arguments[3] : void 0;
    if (e === b) return e;
    var h = void 0 !== o ? null === (r1 = n._$Cl) || void 0 === r1 ? void 0 : r1[o] : n._$Cu, l = r$1(e) ? void 0 : e._$litDirective$;
    return (null == h ? void 0 : h.constructor) !== l && (null === (i = null == h ? void 0 : h._$AO) || void 0 === i || i.call(h, !1), void 0 === l ? h = void 0 : (h = new l(t))._$AT(t, n, o), void 0 !== o ? (null !== (s = (a = n)._$Cl) && void 0 !== s ? s : a._$Cl = [])[o] = h : n._$Cu = h), void 0 !== h && (e = P(t, h._$AS(t, e.values), h, o)), e;
}
class V {
    constructor(t, e){
        this.v = [], this._$AN = void 0, this._$AD = t, this._$AM = e;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    p(t) {
        var e, { el: { content: r1 }, parts: i } = this._$AD, s = (null !== (e = null == t ? void 0 : t.creationScope) && void 0 !== e ? e : l$2).importNode(r1, !0);
        A.currentNode = s;
        for(var a = A.nextNode(), n = 0, o = 0, h = i[0]; void 0 !== h;){
            if (n === h.index) {
                var l = void 0;
                2 === h.type ? l = new N(a, a.nextSibling, this, t) : 1 === h.type ? l = new h.ctor(a, h.name, h.strings, this, t) : 6 === h.type && (l = new L(a, this, t)), this.v.push(l), h = i[++o];
            }
            n !== (null == h ? void 0 : h.index) && (a = A.nextNode(), n++);
        }
        return s;
    }
    m(t) {
        var e = 0;
        for (var r1 of this.v)void 0 !== r1 && (void 0 !== r1.strings ? (r1._$AI(t, r1, e), e += r1.strings.length - 2) : r1._$AI(t[e])), e++;
    }
}
class N {
    constructor(t, e, r1, i){
        var s;
        this.type = 2, this._$AH = w, this._$AN = void 0, this._$AA = t, this._$AB = e, this._$AM = r1, this.options = i, this._$Cg = null === (s = null == i ? void 0 : i.isConnected) || void 0 === s || s;
    }
    get _$AU() {
        var t, e;
        return null !== (e = null === (t = this._$AM) || void 0 === t ? void 0 : t._$AU) && void 0 !== e ? e : this._$Cg;
    }
    get parentNode() {
        var t = this._$AA.parentNode, e = this._$AM;
        return void 0 !== e && 11 === t.nodeType && (t = e.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t) {
        t = P(this, t, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this), r$1(t) ? t === w || null == t || "" === t ? (this._$AH !== w && this._$AR(), this._$AH = w) : t !== this._$AH && t !== b && this.$(t) : void 0 !== t._$litType$ ? this.T(t) : void 0 !== t.nodeType ? this.S(t) : u(t) ? this.A(t) : this.$(t);
    }
    M(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this._$AB;
        return this._$AA.parentNode.insertBefore(t, e);
    }
    S(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.M(t));
    }
    $(t) {
        this._$AH !== w && r$1(this._$AH) ? this._$AA.nextSibling.data = t : this.S(l$2.createTextNode(t)), this._$AH = t;
    }
    T(t) {
        var e, { values: r1, _$litType$: i } = t, s = "number" == typeof i ? this._$AC(t) : (void 0 === i.el && (i.el = E.createElement(i.h, this.options)), i);
        if ((null === (e = this._$AH) || void 0 === e ? void 0 : e._$AD) === s) this._$AH.m(r1);
        else {
            var a = new V(s, this), n = a.p(this.options);
            a.m(r1), this.S(n), this._$AH = a;
        }
    }
    _$AC(t) {
        var e = T.get(t.strings);
        return void 0 === e && T.set(t.strings, e = new E(t)), e;
    }
    A(t) {
        d(this._$AH) || (this._$AH = [], this._$AR());
        var e, r1 = this._$AH, i = 0;
        for (var s of t)i === r1.length ? r1.push(e = new N(this.M(h$1()), this.M(h$1()), this, this.options)) : e = r1[i], e._$AI(s), i++;
        i < r1.length && (this._$AR(e && e._$AB.nextSibling, i), r1.length = i);
    }
    _$AR() {
        var t, e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this._$AA.nextSibling, r1 = arguments.length > 1 ? arguments[1] : void 0;
        for(null === (t = this._$AP) || void 0 === t || t.call(this, !1, !0, r1); e && e !== this._$AB;){
            var i = e.nextSibling;
            e.remove(), e = i;
        }
    }
    setConnected(t) {
        var e;
        void 0 === this._$AM && (this._$Cg = t, null === (e = this._$AP) || void 0 === e || e.call(this, t));
    }
}
class S {
    constructor(t, e, r1, i, s){
        this.type = 1, this._$AH = w, this._$AN = void 0, this.element = t, this.name = e, this._$AM = i, this.options = s, r1.length > 2 || "" !== r1[0] || "" !== r1[1] ? (this._$AH = Array(r1.length - 1).fill(new String), this.strings = r1) : this._$AH = w;
    }
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this, r1 = arguments.length > 2 ? arguments[2] : void 0, i = arguments.length > 3 ? arguments[3] : void 0, s = this.strings, a = !1;
        if (void 0 === s) t = P(this, t, e, 0), (a = !r$1(t) || t !== this._$AH && t !== b) && (this._$AH = t);
        else {
            var n, o, h = t;
            for(t = s[0], n = 0; n < s.length - 1; n++)(o = P(this, h[r1 + n], e, n)) === b && (o = this._$AH[n]), a || (a = !r$1(o) || o !== this._$AH[n]), o === w ? t = w : t !== w && (t += (null != o ? o : "") + s[n + 1]), this._$AH[n] = o;
        }
        a && !i && this.k(t);
    }
    k(t) {
        t === w ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, null != t ? t : "");
    }
}
class M extends S {
    constructor(){
        super(...arguments), this.type = 3;
    }
    k(t) {
        this.element[this.name] = t === w ? void 0 : t;
    }
}
var k = i$2 ? i$2.emptyScript : "";
class H extends S {
    constructor(){
        super(...arguments), this.type = 4;
    }
    k(t) {
        t && t !== w ? this.element.setAttribute(this.name, k) : this.element.removeAttribute(this.name);
    }
}
class I extends S {
    constructor(t, e, r1, i, s){
        super(t, e, r1, i, s), this.type = 5;
    }
    _$AI(t) {
        var e;
        if ((t = null !== (e = P(this, t, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this, 0)) && void 0 !== e ? e : w) !== b) {
            var r1 = this._$AH, i = t === w && r1 !== w || t.capture !== r1.capture || t.once !== r1.once || t.passive !== r1.passive, s = t !== w && (r1 === w || i);
            i && this.element.removeEventListener(this.name, this, r1), s && this.element.addEventListener(this.name, this, t), this._$AH = t;
        }
    }
    handleEvent(t) {
        var e, r1;
        "function" == typeof this._$AH ? this._$AH.call(null !== (r1 = null === (e = this.options) || void 0 === e ? void 0 : e.host) && void 0 !== r1 ? r1 : this.element, t) : this._$AH.handleEvent(t);
    }
}
class L {
    constructor(t, e, r1){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = e, this.options = r1;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        P(this, t);
    }
}
var R = {
    P: "$lit$",
    V: e$6,
    L: o$3,
    I: 1,
    N: C,
    R: V,
    D: u,
    j: P,
    H: N,
    O: S,
    F: H,
    B: I,
    W: M,
    Z: L
}, z = window.litHtmlPolyfillSupport, l$1, o$2;
null == z || z(E, N), (null !== (t$2 = globalThis.litHtmlVersions) && void 0 !== t$2 ? t$2 : globalThis.litHtmlVersions = []).push("2.1.2");
var r1 = a$1;
class s extends a$1 {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Dt = void 0;
    }
    createRenderRoot() {
        var t, e, r1 = super.createRenderRoot();
        return null !== (t = (e = this.renderOptions).renderBefore) && void 0 !== t || (e.renderBefore = r1.firstChild), r1;
    }
    update(t) {
        var e = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Dt = x(e, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        var t;
        super.connectedCallback(), null === (t = this._$Dt) || void 0 === t || t.setConnected(!0);
    }
    disconnectedCallback() {
        var t;
        super.disconnectedCallback(), null === (t = this._$Dt) || void 0 === t || t.setConnected(!1);
    }
    render() {
        return b;
    }
}
s.finalized = !0, s._$litElement$ = !0, null === (l$1 = globalThis.litElementHydrateSupport) || void 0 === l$1 || l$1.call(globalThis, {
    LitElement: s
});
var n$2 = globalThis.litElementPolyfillSupport;
null == n$2 || n$2({
    LitElement: s
});
var h = {
    _$AK: (t, e, r1)=>{
        t._$AK(e, r1);
    },
    _$AL: (t)=>t._$AL
};
(null !== (o$2 = globalThis.litElementVersions) && void 0 !== o$2 ? o$2 : globalThis.litElementVersions = []).push("3.1.2");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var n$1 = (t)=>(e)=>"function" == typeof e ? ((t, e)=>(window.customElements.define(t, e), e))(t, e) : ((t, e)=>{
            var { kind: r1, elements: i } = e;
            return {
                kind: r1,
                elements: i,
                finisher (e) {
                    window.customElements.define(t, e);
                }
            };
        })(t, e), i$1 = (t, e)=>"method" === e.kind && e.descriptor && !("value" in e.descriptor) ? _objectSpread2(_objectSpread2({}, e), {}, {
        finisher (r1) {
            r1.createProperty(e.key, t);
        }
    }) : {
        kind: "field",
        key: Symbol(),
        placement: "own",
        descriptor: {},
        originalKey: e.key,
        initializer () {
            "function" == typeof e.initializer && (this[e.key] = e.initializer.call(this));
        },
        finisher (r1) {
            r1.createProperty(e.key, t);
        }
    };
function e$5(t) {
    return (e, r1)=>void 0 !== r1 ? ((t, e, r1)=>{
            e.constructor.createProperty(r1, t);
        })(t, e, r1) : i$1(t, e);
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function t$1(t) {
    return e$5(_objectSpread2(_objectSpread2({}, t), {}, {
        state: !0
    }));
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var e$4 = (t, e, r1)=>{
    Object.defineProperty(e, r1, t);
}, t = (t, e)=>({
        kind: "method",
        placement: "prototype",
        key: e.key,
        descriptor: t
    }), o$1 = (t)=>{
    var { finisher: e, descriptor: r1 } = t;
    return (t, i)=>{
        var s;
        if (void 0 === i) {
            var a = null !== (s = t.originalKey) && void 0 !== s ? s : t.key, n = null != r1 ? {
                kind: "method",
                placement: "prototype",
                key: a,
                descriptor: r1(t.key)
            } : _objectSpread2(_objectSpread2({}, t), {}, {
                key: a
            });
            return null != e && (n.finisher = function(t) {
                e(t, a);
            }), n;
        }
        var o = t.constructor;
        void 0 !== r1 && Object.defineProperty(t, i, r1(i)), null == e || e(o, i);
    };
}, n;
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function e$3(t) {
    return o$1({
        finisher: (e, r1)=>{
            Object.assign(e.prototype[r1], t);
        }
    });
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function i(t, e) {
    return o$1({
        descriptor: (r1)=>{
            var i1 = {
                get () {
                    var e, r1;
                    return null !== (r1 = null === (e = this.renderRoot) || void 0 === e ? void 0 : e.querySelector(t)) && void 0 !== r1 ? r1 : null;
                },
                enumerable: !0,
                configurable: !0
            };
            if (e) {
                var s = "symbol" == typeof r1 ? Symbol() : "__" + r1;
                i1.get = function() {
                    var e, r1;
                    return void 0 === this[s] && (this[s] = null !== (r1 = null === (e = this.renderRoot) || void 0 === e ? void 0 : e.querySelector(t)) && void 0 !== r1 ? r1 : null), this[s];
                };
            }
            return i1;
        }
    });
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function e$2(t) {
    return o$1({
        descriptor: (e)=>({
                get () {
                    var e, r1;
                    return null !== (r1 = null === (e = this.renderRoot) || void 0 === e ? void 0 : e.querySelectorAll(t)) && void 0 !== r1 ? r1 : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function e$1(t) {
    return o$1({
        descriptor: (e)=>({
                get () {
                    var e = this;
                    return _asyncToGenerator(function*() {
                        var r1;
                        return yield e.updateComplete, null === (r1 = e.renderRoot) || void 0 === r1 ? void 0 : r1.querySelector(t);
                    })();
                },
                enumerable: !0,
                configurable: !0
            })
    });
}
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ var e = null != (null === (n = window.HTMLSlotElement) || void 0 === n ? void 0 : n.prototype.assignedElements) ? (t, e)=>t.assignedElements(e) : (t, e)=>t.assignedNodes(e).filter((t)=>t.nodeType === Node.ELEMENT_NODE);
function l(t) {
    var { slot: r1, selector: i } = null != t ? t : {};
    return o$1({
        descriptor: (s)=>({
                get () {
                    var s, a = "slot" + (r1 ? "[name=".concat(r1, "]") : ":not([name])"), n = null === (s = this.renderRoot) || void 0 === s ? void 0 : s.querySelector(a), o = null != n ? e(n, t) : [];
                    return i ? o.filter((t)=>t.matches(i)) : o;
                },
                enumerable: !0,
                configurable: !0
            })
    });
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function o(t, e, r1) {
    var i, s = t;
    return "object" == typeof t ? (s = t.slot, i = t) : i = {
        flatten: e
    }, r1 ? l({
        slot: s,
        flatten: e,
        selector: r1
    }) : o$1({
        descriptor: (t)=>({
                get () {
                    var t, e, r1 = "slot" + (s ? "[name=".concat(s, "]") : ":not([name])"), a = null === (t = this.renderRoot) || void 0 === t ? void 0 : t.querySelector(r1);
                    return null !== (e = null == a ? void 0 : a.assignedNodes(i)) && void 0 !== e ? e : [];
                },
                enumerable: !0,
                configurable: !0
            })
    });
}
var commonjsGlobal = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {};
function getDefaultExportFromCjs(t) {
    return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function getDefaultExportFromNamespaceIfPresent(t) {
    return t && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function getDefaultExportFromNamespaceIfNotNamed(t) {
    return t && Object.prototype.hasOwnProperty.call(t, "default") && 1 === Object.keys(t).length ? t.default : t;
}
function getAugmentedNamespace(t) {
    if (t.__esModule) return t;
    var e = Object.defineProperty({}, "__esModule", {
        value: !0
    });
    return Object.keys(t).forEach(function(r1) {
        var i = Object.getOwnPropertyDescriptor(t, r1);
        Object.defineProperty(e, r1, i.get ? i : {
            enumerable: !0,
            get: function() {
                return t[r1];
            }
        });
    }), e;
}
function commonjsRequire(t) {
    throw new Error('Could not dynamically require "' + t + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var lottie$1 = {
    exports: {}
};
(function(module, exports) {
    var factory;
    "undefined" != typeof navigator && (factory = function() {
        var svgNS = "http://www.w3.org/2000/svg", locationHref = "", _useWebWorker = !1, initialDefaultFrame = -999999, setWebWorker = function(t) {
            _useWebWorker = !!t;
        }, getWebWorker = function() {
            return _useWebWorker;
        }, setLocationHref = function(t) {
            locationHref = t;
        }, getLocationHref = function() {
            return locationHref;
        };
        function createTag(t) {
            return document.createElement(t);
        }
        function extendPrototype(t, e) {
            var r1, i, s = t.length;
            for(r1 = 0; r1 < s; r1 += 1)for(var a in i = t[r1].prototype)Object.prototype.hasOwnProperty.call(i, a) && (e.prototype[a] = i[a]);
        }
        function getDescriptor(t, e) {
            return Object.getOwnPropertyDescriptor(t, e);
        }
        function createProxyFunction(t) {
            function e() {}
            return e.prototype = t, e;
        }
        var audioControllerFactory = function() {
            function t(t) {
                this.audios = [], this.audioFactory = t, this._volume = 1, this._isMuted = !1;
            }
            return t.prototype = {
                addAudio: function(t) {
                    this.audios.push(t);
                },
                pause: function() {
                    var t, e = this.audios.length;
                    for(t = 0; t < e; t += 1)this.audios[t].pause();
                },
                resume: function() {
                    var t, e = this.audios.length;
                    for(t = 0; t < e; t += 1)this.audios[t].resume();
                },
                setRate: function(t) {
                    var e, r1 = this.audios.length;
                    for(e = 0; e < r1; e += 1)this.audios[e].setRate(t);
                },
                createAudio: function(t) {
                    return this.audioFactory ? this.audioFactory(t) : window.Howl ? new window.Howl({
                        src: [
                            t
                        ]
                    }) : {
                        isPlaying: !1,
                        play: function() {
                            this.isPlaying = !0;
                        },
                        seek: function() {
                            this.isPlaying = !1;
                        },
                        playing: function() {},
                        rate: function() {},
                        setVolume: function() {}
                    };
                },
                setAudioFactory: function(t) {
                    this.audioFactory = t;
                },
                setVolume: function(t) {
                    this._volume = t, this._updateVolume();
                },
                mute: function() {
                    this._isMuted = !0, this._updateVolume();
                },
                unmute: function() {
                    this._isMuted = !1, this._updateVolume();
                },
                getVolume: function() {
                    return this._volume;
                },
                _updateVolume: function() {
                    var t, e = this.audios.length;
                    for(t = 0; t < e; t += 1)this.audios[t].volume(this._volume * (this._isMuted ? 0 : 1));
                }
            }, function() {
                return new t;
            };
        }(), createTypedArray = function() {
            function t(t, e) {
                var r1, i = 0, s = [];
                switch(t){
                    case "int16":
                    case "uint8c":
                        r1 = 1;
                        break;
                    default:
                        r1 = 1.1;
                }
                for(i = 0; i < e; i += 1)s.push(r1);
                return s;
            }
            return "function" == typeof Uint8ClampedArray && "function" == typeof Float32Array ? function(e, r1) {
                return "float32" === e ? new Float32Array(r1) : "int16" === e ? new Int16Array(r1) : "uint8c" === e ? new Uint8ClampedArray(r1) : t(e, r1);
            } : t;
        }();
        function createSizedArray(t) {
            return Array.apply(null, {
                length: t
            });
        }
        function _typeof$6(t) {
            return _typeof$6 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, _typeof$6(t);
        }
        var subframeEnabled = !0, expressionsPlugin = null, expressionsInterfaces = null, idPrefix$1 = "", isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent), _shouldRoundValues = !1, bmPow = Math.pow, bmSqrt = Math.sqrt, bmFloor = Math.floor, bmMax = Math.max, bmMin = Math.min, BMMath = {};
        function ProjectInterface$1() {
            return {};
        }
        !function() {
            var t, e = [
                "abs",
                "acos",
                "acosh",
                "asin",
                "asinh",
                "atan",
                "atanh",
                "atan2",
                "ceil",
                "cbrt",
                "expm1",
                "clz32",
                "cos",
                "cosh",
                "exp",
                "floor",
                "fround",
                "hypot",
                "imul",
                "log",
                "log1p",
                "log2",
                "log10",
                "max",
                "min",
                "pow",
                "random",
                "round",
                "sign",
                "sin",
                "sinh",
                "sqrt",
                "tan",
                "tanh",
                "trunc",
                "E",
                "LN10",
                "LN2",
                "LOG10E",
                "LOG2E",
                "PI",
                "SQRT1_2",
                "SQRT2"
            ], r1 = e.length;
            for(t = 0; t < r1; t += 1)BMMath[e[t]] = Math[e[t]];
        }(), BMMath.random = Math.random, BMMath.abs = function(t) {
            if ("object" === _typeof$6(t) && t.length) {
                var e, r1 = createSizedArray(t.length), i = t.length;
                for(e = 0; e < i; e += 1)r1[e] = Math.abs(t[e]);
                return r1;
            }
            return Math.abs(t);
        };
        var defaultCurveSegments = 150, degToRads = Math.PI / 180, roundCorner = .5519;
        function roundValues(t) {
            _shouldRoundValues = !!t;
        }
        function bmRnd(t) {
            return _shouldRoundValues ? Math.round(t) : t;
        }
        function styleDiv(t) {
            t.style.position = "absolute", t.style.top = 0, t.style.left = 0, t.style.display = "block", t.style.transformOrigin = "0 0", t.style.webkitTransformOrigin = "0 0", t.style.backfaceVisibility = "visible", t.style.webkitBackfaceVisibility = "visible", t.style.transformStyle = "preserve-3d", t.style.webkitTransformStyle = "preserve-3d", t.style.mozTransformStyle = "preserve-3d";
        }
        function BMEnterFrameEvent(t, e, r1, i) {
            this.type = t, this.currentTime = e, this.totalTime = r1, this.direction = i < 0 ? -1 : 1;
        }
        function BMCompleteEvent(t, e) {
            this.type = t, this.direction = e < 0 ? -1 : 1;
        }
        function BMCompleteLoopEvent(t, e, r1, i) {
            this.type = t, this.currentLoop = r1, this.totalLoops = e, this.direction = i < 0 ? -1 : 1;
        }
        function BMSegmentStartEvent(t, e, r1) {
            this.type = t, this.firstFrame = e, this.totalFrames = r1;
        }
        function BMDestroyEvent(t, e) {
            this.type = t, this.target = e;
        }
        function BMRenderFrameErrorEvent(t, e) {
            this.type = "renderFrameError", this.nativeError = t, this.currentTime = e;
        }
        function BMConfigErrorEvent(t) {
            this.type = "configError", this.nativeError = t;
        }
        function BMAnimationConfigErrorEvent(t, e) {
            this.type = t, this.nativeError = e;
        }
        var createElementID = (_count = 0, function() {
            return idPrefix$1 + "__lottie_element_" + (_count += 1);
        }), _count;
        function HSVtoRGB(t, e, r1) {
            var i, s, a, n, o, h, l, p;
            switch(h = r1 * (1 - e), l = r1 * (1 - (o = 6 * t - (n = Math.floor(6 * t))) * e), p = r1 * (1 - (1 - o) * e), n % 6){
                case 0:
                    i = r1, s = p, a = h;
                    break;
                case 1:
                    i = l, s = r1, a = h;
                    break;
                case 2:
                    i = h, s = r1, a = p;
                    break;
                case 3:
                    i = h, s = l, a = r1;
                    break;
                case 4:
                    i = p, s = h, a = r1;
                    break;
                case 5:
                    i = r1, s = h, a = l;
            }
            return [
                i,
                s,
                a
            ];
        }
        function RGBtoHSV(t, e, r1) {
            var i, s = Math.max(t, e, r1), a = Math.min(t, e, r1), n = s - a, o = 0 === s ? 0 : n / s, h = s / 255;
            switch(s){
                case a:
                    i = 0;
                    break;
                case t:
                    i = e - r1 + n * (e < r1 ? 6 : 0), i /= 6 * n;
                    break;
                case e:
                    i = r1 - t + 2 * n, i /= 6 * n;
                    break;
                case r1:
                    i = t - e + 4 * n, i /= 6 * n;
            }
            return [
                i,
                o,
                h
            ];
        }
        function addSaturationToRGB(t, e) {
            var r1 = RGBtoHSV(255 * t[0], 255 * t[1], 255 * t[2]);
            return r1[1] += e, r1[1] > 1 ? r1[1] = 1 : r1[1] <= 0 && (r1[1] = 0), HSVtoRGB(r1[0], r1[1], r1[2]);
        }
        function addBrightnessToRGB(t, e) {
            var r1 = RGBtoHSV(255 * t[0], 255 * t[1], 255 * t[2]);
            return r1[2] += e, r1[2] > 1 ? r1[2] = 1 : r1[2] < 0 && (r1[2] = 0), HSVtoRGB(r1[0], r1[1], r1[2]);
        }
        function addHueToRGB(t, e) {
            var r1 = RGBtoHSV(255 * t[0], 255 * t[1], 255 * t[2]);
            return r1[0] += e / 360, r1[0] > 1 ? r1[0] -= 1 : r1[0] < 0 && (r1[0] += 1), HSVtoRGB(r1[0], r1[1], r1[2]);
        }
        var rgbToHex = function() {
            var t, e, r1 = [];
            for(t = 0; t < 256; t += 1)e = t.toString(16), r1[t] = 1 === e.length ? "0" + e : e;
            return function(t, e, i) {
                return t < 0 && (t = 0), e < 0 && (e = 0), i < 0 && (i = 0), "#" + r1[t] + r1[e] + r1[i];
            };
        }(), setSubframeEnabled = function(t) {
            subframeEnabled = !!t;
        }, getSubframeEnabled = function() {
            return subframeEnabled;
        }, setExpressionsPlugin = function(t) {
            expressionsPlugin = t;
        }, getExpressionsPlugin = function() {
            return expressionsPlugin;
        }, setExpressionInterfaces = function(t) {
            expressionsInterfaces = t;
        }, getExpressionInterfaces = function() {
            return expressionsInterfaces;
        }, setDefaultCurveSegments = function(t) {
            defaultCurveSegments = t;
        }, getDefaultCurveSegments = function() {
            return defaultCurveSegments;
        }, setIdPrefix = function(t) {
            idPrefix$1 = t;
        }, getIdPrefix = function() {
            return idPrefix$1;
        };
        function createNS(t) {
            return document.createElementNS(svgNS, t);
        }
        function _typeof$5(t) {
            return _typeof$5 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, _typeof$5(t);
        }
        var dataManager = function() {
            var t, e, r1 = 1, i = [], s = {
                onmessage: function() {},
                postMessage: function(e) {
                    t({
                        data: e
                    });
                }
            }, _workerSelf = {
                postMessage: function(t) {
                    s.onmessage({
                        data: t
                    });
                }
            };
            function a() {
                e || (e = function(e) {
                    if (window.Worker && window.Blob && getWebWorker()) {
                        var r1 = new Blob([
                            "var _workerSelf = self; self.onmessage = ",
                            e.toString()
                        ], {
                            type: "text/javascript"
                        }), i = URL.createObjectURL(r1);
                        return new Worker(i);
                    }
                    return t = e, s;
                }(function(t) {
                    if (_workerSelf.dataManager || (_workerSelf.dataManager = function() {
                        function t(s, a) {
                            var n, o, h, l, p, f, u = s.length;
                            for(o = 0; o < u; o += 1)if ("ks" in (n = s[o]) && !n.completed) {
                                if (n.completed = !0, n.hasMask) {
                                    var d = n.masksProperties;
                                    for(l = d.length, h = 0; h < l; h += 1)if (d[h].pt.k.i) i(d[h].pt.k);
                                    else for(f = d[h].pt.k.length, p = 0; p < f; p += 1)d[h].pt.k[p].s && i(d[h].pt.k[p].s[0]), d[h].pt.k[p].e && i(d[h].pt.k[p].e[0]);
                                }
                                0 === n.ty ? (n.layers = e(n.refId, a), t(n.layers, a)) : 4 === n.ty ? r1(n.shapes) : 5 === n.ty && c(n);
                            }
                        }
                        function e(t, e) {
                            var r1 = function(t, e) {
                                for(var r1 = 0, i = e.length; r1 < i;){
                                    if (e[r1].id === t) return e[r1];
                                    r1 += 1;
                                }
                                return null;
                            }(t, e);
                            return r1 ? r1.layers.__used ? JSON.parse(JSON.stringify(r1.layers)) : (r1.layers.__used = !0, r1.layers) : null;
                        }
                        function r1(t) {
                            var e, s, a;
                            for(e = t.length - 1; e >= 0; e -= 1)if ("sh" === t[e].ty) {
                                if (t[e].ks.k.i) i(t[e].ks.k);
                                else for(a = t[e].ks.k.length, s = 0; s < a; s += 1)t[e].ks.k[s].s && i(t[e].ks.k[s].s[0]), t[e].ks.k[s].e && i(t[e].ks.k[s].e[0]);
                            } else "gr" === t[e].ty && r1(t[e].it);
                        }
                        function i(t) {
                            var e, r1 = t.i.length;
                            for(e = 0; e < r1; e += 1)t.i[e][0] += t.v[e][0], t.i[e][1] += t.v[e][1], t.o[e][0] += t.v[e][0], t.o[e][1] += t.v[e][1];
                        }
                        function s(t, e) {
                            var r1 = e ? e.split(".") : [
                                100,
                                100,
                                100
                            ];
                            return t[0] > r1[0] || !(r1[0] > t[0]) && (t[1] > r1[1] || !(r1[1] > t[1]) && (t[2] > r1[2] || !(r1[2] > t[2]) && null));
                        }
                        var a, n = function() {
                            var t = [
                                4,
                                4,
                                14
                            ];
                            function e(t) {
                                var e, r1, i, s = t.length;
                                for(e = 0; e < s; e += 1)5 === t[e].ty && (i = void 0, i = (r1 = t[e]).t.d, r1.t.d = {
                                    k: [
                                        {
                                            s: i,
                                            t: 0
                                        }
                                    ]
                                });
                            }
                            return function(r1) {
                                if (s(t, r1.v) && (e(r1.layers), r1.assets)) {
                                    var i, a = r1.assets.length;
                                    for(i = 0; i < a; i += 1)r1.assets[i].layers && e(r1.assets[i].layers);
                                }
                            };
                        }(), o = (a = [
                            4,
                            7,
                            99
                        ], function(t) {
                            if (t.chars && !s(a, t.v)) {
                                var e, i = t.chars.length;
                                for(e = 0; e < i; e += 1){
                                    var n = t.chars[e];
                                    n.data && n.data.shapes && (r1(n.data.shapes), n.data.ip = 0, n.data.op = 99999, n.data.st = 0, n.data.sr = 1, n.data.ks = {
                                        p: {
                                            k: [
                                                0,
                                                0
                                            ],
                                            a: 0
                                        },
                                        s: {
                                            k: [
                                                100,
                                                100
                                            ],
                                            a: 0
                                        },
                                        a: {
                                            k: [
                                                0,
                                                0
                                            ],
                                            a: 0
                                        },
                                        r: {
                                            k: 0,
                                            a: 0
                                        },
                                        o: {
                                            k: 100,
                                            a: 0
                                        }
                                    }, t.chars[e].t || (n.data.shapes.push({
                                        ty: "no"
                                    }), n.data.shapes[0].it.push({
                                        p: {
                                            k: [
                                                0,
                                                0
                                            ],
                                            a: 0
                                        },
                                        s: {
                                            k: [
                                                100,
                                                100
                                            ],
                                            a: 0
                                        },
                                        a: {
                                            k: [
                                                0,
                                                0
                                            ],
                                            a: 0
                                        },
                                        r: {
                                            k: 0,
                                            a: 0
                                        },
                                        o: {
                                            k: 100,
                                            a: 0
                                        },
                                        sk: {
                                            k: 0,
                                            a: 0
                                        },
                                        sa: {
                                            k: 0,
                                            a: 0
                                        },
                                        ty: "tr"
                                    })));
                                }
                            }
                        }), h = function() {
                            var t = [
                                5,
                                7,
                                15
                            ];
                            function e(t) {
                                var e, r1, i = t.length;
                                for(e = 0; e < i; e += 1)5 === t[e].ty && (r1 = void 0, "number" == typeof (r1 = t[e].t.p).a && (r1.a = {
                                    a: 0,
                                    k: r1.a
                                }), "number" == typeof r1.p && (r1.p = {
                                    a: 0,
                                    k: r1.p
                                }), "number" == typeof r1.r && (r1.r = {
                                    a: 0,
                                    k: r1.r
                                }));
                            }
                            return function(r1) {
                                if (s(t, r1.v) && (e(r1.layers), r1.assets)) {
                                    var i, a = r1.assets.length;
                                    for(i = 0; i < a; i += 1)r1.assets[i].layers && e(r1.assets[i].layers);
                                }
                            };
                        }(), l = function() {
                            var t = [
                                4,
                                1,
                                9
                            ];
                            function e(t) {
                                var r1, i, s, a = t.length;
                                for(r1 = 0; r1 < a; r1 += 1)if ("gr" === t[r1].ty) e(t[r1].it);
                                else if ("fl" === t[r1].ty || "st" === t[r1].ty) {
                                    if (t[r1].c.k && t[r1].c.k[0].i) for(s = t[r1].c.k.length, i = 0; i < s; i += 1)t[r1].c.k[i].s && (t[r1].c.k[i].s[0] /= 255, t[r1].c.k[i].s[1] /= 255, t[r1].c.k[i].s[2] /= 255, t[r1].c.k[i].s[3] /= 255), t[r1].c.k[i].e && (t[r1].c.k[i].e[0] /= 255, t[r1].c.k[i].e[1] /= 255, t[r1].c.k[i].e[2] /= 255, t[r1].c.k[i].e[3] /= 255);
                                    else t[r1].c.k[0] /= 255, t[r1].c.k[1] /= 255, t[r1].c.k[2] /= 255, t[r1].c.k[3] /= 255;
                                }
                            }
                            function r1(t) {
                                var r1, i = t.length;
                                for(r1 = 0; r1 < i; r1 += 1)4 === t[r1].ty && e(t[r1].shapes);
                            }
                            return function(e) {
                                if (s(t, e.v) && (r1(e.layers), e.assets)) {
                                    var i, a = e.assets.length;
                                    for(i = 0; i < a; i += 1)e.assets[i].layers && r1(e.assets[i].layers);
                                }
                            };
                        }(), p = function() {
                            var t = [
                                4,
                                4,
                                18
                            ];
                            function e(t) {
                                var r1, i, s;
                                for(r1 = t.length - 1; r1 >= 0; r1 -= 1)if ("sh" === t[r1].ty) {
                                    if (t[r1].ks.k.i) t[r1].ks.k.c = t[r1].closed;
                                    else for(s = t[r1].ks.k.length, i = 0; i < s; i += 1)t[r1].ks.k[i].s && (t[r1].ks.k[i].s[0].c = t[r1].closed), t[r1].ks.k[i].e && (t[r1].ks.k[i].e[0].c = t[r1].closed);
                                } else "gr" === t[r1].ty && e(t[r1].it);
                            }
                            function r1(t) {
                                var r1, i, s, a, n, o, h = t.length;
                                for(i = 0; i < h; i += 1){
                                    if ((r1 = t[i]).hasMask) {
                                        var l = r1.masksProperties;
                                        for(a = l.length, s = 0; s < a; s += 1)if (l[s].pt.k.i) l[s].pt.k.c = l[s].cl;
                                        else for(o = l[s].pt.k.length, n = 0; n < o; n += 1)l[s].pt.k[n].s && (l[s].pt.k[n].s[0].c = l[s].cl), l[s].pt.k[n].e && (l[s].pt.k[n].e[0].c = l[s].cl);
                                    }
                                    4 === r1.ty && e(r1.shapes);
                                }
                            }
                            return function(e) {
                                if (s(t, e.v) && (r1(e.layers), e.assets)) {
                                    var i, a = e.assets.length;
                                    for(i = 0; i < a; i += 1)e.assets[i].layers && r1(e.assets[i].layers);
                                }
                            };
                        }();
                        function c(t) {
                            0 === t.t.a.length && t.t.p;
                        }
                        var f = {
                            completeData: function(r1) {
                                r1.__complete || (l(r1), n(r1), o(r1), h(r1), p(r1), t(r1.layers, r1.assets), function(r1, i) {
                                    if (r1) {
                                        var s = 0, a = r1.length;
                                        for(s = 0; s < a; s += 1)1 === r1[s].t && (r1[s].data.layers = e(r1[s].data.refId, i), t(r1[s].data.layers, i));
                                    }
                                }(r1.chars, r1.assets), r1.__complete = !0);
                            }
                        };
                        return f.checkColors = l, f.checkChars = o, f.checkPathProperties = h, f.checkShapes = p, f.completeLayers = t, f;
                    }()), _workerSelf.assetLoader || (_workerSelf.assetLoader = function() {
                        function t(t) {
                            var e = t.getResponseHeader("content-type");
                            return e && "json" === t.responseType && -1 !== e.indexOf("json") || t.response && "object" === _typeof$5(t.response) ? t.response : t.response && "string" == typeof t.response ? JSON.parse(t.response) : t.responseText ? JSON.parse(t.responseText) : null;
                        }
                        return {
                            load: function(e, r1, i, s) {
                                var a, n = new XMLHttpRequest;
                                try {
                                    n.responseType = "json";
                                } catch (t) {}
                                n.onreadystatechange = function() {
                                    if (4 === n.readyState) {
                                        if (200 === n.status) a = t(n), i(a);
                                        else try {
                                            a = t(n), i(a);
                                        } catch (t) {
                                            s && s(t);
                                        }
                                    }
                                };
                                try {
                                    n.open([
                                        "G",
                                        "E",
                                        "T"
                                    ].join(""), e, !0);
                                } catch (t) {
                                    n.open([
                                        "G",
                                        "E",
                                        "T"
                                    ].join(""), r1 + "/" + e, !0);
                                }
                                n.send();
                            }
                        };
                    }()), "loadAnimation" === t.data.type) _workerSelf.assetLoader.load(t.data.path, t.data.fullPath, function(e) {
                        _workerSelf.dataManager.completeData(e), _workerSelf.postMessage({
                            id: t.data.id,
                            payload: e,
                            status: "success"
                        });
                    }, function() {
                        _workerSelf.postMessage({
                            id: t.data.id,
                            status: "error"
                        });
                    });
                    else if ("complete" === t.data.type) {
                        var e = t.data.animation;
                        _workerSelf.dataManager.completeData(e), _workerSelf.postMessage({
                            id: t.data.id,
                            payload: e,
                            status: "success"
                        });
                    } else "loadData" === t.data.type && _workerSelf.assetLoader.load(t.data.path, t.data.fullPath, function(e) {
                        _workerSelf.postMessage({
                            id: t.data.id,
                            payload: e,
                            status: "success"
                        });
                    }, function() {
                        _workerSelf.postMessage({
                            id: t.data.id,
                            status: "error"
                        });
                    });
                }), e.onmessage = function(t) {
                    var e = t.data, r1 = e.id, s = i[r1];
                    i[r1] = null, "success" === e.status ? s.onComplete(e.payload) : s.onError && s.onError();
                });
            }
            function n(t, e) {
                var s = "processId_" + (r1 += 1);
                return i[s] = {
                    onComplete: t,
                    onError: e
                }, s;
            }
            return {
                loadAnimation: function(t, r1, i) {
                    a();
                    var s = n(r1, i);
                    e.postMessage({
                        type: "loadAnimation",
                        path: t,
                        fullPath: window.location.origin + window.location.pathname,
                        id: s
                    });
                },
                loadData: function(t, r1, i) {
                    a();
                    var s = n(r1, i);
                    e.postMessage({
                        type: "loadData",
                        path: t,
                        fullPath: window.location.origin + window.location.pathname,
                        id: s
                    });
                },
                completeAnimation: function(t, r1, i) {
                    a();
                    var s = n(r1, i);
                    e.postMessage({
                        type: "complete",
                        animation: t,
                        id: s
                    });
                }
            };
        }(), ImagePreloader = function() {
            var t = function() {
                var t = createTag("canvas");
                t.width = 1, t.height = 1;
                var e = t.getContext("2d");
                return e.fillStyle = "rgba(0,0,0,0)", e.fillRect(0, 0, 1, 1), t;
            }();
            function e() {
                this.loadedAssets += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
            }
            function r1() {
                this.loadedFootagesCount += 1, this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages && this.imagesLoadedCb && this.imagesLoadedCb(null);
            }
            function i(t, e, r1) {
                var i = "";
                if (t.e) i = t.p;
                else if (e) {
                    var s = t.p;
                    -1 !== s.indexOf("images/") && (s = s.split("/")[1]), i = e + s;
                } else i = r1, i += t.u ? t.u : "", i += t.p;
                return i;
            }
            function s(t) {
                var e = 0, r1 = setInterval((function() {
                    (t.getBBox().width || e > 500) && (this._imageLoaded(), clearInterval(r1)), e += 1;
                }).bind(this), 50);
            }
            function a(t) {
                var e = {
                    assetData: t
                }, r1 = i(t, this.assetsPath, this.path);
                return dataManager.loadData(r1, (function(t) {
                    e.img = t, this._footageLoaded();
                }).bind(this), (function() {
                    e.img = {}, this._footageLoaded();
                }).bind(this)), e;
            }
            function n() {
                this._imageLoaded = e.bind(this), this._footageLoaded = r1.bind(this), this.testImageLoaded = s.bind(this), this.createFootageData = a.bind(this), this.assetsPath = "", this.path = "", this.totalImages = 0, this.totalFootages = 0, this.loadedAssets = 0, this.loadedFootagesCount = 0, this.imagesLoadedCb = null, this.images = [];
            }
            return n.prototype = {
                loadAssets: function(t, e) {
                    var r1;
                    this.imagesLoadedCb = e;
                    var i = t.length;
                    for(r1 = 0; r1 < i; r1 += 1)t[r1].layers || (t[r1].t && "seq" !== t[r1].t ? 3 === t[r1].t && (this.totalFootages += 1, this.images.push(this.createFootageData(t[r1]))) : (this.totalImages += 1, this.images.push(this._createImageData(t[r1]))));
                },
                setAssetsPath: function(t) {
                    this.assetsPath = t || "";
                },
                setPath: function(t) {
                    this.path = t || "";
                },
                loadedImages: function() {
                    return this.totalImages === this.loadedAssets;
                },
                loadedFootages: function() {
                    return this.totalFootages === this.loadedFootagesCount;
                },
                destroy: function() {
                    this.imagesLoadedCb = null, this.images.length = 0;
                },
                getAsset: function(t) {
                    for(var e = 0, r1 = this.images.length; e < r1;){
                        if (this.images[e].assetData === t) return this.images[e].img;
                        e += 1;
                    }
                    return null;
                },
                createImgData: function(e) {
                    var r1 = i(e, this.assetsPath, this.path), s = createTag("img");
                    s.crossOrigin = "anonymous", s.addEventListener("load", this._imageLoaded, !1), s.addEventListener("error", (function() {
                        a.img = t, this._imageLoaded();
                    }).bind(this), !1), s.src = r1;
                    var a = {
                        img: s,
                        assetData: e
                    };
                    return a;
                },
                createImageData: function(e) {
                    var r1 = i(e, this.assetsPath, this.path), s = createNS("image");
                    isSafari ? this.testImageLoaded(s) : s.addEventListener("load", this._imageLoaded, !1), s.addEventListener("error", (function() {
                        a.img = t, this._imageLoaded();
                    }).bind(this), !1), s.setAttributeNS("http://www.w3.org/1999/xlink", "href", r1), this._elementHelper.append ? this._elementHelper.append(s) : this._elementHelper.appendChild(s);
                    var a = {
                        img: s,
                        assetData: e
                    };
                    return a;
                },
                imageLoaded: e,
                footageLoaded: r1,
                setCacheType: function(t, e) {
                    "svg" === t ? (this._elementHelper = e, this._createImageData = this.createImageData.bind(this)) : this._createImageData = this.createImgData.bind(this);
                }
            }, n;
        }();
        function BaseEvent() {}
        BaseEvent.prototype = {
            triggerEvent: function(t, e) {
                if (this._cbs[t]) for(var r1 = this._cbs[t], i = 0; i < r1.length; i += 1)r1[i](e);
            },
            addEventListener: function(t, e) {
                return this._cbs[t] || (this._cbs[t] = []), this._cbs[t].push(e), (function() {
                    this.removeEventListener(t, e);
                }).bind(this);
            },
            removeEventListener: function(t, e) {
                if (e) {
                    if (this._cbs[t]) {
                        for(var r1 = 0, i = this._cbs[t].length; r1 < i;)this._cbs[t][r1] === e && (this._cbs[t].splice(r1, 1), r1 -= 1, i -= 1), r1 += 1;
                        this._cbs[t].length || (this._cbs[t] = null);
                    }
                } else this._cbs[t] = null;
            }
        };
        var markerParser = function() {
            function t(t) {
                for(var e, r1 = t.split("\r\n"), i = {}, s = 0, a = 0; a < r1.length; a += 1)2 === (e = r1[a].split(":")).length && (i[e[0]] = e[1].trim(), s += 1);
                if (0 === s) throw new Error;
                return i;
            }
            return function(e) {
                for(var r1 = [], i = 0; i < e.length; i += 1){
                    var s = e[i], a = {
                        time: s.tm,
                        duration: s.dr
                    };
                    try {
                        a.payload = JSON.parse(e[i].cm);
                    } catch (r1) {
                        try {
                            a.payload = t(e[i].cm);
                        } catch (t) {
                            a.payload = {
                                name: e[i].cm
                            };
                        }
                    }
                    r1.push(a);
                }
                return r1;
            };
        }(), ProjectInterface = function() {
            function t(t) {
                this.compositions.push(t);
            }
            return function() {
                function e(t) {
                    for(var e = 0, r1 = this.compositions.length; e < r1;){
                        if (this.compositions[e].data && this.compositions[e].data.nm === t) return this.compositions[e].prepareFrame && this.compositions[e].data.xt && this.compositions[e].prepareFrame(this.currentFrame), this.compositions[e].compInterface;
                        e += 1;
                    }
                    return null;
                }
                return e.compositions = [], e.currentFrame = 0, e.registerComposition = t, e;
            };
        }(), renderers = {}, registerRenderer = function(t, e) {
            renderers[t] = e;
        };
        function getRenderer(t) {
            return renderers[t];
        }
        function getRegisteredRenderer() {
            if (renderers.canvas) return "canvas";
            for(var t in renderers)if (renderers[t]) return t;
            return "";
        }
        function _typeof$4(t) {
            return _typeof$4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, _typeof$4(t);
        }
        var AnimationItem = function() {
            this._cbs = [], this.name = "", this.path = "", this.isLoaded = !1, this.currentFrame = 0, this.currentRawFrame = 0, this.firstFrame = 0, this.totalFrames = 0, this.frameRate = 0, this.frameMult = 0, this.playSpeed = 1, this.playDirection = 1, this.playCount = 0, this.animationData = {}, this.assets = [], this.isPaused = !0, this.autoplay = !1, this.loop = !0, this.renderer = null, this.animationID = createElementID(), this.assetsPath = "", this.timeCompleted = 0, this.segmentPos = 0, this.isSubframeEnabled = getSubframeEnabled(), this.segments = [], this._idle = !0, this._completedLoop = !1, this.projectInterface = ProjectInterface(), this.imagePreloader = new ImagePreloader, this.audioController = audioControllerFactory(), this.markers = [], this.configAnimation = this.configAnimation.bind(this), this.onSetupError = this.onSetupError.bind(this), this.onSegmentComplete = this.onSegmentComplete.bind(this), this.drawnFrameEvent = new BMEnterFrameEvent("drawnFrame", 0, 0, 0), this.expressionsPlugin = getExpressionsPlugin();
        };
        extendPrototype([
            BaseEvent
        ], AnimationItem), AnimationItem.prototype.setParams = function(t) {
            (t.wrapper || t.container) && (this.wrapper = t.wrapper || t.container);
            var e = "svg";
            t.animType ? e = t.animType : t.renderer && (e = t.renderer);
            var r1 = getRenderer(e);
            this.renderer = new r1(this, t.rendererSettings), this.imagePreloader.setCacheType(e, this.renderer.globalData.defs), this.renderer.setProjectInterface(this.projectInterface), this.animType = e, "" === t.loop || null === t.loop || void 0 === t.loop || !0 === t.loop ? this.loop = !0 : !1 === t.loop ? this.loop = !1 : this.loop = parseInt(t.loop, 10), this.autoplay = !("autoplay" in t) || t.autoplay, this.name = t.name ? t.name : "", this.autoloadSegments = !Object.prototype.hasOwnProperty.call(t, "autoloadSegments") || t.autoloadSegments, this.assetsPath = t.assetsPath, this.initialSegment = t.initialSegment, t.audioFactory && this.audioController.setAudioFactory(t.audioFactory), t.animationData ? this.setupAnimation(t.animationData) : t.path && (-1 !== t.path.lastIndexOf("\\") ? this.path = t.path.substr(0, t.path.lastIndexOf("\\") + 1) : this.path = t.path.substr(0, t.path.lastIndexOf("/") + 1), this.fileName = t.path.substr(t.path.lastIndexOf("/") + 1), this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf(".json")), dataManager.loadAnimation(t.path, this.configAnimation, this.onSetupError));
        }, AnimationItem.prototype.onSetupError = function() {
            this.trigger("data_failed");
        }, AnimationItem.prototype.setupAnimation = function(t) {
            dataManager.completeAnimation(t, this.configAnimation);
        }, AnimationItem.prototype.setData = function(t, e) {
            e && "object" !== _typeof$4(e) && (e = JSON.parse(e));
            var r1 = {
                wrapper: t,
                animationData: e
            }, i = t.attributes;
            r1.path = i.getNamedItem("data-animation-path") ? i.getNamedItem("data-animation-path").value : i.getNamedItem("data-bm-path") ? i.getNamedItem("data-bm-path").value : i.getNamedItem("bm-path") ? i.getNamedItem("bm-path").value : "", r1.animType = i.getNamedItem("data-anim-type") ? i.getNamedItem("data-anim-type").value : i.getNamedItem("data-bm-type") ? i.getNamedItem("data-bm-type").value : i.getNamedItem("bm-type") ? i.getNamedItem("bm-type").value : i.getNamedItem("data-bm-renderer") ? i.getNamedItem("data-bm-renderer").value : i.getNamedItem("bm-renderer") ? i.getNamedItem("bm-renderer").value : getRegisteredRenderer() || "canvas";
            var s = i.getNamedItem("data-anim-loop") ? i.getNamedItem("data-anim-loop").value : i.getNamedItem("data-bm-loop") ? i.getNamedItem("data-bm-loop").value : i.getNamedItem("bm-loop") ? i.getNamedItem("bm-loop").value : "";
            "false" === s ? r1.loop = !1 : "true" === s ? r1.loop = !0 : "" !== s && (r1.loop = parseInt(s, 10));
            var a = i.getNamedItem("data-anim-autoplay") ? i.getNamedItem("data-anim-autoplay").value : i.getNamedItem("data-bm-autoplay") ? i.getNamedItem("data-bm-autoplay").value : !i.getNamedItem("bm-autoplay") || i.getNamedItem("bm-autoplay").value;
            r1.autoplay = "false" !== a, r1.name = i.getNamedItem("data-name") ? i.getNamedItem("data-name").value : i.getNamedItem("data-bm-name") ? i.getNamedItem("data-bm-name").value : i.getNamedItem("bm-name") ? i.getNamedItem("bm-name").value : "", "false" === (i.getNamedItem("data-anim-prerender") ? i.getNamedItem("data-anim-prerender").value : i.getNamedItem("data-bm-prerender") ? i.getNamedItem("data-bm-prerender").value : i.getNamedItem("bm-prerender") ? i.getNamedItem("bm-prerender").value : "") && (r1.prerender = !1), r1.path ? this.setParams(r1) : this.trigger("destroy");
        }, AnimationItem.prototype.includeLayers = function(t) {
            t.op > this.animationData.op && (this.animationData.op = t.op, this.totalFrames = Math.floor(t.op - this.animationData.ip));
            var e, r1, i = this.animationData.layers, s = i.length, a = t.layers, n = a.length;
            for(r1 = 0; r1 < n; r1 += 1)for(e = 0; e < s;){
                if (i[e].id === a[r1].id) {
                    i[e] = a[r1];
                    break;
                }
                e += 1;
            }
            if ((t.chars || t.fonts) && (this.renderer.globalData.fontManager.addChars(t.chars), this.renderer.globalData.fontManager.addFonts(t.fonts, this.renderer.globalData.defs)), t.assets) for(s = t.assets.length, e = 0; e < s; e += 1)this.animationData.assets.push(t.assets[e]);
            this.animationData.__complete = !1, dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
        }, AnimationItem.prototype.onSegmentComplete = function(t) {
            this.animationData = t;
            var e = getExpressionsPlugin();
            e && e.initExpressions(this), this.loadNextSegment();
        }, AnimationItem.prototype.loadNextSegment = function() {
            var t = this.animationData.segments;
            if (!t || 0 === t.length || !this.autoloadSegments) return this.trigger("data_ready"), void (this.timeCompleted = this.totalFrames);
            var e = t.shift();
            this.timeCompleted = e.time * this.frameRate;
            var r1 = this.path + this.fileName + "_" + this.segmentPos + ".json";
            this.segmentPos += 1, dataManager.loadData(r1, this.includeLayers.bind(this), (function() {
                this.trigger("data_failed");
            }).bind(this));
        }, AnimationItem.prototype.loadSegments = function() {
            this.animationData.segments || (this.timeCompleted = this.totalFrames), this.loadNextSegment();
        }, AnimationItem.prototype.imagesLoaded = function() {
            this.trigger("loaded_images"), this.checkLoaded();
        }, AnimationItem.prototype.preloadImages = function() {
            this.imagePreloader.setAssetsPath(this.assetsPath), this.imagePreloader.setPath(this.path), this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
        }, AnimationItem.prototype.configAnimation = function(t) {
            if (this.renderer) try {
                this.animationData = t, this.initialSegment ? (this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]), this.firstFrame = Math.round(this.initialSegment[0])) : (this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip), this.firstFrame = Math.round(this.animationData.ip)), this.renderer.configAnimation(t), t.assets || (t.assets = []), this.assets = this.animationData.assets, this.frameRate = this.animationData.fr, this.frameMult = this.animationData.fr / 1e3, this.renderer.searchExtraCompositions(t.assets), this.markers = markerParser(t.markers || []), this.trigger("config_ready"), this.preloadImages(), this.loadSegments(), this.updaFrameModifier(), this.waitForFontsLoaded(), this.isPaused && this.audioController.pause();
            } catch (t) {
                this.triggerConfigError(t);
            }
        }, AnimationItem.prototype.waitForFontsLoaded = function() {
            this.renderer && (this.renderer.globalData.fontManager.isLoaded ? this.checkLoaded() : setTimeout(this.waitForFontsLoaded.bind(this), 20));
        }, AnimationItem.prototype.checkLoaded = function() {
            if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || "canvas" !== this.renderer.rendererType) && this.imagePreloader.loadedFootages()) {
                this.isLoaded = !0;
                var t = getExpressionsPlugin();
                t && t.initExpressions(this), this.renderer.initItems(), setTimeout((function() {
                    this.trigger("DOMLoaded");
                }).bind(this), 0), this.gotoFrame(), this.autoplay && this.play();
            }
        }, AnimationItem.prototype.resize = function(t, e) {
            var r1 = "number" == typeof t ? t : void 0, i = "number" == typeof e ? e : void 0;
            this.renderer.updateContainerSize(r1, i);
        }, AnimationItem.prototype.setSubframe = function(t) {
            this.isSubframeEnabled = !!t;
        }, AnimationItem.prototype.gotoFrame = function() {
            this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame, this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted && (this.currentFrame = this.timeCompleted), this.trigger("enterFrame"), this.renderFrame(), this.trigger("drawnFrame");
        }, AnimationItem.prototype.renderFrame = function() {
            if (!1 !== this.isLoaded && this.renderer) try {
                this.expressionsPlugin && this.expressionsPlugin.resetFrame(), this.renderer.renderFrame(this.currentFrame + this.firstFrame);
            } catch (t) {
                this.triggerRenderFrameError(t);
            }
        }, AnimationItem.prototype.play = function(t) {
            t && this.name !== t || !0 === this.isPaused && (this.isPaused = !1, this.trigger("_play"), this.audioController.resume(), this._idle && (this._idle = !1, this.trigger("_active")));
        }, AnimationItem.prototype.pause = function(t) {
            t && this.name !== t || !1 === this.isPaused && (this.isPaused = !0, this.trigger("_pause"), this._idle = !0, this.trigger("_idle"), this.audioController.pause());
        }, AnimationItem.prototype.togglePause = function(t) {
            t && this.name !== t || (!0 === this.isPaused ? this.play() : this.pause());
        }, AnimationItem.prototype.stop = function(t) {
            t && this.name !== t || (this.pause(), this.playCount = 0, this._completedLoop = !1, this.setCurrentRawFrameValue(0));
        }, AnimationItem.prototype.getMarkerData = function(t) {
            for(var e, r1 = 0; r1 < this.markers.length; r1 += 1)if ((e = this.markers[r1]).payload && e.payload.name === t) return e;
            return null;
        }, AnimationItem.prototype.goToAndStop = function(t, e, r1) {
            if (!r1 || this.name === r1) {
                var i = Number(t);
                if (isNaN(i)) {
                    var s = this.getMarkerData(t);
                    s && this.goToAndStop(s.time, !0);
                } else e ? this.setCurrentRawFrameValue(t) : this.setCurrentRawFrameValue(t * this.frameModifier);
                this.pause();
            }
        }, AnimationItem.prototype.goToAndPlay = function(t, e, r1) {
            if (!r1 || this.name === r1) {
                var i = Number(t);
                if (isNaN(i)) {
                    var s = this.getMarkerData(t);
                    s && (s.duration ? this.playSegments([
                        s.time,
                        s.time + s.duration
                    ], !0) : this.goToAndStop(s.time, !0));
                } else this.goToAndStop(i, e, r1);
                this.play();
            }
        }, AnimationItem.prototype.advanceTime = function(t) {
            if (!0 !== this.isPaused && !1 !== this.isLoaded) {
                var e = this.currentRawFrame + t * this.frameModifier, r1 = !1;
                e >= this.totalFrames - 1 && this.frameModifier > 0 ? this.loop && this.playCount !== this.loop ? e >= this.totalFrames ? (this.playCount += 1, this.checkSegments(e % this.totalFrames) || (this.setCurrentRawFrameValue(e % this.totalFrames), this._completedLoop = !0, this.trigger("loopComplete"))) : this.setCurrentRawFrameValue(e) : this.checkSegments(e > this.totalFrames ? e % this.totalFrames : 0) || (r1 = !0, e = this.totalFrames - 1) : e < 0 ? this.checkSegments(e % this.totalFrames) || (!this.loop || this.playCount-- <= 0 && !0 !== this.loop ? (r1 = !0, e = 0) : (this.setCurrentRawFrameValue(this.totalFrames + e % this.totalFrames), this._completedLoop ? this.trigger("loopComplete") : this._completedLoop = !0)) : this.setCurrentRawFrameValue(e), r1 && (this.setCurrentRawFrameValue(e), this.pause(), this.trigger("complete"));
            }
        }, AnimationItem.prototype.adjustSegment = function(t, e) {
            this.playCount = 0, t[1] < t[0] ? (this.frameModifier > 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(-1)), this.totalFrames = t[0] - t[1], this.timeCompleted = this.totalFrames, this.firstFrame = t[1], this.setCurrentRawFrameValue(this.totalFrames - .001 - e)) : t[1] > t[0] && (this.frameModifier < 0 && (this.playSpeed < 0 ? this.setSpeed(-this.playSpeed) : this.setDirection(1)), this.totalFrames = t[1] - t[0], this.timeCompleted = this.totalFrames, this.firstFrame = t[0], this.setCurrentRawFrameValue(.001 + e)), this.trigger("segmentStart");
        }, AnimationItem.prototype.setSegment = function(t, e) {
            var r1 = -1;
            this.isPaused && (this.currentRawFrame + this.firstFrame < t ? r1 = t : this.currentRawFrame + this.firstFrame > e && (r1 = e - t)), this.firstFrame = t, this.totalFrames = e - t, this.timeCompleted = this.totalFrames, -1 !== r1 && this.goToAndStop(r1, !0);
        }, AnimationItem.prototype.playSegments = function(t, e) {
            if (e && (this.segments.length = 0), "object" === _typeof$4(t[0])) {
                var r1, i = t.length;
                for(r1 = 0; r1 < i; r1 += 1)this.segments.push(t[r1]);
            } else this.segments.push(t);
            this.segments.length && e && this.adjustSegment(this.segments.shift(), 0), this.isPaused && this.play();
        }, AnimationItem.prototype.resetSegments = function(t) {
            this.segments.length = 0, this.segments.push([
                this.animationData.ip,
                this.animationData.op
            ]), t && this.checkSegments(0);
        }, AnimationItem.prototype.checkSegments = function(t) {
            return !!this.segments.length && (this.adjustSegment(this.segments.shift(), t), !0);
        }, AnimationItem.prototype.destroy = function(t) {
            t && this.name !== t || !this.renderer || (this.renderer.destroy(), this.imagePreloader.destroy(), this.trigger("destroy"), this._cbs = null, this.onEnterFrame = null, this.onLoopComplete = null, this.onComplete = null, this.onSegmentStart = null, this.onDestroy = null, this.renderer = null, this.expressionsPlugin = null, this.imagePreloader = null, this.projectInterface = null);
        }, AnimationItem.prototype.setCurrentRawFrameValue = function(t) {
            this.currentRawFrame = t, this.gotoFrame();
        }, AnimationItem.prototype.setSpeed = function(t) {
            this.playSpeed = t, this.updaFrameModifier();
        }, AnimationItem.prototype.setDirection = function(t) {
            this.playDirection = t < 0 ? -1 : 1, this.updaFrameModifier();
        }, AnimationItem.prototype.setLoop = function(t) {
            this.loop = t;
        }, AnimationItem.prototype.setVolume = function(t, e) {
            e && this.name !== e || this.audioController.setVolume(t);
        }, AnimationItem.prototype.getVolume = function() {
            return this.audioController.getVolume();
        }, AnimationItem.prototype.mute = function(t) {
            t && this.name !== t || this.audioController.mute();
        }, AnimationItem.prototype.unmute = function(t) {
            t && this.name !== t || this.audioController.unmute();
        }, AnimationItem.prototype.updaFrameModifier = function() {
            this.frameModifier = this.frameMult * this.playSpeed * this.playDirection, this.audioController.setRate(this.playSpeed * this.playDirection);
        }, AnimationItem.prototype.getPath = function() {
            return this.path;
        }, AnimationItem.prototype.getAssetsPath = function(t) {
            var e = "";
            if (t.e) e = t.p;
            else if (this.assetsPath) {
                var r1 = t.p;
                -1 !== r1.indexOf("images/") && (r1 = r1.split("/")[1]), e = this.assetsPath + r1;
            } else e = this.path, e += t.u ? t.u : "", e += t.p;
            return e;
        }, AnimationItem.prototype.getAssetData = function(t) {
            for(var e = 0, r1 = this.assets.length; e < r1;){
                if (t === this.assets[e].id) return this.assets[e];
                e += 1;
            }
            return null;
        }, AnimationItem.prototype.hide = function() {
            this.renderer.hide();
        }, AnimationItem.prototype.show = function() {
            this.renderer.show();
        }, AnimationItem.prototype.getDuration = function(t) {
            return t ? this.totalFrames : this.totalFrames / this.frameRate;
        }, AnimationItem.prototype.updateDocumentData = function(t, e, r1) {
            try {
                this.renderer.getElementByPath(t).updateDocumentData(e, r1);
            } catch (t) {}
        }, AnimationItem.prototype.trigger = function(t) {
            if (this._cbs && this._cbs[t]) switch(t){
                case "enterFrame":
                    this.triggerEvent(t, new BMEnterFrameEvent(t, this.currentFrame, this.totalFrames, this.frameModifier));
                    break;
                case "drawnFrame":
                    this.drawnFrameEvent.currentTime = this.currentFrame, this.drawnFrameEvent.totalTime = this.totalFrames, this.drawnFrameEvent.direction = this.frameModifier, this.triggerEvent(t, this.drawnFrameEvent);
                    break;
                case "loopComplete":
                    this.triggerEvent(t, new BMCompleteLoopEvent(t, this.loop, this.playCount, this.frameMult));
                    break;
                case "complete":
                    this.triggerEvent(t, new BMCompleteEvent(t, this.frameMult));
                    break;
                case "segmentStart":
                    this.triggerEvent(t, new BMSegmentStartEvent(t, this.firstFrame, this.totalFrames));
                    break;
                case "destroy":
                    this.triggerEvent(t, new BMDestroyEvent(t, this));
                    break;
                default:
                    this.triggerEvent(t);
            }
            "enterFrame" === t && this.onEnterFrame && this.onEnterFrame.call(this, new BMEnterFrameEvent(t, this.currentFrame, this.totalFrames, this.frameMult)), "loopComplete" === t && this.onLoopComplete && this.onLoopComplete.call(this, new BMCompleteLoopEvent(t, this.loop, this.playCount, this.frameMult)), "complete" === t && this.onComplete && this.onComplete.call(this, new BMCompleteEvent(t, this.frameMult)), "segmentStart" === t && this.onSegmentStart && this.onSegmentStart.call(this, new BMSegmentStartEvent(t, this.firstFrame, this.totalFrames)), "destroy" === t && this.onDestroy && this.onDestroy.call(this, new BMDestroyEvent(t, this));
        }, AnimationItem.prototype.triggerRenderFrameError = function(t) {
            var e = new BMRenderFrameErrorEvent(t, this.currentFrame);
            this.triggerEvent("error", e), this.onError && this.onError.call(this, e);
        }, AnimationItem.prototype.triggerConfigError = function(t) {
            var e = new BMConfigErrorEvent(t, this.currentFrame);
            this.triggerEvent("error", e), this.onError && this.onError.call(this, e);
        };
        var animationManager = function() {
            var t = {}, e = [], r1 = 0, i = 0, s = 0, a = !0, n = !1;
            function o(t) {
                for(var r1 = 0, s = t.target; r1 < i;)e[r1].animation === s && (e.splice(r1, 1), r1 -= 1, i -= 1, s.isPaused || p()), r1 += 1;
            }
            function h(t, r1) {
                if (!t) return null;
                for(var s = 0; s < i;){
                    if (e[s].elem === t && null !== e[s].elem) return e[s].animation;
                    s += 1;
                }
                var a = new AnimationItem;
                return c(a, t), a.setData(t, r1), a;
            }
            function l() {
                s += 1, d();
            }
            function p() {
                s -= 1;
            }
            function c(t, r1) {
                t.addEventListener("destroy", o), t.addEventListener("_active", l), t.addEventListener("_idle", p), e.push({
                    elem: r1,
                    animation: t
                }), i += 1;
            }
            function f(t) {
                var o, h = t - r1;
                for(o = 0; o < i; o += 1)e[o].animation.advanceTime(h);
                r1 = t, s && !n ? window.requestAnimationFrame(f) : a = !0;
            }
            function u(t) {
                r1 = t, window.requestAnimationFrame(f);
            }
            function d() {
                !n && s && a && (window.requestAnimationFrame(u), a = !1);
            }
            return t.registerAnimation = h, t.loadAnimation = function(t) {
                var e = new AnimationItem;
                return c(e, null), e.setParams(t), e;
            }, t.setSpeed = function(t, r1) {
                var s;
                for(s = 0; s < i; s += 1)e[s].animation.setSpeed(t, r1);
            }, t.setDirection = function(t, r1) {
                var s;
                for(s = 0; s < i; s += 1)e[s].animation.setDirection(t, r1);
            }, t.play = function(t) {
                var r1;
                for(r1 = 0; r1 < i; r1 += 1)e[r1].animation.play(t);
            }, t.pause = function(t) {
                var r1;
                for(r1 = 0; r1 < i; r1 += 1)e[r1].animation.pause(t);
            }, t.stop = function(t) {
                var r1;
                for(r1 = 0; r1 < i; r1 += 1)e[r1].animation.stop(t);
            }, t.togglePause = function(t) {
                var r1;
                for(r1 = 0; r1 < i; r1 += 1)e[r1].animation.togglePause(t);
            }, t.searchAnimations = function(t, e, r1) {
                var i, s = [].concat([].slice.call(document.getElementsByClassName("lottie")), [].slice.call(document.getElementsByClassName("bodymovin"))), a = s.length;
                for(i = 0; i < a; i += 1)r1 && s[i].setAttribute("data-bm-type", r1), h(s[i], t);
                if (e && 0 === a) {
                    r1 || (r1 = "svg");
                    var n = document.getElementsByTagName("body")[0];
                    n.innerText = "";
                    var o = createTag("div");
                    o.style.width = "100%", o.style.height = "100%", o.setAttribute("data-bm-type", r1), n.appendChild(o), h(o, t);
                }
            }, t.resize = function() {
                var t;
                for(t = 0; t < i; t += 1)e[t].animation.resize();
            }, t.goToAndStop = function(t, r1, s) {
                var a;
                for(a = 0; a < i; a += 1)e[a].animation.goToAndStop(t, r1, s);
            }, t.destroy = function(t) {
                var r1;
                for(r1 = i - 1; r1 >= 0; r1 -= 1)e[r1].animation.destroy(t);
            }, t.freeze = function() {
                n = !0;
            }, t.unfreeze = function() {
                n = !1, d();
            }, t.setVolume = function(t, r1) {
                var s;
                for(s = 0; s < i; s += 1)e[s].animation.setVolume(t, r1);
            }, t.mute = function(t) {
                var r1;
                for(r1 = 0; r1 < i; r1 += 1)e[r1].animation.mute(t);
            }, t.unmute = function(t) {
                var r1;
                for(r1 = 0; r1 < i; r1 += 1)e[r1].animation.unmute(t);
            }, t.getRegisteredAnimations = function() {
                var t, r1 = e.length, i = [];
                for(t = 0; t < r1; t += 1)i.push(e[t].animation);
                return i;
            }, t;
        }(), BezierFactory = function() {
            var t = {
                getBezierEasing: function(t, r1, i, s, a) {
                    var n = a || ("bez_" + t + "_" + r1 + "_" + i + "_" + s).replace(/\./g, "p");
                    if (e[n]) return e[n];
                    var o = new l([
                        t,
                        r1,
                        i,
                        s
                    ]);
                    return e[n] = o, o;
                }
            }, e = {}, r1 = .1, i = "function" == typeof Float32Array;
            function s(t, e) {
                return 1 - 3 * e + 3 * t;
            }
            function a(t, e) {
                return 3 * e - 6 * t;
            }
            function n(t) {
                return 3 * t;
            }
            function o(t, e, r1) {
                return ((s(e, r1) * t + a(e, r1)) * t + n(e)) * t;
            }
            function h(t, e, r1) {
                return 3 * s(e, r1) * t * t + 2 * a(e, r1) * t + n(e);
            }
            function l(t) {
                this._p = t, this._mSampleValues = i ? new Float32Array(11) : new Array(11), this._precomputed = !1, this.get = this.get.bind(this);
            }
            return l.prototype = {
                get: function(t) {
                    var e = this._p[0], r1 = this._p[1], i = this._p[2], s = this._p[3];
                    return this._precomputed || this._precompute(), e === r1 && i === s ? t : 0 === t ? 0 : 1 === t ? 1 : o(this._getTForX(t), r1, s);
                },
                _precompute: function() {
                    var t = this._p[0], e = this._p[1], r1 = this._p[2], i = this._p[3];
                    this._precomputed = !0, t === e && r1 === i || this._calcSampleValues();
                },
                _calcSampleValues: function() {
                    for(var t = this._p[0], e = this._p[2], i = 0; i < 11; ++i)this._mSampleValues[i] = o(i * r1, t, e);
                },
                _getTForX: function(t) {
                    for(var e = this._p[0], i = this._p[2], s = this._mSampleValues, a = 0, n = 1; 10 !== n && s[n] <= t; ++n)a += r1;
                    var l = a + (t - s[--n]) / (s[n + 1] - s[n]) * r1, p = h(l, e, i);
                    return p >= .001 ? function(t, e, r1, i) {
                        for(var s = 0; s < 4; ++s){
                            var a = h(e, r1, i);
                            if (0 === a) return e;
                            e -= (o(e, r1, i) - t) / a;
                        }
                        return e;
                    }(t, l, e, i) : 0 === p ? l : function(t, e, r1, i, s) {
                        var a, n, h = 0;
                        do (a = o(n = e + (r1 - e) / 2, i, s) - t) > 0 ? r1 = n : e = n;
                        while (Math.abs(a) > 1e-7 && ++h < 10);
                        return n;
                    }(t, a, a + r1, e, i);
                }
            }, t;
        }(), pooling = {
            double: function(t) {
                return t.concat(createSizedArray(t.length));
            }
        }, poolFactory = function(t, e, r1) {
            var i = 0, s = t, a = createSizedArray(s);
            return {
                newElement: function() {
                    return i ? a[i -= 1] : e();
                },
                release: function(t) {
                    i === s && (a = pooling.double(a), s *= 2), r1 && r1(t), a[i] = t, i += 1;
                }
            };
        }, bezierLengthPool = poolFactory(8, function() {
            return {
                addedLength: 0,
                percents: createTypedArray("float32", getDefaultCurveSegments()),
                lengths: createTypedArray("float32", getDefaultCurveSegments())
            };
        }), segmentsLengthPool = poolFactory(8, function() {
            return {
                lengths: [],
                totalLength: 0
            };
        }, function(t) {
            var e, r1 = t.lengths.length;
            for(e = 0; e < r1; e += 1)bezierLengthPool.release(t.lengths[e]);
            t.lengths.length = 0;
        });
        function bezFunction() {
            var t = Math;
            function e(t, e, r1, i, s, a) {
                var n = t * i + e * s + r1 * a - s * i - a * t - r1 * e;
                return n > -0.001 && n < .001;
            }
            var r1 = function(t, e, r1, i) {
                var s, a, n, o, h, l, p = getDefaultCurveSegments(), c = 0, f = [], u = [], d = bezierLengthPool.newElement();
                for(n = r1.length, s = 0; s < p; s += 1){
                    for(h = s / (p - 1), l = 0, a = 0; a < n; a += 1)o = bmPow(1 - h, 3) * t[a] + 3 * bmPow(1 - h, 2) * h * r1[a] + 3 * (1 - h) * bmPow(h, 2) * i[a] + bmPow(h, 3) * e[a], f[a] = o, null !== u[a] && (l += bmPow(f[a] - u[a], 2)), u[a] = f[a];
                    l && (c += l = bmSqrt(l)), d.percents[s] = h, d.lengths[s] = c;
                }
                return d.addedLength = c, d;
            };
            function i(t) {
                this.segmentLength = 0, this.points = new Array(t);
            }
            function s(t, e) {
                this.partialLength = t, this.point = e;
            }
            var a, n = (a = {}, function(t, r1, n, o) {
                var h = (t[0] + "_" + t[1] + "_" + r1[0] + "_" + r1[1] + "_" + n[0] + "_" + n[1] + "_" + o[0] + "_" + o[1]).replace(/\./g, "p");
                if (!a[h]) {
                    var l, p, c, f, u, d, m, y = getDefaultCurveSegments(), g = 0, v = null;
                    2 === t.length && (t[0] !== r1[0] || t[1] !== r1[1]) && e(t[0], t[1], r1[0], r1[1], t[0] + n[0], t[1] + n[1]) && e(t[0], t[1], r1[0], r1[1], r1[0] + o[0], r1[1] + o[1]) && (y = 2);
                    var b = new i(y);
                    for(c = n.length, l = 0; l < y; l += 1){
                        for(m = createSizedArray(c), u = l / (y - 1), d = 0, p = 0; p < c; p += 1)f = bmPow(1 - u, 3) * t[p] + 3 * bmPow(1 - u, 2) * u * (t[p] + n[p]) + 3 * (1 - u) * bmPow(u, 2) * (r1[p] + o[p]) + bmPow(u, 3) * r1[p], m[p] = f, null !== v && (d += bmPow(m[p] - v[p], 2));
                        g += d = bmSqrt(d), b.points[l] = new s(d, m), v = m;
                    }
                    b.segmentLength = g, a[h] = b;
                }
                return a[h];
            });
            function o(t, e) {
                var r1 = e.percents, i = e.lengths, s = r1.length, a = bmFloor((s - 1) * t), n = t * e.addedLength, o = 0;
                if (a === s - 1 || 0 === a || n === i[a]) return r1[a];
                for(var h = i[a] > n ? -1 : 1, l = !0; l;)if (i[a] <= n && i[a + 1] > n ? (o = (n - i[a]) / (i[a + 1] - i[a]), l = !1) : a += h, a < 0 || a >= s - 1) {
                    if (a === s - 1) return r1[a];
                    l = !1;
                }
                return r1[a] + (r1[a + 1] - r1[a]) * o;
            }
            var h = createTypedArray("float32", 8);
            return {
                getSegmentsLength: function(t) {
                    var e, i = segmentsLengthPool.newElement(), s = t.c, a = t.v, n = t.o, o = t.i, h = t._length, l = i.lengths, p = 0;
                    for(e = 0; e < h - 1; e += 1)l[e] = r1(a[e], a[e + 1], n[e], o[e + 1]), p += l[e].addedLength;
                    return s && h && (l[e] = r1(a[e], a[0], n[e], o[0]), p += l[e].addedLength), i.totalLength = p, i;
                },
                getNewSegment: function(e, r1, i, s, a, n, l) {
                    a < 0 ? a = 0 : a > 1 && (a = 1);
                    var p, c = o(a, l), f = o(n = n > 1 ? 1 : n, l), u = e.length, d = 1 - c, m = 1 - f, y = d * d * d, g = c * d * d * 3, v = c * c * d * 3, b = c * c * c, _ = d * d * m, P = c * d * m + d * c * m + d * d * f, S = c * c * m + d * c * f + c * d * f, E = c * c * f, x = d * m * m, C = c * m * m + d * f * m + d * m * f, A = c * f * m + d * f * f + c * m * f, w = c * f * f, k = m * m * m, T = f * m * m + m * f * m + m * m * f, M = f * f * m + m * f * f + f * m * f, D = f * f * f;
                    for(p = 0; p < u; p += 1)h[4 * p] = t.round(1e3 * (y * e[p] + g * i[p] + v * s[p] + b * r1[p])) / 1e3, h[4 * p + 1] = t.round(1e3 * (_ * e[p] + P * i[p] + S * s[p] + E * r1[p])) / 1e3, h[4 * p + 2] = t.round(1e3 * (x * e[p] + C * i[p] + A * s[p] + w * r1[p])) / 1e3, h[4 * p + 3] = t.round(1e3 * (k * e[p] + T * i[p] + M * s[p] + D * r1[p])) / 1e3;
                    return h;
                },
                getPointInSegment: function(e, r1, i, s, a, n) {
                    var h = o(a, n), l = 1 - h;
                    return [
                        t.round(1e3 * (l * l * l * e[0] + (h * l * l + l * h * l + l * l * h) * i[0] + (h * h * l + l * h * h + h * l * h) * s[0] + h * h * h * r1[0])) / 1e3,
                        t.round(1e3 * (l * l * l * e[1] + (h * l * l + l * h * l + l * l * h) * i[1] + (h * h * l + l * h * h + h * l * h) * s[1] + h * h * h * r1[1])) / 1e3
                    ];
                },
                buildBezierData: n,
                pointOnLine2D: e,
                pointOnLine3D: function(r1, i, s, a, n, o, h, l, p) {
                    if (0 === s && 0 === o && 0 === p) return e(r1, i, a, n, h, l);
                    var c, f = t.sqrt(t.pow(a - r1, 2) + t.pow(n - i, 2) + t.pow(o - s, 2)), u = t.sqrt(t.pow(h - r1, 2) + t.pow(l - i, 2) + t.pow(p - s, 2)), d = t.sqrt(t.pow(h - a, 2) + t.pow(l - n, 2) + t.pow(p - o, 2));
                    return (c = f > u ? f > d ? f - u - d : d - u - f : d > u ? d - u - f : u - f - d) > -0.0001 && c < 1e-4;
                }
            };
        }
        var bez = bezFunction(), initFrame = initialDefaultFrame, mathAbs = Math.abs;
        function interpolateValue(t, e) {
            var r1, i = this.offsetTime;
            "multidimensional" === this.propType && (r1 = createTypedArray("float32", this.pv.length));
            for(var s, a, n, o, h, l, p, c, f, u = e.lastIndex, d = u, m = this.keyframes.length - 1, y = !0; y;){
                if (s = this.keyframes[d], a = this.keyframes[d + 1], d === m - 1 && t >= a.t - i) {
                    s.h && (s = a), u = 0;
                    break;
                }
                if (a.t - i > t) {
                    u = d;
                    break;
                }
                d < m - 1 ? d += 1 : (u = 0, y = !1);
            }
            n = this.keyframesMetadata[d] || {};
            var g, v = a.t - i, b = s.t - i;
            if (s.to) {
                n.bezierData || (n.bezierData = bez.buildBezierData(s.s, a.s || s.e, s.to, s.ti));
                var _ = n.bezierData;
                if (t >= v || t < b) {
                    var P = t >= v ? _.points.length - 1 : 0;
                    for(h = _.points[P].point.length, o = 0; o < h; o += 1)r1[o] = _.points[P].point[o];
                } else {
                    n.__fnct ? f = n.__fnct : (f = BezierFactory.getBezierEasing(s.o.x, s.o.y, s.i.x, s.i.y, s.n).get, n.__fnct = f), l = f((t - b) / (v - b));
                    var S, E = _.segmentLength * l, x = e.lastFrame < t && e._lastKeyframeIndex === d ? e._lastAddedLength : 0;
                    for(c = e.lastFrame < t && e._lastKeyframeIndex === d ? e._lastPoint : 0, y = !0, p = _.points.length; y;){
                        if (x += _.points[c].partialLength, 0 === E || 0 === l || c === _.points.length - 1) {
                            for(h = _.points[c].point.length, o = 0; o < h; o += 1)r1[o] = _.points[c].point[o];
                            break;
                        }
                        if (E >= x && E < x + _.points[c + 1].partialLength) {
                            for(S = (E - x) / _.points[c + 1].partialLength, h = _.points[c].point.length, o = 0; o < h; o += 1)r1[o] = _.points[c].point[o] + (_.points[c + 1].point[o] - _.points[c].point[o]) * S;
                            break;
                        }
                        c < p - 1 ? c += 1 : y = !1;
                    }
                    e._lastPoint = c, e._lastAddedLength = x - _.points[c].partialLength, e._lastKeyframeIndex = d;
                }
            } else {
                var C, A, w, k, T;
                if (m = s.s.length, g = a.s || s.e, this.sh && 1 !== s.h) t >= v ? (r1[0] = g[0], r1[1] = g[1], r1[2] = g[2]) : t <= b ? (r1[0] = s.s[0], r1[1] = s.s[1], r1[2] = s.s[2]) : quaternionToEuler(r1, slerp(createQuaternion(s.s), createQuaternion(g), (t - b) / (v - b)));
                else for(d = 0; d < m; d += 1)1 !== s.h && (t >= v ? l = 1 : t < b ? l = 0 : (s.o.x.constructor === Array ? (n.__fnct || (n.__fnct = []), n.__fnct[d] ? f = n.__fnct[d] : (C = void 0 === s.o.x[d] ? s.o.x[0] : s.o.x[d], A = void 0 === s.o.y[d] ? s.o.y[0] : s.o.y[d], w = void 0 === s.i.x[d] ? s.i.x[0] : s.i.x[d], k = void 0 === s.i.y[d] ? s.i.y[0] : s.i.y[d], f = BezierFactory.getBezierEasing(C, A, w, k).get, n.__fnct[d] = f)) : n.__fnct ? f = n.__fnct : (C = s.o.x, A = s.o.y, w = s.i.x, k = s.i.y, f = BezierFactory.getBezierEasing(C, A, w, k).get, s.keyframeMetadata = f), l = f((t - b) / (v - b)))), g = a.s || s.e, T = 1 === s.h ? s.s[d] : s.s[d] + (g[d] - s.s[d]) * l, "multidimensional" === this.propType ? r1[d] = T : r1 = T;
            }
            return e.lastIndex = u, r1;
        }
        function slerp(t, e, r1) {
            var i, s, a, n, o, h = [], l = t[0], p = t[1], c = t[2], f = t[3], u = e[0], d = e[1], m = e[2], y = e[3];
            return (s = l * u + p * d + c * m + f * y) < 0 && (s = -s, u = -u, d = -d, m = -m, y = -y), 1 - s > 1e-6 ? (i = Math.acos(s), a = Math.sin(i), n = Math.sin((1 - r1) * i) / a, o = Math.sin(r1 * i) / a) : (n = 1 - r1, o = r1), h[0] = n * l + o * u, h[1] = n * p + o * d, h[2] = n * c + o * m, h[3] = n * f + o * y, h;
        }
        function quaternionToEuler(t, e) {
            var r1 = e[0], i = e[1], s = e[2], a = e[3], n = Math.atan2(2 * i * a - 2 * r1 * s, 1 - 2 * i * i - 2 * s * s), o = Math.asin(2 * r1 * i + 2 * s * a), h = Math.atan2(2 * r1 * a - 2 * i * s, 1 - 2 * r1 * r1 - 2 * s * s);
            t[0] = n / degToRads, t[1] = o / degToRads, t[2] = h / degToRads;
        }
        function createQuaternion(t) {
            var e = t[0] * degToRads, r1 = t[1] * degToRads, i = t[2] * degToRads, s = Math.cos(e / 2), a = Math.cos(r1 / 2), n = Math.cos(i / 2), o = Math.sin(e / 2), h = Math.sin(r1 / 2), l = Math.sin(i / 2);
            return [
                o * h * n + s * a * l,
                o * a * n + s * h * l,
                s * h * n - o * a * l,
                s * a * n - o * h * l
            ];
        }
        function getValueAtCurrentTime() {
            var t = this.comp.renderedFrame - this.offsetTime, e = this.keyframes[0].t - this.offsetTime, r1 = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
            if (!(t === this._caching.lastFrame || this._caching.lastFrame !== initFrame && (this._caching.lastFrame >= r1 && t >= r1 || this._caching.lastFrame < e && t < e))) {
                this._caching.lastFrame >= t && (this._caching._lastKeyframeIndex = -1, this._caching.lastIndex = 0);
                var i = this.interpolateValue(t, this._caching);
                this.pv = i;
            }
            return this._caching.lastFrame = t, this.pv;
        }
        function setVValue(t) {
            var e;
            if ("unidimensional" === this.propType) e = t * this.mult, mathAbs(this.v - e) > 1e-5 && (this.v = e, this._mdf = !0);
            else for(var r1 = 0, i = this.v.length; r1 < i;)e = t[r1] * this.mult, mathAbs(this.v[r1] - e) > 1e-5 && (this.v[r1] = e, this._mdf = !0), r1 += 1;
        }
        function processEffectsSequence() {
            if (this.elem.globalData.frameId !== this.frameId && this.effectsSequence.length) {
                if (this.lock) this.setVValue(this.pv);
                else {
                    var t;
                    this.lock = !0, this._mdf = this._isFirstFrame;
                    var e = this.effectsSequence.length, r1 = this.kf ? this.pv : this.data.k;
                    for(t = 0; t < e; t += 1)r1 = this.effectsSequence[t](r1);
                    this.setVValue(r1), this._isFirstFrame = !1, this.lock = !1, this.frameId = this.elem.globalData.frameId;
                }
            }
        }
        function addEffect(t) {
            this.effectsSequence.push(t), this.container.addDynamicProperty(this);
        }
        function ValueProperty(t, e, r1, i) {
            this.propType = "unidimensional", this.mult = r1 || 1, this.data = e, this.v = r1 ? e.k * r1 : e.k, this.pv = e.k, this._mdf = !1, this.elem = t, this.container = i, this.comp = t.comp, this.k = !1, this.kf = !1, this.vel = 0, this.effectsSequence = [], this._isFirstFrame = !0, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.addEffect = addEffect;
        }
        function MultiDimensionalProperty(t, e, r1, i) {
            var s;
            this.propType = "multidimensional", this.mult = r1 || 1, this.data = e, this._mdf = !1, this.elem = t, this.container = i, this.comp = t.comp, this.k = !1, this.kf = !1, this.frameId = -1;
            var a = e.k.length;
            for(this.v = createTypedArray("float32", a), this.pv = createTypedArray("float32", a), this.vel = createTypedArray("float32", a), s = 0; s < a; s += 1)this.v[s] = e.k[s] * this.mult, this.pv[s] = e.k[s];
            this._isFirstFrame = !0, this.effectsSequence = [], this.getValue = processEffectsSequence, this.setVValue = setVValue, this.addEffect = addEffect;
        }
        function KeyframedValueProperty(t, e, r1, i) {
            this.propType = "unidimensional", this.keyframes = e.k, this.keyframesMetadata = [], this.offsetTime = t.data.st, this.frameId = -1, this._caching = {
                lastFrame: initFrame,
                lastIndex: 0,
                value: 0,
                _lastKeyframeIndex: -1
            }, this.k = !0, this.kf = !0, this.data = e, this.mult = r1 || 1, this.elem = t, this.container = i, this.comp = t.comp, this.v = initFrame, this.pv = initFrame, this._isFirstFrame = !0, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.interpolateValue = interpolateValue, this.effectsSequence = [
                getValueAtCurrentTime.bind(this)
            ], this.addEffect = addEffect;
        }
        function KeyframedMultidimensionalProperty(t, e, r1, i) {
            var s;
            this.propType = "multidimensional";
            var a, n, o, h, l = e.k.length;
            for(s = 0; s < l - 1; s += 1)e.k[s].to && e.k[s].s && e.k[s + 1] && e.k[s + 1].s && (a = e.k[s].s, n = e.k[s + 1].s, o = e.k[s].to, h = e.k[s].ti, (2 === a.length && (a[0] !== n[0] || a[1] !== n[1]) && bez.pointOnLine2D(a[0], a[1], n[0], n[1], a[0] + o[0], a[1] + o[1]) && bez.pointOnLine2D(a[0], a[1], n[0], n[1], n[0] + h[0], n[1] + h[1]) || 3 === a.length && (a[0] !== n[0] || a[1] !== n[1] || a[2] !== n[2]) && bez.pointOnLine3D(a[0], a[1], a[2], n[0], n[1], n[2], a[0] + o[0], a[1] + o[1], a[2] + o[2]) && bez.pointOnLine3D(a[0], a[1], a[2], n[0], n[1], n[2], n[0] + h[0], n[1] + h[1], n[2] + h[2])) && (e.k[s].to = null, e.k[s].ti = null), a[0] === n[0] && a[1] === n[1] && 0 === o[0] && 0 === o[1] && 0 === h[0] && 0 === h[1] && (2 === a.length || a[2] === n[2] && 0 === o[2] && 0 === h[2]) && (e.k[s].to = null, e.k[s].ti = null));
            this.effectsSequence = [
                getValueAtCurrentTime.bind(this)
            ], this.data = e, this.keyframes = e.k, this.keyframesMetadata = [], this.offsetTime = t.data.st, this.k = !0, this.kf = !0, this._isFirstFrame = !0, this.mult = r1 || 1, this.elem = t, this.container = i, this.comp = t.comp, this.getValue = processEffectsSequence, this.setVValue = setVValue, this.interpolateValue = interpolateValue, this.frameId = -1;
            var p = e.k[0].s.length;
            for(this.v = createTypedArray("float32", p), this.pv = createTypedArray("float32", p), s = 0; s < p; s += 1)this.v[s] = initFrame, this.pv[s] = initFrame;
            this._caching = {
                lastFrame: initFrame,
                lastIndex: 0,
                value: createTypedArray("float32", p)
            }, this.addEffect = addEffect;
        }
        var PropertyFactory = (ob = {
            getProp: function(t, e, r1, i, s) {
                var a;
                if (e.sid && (e = t.globalData.slotManager.getProp(e)), e.k.length) {
                    if ("number" == typeof e.k[0]) a = new MultiDimensionalProperty(t, e, i, s);
                    else switch(r1){
                        case 0:
                            a = new KeyframedValueProperty(t, e, i, s);
                            break;
                        case 1:
                            a = new KeyframedMultidimensionalProperty(t, e, i, s);
                    }
                } else a = new ValueProperty(t, e, i, s);
                return a.effectsSequence.length && s.addDynamicProperty(a), a;
            }
        }, ob), ob;
        function DynamicPropertyContainer() {}
        DynamicPropertyContainer.prototype = {
            addDynamicProperty: function(t) {
                -1 === this.dynamicProperties.indexOf(t) && (this.dynamicProperties.push(t), this.container.addDynamicProperty(this), this._isAnimated = !0);
            },
            iterateDynamicProperties: function() {
                var t;
                this._mdf = !1;
                var e = this.dynamicProperties.length;
                for(t = 0; t < e; t += 1)this.dynamicProperties[t].getValue(), this.dynamicProperties[t]._mdf && (this._mdf = !0);
            },
            initDynamicPropertyContainer: function(t) {
                this.container = t, this.dynamicProperties = [], this._mdf = !1, this._isAnimated = !1;
            }
        };
        var pointPool = poolFactory(8, function() {
            return createTypedArray("float32", 2);
        });
        function ShapePath() {
            this.c = !1, this._length = 0, this._maxLength = 8, this.v = createSizedArray(this._maxLength), this.o = createSizedArray(this._maxLength), this.i = createSizedArray(this._maxLength);
        }
        ShapePath.prototype.setPathData = function(t, e) {
            this.c = t, this.setLength(e);
            for(var r1 = 0; r1 < e;)this.v[r1] = pointPool.newElement(), this.o[r1] = pointPool.newElement(), this.i[r1] = pointPool.newElement(), r1 += 1;
        }, ShapePath.prototype.setLength = function(t) {
            for(; this._maxLength < t;)this.doubleArrayLength();
            this._length = t;
        }, ShapePath.prototype.doubleArrayLength = function() {
            this.v = this.v.concat(createSizedArray(this._maxLength)), this.i = this.i.concat(createSizedArray(this._maxLength)), this.o = this.o.concat(createSizedArray(this._maxLength)), this._maxLength *= 2;
        }, ShapePath.prototype.setXYAt = function(t, e, r1, i, s) {
            var a;
            switch(this._length = Math.max(this._length, i + 1), this._length >= this._maxLength && this.doubleArrayLength(), r1){
                case "v":
                    a = this.v;
                    break;
                case "i":
                    a = this.i;
                    break;
                case "o":
                    a = this.o;
                    break;
                default:
                    a = [];
            }
            (!a[i] || a[i] && !s) && (a[i] = pointPool.newElement()), a[i][0] = t, a[i][1] = e;
        }, ShapePath.prototype.setTripleAt = function(t, e, r1, i, s, a, n, o) {
            this.setXYAt(t, e, "v", n, o), this.setXYAt(r1, i, "o", n, o), this.setXYAt(s, a, "i", n, o);
        }, ShapePath.prototype.reverse = function() {
            var t = new ShapePath;
            t.setPathData(this.c, this._length);
            var e = this.v, r1 = this.o, i = this.i, s = 0;
            this.c && (t.setTripleAt(e[0][0], e[0][1], i[0][0], i[0][1], r1[0][0], r1[0][1], 0, !1), s = 1);
            var a, n = this._length - 1, o = this._length;
            for(a = s; a < o; a += 1)t.setTripleAt(e[n][0], e[n][1], i[n][0], i[n][1], r1[n][0], r1[n][1], a, !1), n -= 1;
            return t;
        }, ShapePath.prototype.length = function() {
            return this._length;
        };
        var shapePool = (factory = poolFactory(4, function() {
            return new ShapePath;
        }, function(t) {
            var e, r1 = t._length;
            for(e = 0; e < r1; e += 1)pointPool.release(t.v[e]), pointPool.release(t.i[e]), pointPool.release(t.o[e]), t.v[e] = null, t.i[e] = null, t.o[e] = null;
            t._length = 0, t.c = !1;
        }), factory.clone = function(t) {
            var e, r1 = factory.newElement(), i = void 0 === t._length ? t.v.length : t._length;
            for(r1.setLength(i), r1.c = t.c, e = 0; e < i; e += 1)r1.setTripleAt(t.v[e][0], t.v[e][1], t.o[e][0], t.o[e][1], t.i[e][0], t.i[e][1], e);
            return r1;
        }, factory), factory;
        function ShapeCollection() {
            this._length = 0, this._maxLength = 4, this.shapes = createSizedArray(this._maxLength);
        }
        ShapeCollection.prototype.addShape = function(t) {
            this._length === this._maxLength && (this.shapes = this.shapes.concat(createSizedArray(this._maxLength)), this._maxLength *= 2), this.shapes[this._length] = t, this._length += 1;
        }, ShapeCollection.prototype.releaseShapes = function() {
            var t;
            for(t = 0; t < this._length; t += 1)shapePool.release(this.shapes[t]);
            this._length = 0;
        };
        var shapeCollectionPool = function() {
            var t = {
                newShapeCollection: function() {
                    return e ? i[e -= 1] : new ShapeCollection;
                },
                release: function(t) {
                    var s, a = t._length;
                    for(s = 0; s < a; s += 1)shapePool.release(t.shapes[s]);
                    t._length = 0, e === r1 && (i = pooling.double(i), r1 *= 2), i[e] = t, e += 1;
                }
            }, e = 0, r1 = 4, i = createSizedArray(r1);
            return t;
        }(), ShapePropertyFactory = function() {
            var t = -999999;
            function e(t, e, r1) {
                var i, s, a, n, o, h, l, p, c, f = r1.lastIndex, u = this.keyframes;
                if (t < u[0].t - this.offsetTime) i = u[0].s[0], a = !0, f = 0;
                else if (t >= u[u.length - 1].t - this.offsetTime) i = u[u.length - 1].s ? u[u.length - 1].s[0] : u[u.length - 2].e[0], a = !0;
                else {
                    for(var d, m, y, g = f, v = u.length - 1, b = !0; b && (d = u[g], !((m = u[g + 1]).t - this.offsetTime > t));)g < v - 1 ? g += 1 : b = !1;
                    if (y = this.keyframesMetadata[g] || {}, f = g, !(a = 1 === d.h)) {
                        if (t >= m.t - this.offsetTime) p = 1;
                        else if (t < d.t - this.offsetTime) p = 0;
                        else {
                            var _;
                            y.__fnct ? _ = y.__fnct : (_ = BezierFactory.getBezierEasing(d.o.x, d.o.y, d.i.x, d.i.y).get, y.__fnct = _), p = _((t - (d.t - this.offsetTime)) / (m.t - this.offsetTime - (d.t - this.offsetTime)));
                        }
                        s = m.s ? m.s[0] : d.e[0];
                    }
                    i = d.s[0];
                }
                for(h = e._length, l = i.i[0].length, r1.lastIndex = f, n = 0; n < h; n += 1)for(o = 0; o < l; o += 1)c = a ? i.i[n][o] : i.i[n][o] + (s.i[n][o] - i.i[n][o]) * p, e.i[n][o] = c, c = a ? i.o[n][o] : i.o[n][o] + (s.o[n][o] - i.o[n][o]) * p, e.o[n][o] = c, c = a ? i.v[n][o] : i.v[n][o] + (s.v[n][o] - i.v[n][o]) * p, e.v[n][o] = c;
            }
            function r1() {
                var e = this.comp.renderedFrame - this.offsetTime, r1 = this.keyframes[0].t - this.offsetTime, i = this.keyframes[this.keyframes.length - 1].t - this.offsetTime, s = this._caching.lastFrame;
                return s !== t && (s < r1 && e < r1 || s > i && e > i) || (this._caching.lastIndex = s < e ? this._caching.lastIndex : 0, this.interpolateShape(e, this.pv, this._caching)), this._caching.lastFrame = e, this.pv;
            }
            function i() {
                this.paths = this.localShapeCollection;
            }
            function s(t) {
                (function(t, e) {
                    if (t._length !== e._length || t.c !== e.c) return !1;
                    var r1, i = t._length;
                    for(r1 = 0; r1 < i; r1 += 1)if (t.v[r1][0] !== e.v[r1][0] || t.v[r1][1] !== e.v[r1][1] || t.o[r1][0] !== e.o[r1][0] || t.o[r1][1] !== e.o[r1][1] || t.i[r1][0] !== e.i[r1][0] || t.i[r1][1] !== e.i[r1][1]) return !1;
                    return !0;
                })(this.v, t) || (this.v = shapePool.clone(t), this.localShapeCollection.releaseShapes(), this.localShapeCollection.addShape(this.v), this._mdf = !0, this.paths = this.localShapeCollection);
            }
            function a() {
                if (this.elem.globalData.frameId !== this.frameId) {
                    if (this.effectsSequence.length) {
                        if (this.lock) this.setVValue(this.pv);
                        else {
                            var t, e;
                            this.lock = !0, this._mdf = !1, t = this.kf ? this.pv : this.data.ks ? this.data.ks.k : this.data.pt.k;
                            var r1 = this.effectsSequence.length;
                            for(e = 0; e < r1; e += 1)t = this.effectsSequence[e](t);
                            this.setVValue(t), this.lock = !1, this.frameId = this.elem.globalData.frameId;
                        }
                    } else this._mdf = !1;
                }
            }
            function n(t, e, r1) {
                this.propType = "shape", this.comp = t.comp, this.container = t, this.elem = t, this.data = e, this.k = !1, this.kf = !1, this._mdf = !1;
                var s = 3 === r1 ? e.pt.k : e.ks.k;
                this.v = shapePool.clone(s), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.reset = i, this.effectsSequence = [];
            }
            function o(t) {
                this.effectsSequence.push(t), this.container.addDynamicProperty(this);
            }
            function h(e, s, a) {
                this.propType = "shape", this.comp = e.comp, this.elem = e, this.container = e, this.offsetTime = e.data.st, this.keyframes = 3 === a ? s.pt.k : s.ks.k, this.keyframesMetadata = [], this.k = !0, this.kf = !0;
                var n = this.keyframes[0].s[0].i.length;
                this.v = shapePool.newElement(), this.v.setPathData(this.keyframes[0].s[0].c, n), this.pv = shapePool.clone(this.v), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.paths.addShape(this.v), this.lastFrame = t, this.reset = i, this._caching = {
                    lastFrame: t,
                    lastIndex: 0
                }, this.effectsSequence = [
                    r1.bind(this)
                ];
            }
            n.prototype.interpolateShape = e, n.prototype.getValue = a, n.prototype.setVValue = s, n.prototype.addEffect = o, h.prototype.getValue = a, h.prototype.interpolateShape = e, h.prototype.setVValue = s, h.prototype.addEffect = o;
            var l = function() {
                var t = roundCorner;
                function e(t, e) {
                    this.v = shapePool.newElement(), this.v.setPathData(!0, 4), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.paths = this.localShapeCollection, this.localShapeCollection.addShape(this.v), this.d = e.d, this.elem = t, this.comp = t.comp, this.frameId = -1, this.initDynamicPropertyContainer(t), this.p = PropertyFactory.getProp(t, e.p, 1, 0, this), this.s = PropertyFactory.getProp(t, e.s, 1, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertEllToPath());
                }
                return e.prototype = {
                    reset: i,
                    getValue: function() {
                        this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertEllToPath());
                    },
                    convertEllToPath: function() {
                        var e = this.p.v[0], r1 = this.p.v[1], i = this.s.v[0] / 2, s = this.s.v[1] / 2, a = 3 !== this.d, n = this.v;
                        n.v[0][0] = e, n.v[0][1] = r1 - s, n.v[1][0] = a ? e + i : e - i, n.v[1][1] = r1, n.v[2][0] = e, n.v[2][1] = r1 + s, n.v[3][0] = a ? e - i : e + i, n.v[3][1] = r1, n.i[0][0] = a ? e - i * t : e + i * t, n.i[0][1] = r1 - s, n.i[1][0] = a ? e + i : e - i, n.i[1][1] = r1 - s * t, n.i[2][0] = a ? e + i * t : e - i * t, n.i[2][1] = r1 + s, n.i[3][0] = a ? e - i : e + i, n.i[3][1] = r1 + s * t, n.o[0][0] = a ? e + i * t : e - i * t, n.o[0][1] = r1 - s, n.o[1][0] = a ? e + i : e - i, n.o[1][1] = r1 + s * t, n.o[2][0] = a ? e - i * t : e + i * t, n.o[2][1] = r1 + s, n.o[3][0] = a ? e - i : e + i, n.o[3][1] = r1 - s * t;
                    }
                }, extendPrototype([
                    DynamicPropertyContainer
                ], e), e;
            }(), p = function() {
                function t(t, e) {
                    this.v = shapePool.newElement(), this.v.setPathData(!0, 0), this.elem = t, this.comp = t.comp, this.data = e, this.frameId = -1, this.d = e.d, this.initDynamicPropertyContainer(t), 1 === e.sy ? (this.ir = PropertyFactory.getProp(t, e.ir, 0, 0, this), this.is = PropertyFactory.getProp(t, e.is, 0, .01, this), this.convertToPath = this.convertStarToPath) : this.convertToPath = this.convertPolygonToPath, this.pt = PropertyFactory.getProp(t, e.pt, 0, 0, this), this.p = PropertyFactory.getProp(t, e.p, 1, 0, this), this.r = PropertyFactory.getProp(t, e.r, 0, degToRads, this), this.or = PropertyFactory.getProp(t, e.or, 0, 0, this), this.os = PropertyFactory.getProp(t, e.os, 0, .01, this), this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertToPath());
                }
                return t.prototype = {
                    reset: i,
                    getValue: function() {
                        this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertToPath());
                    },
                    convertStarToPath: function() {
                        var t, e, r1, i, s = 2 * Math.floor(this.pt.v), a = 2 * Math.PI / s, n = !0, o = this.or.v, h = this.ir.v, l = this.os.v, p = this.is.v, c = 2 * Math.PI * o / (2 * s), f = 2 * Math.PI * h / (2 * s), u = -Math.PI / 2;
                        u += this.r.v;
                        var d = 3 === this.data.d ? -1 : 1;
                        for(this.v._length = 0, t = 0; t < s; t += 1){
                            r1 = n ? l : p, i = n ? c : f;
                            var m = (e = n ? o : h) * Math.cos(u), y = e * Math.sin(u), g = 0 === m && 0 === y ? 0 : y / Math.sqrt(m * m + y * y), v = 0 === m && 0 === y ? 0 : -m / Math.sqrt(m * m + y * y);
                            m += +this.p.v[0], y += +this.p.v[1], this.v.setTripleAt(m, y, m - g * i * r1 * d, y - v * i * r1 * d, m + g * i * r1 * d, y + v * i * r1 * d, t, !0), n = !n, u += a * d;
                        }
                    },
                    convertPolygonToPath: function() {
                        var t, e = Math.floor(this.pt.v), r1 = 2 * Math.PI / e, i = this.or.v, s = this.os.v, a = 2 * Math.PI * i / (4 * e), n = .5 * -Math.PI, o = 3 === this.data.d ? -1 : 1;
                        for(n += this.r.v, this.v._length = 0, t = 0; t < e; t += 1){
                            var h = i * Math.cos(n), l = i * Math.sin(n), p = 0 === h && 0 === l ? 0 : l / Math.sqrt(h * h + l * l), c = 0 === h && 0 === l ? 0 : -h / Math.sqrt(h * h + l * l);
                            h += +this.p.v[0], l += +this.p.v[1], this.v.setTripleAt(h, l, h - p * a * s * o, l - c * a * s * o, h + p * a * s * o, l + c * a * s * o, t, !0), n += r1 * o;
                        }
                        this.paths.length = 0, this.paths[0] = this.v;
                    }
                }, extendPrototype([
                    DynamicPropertyContainer
                ], t), t;
            }(), c = function() {
                function t(t, e) {
                    this.v = shapePool.newElement(), this.v.c = !0, this.localShapeCollection = shapeCollectionPool.newShapeCollection(), this.localShapeCollection.addShape(this.v), this.paths = this.localShapeCollection, this.elem = t, this.comp = t.comp, this.frameId = -1, this.d = e.d, this.initDynamicPropertyContainer(t), this.p = PropertyFactory.getProp(t, e.p, 1, 0, this), this.s = PropertyFactory.getProp(t, e.s, 1, 0, this), this.r = PropertyFactory.getProp(t, e.r, 0, 0, this), this.dynamicProperties.length ? this.k = !0 : (this.k = !1, this.convertRectToPath());
                }
                return t.prototype = {
                    convertRectToPath: function() {
                        var t = this.p.v[0], e = this.p.v[1], r1 = this.s.v[0] / 2, i = this.s.v[1] / 2, s = bmMin(r1, i, this.r.v), a = s * (1 - roundCorner);
                        this.v._length = 0, 2 === this.d || 1 === this.d ? (this.v.setTripleAt(t + r1, e - i + s, t + r1, e - i + s, t + r1, e - i + a, 0, !0), this.v.setTripleAt(t + r1, e + i - s, t + r1, e + i - a, t + r1, e + i - s, 1, !0), 0 !== s ? (this.v.setTripleAt(t + r1 - s, e + i, t + r1 - s, e + i, t + r1 - a, e + i, 2, !0), this.v.setTripleAt(t - r1 + s, e + i, t - r1 + a, e + i, t - r1 + s, e + i, 3, !0), this.v.setTripleAt(t - r1, e + i - s, t - r1, e + i - s, t - r1, e + i - a, 4, !0), this.v.setTripleAt(t - r1, e - i + s, t - r1, e - i + a, t - r1, e - i + s, 5, !0), this.v.setTripleAt(t - r1 + s, e - i, t - r1 + s, e - i, t - r1 + a, e - i, 6, !0), this.v.setTripleAt(t + r1 - s, e - i, t + r1 - a, e - i, t + r1 - s, e - i, 7, !0)) : (this.v.setTripleAt(t - r1, e + i, t - r1 + a, e + i, t - r1, e + i, 2), this.v.setTripleAt(t - r1, e - i, t - r1, e - i + a, t - r1, e - i, 3))) : (this.v.setTripleAt(t + r1, e - i + s, t + r1, e - i + a, t + r1, e - i + s, 0, !0), 0 !== s ? (this.v.setTripleAt(t + r1 - s, e - i, t + r1 - s, e - i, t + r1 - a, e - i, 1, !0), this.v.setTripleAt(t - r1 + s, e - i, t - r1 + a, e - i, t - r1 + s, e - i, 2, !0), this.v.setTripleAt(t - r1, e - i + s, t - r1, e - i + s, t - r1, e - i + a, 3, !0), this.v.setTripleAt(t - r1, e + i - s, t - r1, e + i - a, t - r1, e + i - s, 4, !0), this.v.setTripleAt(t - r1 + s, e + i, t - r1 + s, e + i, t - r1 + a, e + i, 5, !0), this.v.setTripleAt(t + r1 - s, e + i, t + r1 - a, e + i, t + r1 - s, e + i, 6, !0), this.v.setTripleAt(t + r1, e + i - s, t + r1, e + i - s, t + r1, e + i - a, 7, !0)) : (this.v.setTripleAt(t - r1, e - i, t - r1 + a, e - i, t - r1, e - i, 1, !0), this.v.setTripleAt(t - r1, e + i, t - r1, e + i - a, t - r1, e + i, 2, !0), this.v.setTripleAt(t + r1, e + i, t + r1 - a, e + i, t + r1, e + i, 3, !0)));
                    },
                    getValue: function() {
                        this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf && this.convertRectToPath());
                    },
                    reset: i
                }, extendPrototype([
                    DynamicPropertyContainer
                ], t), t;
            }(), f = {
                getShapeProp: function(t, e, r1) {
                    var i;
                    return 3 === r1 || 4 === r1 ? i = (3 === r1 ? e.pt : e.ks).k.length ? new h(t, e, r1) : new n(t, e, r1) : 5 === r1 ? i = new c(t, e) : 6 === r1 ? i = new l(t, e) : 7 === r1 && (i = new p(t, e)), i.k && t.addDynamicProperty(i), i;
                },
                getConstructorFunction: function() {
                    return n;
                },
                getKeyframedConstructorFunction: function() {
                    return h;
                }
            };
            return f;
        }(), Matrix = function() {
            var t = Math.cos, e = Math.sin, r1 = Math.tan, i = Math.round;
            function s() {
                return this.props[0] = 1, this.props[1] = 0, this.props[2] = 0, this.props[3] = 0, this.props[4] = 0, this.props[5] = 1, this.props[6] = 0, this.props[7] = 0, this.props[8] = 0, this.props[9] = 0, this.props[10] = 1, this.props[11] = 0, this.props[12] = 0, this.props[13] = 0, this.props[14] = 0, this.props[15] = 1, this;
            }
            function a(r1) {
                if (0 === r1) return this;
                var i = t(r1), s = e(r1);
                return this._t(i, -s, 0, 0, s, i, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
            }
            function n(r1) {
                if (0 === r1) return this;
                var i = t(r1), s = e(r1);
                return this._t(1, 0, 0, 0, 0, i, -s, 0, 0, s, i, 0, 0, 0, 0, 1);
            }
            function o(r1) {
                if (0 === r1) return this;
                var i = t(r1), s = e(r1);
                return this._t(i, 0, s, 0, 0, 1, 0, 0, -s, 0, i, 0, 0, 0, 0, 1);
            }
            function h(r1) {
                if (0 === r1) return this;
                var i = t(r1), s = e(r1);
                return this._t(i, -s, 0, 0, s, i, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
            }
            function l(t, e) {
                return this._t(1, e, t, 1, 0, 0);
            }
            function p(t, e) {
                return this.shear(r1(t), r1(e));
            }
            function c(i, s) {
                var a = t(s), n = e(s);
                return this._t(a, n, 0, 0, -n, a, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, r1(i), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(a, -n, 0, 0, n, a, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
            }
            function f(t, e, r1) {
                return r1 || 0 === r1 || (r1 = 1), 1 === t && 1 === e && 1 === r1 ? this : this._t(t, 0, 0, 0, 0, e, 0, 0, 0, 0, r1, 0, 0, 0, 0, 1);
            }
            function u(t, e, r1, i, s, a, n, o, h, l, p, c, f, u, d, m) {
                return this.props[0] = t, this.props[1] = e, this.props[2] = r1, this.props[3] = i, this.props[4] = s, this.props[5] = a, this.props[6] = n, this.props[7] = o, this.props[8] = h, this.props[9] = l, this.props[10] = p, this.props[11] = c, this.props[12] = f, this.props[13] = u, this.props[14] = d, this.props[15] = m, this;
            }
            function d(t, e, r1) {
                return r1 = r1 || 0, 0 !== t || 0 !== e || 0 !== r1 ? this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, t, e, r1, 1) : this;
            }
            function m(t, e, r1, i, s, a, n, o, h, l, p, c, f, u, d, m) {
                var y = this.props;
                if (1 === t && 0 === e && 0 === r1 && 0 === i && 0 === s && 1 === a && 0 === n && 0 === o && 0 === h && 0 === l && 1 === p && 0 === c) return y[12] = y[12] * t + y[15] * f, y[13] = y[13] * a + y[15] * u, y[14] = y[14] * p + y[15] * d, y[15] *= m, this._identityCalculated = !1, this;
                var g = y[0], v = y[1], b = y[2], _ = y[3], P = y[4], S = y[5], E = y[6], x = y[7], C = y[8], A = y[9], w = y[10], k = y[11], T = y[12], M = y[13], D = y[14], F = y[15];
                return y[0] = g * t + v * s + b * h + _ * f, y[1] = g * e + v * a + b * l + _ * u, y[2] = g * r1 + v * n + b * p + _ * d, y[3] = g * i + v * o + b * c + _ * m, y[4] = P * t + S * s + E * h + x * f, y[5] = P * e + S * a + E * l + x * u, y[6] = P * r1 + S * n + E * p + x * d, y[7] = P * i + S * o + E * c + x * m, y[8] = C * t + A * s + w * h + k * f, y[9] = C * e + A * a + w * l + k * u, y[10] = C * r1 + A * n + w * p + k * d, y[11] = C * i + A * o + w * c + k * m, y[12] = T * t + M * s + D * h + F * f, y[13] = T * e + M * a + D * l + F * u, y[14] = T * r1 + M * n + D * p + F * d, y[15] = T * i + M * o + D * c + F * m, this._identityCalculated = !1, this;
            }
            function y(t) {
                var e = t.props;
                return this.transform(e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15]);
            }
            function g() {
                return this._identityCalculated || (this._identity = !(1 !== this.props[0] || 0 !== this.props[1] || 0 !== this.props[2] || 0 !== this.props[3] || 0 !== this.props[4] || 1 !== this.props[5] || 0 !== this.props[6] || 0 !== this.props[7] || 0 !== this.props[8] || 0 !== this.props[9] || 1 !== this.props[10] || 0 !== this.props[11] || 0 !== this.props[12] || 0 !== this.props[13] || 0 !== this.props[14] || 1 !== this.props[15]), this._identityCalculated = !0), this._identity;
            }
            function v(t) {
                for(var e = 0; e < 16;){
                    if (t.props[e] !== this.props[e]) return !1;
                    e += 1;
                }
                return !0;
            }
            function b(t) {
                var e;
                for(e = 0; e < 16; e += 1)t.props[e] = this.props[e];
                return t;
            }
            function _(t) {
                var e;
                for(e = 0; e < 16; e += 1)this.props[e] = t[e];
            }
            function P(t, e, r1) {
                return {
                    x: t * this.props[0] + e * this.props[4] + r1 * this.props[8] + this.props[12],
                    y: t * this.props[1] + e * this.props[5] + r1 * this.props[9] + this.props[13],
                    z: t * this.props[2] + e * this.props[6] + r1 * this.props[10] + this.props[14]
                };
            }
            function S(t, e, r1) {
                return t * this.props[0] + e * this.props[4] + r1 * this.props[8] + this.props[12];
            }
            function E(t, e, r1) {
                return t * this.props[1] + e * this.props[5] + r1 * this.props[9] + this.props[13];
            }
            function x(t, e, r1) {
                return t * this.props[2] + e * this.props[6] + r1 * this.props[10] + this.props[14];
            }
            function C() {
                var t = this.props[0] * this.props[5] - this.props[1] * this.props[4], e = this.props[5] / t, r1 = -this.props[1] / t, i = -this.props[4] / t, s = this.props[0] / t, a = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / t, n = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / t, o = new Matrix;
                return o.props[0] = e, o.props[1] = r1, o.props[4] = i, o.props[5] = s, o.props[12] = a, o.props[13] = n, o;
            }
            function A(t) {
                return this.getInverseMatrix().applyToPointArray(t[0], t[1], t[2] || 0);
            }
            function w(t) {
                var e, r1 = t.length, i = [];
                for(e = 0; e < r1; e += 1)i[e] = A(t[e]);
                return i;
            }
            function k(t, e, r1) {
                var i = createTypedArray("float32", 6);
                if (this.isIdentity()) i[0] = t[0], i[1] = t[1], i[2] = e[0], i[3] = e[1], i[4] = r1[0], i[5] = r1[1];
                else {
                    var s = this.props[0], a = this.props[1], n = this.props[4], o = this.props[5], h = this.props[12], l = this.props[13];
                    i[0] = t[0] * s + t[1] * n + h, i[1] = t[0] * a + t[1] * o + l, i[2] = e[0] * s + e[1] * n + h, i[3] = e[0] * a + e[1] * o + l, i[4] = r1[0] * s + r1[1] * n + h, i[5] = r1[0] * a + r1[1] * o + l;
                }
                return i;
            }
            function T(t, e, r1) {
                return this.isIdentity() ? [
                    t,
                    e,
                    r1
                ] : [
                    t * this.props[0] + e * this.props[4] + r1 * this.props[8] + this.props[12],
                    t * this.props[1] + e * this.props[5] + r1 * this.props[9] + this.props[13],
                    t * this.props[2] + e * this.props[6] + r1 * this.props[10] + this.props[14]
                ];
            }
            function M(t, e) {
                if (this.isIdentity()) return t + "," + e;
                var r1 = this.props;
                return Math.round(100 * (t * r1[0] + e * r1[4] + r1[12])) / 100 + "," + Math.round(100 * (t * r1[1] + e * r1[5] + r1[13])) / 100;
            }
            function D() {
                for(var t = 0, e = this.props, r1 = "matrix3d("; t < 16;)r1 += i(1e4 * e[t]) / 1e4, r1 += 15 === t ? ")" : ",", t += 1;
                return r1;
            }
            function F(t) {
                return t < 1e-6 && t > 0 || t > -0.000001 && t < 0 ? i(1e4 * t) / 1e4 : t;
            }
            function I() {
                var t = this.props;
                return "matrix(" + F(t[0]) + "," + F(t[1]) + "," + F(t[4]) + "," + F(t[5]) + "," + F(t[12]) + "," + F(t[13]) + ")";
            }
            return function() {
                this.reset = s, this.rotate = a, this.rotateX = n, this.rotateY = o, this.rotateZ = h, this.skew = p, this.skewFromAxis = c, this.shear = l, this.scale = f, this.setTransform = u, this.translate = d, this.transform = m, this.multiply = y, this.applyToPoint = P, this.applyToX = S, this.applyToY = E, this.applyToZ = x, this.applyToPointArray = T, this.applyToTriplePoints = k, this.applyToPointStringified = M, this.toCSS = D, this.to2dCSS = I, this.clone = b, this.cloneFromProps = _, this.equals = v, this.inversePoints = w, this.inversePoint = A, this.getInverseMatrix = C, this._t = this.transform, this.isIdentity = g, this._identity = !0, this._identityCalculated = !1, this.props = createTypedArray("float32", 16), this.reset();
            };
        }();
        function _typeof$3(t) {
            return _typeof$3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, _typeof$3(t);
        }
        var lottie = {}, standalone = "__[STANDALONE]__", animationData = "__[ANIMATIONDATA]__", renderer = "";
        function setLocation(t) {
            setLocationHref(t);
        }
        function searchAnimations() {
            !0 === standalone ? animationManager.searchAnimations(animationData, standalone, renderer) : animationManager.searchAnimations();
        }
        function setSubframeRendering(t) {
            setSubframeEnabled(t);
        }
        function setPrefix(t) {
            setIdPrefix(t);
        }
        function loadAnimation(t) {
            return !0 === standalone && (t.animationData = JSON.parse(animationData)), animationManager.loadAnimation(t);
        }
        function setQuality(t) {
            if ("string" == typeof t) switch(t){
                case "high":
                    setDefaultCurveSegments(200);
                    break;
                default:
                case "medium":
                    setDefaultCurveSegments(50);
                    break;
                case "low":
                    setDefaultCurveSegments(10);
            }
            else !isNaN(t) && t > 1 && setDefaultCurveSegments(t);
            getDefaultCurveSegments() >= 50 ? roundValues(!1) : roundValues(!0);
        }
        function inBrowser() {
            return "undefined" != typeof navigator;
        }
        function installPlugin(t, e) {
            "expressions" === t && setExpressionsPlugin(e);
        }
        function getFactory(t) {
            switch(t){
                case "propertyFactory":
                    return PropertyFactory;
                case "shapePropertyFactory":
                    return ShapePropertyFactory;
                case "matrix":
                    return Matrix;
                default:
                    return null;
            }
        }
        function checkReady() {
            "complete" === document.readyState && (clearInterval(readyStateCheckInterval), searchAnimations());
        }
        function getQueryVariable(t) {
            for(var e = queryString.split("&"), r1 = 0; r1 < e.length; r1 += 1){
                var i = e[r1].split("=");
                if (decodeURIComponent(i[0]) == t) return decodeURIComponent(i[1]);
            }
            return null;
        }
        lottie.play = animationManager.play, lottie.pause = animationManager.pause, lottie.setLocationHref = setLocation, lottie.togglePause = animationManager.togglePause, lottie.setSpeed = animationManager.setSpeed, lottie.setDirection = animationManager.setDirection, lottie.stop = animationManager.stop, lottie.searchAnimations = searchAnimations, lottie.registerAnimation = animationManager.registerAnimation, lottie.loadAnimation = loadAnimation, lottie.setSubframeRendering = setSubframeRendering, lottie.resize = animationManager.resize, lottie.goToAndStop = animationManager.goToAndStop, lottie.destroy = animationManager.destroy, lottie.setQuality = setQuality, lottie.inBrowser = inBrowser, lottie.installPlugin = installPlugin, lottie.freeze = animationManager.freeze, lottie.unfreeze = animationManager.unfreeze, lottie.setVolume = animationManager.setVolume, lottie.mute = animationManager.mute, lottie.unmute = animationManager.unmute, lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations, lottie.useWebWorker = setWebWorker, lottie.setIDPrefix = setPrefix, lottie.__getFactory = getFactory, lottie.version = "5.12.2";
        var queryString = "";
        if (standalone) {
            var scripts = document.getElementsByTagName("script"), index = scripts.length - 1, myScript = scripts[index] || {
                src: ""
            };
            queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, "") : "", renderer = getQueryVariable("renderer");
        }
        var readyStateCheckInterval = setInterval(checkReady, 100);
        try {
            "object" !== _typeof$3(exports) && (window.bodymovin = lottie);
        } catch (t) {}
        var ShapeModifiers = function() {
            var t = {}, e = {};
            return t.registerModifier = function(t, r1) {
                e[t] || (e[t] = r1);
            }, t.getModifier = function(t, r1, i) {
                return new e[t](r1, i);
            }, t;
        }();
        function ShapeModifier() {}
        function TrimModifier() {}
        function PuckerAndBloatModifier() {}
        ShapeModifier.prototype.initModifierProperties = function() {}, ShapeModifier.prototype.addShapeToModifier = function() {}, ShapeModifier.prototype.addShape = function(t) {
            if (!this.closed) {
                t.sh.container.addDynamicProperty(t.sh);
                var e = {
                    shape: t.sh,
                    data: t,
                    localShapeCollection: shapeCollectionPool.newShapeCollection()
                };
                this.shapes.push(e), this.addShapeToModifier(e), this._isAnimated && t.setAsAnimated();
            }
        }, ShapeModifier.prototype.init = function(t, e) {
            this.shapes = [], this.elem = t, this.initDynamicPropertyContainer(t), this.initModifierProperties(t, e), this.frameId = initialDefaultFrame, this.closed = !1, this.k = !1, this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
        }, ShapeModifier.prototype.processKeys = function() {
            this.elem.globalData.frameId !== this.frameId && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties());
        }, extendPrototype([
            DynamicPropertyContainer
        ], ShapeModifier), extendPrototype([
            ShapeModifier
        ], TrimModifier), TrimModifier.prototype.initModifierProperties = function(t, e) {
            this.s = PropertyFactory.getProp(t, e.s, 0, .01, this), this.e = PropertyFactory.getProp(t, e.e, 0, .01, this), this.o = PropertyFactory.getProp(t, e.o, 0, 0, this), this.sValue = 0, this.eValue = 0, this.getValue = this.processKeys, this.m = e.m, this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
        }, TrimModifier.prototype.addShapeToModifier = function(t) {
            t.pathsData = [];
        }, TrimModifier.prototype.calculateShapeEdges = function(t, e, r1, i, s) {
            var a = [];
            e <= 1 ? a.push({
                s: t,
                e: e
            }) : t >= 1 ? a.push({
                s: t - 1,
                e: e - 1
            }) : (a.push({
                s: t,
                e: 1
            }), a.push({
                s: 0,
                e: e - 1
            }));
            var n, o, h = [], l = a.length;
            for(n = 0; n < l; n += 1){
                var p, c;
                (o = a[n]).e * s < i || o.s * s > i + r1 || (p = o.s * s <= i ? 0 : (o.s * s - i) / r1, c = o.e * s >= i + r1 ? 1 : (o.e * s - i) / r1, h.push([
                    p,
                    c
                ]));
            }
            return h.length || h.push([
                0,
                0
            ]), h;
        }, TrimModifier.prototype.releasePathsData = function(t) {
            var e, r1 = t.length;
            for(e = 0; e < r1; e += 1)segmentsLengthPool.release(t[e]);
            return t.length = 0, t;
        }, TrimModifier.prototype.processShapes = function(t) {
            var e, r1, i, s;
            if (this._mdf || t) {
                var a = this.o.v % 360 / 360;
                if (a < 0 && (a += 1), (e = this.s.v > 1 ? 1 + a : this.s.v < 0 ? 0 + a : this.s.v + a) > (r1 = this.e.v > 1 ? 1 + a : this.e.v < 0 ? 0 + a : this.e.v + a)) {
                    var n = e;
                    e = r1, r1 = n;
                }
                e = 1e-4 * Math.round(1e4 * e), r1 = 1e-4 * Math.round(1e4 * r1), this.sValue = e, this.eValue = r1;
            } else e = this.sValue, r1 = this.eValue;
            var o, h, l, p, c, f = this.shapes.length, u = 0;
            if (r1 === e) for(s = 0; s < f; s += 1)this.shapes[s].localShapeCollection.releaseShapes(), this.shapes[s].shape._mdf = !0, this.shapes[s].shape.paths = this.shapes[s].localShapeCollection, this._mdf && (this.shapes[s].pathsData.length = 0);
            else if (1 === r1 && 0 === e || 0 === r1 && 1 === e) {
                if (this._mdf) for(s = 0; s < f; s += 1)this.shapes[s].pathsData.length = 0, this.shapes[s].shape._mdf = !0;
            } else {
                var d, m, y = [];
                for(s = 0; s < f; s += 1)if ((d = this.shapes[s]).shape._mdf || this._mdf || t || 2 === this.m) {
                    if (h = (i = d.shape.paths)._length, c = 0, !d.shape._mdf && d.pathsData.length) c = d.totalShapeLength;
                    else {
                        for(l = this.releasePathsData(d.pathsData), o = 0; o < h; o += 1)p = bez.getSegmentsLength(i.shapes[o]), l.push(p), c += p.totalLength;
                        d.totalShapeLength = c, d.pathsData = l;
                    }
                    u += c, d.shape._mdf = !0;
                } else d.shape.paths = d.localShapeCollection;
                var g, v = e, b = r1, _ = 0;
                for(s = f - 1; s >= 0; s -= 1)if ((d = this.shapes[s]).shape._mdf) {
                    for((m = d.localShapeCollection).releaseShapes(), 2 === this.m && f > 1 ? (g = this.calculateShapeEdges(e, r1, d.totalShapeLength, _, u), _ += d.totalShapeLength) : g = [
                        [
                            v,
                            b
                        ]
                    ], h = g.length, o = 0; o < h; o += 1){
                        v = g[o][0], b = g[o][1], y.length = 0, b <= 1 ? y.push({
                            s: d.totalShapeLength * v,
                            e: d.totalShapeLength * b
                        }) : v >= 1 ? y.push({
                            s: d.totalShapeLength * (v - 1),
                            e: d.totalShapeLength * (b - 1)
                        }) : (y.push({
                            s: d.totalShapeLength * v,
                            e: d.totalShapeLength
                        }), y.push({
                            s: 0,
                            e: d.totalShapeLength * (b - 1)
                        }));
                        var P = this.addShapes(d, y[0]);
                        if (y[0].s !== y[0].e) {
                            if (y.length > 1) {
                                if (d.shape.paths.shapes[d.shape.paths._length - 1].c) {
                                    var S = P.pop();
                                    this.addPaths(P, m), P = this.addShapes(d, y[1], S);
                                } else this.addPaths(P, m), P = this.addShapes(d, y[1]);
                            }
                            this.addPaths(P, m);
                        }
                    }
                    d.shape.paths = m;
                }
            }
        }, TrimModifier.prototype.addPaths = function(t, e) {
            var r1, i = t.length;
            for(r1 = 0; r1 < i; r1 += 1)e.addShape(t[r1]);
        }, TrimModifier.prototype.addSegment = function(t, e, r1, i, s, a, n) {
            s.setXYAt(e[0], e[1], "o", a), s.setXYAt(r1[0], r1[1], "i", a + 1), n && s.setXYAt(t[0], t[1], "v", a), s.setXYAt(i[0], i[1], "v", a + 1);
        }, TrimModifier.prototype.addSegmentFromArray = function(t, e, r1, i) {
            e.setXYAt(t[1], t[5], "o", r1), e.setXYAt(t[2], t[6], "i", r1 + 1), i && e.setXYAt(t[0], t[4], "v", r1), e.setXYAt(t[3], t[7], "v", r1 + 1);
        }, TrimModifier.prototype.addShapes = function(t, e, r1) {
            var i, s, a, n, o, h, l, p, c = t.pathsData, f = t.shape.paths.shapes, u = t.shape.paths._length, d = 0, m = [], y = !0;
            for(r1 ? (o = r1._length, p = r1._length) : (r1 = shapePool.newElement(), o = 0, p = 0), m.push(r1), i = 0; i < u; i += 1){
                for(h = c[i].lengths, r1.c = f[i].c, a = f[i].c ? h.length : h.length + 1, s = 1; s < a; s += 1)if (d + (n = h[s - 1]).addedLength < e.s) d += n.addedLength, r1.c = !1;
                else {
                    if (d > e.e) {
                        r1.c = !1;
                        break;
                    }
                    e.s <= d && e.e >= d + n.addedLength ? (this.addSegment(f[i].v[s - 1], f[i].o[s - 1], f[i].i[s], f[i].v[s], r1, o, y), y = !1) : (l = bez.getNewSegment(f[i].v[s - 1], f[i].v[s], f[i].o[s - 1], f[i].i[s], (e.s - d) / n.addedLength, (e.e - d) / n.addedLength, h[s - 1]), this.addSegmentFromArray(l, r1, o, y), y = !1, r1.c = !1), d += n.addedLength, o += 1;
                }
                if (f[i].c && h.length) {
                    if (n = h[s - 1], d <= e.e) {
                        var g = h[s - 1].addedLength;
                        e.s <= d && e.e >= d + g ? (this.addSegment(f[i].v[s - 1], f[i].o[s - 1], f[i].i[0], f[i].v[0], r1, o, y), y = !1) : (l = bez.getNewSegment(f[i].v[s - 1], f[i].v[0], f[i].o[s - 1], f[i].i[0], (e.s - d) / g, (e.e - d) / g, h[s - 1]), this.addSegmentFromArray(l, r1, o, y), y = !1, r1.c = !1);
                    } else r1.c = !1;
                    d += n.addedLength, o += 1;
                }
                if (r1._length && (r1.setXYAt(r1.v[p][0], r1.v[p][1], "i", p), r1.setXYAt(r1.v[r1._length - 1][0], r1.v[r1._length - 1][1], "o", r1._length - 1)), d > e.e) break;
                i < u - 1 && (r1 = shapePool.newElement(), y = !0, m.push(r1), o = 0);
            }
            return m;
        }, extendPrototype([
            ShapeModifier
        ], PuckerAndBloatModifier), PuckerAndBloatModifier.prototype.initModifierProperties = function(t, e) {
            this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(t, e.a, 0, null, this), this._isAnimated = !!this.amount.effectsSequence.length;
        }, PuckerAndBloatModifier.prototype.processPath = function(t, e) {
            var r1 = e / 100, i = [
                0,
                0
            ], s = t._length, a = 0;
            for(a = 0; a < s; a += 1)i[0] += t.v[a][0], i[1] += t.v[a][1];
            i[0] /= s, i[1] /= s;
            var n, o, h, l, p, c, f = shapePool.newElement();
            for(f.c = t.c, a = 0; a < s; a += 1)n = t.v[a][0] + (i[0] - t.v[a][0]) * r1, o = t.v[a][1] + (i[1] - t.v[a][1]) * r1, h = t.o[a][0] + (i[0] - t.o[a][0]) * -r1, l = t.o[a][1] + (i[1] - t.o[a][1]) * -r1, p = t.i[a][0] + (i[0] - t.i[a][0]) * -r1, c = t.i[a][1] + (i[1] - t.i[a][1]) * -r1, f.setTripleAt(n, o, h, l, p, c, a);
            return f;
        }, PuckerAndBloatModifier.prototype.processShapes = function(t) {
            var e, r1, i, s, a, n, o = this.shapes.length, h = this.amount.v;
            if (0 !== h) for(r1 = 0; r1 < o; r1 += 1){
                if (n = (a = this.shapes[r1]).localShapeCollection, a.shape._mdf || this._mdf || t) for(n.releaseShapes(), a.shape._mdf = !0, e = a.shape.paths.shapes, s = a.shape.paths._length, i = 0; i < s; i += 1)n.addShape(this.processPath(e[i], h));
                a.shape.paths = a.localShapeCollection;
            }
            this.dynamicProperties.length || (this._mdf = !1);
        };
        var TransformPropertyFactory = function() {
            var t = [
                0,
                0
            ];
            function e(t, e, r1) {
                if (this.elem = t, this.frameId = -1, this.propType = "transform", this.data = e, this.v = new Matrix, this.pre = new Matrix, this.appliedTransformations = 0, this.initDynamicPropertyContainer(r1 || t), e.p && e.p.s ? (this.px = PropertyFactory.getProp(t, e.p.x, 0, 0, this), this.py = PropertyFactory.getProp(t, e.p.y, 0, 0, this), e.p.z && (this.pz = PropertyFactory.getProp(t, e.p.z, 0, 0, this))) : this.p = PropertyFactory.getProp(t, e.p || {
                    k: [
                        0,
                        0,
                        0
                    ]
                }, 1, 0, this), e.rx) {
                    if (this.rx = PropertyFactory.getProp(t, e.rx, 0, degToRads, this), this.ry = PropertyFactory.getProp(t, e.ry, 0, degToRads, this), this.rz = PropertyFactory.getProp(t, e.rz, 0, degToRads, this), e.or.k[0].ti) {
                        var i, s = e.or.k.length;
                        for(i = 0; i < s; i += 1)e.or.k[i].to = null, e.or.k[i].ti = null;
                    }
                    this.or = PropertyFactory.getProp(t, e.or, 1, degToRads, this), this.or.sh = !0;
                } else this.r = PropertyFactory.getProp(t, e.r || {
                    k: 0
                }, 0, degToRads, this);
                e.sk && (this.sk = PropertyFactory.getProp(t, e.sk, 0, degToRads, this), this.sa = PropertyFactory.getProp(t, e.sa, 0, degToRads, this)), this.a = PropertyFactory.getProp(t, e.a || {
                    k: [
                        0,
                        0,
                        0
                    ]
                }, 1, 0, this), this.s = PropertyFactory.getProp(t, e.s || {
                    k: [
                        100,
                        100,
                        100
                    ]
                }, 1, .01, this), e.o ? this.o = PropertyFactory.getProp(t, e.o, 0, .01, t) : this.o = {
                    _mdf: !1,
                    v: 1
                }, this._isDirty = !0, this.dynamicProperties.length || this.getValue(!0);
            }
            return e.prototype = {
                applyToMatrix: function(t) {
                    var e = this._mdf;
                    this.iterateDynamicProperties(), this._mdf = this._mdf || e, this.a && t.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.s && t.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && t.skewFromAxis(-this.sk.v, this.sa.v), this.r ? t.rotate(-this.r.v) : t.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.data.p.s ? this.data.p.z ? t.translate(this.px.v, this.py.v, -this.pz.v) : t.translate(this.px.v, this.py.v, 0) : t.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
                },
                getValue: function(e) {
                    if (this.elem.globalData.frameId !== this.frameId) {
                        if (this._isDirty && (this.precalculateMatrix(), this._isDirty = !1), this.iterateDynamicProperties(), this._mdf || e) {
                            var r1;
                            if (this.v.cloneFromProps(this.pre.props), this.appliedTransformations < 1 && this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations < 2 && this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.sk && this.appliedTransformations < 3 && this.v.skewFromAxis(-this.sk.v, this.sa.v), this.r && this.appliedTransformations < 4 ? this.v.rotate(-this.r.v) : !this.r && this.appliedTransformations < 4 && this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.autoOriented) {
                                var i, s;
                                if (r1 = this.elem.globalData.frameRate, this.p && this.p.keyframes && this.p.getValueAtTime) this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t ? (i = this.p.getValueAtTime((this.p.keyframes[0].t + .01) / r1, 0), s = this.p.getValueAtTime(this.p.keyframes[0].t / r1, 0)) : this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t ? (i = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / r1, 0), s = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - .05) / r1, 0)) : (i = this.p.pv, s = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - .01) / r1, this.p.offsetTime));
                                else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
                                    i = [], s = [];
                                    var a = this.px, n = this.py;
                                    a._caching.lastFrame + a.offsetTime <= a.keyframes[0].t ? (i[0] = a.getValueAtTime((a.keyframes[0].t + .01) / r1, 0), i[1] = n.getValueAtTime((n.keyframes[0].t + .01) / r1, 0), s[0] = a.getValueAtTime(a.keyframes[0].t / r1, 0), s[1] = n.getValueAtTime(n.keyframes[0].t / r1, 0)) : a._caching.lastFrame + a.offsetTime >= a.keyframes[a.keyframes.length - 1].t ? (i[0] = a.getValueAtTime(a.keyframes[a.keyframes.length - 1].t / r1, 0), i[1] = n.getValueAtTime(n.keyframes[n.keyframes.length - 1].t / r1, 0), s[0] = a.getValueAtTime((a.keyframes[a.keyframes.length - 1].t - .01) / r1, 0), s[1] = n.getValueAtTime((n.keyframes[n.keyframes.length - 1].t - .01) / r1, 0)) : (i = [
                                        a.pv,
                                        n.pv
                                    ], s[0] = a.getValueAtTime((a._caching.lastFrame + a.offsetTime - .01) / r1, a.offsetTime), s[1] = n.getValueAtTime((n._caching.lastFrame + n.offsetTime - .01) / r1, n.offsetTime));
                                } else i = s = t;
                                this.v.rotate(-Math.atan2(i[1] - s[1], i[0] - s[0]));
                            }
                            this.data.p && this.data.p.s ? this.data.p.z ? this.v.translate(this.px.v, this.py.v, -this.pz.v) : this.v.translate(this.px.v, this.py.v, 0) : this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
                        }
                        this.frameId = this.elem.globalData.frameId;
                    }
                },
                precalculateMatrix: function() {
                    if (this.appliedTransformations = 0, this.pre.reset(), !this.a.effectsSequence.length && (this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]), this.appliedTransformations = 1, !this.s.effectsSequence.length)) {
                        if (this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]), this.appliedTransformations = 2, this.sk) {
                            if (this.sk.effectsSequence.length || this.sa.effectsSequence.length) return;
                            this.pre.skewFromAxis(-this.sk.v, this.sa.v), this.appliedTransformations = 3;
                        }
                        this.r ? this.r.effectsSequence.length || (this.pre.rotate(-this.r.v), this.appliedTransformations = 4) : this.rz.effectsSequence.length || this.ry.effectsSequence.length || this.rx.effectsSequence.length || this.or.effectsSequence.length || (this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]), this.appliedTransformations = 4);
                    }
                },
                autoOrient: function() {}
            }, extendPrototype([
                DynamicPropertyContainer
            ], e), e.prototype.addDynamicProperty = function(t) {
                this._addDynamicProperty(t), this.elem.addDynamicProperty(t), this._isDirty = !0;
            }, e.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty, {
                getTransformProperty: function(t, r1, i) {
                    return new e(t, r1, i);
                }
            };
        }();
        function RepeaterModifier() {}
        function RoundCornersModifier() {}
        function floatEqual(t, e) {
            return 1e5 * Math.abs(t - e) <= Math.min(Math.abs(t), Math.abs(e));
        }
        function floatZero(t) {
            return Math.abs(t) <= 1e-5;
        }
        function lerp(t, e, r1) {
            return t * (1 - r1) + e * r1;
        }
        function lerpPoint(t, e, r1) {
            return [
                lerp(t[0], e[0], r1),
                lerp(t[1], e[1], r1)
            ];
        }
        function quadRoots(t, e, r1) {
            if (0 === t) return [];
            var i = e * e - 4 * t * r1;
            if (i < 0) return [];
            var s = -e / (2 * t);
            if (0 === i) return [
                s
            ];
            var a = Math.sqrt(i) / (2 * t);
            return [
                s - a,
                s + a
            ];
        }
        function polynomialCoefficients(t, e, r1, i) {
            return [
                3 * e - t - 3 * r1 + i,
                3 * t - 6 * e + 3 * r1,
                -3 * t + 3 * e,
                t
            ];
        }
        function singlePoint(t) {
            return new PolynomialBezier(t, t, t, t, !1);
        }
        function PolynomialBezier(t, e, r1, i, s) {
            s && pointEqual(t, e) && (e = lerpPoint(t, i, 1 / 3)), s && pointEqual(r1, i) && (r1 = lerpPoint(t, i, 2 / 3));
            var a = polynomialCoefficients(t[0], e[0], r1[0], i[0]), n = polynomialCoefficients(t[1], e[1], r1[1], i[1]);
            this.a = [
                a[0],
                n[0]
            ], this.b = [
                a[1],
                n[1]
            ], this.c = [
                a[2],
                n[2]
            ], this.d = [
                a[3],
                n[3]
            ], this.points = [
                t,
                e,
                r1,
                i
            ];
        }
        function extrema(t, e) {
            var r1 = t.points[0][e], i = t.points[t.points.length - 1][e];
            if (r1 > i) {
                var s = i;
                i = r1, r1 = s;
            }
            for(var a = quadRoots(3 * t.a[e], 2 * t.b[e], t.c[e]), n = 0; n < a.length; n += 1)if (a[n] > 0 && a[n] < 1) {
                var o = t.point(a[n])[e];
                o < r1 ? r1 = o : o > i && (i = o);
            }
            return {
                min: r1,
                max: i
            };
        }
        function intersectData(t, e, r1) {
            var i = t.boundingBox();
            return {
                cx: i.cx,
                cy: i.cy,
                width: i.width,
                height: i.height,
                bez: t,
                t: (e + r1) / 2,
                t1: e,
                t2: r1
            };
        }
        function splitData(t) {
            var e = t.bez.split(.5);
            return [
                intersectData(e[0], t.t1, t.t),
                intersectData(e[1], t.t, t.t2)
            ];
        }
        function boxIntersect(t, e) {
            return 2 * Math.abs(t.cx - e.cx) < t.width + e.width && 2 * Math.abs(t.cy - e.cy) < t.height + e.height;
        }
        function intersectsImpl(t, e, r1, i, s, a) {
            if (boxIntersect(t, e)) {
                if (r1 >= a || t.width <= i && t.height <= i && e.width <= i && e.height <= i) s.push([
                    t.t,
                    e.t
                ]);
                else {
                    var n = splitData(t), o = splitData(e);
                    intersectsImpl(n[0], o[0], r1 + 1, i, s, a), intersectsImpl(n[0], o[1], r1 + 1, i, s, a), intersectsImpl(n[1], o[0], r1 + 1, i, s, a), intersectsImpl(n[1], o[1], r1 + 1, i, s, a);
                }
            }
        }
        function crossProduct(t, e) {
            return [
                t[1] * e[2] - t[2] * e[1],
                t[2] * e[0] - t[0] * e[2],
                t[0] * e[1] - t[1] * e[0]
            ];
        }
        function lineIntersection(t, e, r1, i) {
            var s = [
                t[0],
                t[1],
                1
            ], a = [
                e[0],
                e[1],
                1
            ], n = [
                r1[0],
                r1[1],
                1
            ], o = [
                i[0],
                i[1],
                1
            ], h = crossProduct(crossProduct(s, a), crossProduct(n, o));
            return floatZero(h[2]) ? null : [
                h[0] / h[2],
                h[1] / h[2]
            ];
        }
        function polarOffset(t, e, r1) {
            return [
                t[0] + Math.cos(e) * r1,
                t[1] - Math.sin(e) * r1
            ];
        }
        function pointDistance(t, e) {
            return Math.hypot(t[0] - e[0], t[1] - e[1]);
        }
        function pointEqual(t, e) {
            return floatEqual(t[0], e[0]) && floatEqual(t[1], e[1]);
        }
        function ZigZagModifier() {}
        function setPoint(t, e, r1, i, s, a, n) {
            var o = r1 - Math.PI / 2, h = r1 + Math.PI / 2, l = e[0] + Math.cos(r1) * i * s, p = e[1] - Math.sin(r1) * i * s;
            t.setTripleAt(l, p, l + Math.cos(o) * a, p - Math.sin(o) * a, l + Math.cos(h) * n, p - Math.sin(h) * n, t.length());
        }
        function getPerpendicularVector(t, e) {
            var r1 = [
                e[0] - t[0],
                e[1] - t[1]
            ], i = .5 * -Math.PI;
            return [
                Math.cos(i) * r1[0] - Math.sin(i) * r1[1],
                Math.sin(i) * r1[0] + Math.cos(i) * r1[1]
            ];
        }
        function getProjectingAngle(t, e) {
            var r1 = 0 === e ? t.length() - 1 : e - 1, i = (e + 1) % t.length(), s = getPerpendicularVector(t.v[r1], t.v[i]);
            return Math.atan2(0, 1) - Math.atan2(s[1], s[0]);
        }
        function zigZagCorner(t, e, r1, i, s, a, n) {
            var o = getProjectingAngle(e, r1), h = e.v[r1 % e._length], l = e.v[0 === r1 ? e._length - 1 : r1 - 1], p = e.v[(r1 + 1) % e._length], c = 2 === a ? Math.sqrt(Math.pow(h[0] - l[0], 2) + Math.pow(h[1] - l[1], 2)) : 0, f = 2 === a ? Math.sqrt(Math.pow(h[0] - p[0], 2) + Math.pow(h[1] - p[1], 2)) : 0;
            setPoint(t, e.v[r1 % e._length], o, n, i, f / (2 * (s + 1)), c / (2 * (s + 1)), a);
        }
        function zigZagSegment(t, e, r1, i, s, a) {
            for(var n = 0; n < i; n += 1){
                var o = (n + 1) / (i + 1), h = 2 === s ? Math.sqrt(Math.pow(e.points[3][0] - e.points[0][0], 2) + Math.pow(e.points[3][1] - e.points[0][1], 2)) : 0, l = e.normalAngle(o);
                setPoint(t, e.point(o), l, a, r1, h / (2 * (i + 1)), h / (2 * (i + 1)), s), a = -a;
            }
            return a;
        }
        function linearOffset(t, e, r1) {
            var i = Math.atan2(e[0] - t[0], e[1] - t[1]);
            return [
                polarOffset(t, i, r1),
                polarOffset(e, i, r1)
            ];
        }
        function offsetSegment(t, e) {
            var r1, i, s, a, n, o, h;
            r1 = (h = linearOffset(t.points[0], t.points[1], e))[0], i = h[1], s = (h = linearOffset(t.points[1], t.points[2], e))[0], a = h[1], n = (h = linearOffset(t.points[2], t.points[3], e))[0], o = h[1];
            var l = lineIntersection(r1, i, s, a);
            null === l && (l = i);
            var p = lineIntersection(n, o, s, a);
            return null === p && (p = n), new PolynomialBezier(r1, l, p, o);
        }
        function joinLines(t, e, r1, i, s) {
            var a = e.points[3], n = r1.points[0];
            if (3 === i) return a;
            if (pointEqual(a, n)) return a;
            if (2 === i) {
                var o = -e.tangentAngle(1), h = -r1.tangentAngle(0) + Math.PI, l = lineIntersection(a, polarOffset(a, o + Math.PI / 2, 100), n, polarOffset(n, o + Math.PI / 2, 100)), p = l ? pointDistance(l, a) : pointDistance(a, n) / 2, c = polarOffset(a, o, 2 * p * roundCorner);
                return t.setXYAt(c[0], c[1], "o", t.length() - 1), c = polarOffset(n, h, 2 * p * roundCorner), t.setTripleAt(n[0], n[1], n[0], n[1], c[0], c[1], t.length()), n;
            }
            var f = lineIntersection(pointEqual(a, e.points[2]) ? e.points[0] : e.points[2], a, n, pointEqual(n, r1.points[1]) ? r1.points[3] : r1.points[1]);
            return f && pointDistance(f, a) < s ? (t.setTripleAt(f[0], f[1], f[0], f[1], f[0], f[1], t.length()), f) : a;
        }
        function getIntersection(t, e) {
            var r1 = t.intersections(e);
            return r1.length && floatEqual(r1[0][0], 1) && r1.shift(), r1.length ? r1[0] : null;
        }
        function pruneSegmentIntersection(t, e) {
            var r1 = t.slice(), i = e.slice(), s = getIntersection(t[t.length - 1], e[0]);
            return s && (r1[t.length - 1] = t[t.length - 1].split(s[0])[0], i[0] = e[0].split(s[1])[1]), t.length > 1 && e.length > 1 && (s = getIntersection(t[0], e[e.length - 1])) ? [
                [
                    t[0].split(s[0])[0]
                ],
                [
                    e[e.length - 1].split(s[1])[1]
                ]
            ] : [
                r1,
                i
            ];
        }
        function pruneIntersections(t) {
            for(var e, r1 = 1; r1 < t.length; r1 += 1)e = pruneSegmentIntersection(t[r1 - 1], t[r1]), t[r1 - 1] = e[0], t[r1] = e[1];
            return t.length > 1 && (e = pruneSegmentIntersection(t[t.length - 1], t[0]), t[t.length - 1] = e[0], t[0] = e[1]), t;
        }
        function offsetSegmentSplit(t, e) {
            var r1, i, s, a, n = t.inflectionPoints();
            if (0 === n.length) return [
                offsetSegment(t, e)
            ];
            if (1 === n.length || floatEqual(n[1], 1)) return r1 = (s = t.split(n[0]))[0], i = s[1], [
                offsetSegment(r1, e),
                offsetSegment(i, e)
            ];
            r1 = (s = t.split(n[0]))[0];
            var o = (n[1] - n[0]) / (1 - n[0]);
            return a = (s = s[1].split(o))[0], i = s[1], [
                offsetSegment(r1, e),
                offsetSegment(a, e),
                offsetSegment(i, e)
            ];
        }
        function OffsetPathModifier() {}
        function getFontProperties(t) {
            for(var e = t.fStyle ? t.fStyle.split(" ") : [], r1 = "normal", i = "normal", s = e.length, a = 0; a < s; a += 1)switch(e[a].toLowerCase()){
                case "italic":
                    i = "italic";
                    break;
                case "bold":
                    r1 = "700";
                    break;
                case "black":
                    r1 = "900";
                    break;
                case "medium":
                    r1 = "500";
                    break;
                case "regular":
                case "normal":
                    r1 = "400";
                    break;
                case "light":
                case "thin":
                    r1 = "200";
            }
            return {
                style: i,
                weight: t.fWeight || r1
            };
        }
        extendPrototype([
            ShapeModifier
        ], RepeaterModifier), RepeaterModifier.prototype.initModifierProperties = function(t, e) {
            this.getValue = this.processKeys, this.c = PropertyFactory.getProp(t, e.c, 0, null, this), this.o = PropertyFactory.getProp(t, e.o, 0, null, this), this.tr = TransformPropertyFactory.getTransformProperty(t, e.tr, this), this.so = PropertyFactory.getProp(t, e.tr.so, 0, .01, this), this.eo = PropertyFactory.getProp(t, e.tr.eo, 0, .01, this), this.data = e, this.dynamicProperties.length || this.getValue(!0), this._isAnimated = !!this.dynamicProperties.length, this.pMatrix = new Matrix, this.rMatrix = new Matrix, this.sMatrix = new Matrix, this.tMatrix = new Matrix, this.matrix = new Matrix;
        }, RepeaterModifier.prototype.applyTransforms = function(t, e, r1, i, s, a) {
            var n = a ? -1 : 1, o = i.s.v[0] + (1 - i.s.v[0]) * (1 - s), h = i.s.v[1] + (1 - i.s.v[1]) * (1 - s);
            t.translate(i.p.v[0] * n * s, i.p.v[1] * n * s, i.p.v[2]), e.translate(-i.a.v[0], -i.a.v[1], i.a.v[2]), e.rotate(-i.r.v * n * s), e.translate(i.a.v[0], i.a.v[1], i.a.v[2]), r1.translate(-i.a.v[0], -i.a.v[1], i.a.v[2]), r1.scale(a ? 1 / o : o, a ? 1 / h : h), r1.translate(i.a.v[0], i.a.v[1], i.a.v[2]);
        }, RepeaterModifier.prototype.init = function(t, e, r1, i) {
            for(this.elem = t, this.arr = e, this.pos = r1, this.elemsData = i, this._currentCopies = 0, this._elements = [], this._groups = [], this.frameId = -1, this.initDynamicPropertyContainer(t), this.initModifierProperties(t, e[r1]); r1 > 0;)r1 -= 1, this._elements.unshift(e[r1]);
            this.dynamicProperties.length ? this.k = !0 : this.getValue(!0);
        }, RepeaterModifier.prototype.resetElements = function(t) {
            var e, r1 = t.length;
            for(e = 0; e < r1; e += 1)t[e]._processed = !1, "gr" === t[e].ty && this.resetElements(t[e].it);
        }, RepeaterModifier.prototype.cloneElements = function(t) {
            var e = JSON.parse(JSON.stringify(t));
            return this.resetElements(e), e;
        }, RepeaterModifier.prototype.changeGroupRender = function(t, e) {
            var r1, i = t.length;
            for(r1 = 0; r1 < i; r1 += 1)t[r1]._render = e, "gr" === t[r1].ty && this.changeGroupRender(t[r1].it, e);
        }, RepeaterModifier.prototype.processShapes = function(t) {
            var e, r1, i, s, a, n = !1;
            if (this._mdf || t) {
                var o, h = Math.ceil(this.c.v);
                if (this._groups.length < h) {
                    for(; this._groups.length < h;){
                        var l = {
                            it: this.cloneElements(this._elements),
                            ty: "gr"
                        };
                        l.it.push({
                            a: {
                                a: 0,
                                ix: 1,
                                k: [
                                    0,
                                    0
                                ]
                            },
                            nm: "Transform",
                            o: {
                                a: 0,
                                ix: 7,
                                k: 100
                            },
                            p: {
                                a: 0,
                                ix: 2,
                                k: [
                                    0,
                                    0
                                ]
                            },
                            r: {
                                a: 1,
                                ix: 6,
                                k: [
                                    {
                                        s: 0,
                                        e: 0,
                                        t: 0
                                    },
                                    {
                                        s: 0,
                                        e: 0,
                                        t: 1
                                    }
                                ]
                            },
                            s: {
                                a: 0,
                                ix: 3,
                                k: [
                                    100,
                                    100
                                ]
                            },
                            sa: {
                                a: 0,
                                ix: 5,
                                k: 0
                            },
                            sk: {
                                a: 0,
                                ix: 4,
                                k: 0
                            },
                            ty: "tr"
                        }), this.arr.splice(0, 0, l), this._groups.splice(0, 0, l), this._currentCopies += 1;
                    }
                    this.elem.reloadShapes(), n = !0;
                }
                for(a = 0, i = 0; i <= this._groups.length - 1; i += 1){
                    if (o = a < h, this._groups[i]._render = o, this.changeGroupRender(this._groups[i].it, o), !o) {
                        var p = this.elemsData[i].it, c = p[p.length - 1];
                        0 !== c.transform.op.v ? (c.transform.op._mdf = !0, c.transform.op.v = 0) : c.transform.op._mdf = !1;
                    }
                    a += 1;
                }
                this._currentCopies = h;
                var f = this.o.v, u = f % 1, d = f > 0 ? Math.floor(f) : Math.ceil(f), m = this.pMatrix.props, y = this.rMatrix.props, g = this.sMatrix.props;
                this.pMatrix.reset(), this.rMatrix.reset(), this.sMatrix.reset(), this.tMatrix.reset(), this.matrix.reset();
                var v, b, _ = 0;
                if (f > 0) {
                    for(; _ < d;)this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), _ += 1;
                    u && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, u, !1), _ += u);
                } else if (f < 0) {
                    for(; _ > d;)this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !0), _ -= 1;
                    u && (this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -u, !0), _ -= u);
                }
                for(i = 1 === this.data.m ? 0 : this._currentCopies - 1, s = 1 === this.data.m ? 1 : -1, a = this._currentCopies; a;){
                    if (b = (r1 = (e = this.elemsData[i].it)[e.length - 1].transform.mProps.v.props).length, e[e.length - 1].transform.mProps._mdf = !0, e[e.length - 1].transform.op._mdf = !0, e[e.length - 1].transform.op.v = 1 === this._currentCopies ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (i / (this._currentCopies - 1)), 0 !== _) {
                        for((0 !== i && 1 === s || i !== this._currentCopies - 1 && -1 === s) && this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, !1), this.matrix.transform(y[0], y[1], y[2], y[3], y[4], y[5], y[6], y[7], y[8], y[9], y[10], y[11], y[12], y[13], y[14], y[15]), this.matrix.transform(g[0], g[1], g[2], g[3], g[4], g[5], g[6], g[7], g[8], g[9], g[10], g[11], g[12], g[13], g[14], g[15]), this.matrix.transform(m[0], m[1], m[2], m[3], m[4], m[5], m[6], m[7], m[8], m[9], m[10], m[11], m[12], m[13], m[14], m[15]), v = 0; v < b; v += 1)r1[v] = this.matrix.props[v];
                        this.matrix.reset();
                    } else for(this.matrix.reset(), v = 0; v < b; v += 1)r1[v] = this.matrix.props[v];
                    _ += 1, a -= 1, i += s;
                }
            } else for(a = this._currentCopies, i = 0, s = 1; a;)r1 = (e = this.elemsData[i].it)[e.length - 1].transform.mProps.v.props, e[e.length - 1].transform.mProps._mdf = !1, e[e.length - 1].transform.op._mdf = !1, a -= 1, i += s;
            return n;
        }, RepeaterModifier.prototype.addShape = function() {}, extendPrototype([
            ShapeModifier
        ], RoundCornersModifier), RoundCornersModifier.prototype.initModifierProperties = function(t, e) {
            this.getValue = this.processKeys, this.rd = PropertyFactory.getProp(t, e.r, 0, null, this), this._isAnimated = !!this.rd.effectsSequence.length;
        }, RoundCornersModifier.prototype.processPath = function(t, e) {
            var r1, i = shapePool.newElement();
            i.c = t.c;
            var s, a, n, o, h, l, p, c, f, u, d, m, y = t._length, g = 0;
            for(r1 = 0; r1 < y; r1 += 1)s = t.v[r1], n = t.o[r1], a = t.i[r1], s[0] === n[0] && s[1] === n[1] && s[0] === a[0] && s[1] === a[1] ? 0 !== r1 && r1 !== y - 1 || t.c ? (o = 0 === r1 ? t.v[y - 1] : t.v[r1 - 1], l = (h = Math.sqrt(Math.pow(s[0] - o[0], 2) + Math.pow(s[1] - o[1], 2))) ? Math.min(h / 2, e) / h : 0, p = d = s[0] + (o[0] - s[0]) * l, c = m = s[1] - (s[1] - o[1]) * l, f = p - (p - s[0]) * roundCorner, u = c - (c - s[1]) * roundCorner, i.setTripleAt(p, c, f, u, d, m, g), g += 1, o = r1 === y - 1 ? t.v[0] : t.v[r1 + 1], l = (h = Math.sqrt(Math.pow(s[0] - o[0], 2) + Math.pow(s[1] - o[1], 2))) ? Math.min(h / 2, e) / h : 0, p = f = s[0] + (o[0] - s[0]) * l, c = u = s[1] + (o[1] - s[1]) * l, d = p - (p - s[0]) * roundCorner, m = c - (c - s[1]) * roundCorner, i.setTripleAt(p, c, f, u, d, m, g), g += 1) : (i.setTripleAt(s[0], s[1], n[0], n[1], a[0], a[1], g), g += 1) : (i.setTripleAt(t.v[r1][0], t.v[r1][1], t.o[r1][0], t.o[r1][1], t.i[r1][0], t.i[r1][1], g), g += 1);
            return i;
        }, RoundCornersModifier.prototype.processShapes = function(t) {
            var e, r1, i, s, a, n, o = this.shapes.length, h = this.rd.v;
            if (0 !== h) for(r1 = 0; r1 < o; r1 += 1){
                if (n = (a = this.shapes[r1]).localShapeCollection, a.shape._mdf || this._mdf || t) for(n.releaseShapes(), a.shape._mdf = !0, e = a.shape.paths.shapes, s = a.shape.paths._length, i = 0; i < s; i += 1)n.addShape(this.processPath(e[i], h));
                a.shape.paths = a.localShapeCollection;
            }
            this.dynamicProperties.length || (this._mdf = !1);
        }, PolynomialBezier.prototype.point = function(t) {
            return [
                ((this.a[0] * t + this.b[0]) * t + this.c[0]) * t + this.d[0],
                ((this.a[1] * t + this.b[1]) * t + this.c[1]) * t + this.d[1]
            ];
        }, PolynomialBezier.prototype.derivative = function(t) {
            return [
                (3 * t * this.a[0] + 2 * this.b[0]) * t + this.c[0],
                (3 * t * this.a[1] + 2 * this.b[1]) * t + this.c[1]
            ];
        }, PolynomialBezier.prototype.tangentAngle = function(t) {
            var e = this.derivative(t);
            return Math.atan2(e[1], e[0]);
        }, PolynomialBezier.prototype.normalAngle = function(t) {
            var e = this.derivative(t);
            return Math.atan2(e[0], e[1]);
        }, PolynomialBezier.prototype.inflectionPoints = function() {
            var t = this.a[1] * this.b[0] - this.a[0] * this.b[1];
            if (floatZero(t)) return [];
            var e = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / t, r1 = e * e - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / t;
            if (r1 < 0) return [];
            var i = Math.sqrt(r1);
            return floatZero(i) ? i > 0 && i < 1 ? [
                e
            ] : [] : [
                e - i,
                e + i
            ].filter(function(t) {
                return t > 0 && t < 1;
            });
        }, PolynomialBezier.prototype.split = function(t) {
            if (t <= 0) return [
                singlePoint(this.points[0]),
                this
            ];
            if (t >= 1) return [
                this,
                singlePoint(this.points[this.points.length - 1])
            ];
            var e = lerpPoint(this.points[0], this.points[1], t), r1 = lerpPoint(this.points[1], this.points[2], t), i = lerpPoint(this.points[2], this.points[3], t), s = lerpPoint(e, r1, t), a = lerpPoint(r1, i, t), n = lerpPoint(s, a, t);
            return [
                new PolynomialBezier(this.points[0], e, s, n, !0),
                new PolynomialBezier(n, a, i, this.points[3], !0)
            ];
        }, PolynomialBezier.prototype.bounds = function() {
            return {
                x: extrema(this, 0),
                y: extrema(this, 1)
            };
        }, PolynomialBezier.prototype.boundingBox = function() {
            var t = this.bounds();
            return {
                left: t.x.min,
                right: t.x.max,
                top: t.y.min,
                bottom: t.y.max,
                width: t.x.max - t.x.min,
                height: t.y.max - t.y.min,
                cx: (t.x.max + t.x.min) / 2,
                cy: (t.y.max + t.y.min) / 2
            };
        }, PolynomialBezier.prototype.intersections = function(t, e, r1) {
            void 0 === e && (e = 2), void 0 === r1 && (r1 = 7);
            var i = [];
            return intersectsImpl(intersectData(this, 0, 1), intersectData(t, 0, 1), 0, e, i, r1), i;
        }, PolynomialBezier.shapeSegment = function(t, e) {
            var r1 = (e + 1) % t.length();
            return new PolynomialBezier(t.v[e], t.o[e], t.i[r1], t.v[r1], !0);
        }, PolynomialBezier.shapeSegmentInverted = function(t, e) {
            var r1 = (e + 1) % t.length();
            return new PolynomialBezier(t.v[r1], t.i[r1], t.o[e], t.v[e], !0);
        }, extendPrototype([
            ShapeModifier
        ], ZigZagModifier), ZigZagModifier.prototype.initModifierProperties = function(t, e) {
            this.getValue = this.processKeys, this.amplitude = PropertyFactory.getProp(t, e.s, 0, null, this), this.frequency = PropertyFactory.getProp(t, e.r, 0, null, this), this.pointsType = PropertyFactory.getProp(t, e.pt, 0, null, this), this._isAnimated = 0 !== this.amplitude.effectsSequence.length || 0 !== this.frequency.effectsSequence.length || 0 !== this.pointsType.effectsSequence.length;
        }, ZigZagModifier.prototype.processPath = function(t, e, r1, i) {
            var s = t._length, a = shapePool.newElement();
            if (a.c = t.c, t.c || (s -= 1), 0 === s) return a;
            var n = -1, o = PolynomialBezier.shapeSegment(t, 0);
            zigZagCorner(a, t, 0, e, r1, i, n);
            for(var h = 0; h < s; h += 1)n = zigZagSegment(a, o, e, r1, i, -n), o = h !== s - 1 || t.c ? PolynomialBezier.shapeSegment(t, (h + 1) % s) : null, zigZagCorner(a, t, h + 1, e, r1, i, n);
            return a;
        }, ZigZagModifier.prototype.processShapes = function(t) {
            var e, r1, i, s, a, n, o = this.shapes.length, h = this.amplitude.v, l = Math.max(0, Math.round(this.frequency.v)), p = this.pointsType.v;
            if (0 !== h) for(r1 = 0; r1 < o; r1 += 1){
                if (n = (a = this.shapes[r1]).localShapeCollection, a.shape._mdf || this._mdf || t) for(n.releaseShapes(), a.shape._mdf = !0, e = a.shape.paths.shapes, s = a.shape.paths._length, i = 0; i < s; i += 1)n.addShape(this.processPath(e[i], h, l, p));
                a.shape.paths = a.localShapeCollection;
            }
            this.dynamicProperties.length || (this._mdf = !1);
        }, extendPrototype([
            ShapeModifier
        ], OffsetPathModifier), OffsetPathModifier.prototype.initModifierProperties = function(t, e) {
            this.getValue = this.processKeys, this.amount = PropertyFactory.getProp(t, e.a, 0, null, this), this.miterLimit = PropertyFactory.getProp(t, e.ml, 0, null, this), this.lineJoin = e.lj, this._isAnimated = 0 !== this.amount.effectsSequence.length;
        }, OffsetPathModifier.prototype.processPath = function(t, e, r1, i) {
            var s = shapePool.newElement();
            s.c = t.c;
            var a, n, o, h = t.length();
            t.c || (h -= 1);
            var l = [];
            for(a = 0; a < h; a += 1)o = PolynomialBezier.shapeSegment(t, a), l.push(offsetSegmentSplit(o, e));
            if (!t.c) for(a = h - 1; a >= 0; a -= 1)o = PolynomialBezier.shapeSegmentInverted(t, a), l.push(offsetSegmentSplit(o, e));
            l = pruneIntersections(l);
            var p = null, c = null;
            for(a = 0; a < l.length; a += 1){
                var f = l[a];
                for(c && (p = joinLines(s, c, f[0], r1, i)), c = f[f.length - 1], n = 0; n < f.length; n += 1)o = f[n], p && pointEqual(o.points[0], p) ? s.setXYAt(o.points[1][0], o.points[1][1], "o", s.length() - 1) : s.setTripleAt(o.points[0][0], o.points[0][1], o.points[1][0], o.points[1][1], o.points[0][0], o.points[0][1], s.length()), s.setTripleAt(o.points[3][0], o.points[3][1], o.points[3][0], o.points[3][1], o.points[2][0], o.points[2][1], s.length()), p = o.points[3];
            }
            return l.length && joinLines(s, c, l[0][0], r1, i), s;
        }, OffsetPathModifier.prototype.processShapes = function(t) {
            var e, r1, i, s, a, n, o = this.shapes.length, h = this.amount.v, l = this.miterLimit.v, p = this.lineJoin;
            if (0 !== h) for(r1 = 0; r1 < o; r1 += 1){
                if (n = (a = this.shapes[r1]).localShapeCollection, a.shape._mdf || this._mdf || t) for(n.releaseShapes(), a.shape._mdf = !0, e = a.shape.paths.shapes, s = a.shape.paths._length, i = 0; i < s; i += 1)n.addShape(this.processPath(e[i], h, p, l));
                a.shape.paths = a.localShapeCollection;
            }
            this.dynamicProperties.length || (this._mdf = !1);
        };
        var FontManager = function() {
            var t = {
                w: 0,
                size: 0,
                shapes: [],
                data: {
                    shapes: []
                }
            }, e = [];
            e = e.concat([
                2304,
                2305,
                2306,
                2307,
                2362,
                2363,
                2364,
                2364,
                2366,
                2367,
                2368,
                2369,
                2370,
                2371,
                2372,
                2373,
                2374,
                2375,
                2376,
                2377,
                2378,
                2379,
                2380,
                2381,
                2382,
                2383,
                2387,
                2388,
                2389,
                2390,
                2391,
                2402,
                2403
            ]);
            var r1 = 127988, i = [
                "d83cdffb",
                "d83cdffc",
                "d83cdffd",
                "d83cdffe",
                "d83cdfff"
            ];
            function s(t, e) {
                var r1 = createTag("span");
                r1.setAttribute("aria-hidden", !0), r1.style.fontFamily = e;
                var i = createTag("span");
                i.innerText = "giItT1WQy@!-/#", r1.style.position = "absolute", r1.style.left = "-10000px", r1.style.top = "-10000px", r1.style.fontSize = "300px", r1.style.fontVariant = "normal", r1.style.fontStyle = "normal", r1.style.fontWeight = "normal", r1.style.letterSpacing = "0", r1.appendChild(i), document.body.appendChild(r1);
                var s = i.offsetWidth;
                return i.style.fontFamily = function(t) {
                    var e, r1 = t.split(","), i = r1.length, s = [];
                    for(e = 0; e < i; e += 1)"sans-serif" !== r1[e] && "monospace" !== r1[e] && s.push(r1[e]);
                    return s.join(",");
                }(t) + ", " + e, {
                    node: i,
                    w: s,
                    parent: r1
                };
            }
            function a(t, e) {
                var r1, i = document.body && e ? "svg" : "canvas", s = getFontProperties(t);
                if ("svg" === i) {
                    var a = createNS("text");
                    a.style.fontSize = "100px", a.setAttribute("font-family", t.fFamily), a.setAttribute("font-style", s.style), a.setAttribute("font-weight", s.weight), a.textContent = "1", t.fClass ? (a.style.fontFamily = "inherit", a.setAttribute("class", t.fClass)) : a.style.fontFamily = t.fFamily, e.appendChild(a), r1 = a;
                } else {
                    var n = new OffscreenCanvas(500, 500).getContext("2d");
                    n.font = s.style + " " + s.weight + " 100px " + t.fFamily, r1 = n;
                }
                return {
                    measureText: function(t) {
                        return "svg" === i ? (r1.textContent = t, r1.getComputedTextLength()) : r1.measureText(t).width;
                    }
                };
            }
            function n(t) {
                var e = 0, r1 = t.charCodeAt(0);
                if (r1 >= 55296 && r1 <= 56319) {
                    var i = t.charCodeAt(1);
                    i >= 56320 && i <= 57343 && (e = 1024 * (r1 - 55296) + i - 56320 + 65536);
                }
                return e;
            }
            function o(t) {
                var e = n(t);
                return e >= 127462 && e <= 127487;
            }
            var h = function() {
                this.fonts = [], this.chars = null, this.typekitLoaded = 0, this.isLoaded = !1, this._warned = !1, this.initTime = Date.now(), this.setIsLoadedBinded = this.setIsLoaded.bind(this), this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
            };
            h.isModifier = function(t, e) {
                var r1 = t.toString(16) + e.toString(16);
                return -1 !== i.indexOf(r1);
            }, h.isZeroWidthJoiner = function(t) {
                return 8205 === t;
            }, h.isFlagEmoji = function(t) {
                return o(t.substr(0, 2)) && o(t.substr(2, 2));
            }, h.isRegionalCode = o, h.isCombinedCharacter = function(t) {
                return -1 !== e.indexOf(t);
            }, h.isRegionalFlag = function(t, e) {
                var i = n(t.substr(e, 2));
                if (i !== r1) return !1;
                var s = 0;
                for(e += 2; s < 5;){
                    if ((i = n(t.substr(e, 2))) < 917601 || i > 917626) return !1;
                    s += 1, e += 2;
                }
                return 917631 === n(t.substr(e, 2));
            }, h.isVariationSelector = function(t) {
                return 65039 === t;
            }, h.BLACK_FLAG_CODE_POINT = r1;
            var l = {
                addChars: function(t) {
                    if (t) {
                        var e;
                        this.chars || (this.chars = []);
                        var r1, i, s = t.length, a = this.chars.length;
                        for(e = 0; e < s; e += 1){
                            for(r1 = 0, i = !1; r1 < a;)this.chars[r1].style === t[e].style && this.chars[r1].fFamily === t[e].fFamily && this.chars[r1].ch === t[e].ch && (i = !0), r1 += 1;
                            i || (this.chars.push(t[e]), a += 1);
                        }
                    }
                },
                addFonts: function(t, e) {
                    if (t) {
                        if (this.chars) return this.isLoaded = !0, void (this.fonts = t.list);
                        if (!document.body) return this.isLoaded = !0, t.list.forEach(function(t) {
                            t.helper = a(t), t.cache = {};
                        }), void (this.fonts = t.list);
                        var r1, i = t.list, n = i.length, o = n;
                        for(r1 = 0; r1 < n; r1 += 1){
                            var h, l, p = !0;
                            if (i[r1].loaded = !1, i[r1].monoCase = s(i[r1].fFamily, "monospace"), i[r1].sansCase = s(i[r1].fFamily, "sans-serif"), i[r1].fPath) {
                                if ("p" === i[r1].fOrigin || 3 === i[r1].origin) {
                                    if ((h = document.querySelectorAll('style[f-forigin="p"][f-family="' + i[r1].fFamily + '"], style[f-origin="3"][f-family="' + i[r1].fFamily + '"]')).length > 0 && (p = !1), p) {
                                        var c = createTag("style");
                                        c.setAttribute("f-forigin", i[r1].fOrigin), c.setAttribute("f-origin", i[r1].origin), c.setAttribute("f-family", i[r1].fFamily), c.type = "text/css", c.innerText = "@font-face {font-family: " + i[r1].fFamily + "; font-style: normal; src: url('" + i[r1].fPath + "');}", e.appendChild(c);
                                    }
                                } else if ("g" === i[r1].fOrigin || 1 === i[r1].origin) {
                                    for(h = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]'), l = 0; l < h.length; l += 1)-1 !== h[l].href.indexOf(i[r1].fPath) && (p = !1);
                                    if (p) {
                                        var f = createTag("link");
                                        f.setAttribute("f-forigin", i[r1].fOrigin), f.setAttribute("f-origin", i[r1].origin), f.type = "text/css", f.rel = "stylesheet", f.href = i[r1].fPath, document.body.appendChild(f);
                                    }
                                } else if ("t" === i[r1].fOrigin || 2 === i[r1].origin) {
                                    for(h = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]'), l = 0; l < h.length; l += 1)i[r1].fPath === h[l].src && (p = !1);
                                    if (p) {
                                        var u = createTag("link");
                                        u.setAttribute("f-forigin", i[r1].fOrigin), u.setAttribute("f-origin", i[r1].origin), u.setAttribute("rel", "stylesheet"), u.setAttribute("href", i[r1].fPath), e.appendChild(u);
                                    }
                                }
                            } else i[r1].loaded = !0, o -= 1;
                            i[r1].helper = a(i[r1], e), i[r1].cache = {}, this.fonts.push(i[r1]);
                        }
                        0 === o ? this.isLoaded = !0 : setTimeout(this.checkLoadedFonts.bind(this), 100);
                    } else this.isLoaded = !0;
                },
                getCharData: function(e, r1, i) {
                    for(var s = 0, a = this.chars.length; s < a;){
                        if (this.chars[s].ch === e && this.chars[s].style === r1 && this.chars[s].fFamily === i) return this.chars[s];
                        s += 1;
                    }
                    return ("string" == typeof e && 13 !== e.charCodeAt(0) || !e) && console && console.warn && !this._warned && (this._warned = !0, console.warn("Missing character from exported characters list: ", e, r1, i)), t;
                },
                getFontByName: function(t) {
                    for(var e = 0, r1 = this.fonts.length; e < r1;){
                        if (this.fonts[e].fName === t) return this.fonts[e];
                        e += 1;
                    }
                    return this.fonts[0];
                },
                measureText: function(t, e, r1) {
                    var i = this.getFontByName(e), s = t;
                    if (!i.cache[s]) {
                        var a = i.helper;
                        if (" " === t) {
                            var n = a.measureText("|" + t + "|"), o = a.measureText("||");
                            i.cache[s] = (n - o) / 100;
                        } else i.cache[s] = a.measureText(t) / 100;
                    }
                    return i.cache[s] * r1;
                },
                checkLoadedFonts: function() {
                    var t, e, r1, i = this.fonts.length, s = i;
                    for(t = 0; t < i; t += 1)this.fonts[t].loaded ? s -= 1 : "n" === this.fonts[t].fOrigin || 0 === this.fonts[t].origin ? this.fonts[t].loaded = !0 : (e = this.fonts[t].monoCase.node, r1 = this.fonts[t].monoCase.w, e.offsetWidth !== r1 ? (s -= 1, this.fonts[t].loaded = !0) : (e = this.fonts[t].sansCase.node, r1 = this.fonts[t].sansCase.w, e.offsetWidth !== r1 && (s -= 1, this.fonts[t].loaded = !0)), this.fonts[t].loaded && (this.fonts[t].sansCase.parent.parentNode.removeChild(this.fonts[t].sansCase.parent), this.fonts[t].monoCase.parent.parentNode.removeChild(this.fonts[t].monoCase.parent)));
                    0 !== s && Date.now() - this.initTime < 5e3 ? setTimeout(this.checkLoadedFontsBinded, 20) : setTimeout(this.setIsLoadedBinded, 10);
                },
                setIsLoaded: function() {
                    this.isLoaded = !0;
                }
            };
            return h.prototype = l, h;
        }();
        function SlotManager(t) {
            this.animationData = t;
        }
        function slotFactory(t) {
            return new SlotManager(t);
        }
        function RenderableElement() {}
        SlotManager.prototype.getProp = function(t) {
            return this.animationData.slots && this.animationData.slots[t.sid] ? Object.assign(t, this.animationData.slots[t.sid].p) : t;
        }, RenderableElement.prototype = {
            initRenderable: function() {
                this.isInRange = !1, this.hidden = !1, this.isTransparent = !1, this.renderableComponents = [];
            },
            addRenderableComponent: function(t) {
                -1 === this.renderableComponents.indexOf(t) && this.renderableComponents.push(t);
            },
            removeRenderableComponent: function(t) {
                -1 !== this.renderableComponents.indexOf(t) && this.renderableComponents.splice(this.renderableComponents.indexOf(t), 1);
            },
            prepareRenderableFrame: function(t) {
                this.checkLayerLimits(t);
            },
            checkTransparency: function() {
                this.finalTransform.mProp.o.v <= 0 ? !this.isTransparent && this.globalData.renderConfig.hideOnTransparent && (this.isTransparent = !0, this.hide()) : this.isTransparent && (this.isTransparent = !1, this.show());
            },
            checkLayerLimits: function(t) {
                this.data.ip - this.data.st <= t && this.data.op - this.data.st > t ? !0 !== this.isInRange && (this.globalData._mdf = !0, this._mdf = !0, this.isInRange = !0, this.show()) : !1 !== this.isInRange && (this.globalData._mdf = !0, this.isInRange = !1, this.hide());
            },
            renderRenderable: function() {
                var t, e = this.renderableComponents.length;
                for(t = 0; t < e; t += 1)this.renderableComponents[t].renderFrame(this._isFirstFrame);
            },
            sourceRectAtTime: function() {
                return {
                    top: 0,
                    left: 0,
                    width: 100,
                    height: 100
                };
            },
            getLayerSize: function() {
                return 5 === this.data.ty ? {
                    w: this.data.textData.width,
                    h: this.data.textData.height
                } : {
                    w: this.data.width,
                    h: this.data.height
                };
            }
        };
        var getBlendMode = (blendModeEnums = {
            0: "source-over",
            1: "multiply",
            2: "screen",
            3: "overlay",
            4: "darken",
            5: "lighten",
            6: "color-dodge",
            7: "color-burn",
            8: "hard-light",
            9: "soft-light",
            10: "difference",
            11: "exclusion",
            12: "hue",
            13: "saturation",
            14: "color",
            15: "luminosity"
        }, function(t) {
            return blendModeEnums[t] || "";
        }), blendModeEnums;
        function SliderEffect(t, e, r1) {
            this.p = PropertyFactory.getProp(e, t.v, 0, 0, r1);
        }
        function AngleEffect(t, e, r1) {
            this.p = PropertyFactory.getProp(e, t.v, 0, 0, r1);
        }
        function ColorEffect(t, e, r1) {
            this.p = PropertyFactory.getProp(e, t.v, 1, 0, r1);
        }
        function PointEffect(t, e, r1) {
            this.p = PropertyFactory.getProp(e, t.v, 1, 0, r1);
        }
        function LayerIndexEffect(t, e, r1) {
            this.p = PropertyFactory.getProp(e, t.v, 0, 0, r1);
        }
        function MaskIndexEffect(t, e, r1) {
            this.p = PropertyFactory.getProp(e, t.v, 0, 0, r1);
        }
        function CheckboxEffect(t, e, r1) {
            this.p = PropertyFactory.getProp(e, t.v, 0, 0, r1);
        }
        function NoValueEffect() {
            this.p = {};
        }
        function EffectsManager(t, e) {
            var r1, i = t.ef || [];
            this.effectElements = [];
            var s, a = i.length;
            for(r1 = 0; r1 < a; r1 += 1)s = new GroupEffect(i[r1], e), this.effectElements.push(s);
        }
        function GroupEffect(t, e) {
            this.init(t, e);
        }
        function BaseElement() {}
        function FrameElement() {}
        function FootageElement(t, e, r1) {
            this.initFrame(), this.initRenderable(), this.assetData = e.getAssetData(t.refId), this.footageData = e.imageLoader.getAsset(this.assetData), this.initBaseData(t, e, r1);
        }
        function AudioElement(t, e, r1) {
            this.initFrame(), this.initRenderable(), this.assetData = e.getAssetData(t.refId), this.initBaseData(t, e, r1), this._isPlaying = !1, this._canPlay = !1;
            var i = this.globalData.getAssetsPath(this.assetData);
            this.audio = this.globalData.audioController.createAudio(i), this._currentTime = 0, this.globalData.audioController.addAudio(this), this._volumeMultiplier = 1, this._volume = 1, this._previousVolume = null, this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this) : {
                _placeholder: !0
            }, this.lv = PropertyFactory.getProp(this, t.au && t.au.lv ? t.au.lv : {
                k: [
                    100
                ]
            }, 1, .01, this);
        }
        function BaseRenderer() {}
        extendPrototype([
            DynamicPropertyContainer
        ], GroupEffect), GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties, GroupEffect.prototype.init = function(t, e) {
            var r1;
            this.data = t, this.effectElements = [], this.initDynamicPropertyContainer(e);
            var i, s = this.data.ef.length, a = this.data.ef;
            for(r1 = 0; r1 < s; r1 += 1){
                switch(i = null, a[r1].ty){
                    case 0:
                        i = new SliderEffect(a[r1], e, this);
                        break;
                    case 1:
                        i = new AngleEffect(a[r1], e, this);
                        break;
                    case 2:
                        i = new ColorEffect(a[r1], e, this);
                        break;
                    case 3:
                        i = new PointEffect(a[r1], e, this);
                        break;
                    case 4:
                    case 7:
                        i = new CheckboxEffect(a[r1], e, this);
                        break;
                    case 10:
                        i = new LayerIndexEffect(a[r1], e, this);
                        break;
                    case 11:
                        i = new MaskIndexEffect(a[r1], e, this);
                        break;
                    case 5:
                        i = new EffectsManager(a[r1], e, this);
                        break;
                    default:
                        i = new NoValueEffect(a[r1], e, this);
                }
                i && this.effectElements.push(i);
            }
        }, BaseElement.prototype = {
            checkMasks: function() {
                if (!this.data.hasMask) return !1;
                for(var t = 0, e = this.data.masksProperties.length; t < e;){
                    if ("n" !== this.data.masksProperties[t].mode && !1 !== this.data.masksProperties[t].cl) return !0;
                    t += 1;
                }
                return !1;
            },
            initExpressions: function() {
                var t = getExpressionInterfaces();
                if (t) {
                    var e = t("layer"), r1 = t("effects"), i = t("shape"), s = t("text"), a = t("comp");
                    this.layerInterface = e(this), this.data.hasMask && this.maskManager && this.layerInterface.registerMaskInterface(this.maskManager);
                    var n = r1.createEffectsInterface(this, this.layerInterface);
                    this.layerInterface.registerEffectsInterface(n), 0 === this.data.ty || this.data.xt ? this.compInterface = a(this) : 4 === this.data.ty ? (this.layerInterface.shapeInterface = i(this.shapesData, this.itemsData, this.layerInterface), this.layerInterface.content = this.layerInterface.shapeInterface) : 5 === this.data.ty && (this.layerInterface.textInterface = s(this), this.layerInterface.text = this.layerInterface.textInterface);
                }
            },
            setBlendMode: function() {
                var t = getBlendMode(this.data.bm);
                (this.baseElement || this.layerElement).style["mix-blend-mode"] = t;
            },
            initBaseData: function(t, e, r1) {
                this.globalData = e, this.comp = r1, this.data = t, this.layerId = createElementID(), this.data.sr || (this.data.sr = 1), this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
            },
            getType: function() {
                return this.type;
            },
            sourceRectAtTime: function() {}
        }, FrameElement.prototype = {
            initFrame: function() {
                this._isFirstFrame = !1, this.dynamicProperties = [], this._mdf = !1;
            },
            prepareProperties: function(t, e) {
                var r1, i = this.dynamicProperties.length;
                for(r1 = 0; r1 < i; r1 += 1)(e || this._isParent && "transform" === this.dynamicProperties[r1].propType) && (this.dynamicProperties[r1].getValue(), this.dynamicProperties[r1]._mdf && (this.globalData._mdf = !0, this._mdf = !0));
            },
            addDynamicProperty: function(t) {
                -1 === this.dynamicProperties.indexOf(t) && this.dynamicProperties.push(t);
            }
        }, FootageElement.prototype.prepareFrame = function() {}, extendPrototype([
            RenderableElement,
            BaseElement,
            FrameElement
        ], FootageElement), FootageElement.prototype.getBaseElement = function() {
            return null;
        }, FootageElement.prototype.renderFrame = function() {}, FootageElement.prototype.destroy = function() {}, FootageElement.prototype.initExpressions = function() {
            var t = getExpressionInterfaces();
            if (t) {
                var e = t("footage");
                this.layerInterface = e(this);
            }
        }, FootageElement.prototype.getFootageData = function() {
            return this.footageData;
        }, AudioElement.prototype.prepareFrame = function(t) {
            if (this.prepareRenderableFrame(t, !0), this.prepareProperties(t, !0), this.tm._placeholder) this._currentTime = t / this.data.sr;
            else {
                var e = this.tm.v;
                this._currentTime = e;
            }
            this._volume = this.lv.v[0];
            var r1 = this._volume * this._volumeMultiplier;
            this._previousVolume !== r1 && (this._previousVolume = r1, this.audio.volume(r1));
        }, extendPrototype([
            RenderableElement,
            BaseElement,
            FrameElement
        ], AudioElement), AudioElement.prototype.renderFrame = function() {
            this.isInRange && this._canPlay && (this._isPlaying ? (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > .1) && this.audio.seek(this._currentTime / this.globalData.frameRate) : (this.audio.play(), this.audio.seek(this._currentTime / this.globalData.frameRate), this._isPlaying = !0));
        }, AudioElement.prototype.show = function() {}, AudioElement.prototype.hide = function() {
            this.audio.pause(), this._isPlaying = !1;
        }, AudioElement.prototype.pause = function() {
            this.audio.pause(), this._isPlaying = !1, this._canPlay = !1;
        }, AudioElement.prototype.resume = function() {
            this._canPlay = !0;
        }, AudioElement.prototype.setRate = function(t) {
            this.audio.rate(t);
        }, AudioElement.prototype.volume = function(t) {
            this._volumeMultiplier = t, this._previousVolume = t * this._volume, this.audio.volume(this._previousVolume);
        }, AudioElement.prototype.getBaseElement = function() {
            return null;
        }, AudioElement.prototype.destroy = function() {}, AudioElement.prototype.sourceRectAtTime = function() {}, AudioElement.prototype.initExpressions = function() {}, BaseRenderer.prototype.checkLayers = function(t) {
            var e, r1, i = this.layers.length;
            for(this.completeLayers = !0, e = i - 1; e >= 0; e -= 1)this.elements[e] || (r1 = this.layers[e]).ip - r1.st <= t - this.layers[e].st && r1.op - r1.st > t - this.layers[e].st && this.buildItem(e), this.completeLayers = !!this.elements[e] && this.completeLayers;
            this.checkPendingElements();
        }, BaseRenderer.prototype.createItem = function(t) {
            switch(t.ty){
                case 2:
                    return this.createImage(t);
                case 0:
                    return this.createComp(t);
                case 1:
                    return this.createSolid(t);
                case 3:
                default:
                    return this.createNull(t);
                case 4:
                    return this.createShape(t);
                case 5:
                    return this.createText(t);
                case 6:
                    return this.createAudio(t);
                case 13:
                    return this.createCamera(t);
                case 15:
                    return this.createFootage(t);
            }
        }, BaseRenderer.prototype.createCamera = function() {
            throw new Error("You're using a 3d camera. Try the html renderer.");
        }, BaseRenderer.prototype.createAudio = function(t) {
            return new AudioElement(t, this.globalData, this);
        }, BaseRenderer.prototype.createFootage = function(t) {
            return new FootageElement(t, this.globalData, this);
        }, BaseRenderer.prototype.buildAllItems = function() {
            var t, e = this.layers.length;
            for(t = 0; t < e; t += 1)this.buildItem(t);
            this.checkPendingElements();
        }, BaseRenderer.prototype.includeLayers = function(t) {
            var e;
            this.completeLayers = !1;
            var r1, i = t.length, s = this.layers.length;
            for(e = 0; e < i; e += 1)for(r1 = 0; r1 < s;){
                if (this.layers[r1].id === t[e].id) {
                    this.layers[r1] = t[e];
                    break;
                }
                r1 += 1;
            }
        }, BaseRenderer.prototype.setProjectInterface = function(t) {
            this.globalData.projectInterface = t;
        }, BaseRenderer.prototype.initItems = function() {
            this.globalData.progressiveLoad || this.buildAllItems();
        }, BaseRenderer.prototype.buildElementParenting = function(t, e, r1) {
            for(var i = this.elements, s = this.layers, a = 0, n = s.length; a < n;)s[a].ind == e && (i[a] && !0 !== i[a] ? (r1.push(i[a]), i[a].setAsParent(), void 0 !== s[a].parent ? this.buildElementParenting(t, s[a].parent, r1) : t.setHierarchy(r1)) : (this.buildItem(a), this.addPendingElement(t))), a += 1;
        }, BaseRenderer.prototype.addPendingElement = function(t) {
            this.pendingElements.push(t);
        }, BaseRenderer.prototype.searchExtraCompositions = function(t) {
            var e, r1 = t.length;
            for(e = 0; e < r1; e += 1)if (t[e].xt) {
                var i = this.createComp(t[e]);
                i.initExpressions(), this.globalData.projectInterface.registerComposition(i);
            }
        }, BaseRenderer.prototype.getElementById = function(t) {
            var e, r1 = this.elements.length;
            for(e = 0; e < r1; e += 1)if (this.elements[e].data.ind === t) return this.elements[e];
            return null;
        }, BaseRenderer.prototype.getElementByPath = function(t) {
            var e, r1 = t.shift();
            if ("number" == typeof r1) e = this.elements[r1];
            else {
                var i, s = this.elements.length;
                for(i = 0; i < s; i += 1)if (this.elements[i].data.nm === r1) {
                    e = this.elements[i];
                    break;
                }
            }
            return 0 === t.length ? e : e.getElementByPath(t);
        }, BaseRenderer.prototype.setupGlobalData = function(t, e) {
            this.globalData.fontManager = new FontManager, this.globalData.slotManager = slotFactory(t), this.globalData.fontManager.addChars(t.chars), this.globalData.fontManager.addFonts(t.fonts, e), this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem), this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem), this.globalData.imageLoader = this.animationItem.imagePreloader, this.globalData.audioController = this.animationItem.audioController, this.globalData.frameId = 0, this.globalData.frameRate = t.fr, this.globalData.nm = t.nm, this.globalData.compSize = {
                w: t.w,
                h: t.h
            };
        };
        var effectTypes = {
            TRANSFORM_EFFECT: "transformEFfect"
        };
        function TransformElement() {}
        function MaskElement(t, e, r1) {
            this.data = t, this.element = e, this.globalData = r1, this.storedData = [], this.masksProperties = this.data.masksProperties || [], this.maskElement = null;
            var i, s, a = this.globalData.defs, n = this.masksProperties ? this.masksProperties.length : 0;
            this.viewData = createSizedArray(n), this.solidPath = "";
            var o, h, l, p, c, f, u = this.masksProperties, d = 0, m = [], y = createElementID(), g = "clipPath", v = "clip-path";
            for(i = 0; i < n; i += 1)if (("a" !== u[i].mode && "n" !== u[i].mode || u[i].inv || 100 !== u[i].o.k || u[i].o.x) && (g = "mask", v = "mask"), "s" !== u[i].mode && "i" !== u[i].mode || 0 !== d ? l = null : ((l = createNS("rect")).setAttribute("fill", "#ffffff"), l.setAttribute("width", this.element.comp.data.w || 0), l.setAttribute("height", this.element.comp.data.h || 0), m.push(l)), s = createNS("path"), "n" === u[i].mode) this.viewData[i] = {
                op: PropertyFactory.getProp(this.element, u[i].o, 0, .01, this.element),
                prop: ShapePropertyFactory.getShapeProp(this.element, u[i], 3),
                elem: s,
                lastPath: ""
            }, a.appendChild(s);
            else {
                var b;
                if (d += 1, s.setAttribute("fill", "s" === u[i].mode ? "#000000" : "#ffffff"), s.setAttribute("clip-rule", "nonzero"), 0 !== u[i].x.k ? (g = "mask", v = "mask", f = PropertyFactory.getProp(this.element, u[i].x, 0, null, this.element), b = createElementID(), (p = createNS("filter")).setAttribute("id", b), (c = createNS("feMorphology")).setAttribute("operator", "erode"), c.setAttribute("in", "SourceGraphic"), c.setAttribute("radius", "0"), p.appendChild(c), a.appendChild(p), s.setAttribute("stroke", "s" === u[i].mode ? "#000000" : "#ffffff")) : (c = null, f = null), this.storedData[i] = {
                    elem: s,
                    x: f,
                    expan: c,
                    lastPath: "",
                    lastOperator: "",
                    filterId: b,
                    lastRadius: 0
                }, "i" === u[i].mode) {
                    h = m.length;
                    var _ = createNS("g");
                    for(o = 0; o < h; o += 1)_.appendChild(m[o]);
                    var P = createNS("mask");
                    P.setAttribute("mask-type", "alpha"), P.setAttribute("id", y + "_" + d), P.appendChild(s), a.appendChild(P), _.setAttribute("mask", "url(" + getLocationHref() + "#" + y + "_" + d + ")"), m.length = 0, m.push(_);
                } else m.push(s);
                u[i].inv && !this.solidPath && (this.solidPath = this.createLayerSolidPath()), this.viewData[i] = {
                    elem: s,
                    lastPath: "",
                    op: PropertyFactory.getProp(this.element, u[i].o, 0, .01, this.element),
                    prop: ShapePropertyFactory.getShapeProp(this.element, u[i], 3),
                    invRect: l
                }, this.viewData[i].prop.k || this.drawPath(u[i], this.viewData[i].prop.v, this.viewData[i]);
            }
            for(this.maskElement = createNS(g), n = m.length, i = 0; i < n; i += 1)this.maskElement.appendChild(m[i]);
            d > 0 && (this.maskElement.setAttribute("id", y), this.element.maskedElement.setAttribute(v, "url(" + getLocationHref() + "#" + y + ")"), a.appendChild(this.maskElement)), this.viewData.length && this.element.addRenderableComponent(this);
        }
        TransformElement.prototype = {
            initTransform: function() {
                var t = new Matrix;
                this.finalTransform = {
                    mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
                        o: 0
                    },
                    _matMdf: !1,
                    _localMatMdf: !1,
                    _opMdf: !1,
                    mat: t,
                    localMat: t,
                    localOpacity: 1
                }, this.data.ao && (this.finalTransform.mProp.autoOriented = !0), this.data.ty;
            },
            renderTransform: function() {
                if (this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame, this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame, this.hierarchy) {
                    var t, e = this.finalTransform.mat, r1 = 0, i = this.hierarchy.length;
                    if (!this.finalTransform._matMdf) for(; r1 < i;){
                        if (this.hierarchy[r1].finalTransform.mProp._mdf) {
                            this.finalTransform._matMdf = !0;
                            break;
                        }
                        r1 += 1;
                    }
                    if (this.finalTransform._matMdf) for(t = this.finalTransform.mProp.v.props, e.cloneFromProps(t), r1 = 0; r1 < i; r1 += 1)e.multiply(this.hierarchy[r1].finalTransform.mProp.v);
                }
                this.finalTransform._matMdf && (this.finalTransform._localMatMdf = this.finalTransform._matMdf), this.finalTransform._opMdf && (this.finalTransform.localOpacity = this.finalTransform.mProp.o.v);
            },
            renderLocalTransform: function() {
                if (this.localTransforms) {
                    var t = 0, e = this.localTransforms.length;
                    if (this.finalTransform._localMatMdf = this.finalTransform._matMdf, !this.finalTransform._localMatMdf || !this.finalTransform._opMdf) for(; t < e;)this.localTransforms[t]._mdf && (this.finalTransform._localMatMdf = !0), this.localTransforms[t]._opMdf && !this.finalTransform._opMdf && (this.finalTransform.localOpacity = this.finalTransform.mProp.o.v, this.finalTransform._opMdf = !0), t += 1;
                    if (this.finalTransform._localMatMdf) {
                        var r1 = this.finalTransform.localMat;
                        for(this.localTransforms[0].matrix.clone(r1), t = 1; t < e; t += 1){
                            var i = this.localTransforms[t].matrix;
                            r1.multiply(i);
                        }
                        r1.multiply(this.finalTransform.mat);
                    }
                    if (this.finalTransform._opMdf) {
                        var s = this.finalTransform.localOpacity;
                        for(t = 0; t < e; t += 1)s *= .01 * this.localTransforms[t].opacity;
                        this.finalTransform.localOpacity = s;
                    }
                }
            },
            searchEffectTransforms: function() {
                if (this.renderableEffectsManager) {
                    var t = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
                    if (t.length) {
                        this.localTransforms = [], this.finalTransform.localMat = new Matrix;
                        var e = 0, r1 = t.length;
                        for(e = 0; e < r1; e += 1)this.localTransforms.push(t[e]);
                    }
                }
            },
            globalToLocal: function(t) {
                var e = [];
                e.push(this.finalTransform);
                for(var r1, i = !0, s = this.comp; i;)s.finalTransform ? (s.data.hasMask && e.splice(0, 0, s.finalTransform), s = s.comp) : i = !1;
                var a, n = e.length;
                for(r1 = 0; r1 < n; r1 += 1)a = e[r1].mat.applyToPointArray(0, 0, 0), t = [
                    t[0] - a[0],
                    t[1] - a[1],
                    0
                ];
                return t;
            },
            mHelper: new Matrix
        }, MaskElement.prototype.getMaskProperty = function(t) {
            return this.viewData[t].prop;
        }, MaskElement.prototype.renderFrame = function(t) {
            var e, r1 = this.element.finalTransform.mat, i = this.masksProperties.length;
            for(e = 0; e < i; e += 1)if ((this.viewData[e].prop._mdf || t) && this.drawPath(this.masksProperties[e], this.viewData[e].prop.v, this.viewData[e]), (this.viewData[e].op._mdf || t) && this.viewData[e].elem.setAttribute("fill-opacity", this.viewData[e].op.v), "n" !== this.masksProperties[e].mode && (this.viewData[e].invRect && (this.element.finalTransform.mProp._mdf || t) && this.viewData[e].invRect.setAttribute("transform", r1.getInverseMatrix().to2dCSS()), this.storedData[e].x && (this.storedData[e].x._mdf || t))) {
                var s = this.storedData[e].expan;
                this.storedData[e].x.v < 0 ? ("erode" !== this.storedData[e].lastOperator && (this.storedData[e].lastOperator = "erode", this.storedData[e].elem.setAttribute("filter", "url(" + getLocationHref() + "#" + this.storedData[e].filterId + ")")), s.setAttribute("radius", -this.storedData[e].x.v)) : ("dilate" !== this.storedData[e].lastOperator && (this.storedData[e].lastOperator = "dilate", this.storedData[e].elem.setAttribute("filter", null)), this.storedData[e].elem.setAttribute("stroke-width", 2 * this.storedData[e].x.v));
            }
        }, MaskElement.prototype.getMaskelement = function() {
            return this.maskElement;
        }, MaskElement.prototype.createLayerSolidPath = function() {
            var t = "M0,0 ";
            return t += " h" + this.globalData.compSize.w, t += " v" + this.globalData.compSize.h, t += " h-" + this.globalData.compSize.w, t += " v-" + this.globalData.compSize.h + " ";
        }, MaskElement.prototype.drawPath = function(t, e, r1) {
            var i, s, a = " M" + e.v[0][0] + "," + e.v[0][1];
            for(s = e._length, i = 1; i < s; i += 1)a += " C" + e.o[i - 1][0] + "," + e.o[i - 1][1] + " " + e.i[i][0] + "," + e.i[i][1] + " " + e.v[i][0] + "," + e.v[i][1];
            if (e.c && s > 1 && (a += " C" + e.o[i - 1][0] + "," + e.o[i - 1][1] + " " + e.i[0][0] + "," + e.i[0][1] + " " + e.v[0][0] + "," + e.v[0][1]), r1.lastPath !== a) {
                var n = "";
                r1.elem && (e.c && (n = t.inv ? this.solidPath + a : a), r1.elem.setAttribute("d", n)), r1.lastPath = a;
            }
        }, MaskElement.prototype.destroy = function() {
            this.element = null, this.globalData = null, this.maskElement = null, this.data = null, this.masksProperties = null;
        };
        var filtersFactory = function() {
            var t = {
                createFilter: function(t, e) {
                    var r1 = createNS("filter");
                    return r1.setAttribute("id", t), !0 !== e && (r1.setAttribute("filterUnits", "objectBoundingBox"), r1.setAttribute("x", "0%"), r1.setAttribute("y", "0%"), r1.setAttribute("width", "100%"), r1.setAttribute("height", "100%")), r1;
                },
                createAlphaToLuminanceFilter: function() {
                    var t = createNS("feColorMatrix");
                    return t.setAttribute("type", "matrix"), t.setAttribute("color-interpolation-filters", "sRGB"), t.setAttribute("values", "0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1"), t;
                }
            };
            return t;
        }(), featureSupport = function() {
            var t = {
                maskType: !0,
                svgLumaHidden: !0,
                offscreenCanvas: "undefined" != typeof OffscreenCanvas
            };
            return (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) && (t.maskType = !1), /firefox/i.test(navigator.userAgent) && (t.svgLumaHidden = !1), t;
        }(), registeredEffects$1 = {}, idPrefix = "filter_result_";
        function SVGEffects(t) {
            var e, r1, i = "SourceGraphic", s = t.data.ef ? t.data.ef.length : 0, a = createElementID(), n = filtersFactory.createFilter(a, !0), o = 0;
            for(this.filters = [], e = 0; e < s; e += 1){
                r1 = null;
                var h = t.data.ef[e].ty;
                registeredEffects$1[h] && (r1 = new registeredEffects$1[h].effect(n, t.effectsManager.effectElements[e], t, idPrefix + o, i), i = idPrefix + o, registeredEffects$1[h].countsAsEffect && (o += 1)), r1 && this.filters.push(r1);
            }
            o && (t.globalData.defs.appendChild(n), t.layerElement.setAttribute("filter", "url(" + getLocationHref() + "#" + a + ")")), this.filters.length && t.addRenderableComponent(this);
        }
        function registerEffect$1(t, e, r1) {
            registeredEffects$1[t] = {
                effect: e,
                countsAsEffect: r1
            };
        }
        function SVGBaseElement() {}
        function HierarchyElement() {}
        function RenderableDOMElement() {}
        function IImageElement(t, e, r1) {
            this.assetData = e.getAssetData(t.refId), this.assetData && this.assetData.sid && (this.assetData = e.slotManager.getProp(this.assetData)), this.initElement(t, e, r1), this.sourceRect = {
                top: 0,
                left: 0,
                width: this.assetData.w,
                height: this.assetData.h
            };
        }
        function ProcessedElement(t, e) {
            this.elem = t, this.pos = e;
        }
        function IShapeElement() {}
        SVGEffects.prototype.renderFrame = function(t) {
            var e, r1 = this.filters.length;
            for(e = 0; e < r1; e += 1)this.filters[e].renderFrame(t);
        }, SVGEffects.prototype.getEffects = function(t) {
            var e, r1 = this.filters.length, i = [];
            for(e = 0; e < r1; e += 1)this.filters[e].type === t && i.push(this.filters[e]);
            return i;
        }, SVGBaseElement.prototype = {
            initRendererElement: function() {
                this.layerElement = createNS("g");
            },
            createContainerElements: function() {
                this.matteElement = createNS("g"), this.transformedElement = this.layerElement, this.maskedElement = this.layerElement, this._sizeChanged = !1;
                var t = null;
                if (this.data.td) {
                    this.matteMasks = {};
                    var e = createNS("g");
                    e.setAttribute("id", this.layerId), e.appendChild(this.layerElement), t = e, this.globalData.defs.appendChild(e);
                } else this.data.tt ? (this.matteElement.appendChild(this.layerElement), t = this.matteElement, this.baseElement = this.matteElement) : this.baseElement = this.layerElement;
                if (this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), 0 === this.data.ty && !this.data.hd) {
                    var r1 = createNS("clipPath"), i = createNS("path");
                    i.setAttribute("d", "M0,0 L" + this.data.w + ",0 L" + this.data.w + "," + this.data.h + " L0," + this.data.h + "z");
                    var s = createElementID();
                    if (r1.setAttribute("id", s), r1.appendChild(i), this.globalData.defs.appendChild(r1), this.checkMasks()) {
                        var a = createNS("g");
                        a.setAttribute("clip-path", "url(" + getLocationHref() + "#" + s + ")"), a.appendChild(this.layerElement), this.transformedElement = a, t ? t.appendChild(this.transformedElement) : this.baseElement = this.transformedElement;
                    } else this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + s + ")");
                }
                0 !== this.data.bm && this.setBlendMode();
            },
            renderElement: function() {
                this.finalTransform._localMatMdf && this.transformedElement.setAttribute("transform", this.finalTransform.localMat.to2dCSS()), this.finalTransform._opMdf && this.transformedElement.setAttribute("opacity", this.finalTransform.localOpacity);
            },
            destroyBaseElement: function() {
                this.layerElement = null, this.matteElement = null, this.maskManager.destroy();
            },
            getBaseElement: function() {
                return this.data.hd ? null : this.baseElement;
            },
            createRenderableComponents: function() {
                this.maskManager = new MaskElement(this.data, this, this.globalData), this.renderableEffectsManager = new SVGEffects(this), this.searchEffectTransforms();
            },
            getMatte: function(t) {
                if (this.matteMasks || (this.matteMasks = {}), !this.matteMasks[t]) {
                    var e, r1, i, s, a = this.layerId + "_" + t;
                    if (1 === t || 3 === t) {
                        var n = createNS("mask");
                        n.setAttribute("id", a), n.setAttribute("mask-type", 3 === t ? "luminance" : "alpha"), (i = createNS("use")).setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), n.appendChild(i), this.globalData.defs.appendChild(n), featureSupport.maskType || 1 !== t || (n.setAttribute("mask-type", "luminance"), e = createElementID(), r1 = filtersFactory.createFilter(e), this.globalData.defs.appendChild(r1), r1.appendChild(filtersFactory.createAlphaToLuminanceFilter()), (s = createNS("g")).appendChild(i), n.appendChild(s), s.setAttribute("filter", "url(" + getLocationHref() + "#" + e + ")"));
                    } else if (2 === t) {
                        var o = createNS("mask");
                        o.setAttribute("id", a), o.setAttribute("mask-type", "alpha");
                        var h = createNS("g");
                        o.appendChild(h), e = createElementID(), r1 = filtersFactory.createFilter(e);
                        var l = createNS("feComponentTransfer");
                        l.setAttribute("in", "SourceGraphic"), r1.appendChild(l);
                        var p = createNS("feFuncA");
                        p.setAttribute("type", "table"), p.setAttribute("tableValues", "1.0 0.0"), l.appendChild(p), this.globalData.defs.appendChild(r1);
                        var c = createNS("rect");
                        c.setAttribute("width", this.comp.data.w), c.setAttribute("height", this.comp.data.h), c.setAttribute("x", "0"), c.setAttribute("y", "0"), c.setAttribute("fill", "#ffffff"), c.setAttribute("opacity", "0"), h.setAttribute("filter", "url(" + getLocationHref() + "#" + e + ")"), h.appendChild(c), (i = createNS("use")).setAttributeNS("http://www.w3.org/1999/xlink", "href", "#" + this.layerId), h.appendChild(i), featureSupport.maskType || (o.setAttribute("mask-type", "luminance"), r1.appendChild(filtersFactory.createAlphaToLuminanceFilter()), s = createNS("g"), h.appendChild(c), s.appendChild(this.layerElement), h.appendChild(s)), this.globalData.defs.appendChild(o);
                    }
                    this.matteMasks[t] = a;
                }
                return this.matteMasks[t];
            },
            setMatte: function(t) {
                this.matteElement && this.matteElement.setAttribute("mask", "url(" + getLocationHref() + "#" + t + ")");
            }
        }, HierarchyElement.prototype = {
            initHierarchy: function() {
                this.hierarchy = [], this._isParent = !1, this.checkParenting();
            },
            setHierarchy: function(t) {
                this.hierarchy = t;
            },
            setAsParent: function() {
                this._isParent = !0;
            },
            checkParenting: function() {
                void 0 !== this.data.parent && this.comp.buildElementParenting(this, this.data.parent, []);
            }
        }, extendPrototype([
            RenderableElement,
            createProxyFunction({
                initElement: function(t, e, r1) {
                    this.initFrame(), this.initBaseData(t, e, r1), this.initTransform(t, e, r1), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide();
                },
                hide: function() {
                    this.hidden || this.isInRange && !this.isTransparent || ((this.baseElement || this.layerElement).style.display = "none", this.hidden = !0);
                },
                show: function() {
                    this.isInRange && !this.isTransparent && (this.data.hd || ((this.baseElement || this.layerElement).style.display = "block"), this.hidden = !1, this._isFirstFrame = !0);
                },
                renderFrame: function() {
                    this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderLocalTransform(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
                },
                renderInnerContent: function() {},
                prepareFrame: function(t) {
                    this._mdf = !1, this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange), this.checkTransparency();
                },
                destroy: function() {
                    this.innerElem = null, this.destroyBaseElement();
                }
            })
        ], RenderableDOMElement), extendPrototype([
            BaseElement,
            TransformElement,
            SVGBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement
        ], IImageElement), IImageElement.prototype.createContent = function() {
            var t = this.globalData.getAssetsPath(this.assetData);
            this.innerElem = createNS("image"), this.innerElem.setAttribute("width", this.assetData.w + "px"), this.innerElem.setAttribute("height", this.assetData.h + "px"), this.innerElem.setAttribute("preserveAspectRatio", this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio), this.innerElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", t), this.layerElement.appendChild(this.innerElem);
        }, IImageElement.prototype.sourceRectAtTime = function() {
            return this.sourceRect;
        }, IShapeElement.prototype = {
            addShapeToModifiers: function(t) {
                var e, r1 = this.shapeModifiers.length;
                for(e = 0; e < r1; e += 1)this.shapeModifiers[e].addShape(t);
            },
            isShapeInAnimatedModifiers: function(t) {
                for(var e = this.shapeModifiers.length; 0 < e;)if (this.shapeModifiers[0].isAnimatedWithShape(t)) return !0;
                return !1;
            },
            renderModifiers: function() {
                if (this.shapeModifiers.length) {
                    var t, e = this.shapes.length;
                    for(t = 0; t < e; t += 1)this.shapes[t].sh.reset();
                    for(t = (e = this.shapeModifiers.length) - 1; t >= 0 && !this.shapeModifiers[t].processShapes(this._isFirstFrame); t -= 1);
                }
            },
            searchProcessedElement: function(t) {
                for(var e = this.processedElements, r1 = 0, i = e.length; r1 < i;){
                    if (e[r1].elem === t) return e[r1].pos;
                    r1 += 1;
                }
                return 0;
            },
            addProcessedElement: function(t, e) {
                for(var r1 = this.processedElements, i = r1.length; i;)if (r1[i -= 1].elem === t) return void (r1[i].pos = e);
                r1.push(new ProcessedElement(t, e));
            },
            prepareFrame: function(t) {
                this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange);
            }
        };
        var lineCapEnum = {
            1: "butt",
            2: "round",
            3: "square"
        }, lineJoinEnum = {
            1: "miter",
            2: "round",
            3: "bevel"
        };
        function SVGShapeData(t, e, r1) {
            this.caches = [], this.styles = [], this.transformers = t, this.lStr = "", this.sh = r1, this.lvl = e, this._isAnimated = !!r1.k;
            for(var i = 0, s = t.length; i < s;){
                if (t[i].mProps.dynamicProperties.length) {
                    this._isAnimated = !0;
                    break;
                }
                i += 1;
            }
        }
        function SVGStyleData(t, e) {
            this.data = t, this.type = t.ty, this.d = "", this.lvl = e, this._mdf = !1, this.closed = !0 === t.hd, this.pElem = createNS("path"), this.msElem = null;
        }
        function DashProperty(t, e, r1, i) {
            var s;
            this.elem = t, this.frameId = -1, this.dataProps = createSizedArray(e.length), this.renderer = r1, this.k = !1, this.dashStr = "", this.dashArray = createTypedArray("float32", e.length ? e.length - 1 : 0), this.dashoffset = createTypedArray("float32", 1), this.initDynamicPropertyContainer(i);
            var a, n = e.length || 0;
            for(s = 0; s < n; s += 1)a = PropertyFactory.getProp(t, e[s].v, 0, 0, this), this.k = a.k || this.k, this.dataProps[s] = {
                n: e[s].n,
                p: a
            };
            this.k || this.getValue(!0), this._isAnimated = this.k;
        }
        function SVGStrokeStyleData(t, e, r1) {
            this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(t, e.o, 0, .01, this), this.w = PropertyFactory.getProp(t, e.w, 0, null, this), this.d = new DashProperty(t, e.d || {}, "svg", this), this.c = PropertyFactory.getProp(t, e.c, 1, 255, this), this.style = r1, this._isAnimated = !!this._isAnimated;
        }
        function SVGFillStyleData(t, e, r1) {
            this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.o = PropertyFactory.getProp(t, e.o, 0, .01, this), this.c = PropertyFactory.getProp(t, e.c, 1, 255, this), this.style = r1;
        }
        function SVGNoStyleData(t, e, r1) {
            this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.style = r1;
        }
        function GradientProperty(t, e, r1) {
            this.data = e, this.c = createTypedArray("uint8c", 4 * e.p);
            var i = e.k.k[0].s ? e.k.k[0].s.length - 4 * e.p : e.k.k.length - 4 * e.p;
            this.o = createTypedArray("float32", i), this._cmdf = !1, this._omdf = !1, this._collapsable = this.checkCollapsable(), this._hasOpacity = i, this.initDynamicPropertyContainer(r1), this.prop = PropertyFactory.getProp(t, e.k, 1, null, this), this.k = this.prop.k, this.getValue(!0);
        }
        function SVGGradientFillStyleData(t, e, r1) {
            this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.initGradientData(t, e, r1);
        }
        function SVGGradientStrokeStyleData(t, e, r1) {
            this.initDynamicPropertyContainer(t), this.getValue = this.iterateDynamicProperties, this.w = PropertyFactory.getProp(t, e.w, 0, null, this), this.d = new DashProperty(t, e.d || {}, "svg", this), this.initGradientData(t, e, r1), this._isAnimated = !!this._isAnimated;
        }
        function ShapeGroupData() {
            this.it = [], this.prevViewData = [], this.gr = createNS("g");
        }
        function SVGTransformData(t, e, r1) {
            this.transform = {
                mProps: t,
                op: e,
                container: r1
            }, this.elements = [], this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
        }
        SVGShapeData.prototype.setAsAnimated = function() {
            this._isAnimated = !0;
        }, SVGStyleData.prototype.reset = function() {
            this.d = "", this._mdf = !1;
        }, DashProperty.prototype.getValue = function(t) {
            if ((this.elem.globalData.frameId !== this.frameId || t) && (this.frameId = this.elem.globalData.frameId, this.iterateDynamicProperties(), this._mdf = this._mdf || t, this._mdf)) {
                var e = 0, r1 = this.dataProps.length;
                for("svg" === this.renderer && (this.dashStr = ""), e = 0; e < r1; e += 1)"o" !== this.dataProps[e].n ? "svg" === this.renderer ? this.dashStr += " " + this.dataProps[e].p.v : this.dashArray[e] = this.dataProps[e].p.v : this.dashoffset[0] = this.dataProps[e].p.v;
            }
        }, extendPrototype([
            DynamicPropertyContainer
        ], DashProperty), extendPrototype([
            DynamicPropertyContainer
        ], SVGStrokeStyleData), extendPrototype([
            DynamicPropertyContainer
        ], SVGFillStyleData), extendPrototype([
            DynamicPropertyContainer
        ], SVGNoStyleData), GradientProperty.prototype.comparePoints = function(t, e) {
            for(var r1 = 0, i = this.o.length / 2; r1 < i;){
                if (Math.abs(t[4 * r1] - t[4 * e + 2 * r1]) > .01) return !1;
                r1 += 1;
            }
            return !0;
        }, GradientProperty.prototype.checkCollapsable = function() {
            if (this.o.length / 2 != this.c.length / 4) return !1;
            if (this.data.k.k[0].s) for(var t = 0, e = this.data.k.k.length; t < e;){
                if (!this.comparePoints(this.data.k.k[t].s, this.data.p)) return !1;
                t += 1;
            }
            else if (!this.comparePoints(this.data.k.k, this.data.p)) return !1;
            return !0;
        }, GradientProperty.prototype.getValue = function(t) {
            if (this.prop.getValue(), this._mdf = !1, this._cmdf = !1, this._omdf = !1, this.prop._mdf || t) {
                var e, r1, i, s = 4 * this.data.p;
                for(e = 0; e < s; e += 1)r1 = e % 4 == 0 ? 100 : 255, i = Math.round(this.prop.v[e] * r1), this.c[e] !== i && (this.c[e] = i, this._cmdf = !t);
                if (this.o.length) for(s = this.prop.v.length, e = 4 * this.data.p; e < s; e += 1)r1 = e % 2 == 0 ? 100 : 1, i = e % 2 == 0 ? Math.round(100 * this.prop.v[e]) : this.prop.v[e], this.o[e - 4 * this.data.p] !== i && (this.o[e - 4 * this.data.p] = i, this._omdf = !t);
                this._mdf = !t;
            }
        }, extendPrototype([
            DynamicPropertyContainer
        ], GradientProperty), SVGGradientFillStyleData.prototype.initGradientData = function(t, e, r1) {
            this.o = PropertyFactory.getProp(t, e.o, 0, .01, this), this.s = PropertyFactory.getProp(t, e.s, 1, null, this), this.e = PropertyFactory.getProp(t, e.e, 1, null, this), this.h = PropertyFactory.getProp(t, e.h || {
                k: 0
            }, 0, .01, this), this.a = PropertyFactory.getProp(t, e.a || {
                k: 0
            }, 0, degToRads, this), this.g = new GradientProperty(t, e.g, this), this.style = r1, this.stops = [], this.setGradientData(r1.pElem, e), this.setGradientOpacity(e, r1), this._isAnimated = !!this._isAnimated;
        }, SVGGradientFillStyleData.prototype.setGradientData = function(t, e) {
            var r1 = createElementID(), i = createNS(1 === e.t ? "linearGradient" : "radialGradient");
            i.setAttribute("id", r1), i.setAttribute("spreadMethod", "pad"), i.setAttribute("gradientUnits", "userSpaceOnUse");
            var s, a, n, o = [];
            for(n = 4 * e.g.p, a = 0; a < n; a += 4)s = createNS("stop"), i.appendChild(s), o.push(s);
            t.setAttribute("gf" === e.ty ? "fill" : "stroke", "url(" + getLocationHref() + "#" + r1 + ")"), this.gf = i, this.cst = o;
        }, SVGGradientFillStyleData.prototype.setGradientOpacity = function(t, e) {
            if (this.g._hasOpacity && !this.g._collapsable) {
                var r1, i, s, a = createNS("mask"), n = createNS("path");
                a.appendChild(n);
                var o = createElementID(), h = createElementID();
                a.setAttribute("id", h);
                var l = createNS(1 === t.t ? "linearGradient" : "radialGradient");
                l.setAttribute("id", o), l.setAttribute("spreadMethod", "pad"), l.setAttribute("gradientUnits", "userSpaceOnUse"), s = t.g.k.k[0].s ? t.g.k.k[0].s.length : t.g.k.k.length;
                var p = this.stops;
                for(i = 4 * t.g.p; i < s; i += 2)(r1 = createNS("stop")).setAttribute("stop-color", "rgb(255,255,255)"), l.appendChild(r1), p.push(r1);
                n.setAttribute("gf" === t.ty ? "fill" : "stroke", "url(" + getLocationHref() + "#" + o + ")"), "gs" === t.ty && (n.setAttribute("stroke-linecap", lineCapEnum[t.lc || 2]), n.setAttribute("stroke-linejoin", lineJoinEnum[t.lj || 2]), 1 === t.lj && n.setAttribute("stroke-miterlimit", t.ml)), this.of = l, this.ms = a, this.ost = p, this.maskId = h, e.msElem = n;
            }
        }, extendPrototype([
            DynamicPropertyContainer
        ], SVGGradientFillStyleData), extendPrototype([
            SVGGradientFillStyleData,
            DynamicPropertyContainer
        ], SVGGradientStrokeStyleData);
        var buildShapeString = function(t, e, r1, i) {
            if (0 === e) return "";
            var s, a = t.o, n = t.i, o = t.v, h = " M" + i.applyToPointStringified(o[0][0], o[0][1]);
            for(s = 1; s < e; s += 1)h += " C" + i.applyToPointStringified(a[s - 1][0], a[s - 1][1]) + " " + i.applyToPointStringified(n[s][0], n[s][1]) + " " + i.applyToPointStringified(o[s][0], o[s][1]);
            return r1 && e && (h += " C" + i.applyToPointStringified(a[s - 1][0], a[s - 1][1]) + " " + i.applyToPointStringified(n[0][0], n[0][1]) + " " + i.applyToPointStringified(o[0][0], o[0][1]), h += "z"), h;
        }, SVGElementsRenderer = function() {
            var t = new Matrix, e = new Matrix;
            function r1(t, e, r1) {
                (r1 || e.transform.op._mdf) && e.transform.container.setAttribute("opacity", e.transform.op.v), (r1 || e.transform.mProps._mdf) && e.transform.container.setAttribute("transform", e.transform.mProps.v.to2dCSS());
            }
            function i() {}
            function s(r1, i, s) {
                var a, n, o, h, l, p, c, f, u, d, m = i.styles.length, y = i.lvl;
                for(p = 0; p < m; p += 1){
                    if (h = i.sh._mdf || s, i.styles[p].lvl < y) {
                        for(f = e.reset(), u = y - i.styles[p].lvl, d = i.transformers.length - 1; !h && u > 0;)h = i.transformers[d].mProps._mdf || h, u -= 1, d -= 1;
                        if (h) for(u = y - i.styles[p].lvl, d = i.transformers.length - 1; u > 0;)f.multiply(i.transformers[d].mProps.v), u -= 1, d -= 1;
                    } else f = t;
                    if (n = (c = i.sh.paths)._length, h) {
                        for(o = "", a = 0; a < n; a += 1)(l = c.shapes[a]) && l._length && (o += buildShapeString(l, l._length, l.c, f));
                        i.caches[p] = o;
                    } else o = i.caches[p];
                    i.styles[p].d += !0 === r1.hd ? "" : o, i.styles[p]._mdf = h || i.styles[p]._mdf;
                }
            }
            function a(t, e, r1) {
                var i = e.style;
                (e.c._mdf || r1) && i.pElem.setAttribute("fill", "rgb(" + bmFloor(e.c.v[0]) + "," + bmFloor(e.c.v[1]) + "," + bmFloor(e.c.v[2]) + ")"), (e.o._mdf || r1) && i.pElem.setAttribute("fill-opacity", e.o.v);
            }
            function n(t, e, r1) {
                o(t, e, r1), h(0, e, r1);
            }
            function o(t, e, r1) {
                var i, s, a, n, o, h = e.gf, l = e.g._hasOpacity, p = e.s.v, c = e.e.v;
                if (e.o._mdf || r1) {
                    var f = "gf" === t.ty ? "fill-opacity" : "stroke-opacity";
                    e.style.pElem.setAttribute(f, e.o.v);
                }
                if (e.s._mdf || r1) {
                    var u = 1 === t.t ? "x1" : "cx", d = "x1" === u ? "y1" : "cy";
                    h.setAttribute(u, p[0]), h.setAttribute(d, p[1]), l && !e.g._collapsable && (e.of.setAttribute(u, p[0]), e.of.setAttribute(d, p[1]));
                }
                if (e.g._cmdf || r1) {
                    i = e.cst;
                    var m = e.g.c;
                    for(a = i.length, s = 0; s < a; s += 1)(n = i[s]).setAttribute("offset", m[4 * s] + "%"), n.setAttribute("stop-color", "rgb(" + m[4 * s + 1] + "," + m[4 * s + 2] + "," + m[4 * s + 3] + ")");
                }
                if (l && (e.g._omdf || r1)) {
                    var y = e.g.o;
                    for(a = (i = e.g._collapsable ? e.cst : e.ost).length, s = 0; s < a; s += 1)n = i[s], e.g._collapsable || n.setAttribute("offset", y[2 * s] + "%"), n.setAttribute("stop-opacity", y[2 * s + 1]);
                }
                if (1 === t.t) (e.e._mdf || r1) && (h.setAttribute("x2", c[0]), h.setAttribute("y2", c[1]), l && !e.g._collapsable && (e.of.setAttribute("x2", c[0]), e.of.setAttribute("y2", c[1])));
                else if ((e.s._mdf || e.e._mdf || r1) && (o = Math.sqrt(Math.pow(p[0] - c[0], 2) + Math.pow(p[1] - c[1], 2)), h.setAttribute("r", o), l && !e.g._collapsable && e.of.setAttribute("r", o)), e.e._mdf || e.h._mdf || e.a._mdf || r1) {
                    o || (o = Math.sqrt(Math.pow(p[0] - c[0], 2) + Math.pow(p[1] - c[1], 2)));
                    var g = Math.atan2(c[1] - p[1], c[0] - p[0]), v = e.h.v;
                    v >= 1 ? v = .99 : v <= -1 && (v = -0.99);
                    var b = o * v, _ = Math.cos(g + e.a.v) * b + p[0], P = Math.sin(g + e.a.v) * b + p[1];
                    h.setAttribute("fx", _), h.setAttribute("fy", P), l && !e.g._collapsable && (e.of.setAttribute("fx", _), e.of.setAttribute("fy", P));
                }
            }
            function h(t, e, r1) {
                var i = e.style, s = e.d;
                s && (s._mdf || r1) && s.dashStr && (i.pElem.setAttribute("stroke-dasharray", s.dashStr), i.pElem.setAttribute("stroke-dashoffset", s.dashoffset[0])), e.c && (e.c._mdf || r1) && i.pElem.setAttribute("stroke", "rgb(" + bmFloor(e.c.v[0]) + "," + bmFloor(e.c.v[1]) + "," + bmFloor(e.c.v[2]) + ")"), (e.o._mdf || r1) && i.pElem.setAttribute("stroke-opacity", e.o.v), (e.w._mdf || r1) && (i.pElem.setAttribute("stroke-width", e.w.v), i.msElem && i.msElem.setAttribute("stroke-width", e.w.v));
            }
            return {
                createRenderFunction: function(t) {
                    switch(t.ty){
                        case "fl":
                            return a;
                        case "gf":
                            return o;
                        case "gs":
                            return n;
                        case "st":
                            return h;
                        case "sh":
                        case "el":
                        case "rc":
                        case "sr":
                            return s;
                        case "tr":
                            return r1;
                        case "no":
                            return i;
                        default:
                            return null;
                    }
                }
            };
        }();
        function SVGShapeElement(t, e, r1) {
            this.shapes = [], this.shapesData = t.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.initElement(t, e, r1), this.prevViewData = [];
        }
        function LetterProps(t, e, r1, i, s, a) {
            this.o = t, this.sw = e, this.sc = r1, this.fc = i, this.m = s, this.p = a, this._mdf = {
                o: !0,
                sw: !!e,
                sc: !!r1,
                fc: !!i,
                m: !0,
                p: !0
            };
        }
        function TextProperty(t, e) {
            this._frameId = initialDefaultFrame, this.pv = "", this.v = "", this.kf = !1, this._isFirstFrame = !0, this._mdf = !1, e.d && e.d.sid && (e.d = t.globalData.slotManager.getProp(e.d)), this.data = e, this.elem = t, this.comp = this.elem.comp, this.keysIndex = 0, this.canResize = !1, this.minimumFontSize = 1, this.effectsSequence = [], this.currentData = {
                ascent: 0,
                boxWidth: this.defaultBoxWidth,
                f: "",
                fStyle: "",
                fWeight: "",
                fc: "",
                j: "",
                justifyOffset: "",
                l: [],
                lh: 0,
                lineWidths: [],
                ls: "",
                of: "",
                s: "",
                sc: "",
                sw: 0,
                t: 0,
                tr: 0,
                sz: 0,
                ps: null,
                fillColorAnim: !1,
                strokeColorAnim: !1,
                strokeWidthAnim: !1,
                yOffset: 0,
                finalSize: 0,
                finalText: [],
                finalLineHeight: 0,
                __complete: !1
            }, this.copyData(this.currentData, this.data.d.k[0].s), this.searchProperty() || this.completeTextData(this.currentData);
        }
        extendPrototype([
            BaseElement,
            TransformElement,
            SVGBaseElement,
            IShapeElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement
        ], SVGShapeElement), SVGShapeElement.prototype.initSecondaryElement = function() {}, SVGShapeElement.prototype.identityMatrix = new Matrix, SVGShapeElement.prototype.buildExpressionInterface = function() {}, SVGShapeElement.prototype.createContent = function() {
            this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes();
        }, SVGShapeElement.prototype.filterUniqueShapes = function() {
            var t, e, r1, i, s = this.shapes.length, a = this.stylesList.length, n = [], o = !1;
            for(r1 = 0; r1 < a; r1 += 1){
                for(i = this.stylesList[r1], o = !1, n.length = 0, t = 0; t < s; t += 1)-1 !== (e = this.shapes[t]).styles.indexOf(i) && (n.push(e), o = e._isAnimated || o);
                n.length > 1 && o && this.setShapesAsAnimated(n);
            }
        }, SVGShapeElement.prototype.setShapesAsAnimated = function(t) {
            var e, r1 = t.length;
            for(e = 0; e < r1; e += 1)t[e].setAsAnimated();
        }, SVGShapeElement.prototype.createStyleElement = function(t, e) {
            var r1, i = new SVGStyleData(t, e), s = i.pElem;
            return "st" === t.ty ? r1 = new SVGStrokeStyleData(this, t, i) : "fl" === t.ty ? r1 = new SVGFillStyleData(this, t, i) : "gf" === t.ty || "gs" === t.ty ? (r1 = new ("gf" === t.ty ? SVGGradientFillStyleData : SVGGradientStrokeStyleData)(this, t, i), this.globalData.defs.appendChild(r1.gf), r1.maskId && (this.globalData.defs.appendChild(r1.ms), this.globalData.defs.appendChild(r1.of), s.setAttribute("mask", "url(" + getLocationHref() + "#" + r1.maskId + ")"))) : "no" === t.ty && (r1 = new SVGNoStyleData(this, t, i)), "st" !== t.ty && "gs" !== t.ty || (s.setAttribute("stroke-linecap", lineCapEnum[t.lc || 2]), s.setAttribute("stroke-linejoin", lineJoinEnum[t.lj || 2]), s.setAttribute("fill-opacity", "0"), 1 === t.lj && s.setAttribute("stroke-miterlimit", t.ml)), 2 === t.r && s.setAttribute("fill-rule", "evenodd"), t.ln && s.setAttribute("id", t.ln), t.cl && s.setAttribute("class", t.cl), t.bm && (s.style["mix-blend-mode"] = getBlendMode(t.bm)), this.stylesList.push(i), this.addToAnimatedContents(t, r1), r1;
        }, SVGShapeElement.prototype.createGroupElement = function(t) {
            var e = new ShapeGroupData;
            return t.ln && e.gr.setAttribute("id", t.ln), t.cl && e.gr.setAttribute("class", t.cl), t.bm && (e.gr.style["mix-blend-mode"] = getBlendMode(t.bm)), e;
        }, SVGShapeElement.prototype.createTransformElement = function(t, e) {
            var r1 = TransformPropertyFactory.getTransformProperty(this, t, this), i = new SVGTransformData(r1, r1.o, e);
            return this.addToAnimatedContents(t, i), i;
        }, SVGShapeElement.prototype.createShapeElement = function(t, e, r1) {
            var i = 4;
            "rc" === t.ty ? i = 5 : "el" === t.ty ? i = 6 : "sr" === t.ty && (i = 7);
            var s = new SVGShapeData(e, r1, ShapePropertyFactory.getShapeProp(this, t, i, this));
            return this.shapes.push(s), this.addShapeToModifiers(s), this.addToAnimatedContents(t, s), s;
        }, SVGShapeElement.prototype.addToAnimatedContents = function(t, e) {
            for(var r1 = 0, i = this.animatedContents.length; r1 < i;){
                if (this.animatedContents[r1].element === e) return;
                r1 += 1;
            }
            this.animatedContents.push({
                fn: SVGElementsRenderer.createRenderFunction(t),
                element: e,
                data: t
            });
        }, SVGShapeElement.prototype.setElementStyles = function(t) {
            var e, r1 = t.styles, i = this.stylesList.length;
            for(e = 0; e < i; e += 1)this.stylesList[e].closed || r1.push(this.stylesList[e]);
        }, SVGShapeElement.prototype.reloadShapes = function() {
            var t;
            this._isFirstFrame = !0;
            var e = this.itemsData.length;
            for(t = 0; t < e; t += 1)this.prevViewData[t] = this.itemsData[t];
            for(this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], !0), this.filterUniqueShapes(), e = this.dynamicProperties.length, t = 0; t < e; t += 1)this.dynamicProperties[t].getValue();
            this.renderModifiers();
        }, SVGShapeElement.prototype.searchShapes = function(t, e, r1, i, s, a, n) {
            var o, h, l, p, c, f, u = [].concat(a), d = t.length - 1, m = [], y = [];
            for(o = d; o >= 0; o -= 1){
                if ((f = this.searchProcessedElement(t[o])) ? e[o] = r1[f - 1] : t[o]._render = n, "fl" === t[o].ty || "st" === t[o].ty || "gf" === t[o].ty || "gs" === t[o].ty || "no" === t[o].ty) f ? e[o].style.closed = !1 : e[o] = this.createStyleElement(t[o], s), t[o]._render && e[o].style.pElem.parentNode !== i && i.appendChild(e[o].style.pElem), m.push(e[o].style);
                else if ("gr" === t[o].ty) {
                    if (f) for(l = e[o].it.length, h = 0; h < l; h += 1)e[o].prevViewData[h] = e[o].it[h];
                    else e[o] = this.createGroupElement(t[o]);
                    this.searchShapes(t[o].it, e[o].it, e[o].prevViewData, e[o].gr, s + 1, u, n), t[o]._render && e[o].gr.parentNode !== i && i.appendChild(e[o].gr);
                } else "tr" === t[o].ty ? (f || (e[o] = this.createTransformElement(t[o], i)), p = e[o].transform, u.push(p)) : "sh" === t[o].ty || "rc" === t[o].ty || "el" === t[o].ty || "sr" === t[o].ty ? (f || (e[o] = this.createShapeElement(t[o], u, s)), this.setElementStyles(e[o])) : "tm" === t[o].ty || "rd" === t[o].ty || "ms" === t[o].ty || "pb" === t[o].ty || "zz" === t[o].ty || "op" === t[o].ty ? (f ? (c = e[o]).closed = !1 : ((c = ShapeModifiers.getModifier(t[o].ty)).init(this, t[o]), e[o] = c, this.shapeModifiers.push(c)), y.push(c)) : "rp" === t[o].ty && (f ? (c = e[o]).closed = !0 : (c = ShapeModifiers.getModifier(t[o].ty), e[o] = c, c.init(this, t, o, e), this.shapeModifiers.push(c), n = !1), y.push(c));
                this.addProcessedElement(t[o], o + 1);
            }
            for(d = m.length, o = 0; o < d; o += 1)m[o].closed = !0;
            for(d = y.length, o = 0; o < d; o += 1)y[o].closed = !0;
        }, SVGShapeElement.prototype.renderInnerContent = function() {
            var t;
            this.renderModifiers();
            var e = this.stylesList.length;
            for(t = 0; t < e; t += 1)this.stylesList[t].reset();
            for(this.renderShape(), t = 0; t < e; t += 1)(this.stylesList[t]._mdf || this._isFirstFrame) && (this.stylesList[t].msElem && (this.stylesList[t].msElem.setAttribute("d", this.stylesList[t].d), this.stylesList[t].d = "M0 0" + this.stylesList[t].d), this.stylesList[t].pElem.setAttribute("d", this.stylesList[t].d || "M0 0"));
        }, SVGShapeElement.prototype.renderShape = function() {
            var t, e, r1 = this.animatedContents.length;
            for(t = 0; t < r1; t += 1)e = this.animatedContents[t], (this._isFirstFrame || e.element._isAnimated) && !0 !== e.data && e.fn(e.data, e.element, this._isFirstFrame);
        }, SVGShapeElement.prototype.destroy = function() {
            this.destroyBaseElement(), this.shapesData = null, this.itemsData = null;
        }, LetterProps.prototype.update = function(t, e, r1, i, s, a) {
            this._mdf.o = !1, this._mdf.sw = !1, this._mdf.sc = !1, this._mdf.fc = !1, this._mdf.m = !1, this._mdf.p = !1;
            var n = !1;
            return this.o !== t && (this.o = t, this._mdf.o = !0, n = !0), this.sw !== e && (this.sw = e, this._mdf.sw = !0, n = !0), this.sc !== r1 && (this.sc = r1, this._mdf.sc = !0, n = !0), this.fc !== i && (this.fc = i, this._mdf.fc = !0, n = !0), this.m !== s && (this.m = s, this._mdf.m = !0, n = !0), !a.length || this.p[0] === a[0] && this.p[1] === a[1] && this.p[4] === a[4] && this.p[5] === a[5] && this.p[12] === a[12] && this.p[13] === a[13] || (this.p = a, this._mdf.p = !0, n = !0), n;
        }, TextProperty.prototype.defaultBoxWidth = [
            0,
            0
        ], TextProperty.prototype.copyData = function(t, e) {
            for(var r1 in e)Object.prototype.hasOwnProperty.call(e, r1) && (t[r1] = e[r1]);
            return t;
        }, TextProperty.prototype.setCurrentData = function(t) {
            t.__complete || this.completeTextData(t), this.currentData = t, this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth, this._mdf = !0;
        }, TextProperty.prototype.searchProperty = function() {
            return this.searchKeyframes();
        }, TextProperty.prototype.searchKeyframes = function() {
            return this.kf = this.data.d.k.length > 1, this.kf && this.addEffect(this.getKeyframeValue.bind(this)), this.kf;
        }, TextProperty.prototype.addEffect = function(t) {
            this.effectsSequence.push(t), this.elem.addDynamicProperty(this);
        }, TextProperty.prototype.getValue = function(t) {
            if (this.elem.globalData.frameId !== this.frameId && this.effectsSequence.length || t) {
                this.currentData.t = this.data.d.k[this.keysIndex].s.t;
                var e = this.currentData, r1 = this.keysIndex;
                if (this.lock) this.setCurrentData(this.currentData);
                else {
                    var i;
                    this.lock = !0, this._mdf = !1;
                    var s = this.effectsSequence.length, a = t || this.data.d.k[this.keysIndex].s;
                    for(i = 0; i < s; i += 1)a = r1 !== this.keysIndex ? this.effectsSequence[i](a, a.t) : this.effectsSequence[i](this.currentData, a.t);
                    e !== a && this.setCurrentData(a), this.v = this.currentData, this.pv = this.v, this.lock = !1, this.frameId = this.elem.globalData.frameId;
                }
            }
        }, TextProperty.prototype.getKeyframeValue = function() {
            for(var t = this.data.d.k, e = this.elem.comp.renderedFrame, r1 = 0, i = t.length; r1 <= i - 1 && !(r1 === i - 1 || t[r1 + 1].t > e);)r1 += 1;
            return this.keysIndex !== r1 && (this.keysIndex = r1), this.data.d.k[this.keysIndex].s;
        }, TextProperty.prototype.buildFinalText = function(t) {
            for(var e, r1, i = [], s = 0, a = t.length, n = !1, o = !1, h = ""; s < a;)n = o, o = !1, e = t.charCodeAt(s), h = t.charAt(s), FontManager.isCombinedCharacter(e) ? n = !0 : e >= 55296 && e <= 56319 ? FontManager.isRegionalFlag(t, s) ? h = t.substr(s, 14) : (r1 = t.charCodeAt(s + 1)) >= 56320 && r1 <= 57343 && (FontManager.isModifier(e, r1) ? (h = t.substr(s, 2), n = !0) : h = FontManager.isFlagEmoji(t.substr(s, 4)) ? t.substr(s, 4) : t.substr(s, 2)) : e > 56319 ? (r1 = t.charCodeAt(s + 1), FontManager.isVariationSelector(e) && (n = !0)) : FontManager.isZeroWidthJoiner(e) && (n = !0, o = !0), n ? (i[i.length - 1] += h, n = !1) : i.push(h), s += h.length;
            return i;
        }, TextProperty.prototype.completeTextData = function(t) {
            t.__complete = !0;
            var e, r1, i, s, a, n, o, h = this.elem.globalData.fontManager, l = this.data, p = [], c = 0, f = l.m.g, u = 0, d = 0, m = 0, y = [], g = 0, v = 0, b = h.getFontByName(t.f), _ = 0, P = getFontProperties(b);
            t.fWeight = P.weight, t.fStyle = P.style, t.finalSize = t.s, t.finalText = this.buildFinalText(t.t), r1 = t.finalText.length, t.finalLineHeight = t.lh;
            var S, E = t.tr / 1e3 * t.finalSize;
            if (t.sz) for(var x, C, A = !0, w = t.sz[0], k = t.sz[1]; A;){
                x = 0, g = 0, r1 = (C = this.buildFinalText(t.t)).length, E = t.tr / 1e3 * t.finalSize;
                var T = -1;
                for(e = 0; e < r1; e += 1)S = C[e].charCodeAt(0), i = !1, " " === C[e] ? T = e : 13 !== S && 3 !== S || (g = 0, i = !0, x += t.finalLineHeight || 1.2 * t.finalSize), h.chars ? (o = h.getCharData(C[e], b.fStyle, b.fFamily), _ = i ? 0 : o.w * t.finalSize / 100) : _ = h.measureText(C[e], t.f, t.finalSize), g + _ > w && " " !== C[e] ? (-1 === T ? r1 += 1 : e = T, x += t.finalLineHeight || 1.2 * t.finalSize, C.splice(e, T === e ? 1 : 0, "\r"), T = -1, g = 0) : (g += _, g += E);
                x += b.ascent * t.finalSize / 100, this.canResize && t.finalSize > this.minimumFontSize && k < x ? (t.finalSize -= 1, t.finalLineHeight = t.finalSize * t.lh / t.s) : (t.finalText = C, r1 = t.finalText.length, A = !1);
            }
            g = -E, _ = 0;
            var M, D = 0;
            for(e = 0; e < r1; e += 1)if (i = !1, 13 === (S = (M = t.finalText[e]).charCodeAt(0)) || 3 === S ? (D = 0, y.push(g), v = g > v ? g : v, g = -2 * E, s = "", i = !0, m += 1) : s = M, h.chars ? (o = h.getCharData(M, b.fStyle, h.getFontByName(t.f).fFamily), _ = i ? 0 : o.w * t.finalSize / 100) : _ = h.measureText(s, t.f, t.finalSize), " " === M ? D += _ + E : (g += _ + E + D, D = 0), p.push({
                l: _,
                an: _,
                add: u,
                n: i,
                anIndexes: [],
                val: s,
                line: m,
                animatorJustifyOffset: 0
            }), 2 == f) {
                if (u += _, "" === s || " " === s || e === r1 - 1) {
                    for("" !== s && " " !== s || (u -= _); d <= e;)p[d].an = u, p[d].ind = c, p[d].extra = _, d += 1;
                    c += 1, u = 0;
                }
            } else if (3 == f) {
                if (u += _, "" === s || e === r1 - 1) {
                    for("" === s && (u -= _); d <= e;)p[d].an = u, p[d].ind = c, p[d].extra = _, d += 1;
                    u = 0, c += 1;
                }
            } else p[c].ind = c, p[c].extra = 0, c += 1;
            if (t.l = p, v = g > v ? g : v, y.push(g), t.sz) t.boxWidth = t.sz[0], t.justifyOffset = 0;
            else switch(t.boxWidth = v, t.j){
                case 1:
                    t.justifyOffset = -t.boxWidth;
                    break;
                case 2:
                    t.justifyOffset = -t.boxWidth / 2;
                    break;
                default:
                    t.justifyOffset = 0;
            }
            t.lineWidths = y;
            var F, I, R, L, V = l.a;
            n = V.length;
            var B = [];
            for(a = 0; a < n; a += 1){
                for((F = V[a]).a.sc && (t.strokeColorAnim = !0), F.a.sw && (t.strokeWidthAnim = !0), (F.a.fc || F.a.fh || F.a.fs || F.a.fb) && (t.fillColorAnim = !0), L = 0, R = F.s.b, e = 0; e < r1; e += 1)(I = p[e]).anIndexes[a] = L, (1 == R && "" !== I.val || 2 == R && "" !== I.val && " " !== I.val || 3 == R && (I.n || " " == I.val || e == r1 - 1) || 4 == R && (I.n || e == r1 - 1)) && (1 === F.s.rn && B.push(L), L += 1);
                l.a[a].s.totalChars = L;
                var O, $ = -1;
                if (1 === F.s.rn) for(e = 0; e < r1; e += 1)$ != (I = p[e]).anIndexes[a] && ($ = I.anIndexes[a], O = B.splice(Math.floor(Math.random() * B.length), 1)[0]), I.anIndexes[a] = O;
            }
            t.yOffset = t.finalLineHeight || 1.2 * t.finalSize, t.ls = t.ls || 0, t.ascent = b.ascent * t.finalSize / 100;
        }, TextProperty.prototype.updateDocumentData = function(t, e) {
            e = void 0 === e ? this.keysIndex : e;
            var r1 = this.copyData({}, this.data.d.k[e].s);
            r1 = this.copyData(r1, t), this.data.d.k[e].s = r1, this.recalculate(e), this.setCurrentData(r1), this.elem.addDynamicProperty(this);
        }, TextProperty.prototype.recalculate = function(t) {
            var e = this.data.d.k[t].s;
            e.__complete = !1, this.keysIndex = 0, this._isFirstFrame = !0, this.getValue(e);
        }, TextProperty.prototype.canResizeFont = function(t) {
            this.canResize = t, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
        }, TextProperty.prototype.setMinimumFontSize = function(t) {
            this.minimumFontSize = Math.floor(t) || 1, this.recalculate(this.keysIndex), this.elem.addDynamicProperty(this);
        };
        var TextSelectorProp = function() {
            var t = Math.max, e = Math.min, r1 = Math.floor;
            function i(t, e) {
                this._currentTextLength = -1, this.k = !1, this.data = e, this.elem = t, this.comp = t.comp, this.finalS = 0, this.finalE = 0, this.initDynamicPropertyContainer(t), this.s = PropertyFactory.getProp(t, e.s || {
                    k: 0
                }, 0, 0, this), this.e = "e" in e ? PropertyFactory.getProp(t, e.e, 0, 0, this) : {
                    v: 100
                }, this.o = PropertyFactory.getProp(t, e.o || {
                    k: 0
                }, 0, 0, this), this.xe = PropertyFactory.getProp(t, e.xe || {
                    k: 0
                }, 0, 0, this), this.ne = PropertyFactory.getProp(t, e.ne || {
                    k: 0
                }, 0, 0, this), this.sm = PropertyFactory.getProp(t, e.sm || {
                    k: 100
                }, 0, 0, this), this.a = PropertyFactory.getProp(t, e.a, 0, .01, this), this.dynamicProperties.length || this.getValue();
            }
            return i.prototype = {
                getMult: function(i) {
                    this._currentTextLength !== this.elem.textProperty.currentData.l.length && this.getValue();
                    var s = 0, a = 0, n = 1, o = 1;
                    this.ne.v > 0 ? s = this.ne.v / 100 : a = -this.ne.v / 100, this.xe.v > 0 ? n = 1 - this.xe.v / 100 : o = 1 + this.xe.v / 100;
                    var h = BezierFactory.getBezierEasing(s, a, n, o).get, l = 0, p = this.finalS, c = this.finalE, f = this.data.sh;
                    if (2 === f) l = h(l = c === p ? i >= c ? 1 : 0 : t(0, e(.5 / (c - p) + (i - p) / (c - p), 1)));
                    else if (3 === f) l = h(l = c === p ? i >= c ? 0 : 1 : 1 - t(0, e(.5 / (c - p) + (i - p) / (c - p), 1)));
                    else if (4 === f) c === p ? l = 0 : (l = t(0, e(.5 / (c - p) + (i - p) / (c - p), 1))) < .5 ? l *= 2 : l = 1 - 2 * (l - .5), l = h(l);
                    else if (5 === f) {
                        if (c === p) l = 0;
                        else {
                            var u = c - p, d = -u / 2 + (i = e(t(0, i + .5 - p), c - p)), m = u / 2;
                            l = Math.sqrt(1 - d * d / (m * m));
                        }
                        l = h(l);
                    } else 6 === f ? (c === p ? l = 0 : (i = e(t(0, i + .5 - p), c - p), l = (1 + Math.cos(Math.PI + 2 * Math.PI * i / (c - p))) / 2), l = h(l)) : (i >= r1(p) && (l = t(0, e(i - p < 0 ? e(c, 1) - (p - i) : c - i, 1))), l = h(l));
                    if (100 !== this.sm.v) {
                        var y = .01 * this.sm.v;
                        0 === y && (y = 1e-8);
                        var g = .5 - .5 * y;
                        l < g ? l = 0 : (l = (l - g) / y) > 1 && (l = 1);
                    }
                    return l * this.a.v;
                },
                getValue: function(t) {
                    this.iterateDynamicProperties(), this._mdf = t || this._mdf, this._currentTextLength = this.elem.textProperty.currentData.l.length || 0, t && 2 === this.data.r && (this.e.v = this._currentTextLength);
                    var e = 2 === this.data.r ? 1 : 100 / this.data.totalChars, r1 = this.o.v / e, i = this.s.v / e + r1, s = this.e.v / e + r1;
                    if (i > s) {
                        var a = i;
                        i = s, s = a;
                    }
                    this.finalS = i, this.finalE = s;
                }
            }, extendPrototype([
                DynamicPropertyContainer
            ], i), {
                getTextSelectorProp: function(t, e, r1) {
                    return new i(t, e, r1);
                }
            };
        }();
        function TextAnimatorDataProperty(t, e, r1) {
            var i = {
                propType: !1
            }, s = PropertyFactory.getProp, a = e.a;
            this.a = {
                r: a.r ? s(t, a.r, 0, degToRads, r1) : i,
                rx: a.rx ? s(t, a.rx, 0, degToRads, r1) : i,
                ry: a.ry ? s(t, a.ry, 0, degToRads, r1) : i,
                sk: a.sk ? s(t, a.sk, 0, degToRads, r1) : i,
                sa: a.sa ? s(t, a.sa, 0, degToRads, r1) : i,
                s: a.s ? s(t, a.s, 1, .01, r1) : i,
                a: a.a ? s(t, a.a, 1, 0, r1) : i,
                o: a.o ? s(t, a.o, 0, .01, r1) : i,
                p: a.p ? s(t, a.p, 1, 0, r1) : i,
                sw: a.sw ? s(t, a.sw, 0, 0, r1) : i,
                sc: a.sc ? s(t, a.sc, 1, 0, r1) : i,
                fc: a.fc ? s(t, a.fc, 1, 0, r1) : i,
                fh: a.fh ? s(t, a.fh, 0, 0, r1) : i,
                fs: a.fs ? s(t, a.fs, 0, .01, r1) : i,
                fb: a.fb ? s(t, a.fb, 0, .01, r1) : i,
                t: a.t ? s(t, a.t, 0, 0, r1) : i
            }, this.s = TextSelectorProp.getTextSelectorProp(t, e.s, r1), this.s.t = e.s.t;
        }
        function TextAnimatorProperty(t, e, r1) {
            this._isFirstFrame = !0, this._hasMaskedPath = !1, this._frameId = -1, this._textData = t, this._renderType = e, this._elem = r1, this._animatorsData = createSizedArray(this._textData.a.length), this._pathData = {}, this._moreOptions = {
                alignment: {}
            }, this.renderedLetters = [], this.lettersChangedFlag = !1, this.initDynamicPropertyContainer(r1);
        }
        function ITextElement() {}
        TextAnimatorProperty.prototype.searchProperties = function() {
            var t, e, r1 = this._textData.a.length, i = PropertyFactory.getProp;
            for(t = 0; t < r1; t += 1)e = this._textData.a[t], this._animatorsData[t] = new TextAnimatorDataProperty(this._elem, e, this);
            this._textData.p && "m" in this._textData.p ? (this._pathData = {
                a: i(this._elem, this._textData.p.a, 0, 0, this),
                f: i(this._elem, this._textData.p.f, 0, 0, this),
                l: i(this._elem, this._textData.p.l, 0, 0, this),
                r: i(this._elem, this._textData.p.r, 0, 0, this),
                p: i(this._elem, this._textData.p.p, 0, 0, this),
                m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
            }, this._hasMaskedPath = !0) : this._hasMaskedPath = !1, this._moreOptions.alignment = i(this._elem, this._textData.m.a, 1, 0, this);
        }, TextAnimatorProperty.prototype.getMeasures = function(t, e) {
            if (this.lettersChangedFlag = e, this._mdf || this._isFirstFrame || e || this._hasMaskedPath && this._pathData.m._mdf) {
                this._isFirstFrame = !1;
                var r1, i, s, a, n, o, h, l, p, c, f, u, d, m, y, g, v, b, _, P = this._moreOptions.alignment.v, S = this._animatorsData, E = this._textData, x = this.mHelper, C = this._renderType, A = this.renderedLetters.length, w = t.l;
                if (this._hasMaskedPath) {
                    if (_ = this._pathData.m, !this._pathData.n || this._pathData._mdf) {
                        var k, T = _.v;
                        for(this._pathData.r.v && (T = T.reverse()), n = {
                            tLength: 0,
                            segments: []
                        }, a = T._length - 1, g = 0, s = 0; s < a; s += 1)k = bez.buildBezierData(T.v[s], T.v[s + 1], [
                            T.o[s][0] - T.v[s][0],
                            T.o[s][1] - T.v[s][1]
                        ], [
                            T.i[s + 1][0] - T.v[s + 1][0],
                            T.i[s + 1][1] - T.v[s + 1][1]
                        ]), n.tLength += k.segmentLength, n.segments.push(k), g += k.segmentLength;
                        s = a, _.v.c && (k = bez.buildBezierData(T.v[s], T.v[0], [
                            T.o[s][0] - T.v[s][0],
                            T.o[s][1] - T.v[s][1]
                        ], [
                            T.i[0][0] - T.v[0][0],
                            T.i[0][1] - T.v[0][1]
                        ]), n.tLength += k.segmentLength, n.segments.push(k), g += k.segmentLength), this._pathData.pi = n;
                    }
                    if (n = this._pathData.pi, o = this._pathData.f.v, f = 0, c = 1, l = 0, p = !0, m = n.segments, o < 0 && _.v.c) for(n.tLength < Math.abs(o) && (o = -Math.abs(o) % n.tLength), c = (d = m[f = m.length - 1].points).length - 1; o < 0;)o += d[c].partialLength, (c -= 1) < 0 && (c = (d = m[f -= 1].points).length - 1);
                    u = (d = m[f].points)[c - 1], y = (h = d[c]).partialLength;
                }
                a = w.length, r1 = 0, i = 0;
                var M, D, F, I, R, L = 1.2 * t.finalSize * .714, V = !0;
                F = S.length;
                var B, O, $, z, G, N, j, H, q, W, U, Y, J = -1, X = o, K = f, Z = c, Q = -1, tt = "", et = this.defaultPropsArray;
                if (2 === t.j || 1 === t.j) {
                    var rt = 0, it = 0, st = 2 === t.j ? -0.5 : -1, at = 0, nt = !0;
                    for(s = 0; s < a; s += 1)if (w[s].n) {
                        for(rt && (rt += it); at < s;)w[at].animatorJustifyOffset = rt, at += 1;
                        rt = 0, nt = !0;
                    } else {
                        for(D = 0; D < F; D += 1)(M = S[D].a).t.propType && (nt && 2 === t.j && (it += M.t.v * st), (R = S[D].s.getMult(w[s].anIndexes[D], E.a[D].s.totalChars)).length ? rt += M.t.v * R[0] * st : rt += M.t.v * R * st);
                        nt = !1;
                    }
                    for(rt && (rt += it); at < s;)w[at].animatorJustifyOffset = rt, at += 1;
                }
                for(s = 0; s < a; s += 1){
                    if (x.reset(), z = 1, w[s].n) r1 = 0, i += t.yOffset, i += V ? 1 : 0, o = X, V = !1, this._hasMaskedPath && (c = Z, u = (d = m[f = K].points)[c - 1], y = (h = d[c]).partialLength, l = 0), tt = "", U = "", q = "", Y = "", et = this.defaultPropsArray;
                    else {
                        if (this._hasMaskedPath) {
                            if (Q !== w[s].line) {
                                switch(t.j){
                                    case 1:
                                        o += g - t.lineWidths[w[s].line];
                                        break;
                                    case 2:
                                        o += (g - t.lineWidths[w[s].line]) / 2;
                                }
                                Q = w[s].line;
                            }
                            J !== w[s].ind && (w[J] && (o += w[J].extra), o += w[s].an / 2, J = w[s].ind), o += P[0] * w[s].an * .005;
                            var ot = 0;
                            for(D = 0; D < F; D += 1)(M = S[D].a).p.propType && ((R = S[D].s.getMult(w[s].anIndexes[D], E.a[D].s.totalChars)).length ? ot += M.p.v[0] * R[0] : ot += M.p.v[0] * R), M.a.propType && ((R = S[D].s.getMult(w[s].anIndexes[D], E.a[D].s.totalChars)).length ? ot += M.a.v[0] * R[0] : ot += M.a.v[0] * R);
                            for(p = !0, this._pathData.a.v && (o = .5 * w[0].an + (g - this._pathData.f.v - .5 * w[0].an - .5 * w[w.length - 1].an) * J / (a - 1), o += this._pathData.f.v); p;)l + y >= o + ot || !d ? (v = (o + ot - l) / h.partialLength, O = u.point[0] + (h.point[0] - u.point[0]) * v, $ = u.point[1] + (h.point[1] - u.point[1]) * v, x.translate(-P[0] * w[s].an * .005, -P[1] * L * .01), p = !1) : d && (l += h.partialLength, (c += 1) >= d.length && (c = 0, m[f += 1] ? d = m[f].points : _.v.c ? (c = 0, d = m[f = 0].points) : (l -= h.partialLength, d = null)), d && (u = h, y = (h = d[c]).partialLength));
                            B = w[s].an / 2 - w[s].add, x.translate(-B, 0, 0);
                        } else B = w[s].an / 2 - w[s].add, x.translate(-B, 0, 0), x.translate(-P[0] * w[s].an * .005, -P[1] * L * .01, 0);
                        for(D = 0; D < F; D += 1)(M = S[D].a).t.propType && (R = S[D].s.getMult(w[s].anIndexes[D], E.a[D].s.totalChars), 0 === r1 && 0 === t.j || (this._hasMaskedPath ? R.length ? o += M.t.v * R[0] : o += M.t.v * R : R.length ? r1 += M.t.v * R[0] : r1 += M.t.v * R));
                        for(t.strokeWidthAnim && (N = t.sw || 0), t.strokeColorAnim && (G = t.sc ? [
                            t.sc[0],
                            t.sc[1],
                            t.sc[2]
                        ] : [
                            0,
                            0,
                            0
                        ]), t.fillColorAnim && t.fc && (j = [
                            t.fc[0],
                            t.fc[1],
                            t.fc[2]
                        ]), D = 0; D < F; D += 1)(M = S[D].a).a.propType && ((R = S[D].s.getMult(w[s].anIndexes[D], E.a[D].s.totalChars)).length ? x.translate(-M.a.v[0] * R[0], -M.a.v[1] * R[1], M.a.v[2] * R[2]) : x.translate(-M.a.v[0] * R, -M.a.v[1] * R, M.a.v[2] * R));
                        for(D = 0; D < F; D += 1)(M = S[D].a).s.propType && ((R = S[D].s.getMult(w[s].anIndexes[D], E.a[D].s.totalChars)).length ? x.scale(1 + (M.s.v[0] - 1) * R[0], 1 + (M.s.v[1] - 1) * R[1], 1) : x.scale(1 + (M.s.v[0] - 1) * R, 1 + (M.s.v[1] - 1) * R, 1));
                        for(D = 0; D < F; D += 1){
                            if (M = S[D].a, R = S[D].s.getMult(w[s].anIndexes[D], E.a[D].s.totalChars), M.sk.propType && (R.length ? x.skewFromAxis(-M.sk.v * R[0], M.sa.v * R[1]) : x.skewFromAxis(-M.sk.v * R, M.sa.v * R)), M.r.propType && (R.length ? x.rotateZ(-M.r.v * R[2]) : x.rotateZ(-M.r.v * R)), M.ry.propType && (R.length ? x.rotateY(M.ry.v * R[1]) : x.rotateY(M.ry.v * R)), M.rx.propType && (R.length ? x.rotateX(M.rx.v * R[0]) : x.rotateX(M.rx.v * R)), M.o.propType && (R.length ? z += (M.o.v * R[0] - z) * R[0] : z += (M.o.v * R - z) * R), t.strokeWidthAnim && M.sw.propType && (R.length ? N += M.sw.v * R[0] : N += M.sw.v * R), t.strokeColorAnim && M.sc.propType) for(H = 0; H < 3; H += 1)R.length ? G[H] += (M.sc.v[H] - G[H]) * R[0] : G[H] += (M.sc.v[H] - G[H]) * R;
                            if (t.fillColorAnim && t.fc) {
                                if (M.fc.propType) for(H = 0; H < 3; H += 1)R.length ? j[H] += (M.fc.v[H] - j[H]) * R[0] : j[H] += (M.fc.v[H] - j[H]) * R;
                                M.fh.propType && (j = R.length ? addHueToRGB(j, M.fh.v * R[0]) : addHueToRGB(j, M.fh.v * R)), M.fs.propType && (j = R.length ? addSaturationToRGB(j, M.fs.v * R[0]) : addSaturationToRGB(j, M.fs.v * R)), M.fb.propType && (j = R.length ? addBrightnessToRGB(j, M.fb.v * R[0]) : addBrightnessToRGB(j, M.fb.v * R));
                            }
                        }
                        for(D = 0; D < F; D += 1)(M = S[D].a).p.propType && (R = S[D].s.getMult(w[s].anIndexes[D], E.a[D].s.totalChars), this._hasMaskedPath ? R.length ? x.translate(0, M.p.v[1] * R[0], -M.p.v[2] * R[1]) : x.translate(0, M.p.v[1] * R, -M.p.v[2] * R) : R.length ? x.translate(M.p.v[0] * R[0], M.p.v[1] * R[1], -M.p.v[2] * R[2]) : x.translate(M.p.v[0] * R, M.p.v[1] * R, -M.p.v[2] * R));
                        if (t.strokeWidthAnim && (q = N < 0 ? 0 : N), t.strokeColorAnim && (W = "rgb(" + Math.round(255 * G[0]) + "," + Math.round(255 * G[1]) + "," + Math.round(255 * G[2]) + ")"), t.fillColorAnim && t.fc && (U = "rgb(" + Math.round(255 * j[0]) + "," + Math.round(255 * j[1]) + "," + Math.round(255 * j[2]) + ")"), this._hasMaskedPath) {
                            if (x.translate(0, -t.ls), x.translate(0, P[1] * L * .01 + i, 0), this._pathData.p.v) {
                                b = (h.point[1] - u.point[1]) / (h.point[0] - u.point[0]);
                                var ht = 180 * Math.atan(b) / Math.PI;
                                h.point[0] < u.point[0] && (ht += 180), x.rotate(-ht * Math.PI / 180);
                            }
                            x.translate(O, $, 0), o -= P[0] * w[s].an * .005, w[s + 1] && J !== w[s + 1].ind && (o += w[s].an / 2, o += .001 * t.tr * t.finalSize);
                        } else {
                            switch(x.translate(r1, i, 0), t.ps && x.translate(t.ps[0], t.ps[1] + t.ascent, 0), t.j){
                                case 1:
                                    x.translate(w[s].animatorJustifyOffset + t.justifyOffset + (t.boxWidth - t.lineWidths[w[s].line]), 0, 0);
                                    break;
                                case 2:
                                    x.translate(w[s].animatorJustifyOffset + t.justifyOffset + (t.boxWidth - t.lineWidths[w[s].line]) / 2, 0, 0);
                            }
                            x.translate(0, -t.ls), x.translate(B, 0, 0), x.translate(P[0] * w[s].an * .005, P[1] * L * .01, 0), r1 += w[s].l + .001 * t.tr * t.finalSize;
                        }
                        "html" === C ? tt = x.toCSS() : "svg" === C ? tt = x.to2dCSS() : et = [
                            x.props[0],
                            x.props[1],
                            x.props[2],
                            x.props[3],
                            x.props[4],
                            x.props[5],
                            x.props[6],
                            x.props[7],
                            x.props[8],
                            x.props[9],
                            x.props[10],
                            x.props[11],
                            x.props[12],
                            x.props[13],
                            x.props[14],
                            x.props[15]
                        ], Y = z;
                    }
                    A <= s ? (I = new LetterProps(Y, q, W, U, tt, et), this.renderedLetters.push(I), A += 1, this.lettersChangedFlag = !0) : (I = this.renderedLetters[s], this.lettersChangedFlag = I.update(Y, q, W, U, tt, et) || this.lettersChangedFlag);
                }
            }
        }, TextAnimatorProperty.prototype.getValue = function() {
            this._elem.globalData.frameId !== this._frameId && (this._frameId = this._elem.globalData.frameId, this.iterateDynamicProperties());
        }, TextAnimatorProperty.prototype.mHelper = new Matrix, TextAnimatorProperty.prototype.defaultPropsArray = [], extendPrototype([
            DynamicPropertyContainer
        ], TextAnimatorProperty), ITextElement.prototype.initElement = function(t, e, r1) {
            this.lettersChangedFlag = !0, this.initFrame(), this.initBaseData(t, e, r1), this.textProperty = new TextProperty(this, t.t, this.dynamicProperties), this.textAnimator = new TextAnimatorProperty(t.t, this.renderType, this), this.initTransform(t, e, r1), this.initHierarchy(), this.initRenderable(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), this.createContent(), this.hide(), this.textAnimator.searchProperties(this.dynamicProperties);
        }, ITextElement.prototype.prepareFrame = function(t) {
            this._mdf = !1, this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange);
        }, ITextElement.prototype.createPathShape = function(t, e) {
            var r1, i, s = e.length, a = "";
            for(r1 = 0; r1 < s; r1 += 1)"sh" === e[r1].ty && (i = e[r1].ks.k, a += buildShapeString(i, i.i.length, !0, t));
            return a;
        }, ITextElement.prototype.updateDocumentData = function(t, e) {
            this.textProperty.updateDocumentData(t, e);
        }, ITextElement.prototype.canResizeFont = function(t) {
            this.textProperty.canResizeFont(t);
        }, ITextElement.prototype.setMinimumFontSize = function(t) {
            this.textProperty.setMinimumFontSize(t);
        }, ITextElement.prototype.applyTextPropertiesToMatrix = function(t, e, r1, i, s) {
            switch(t.ps && e.translate(t.ps[0], t.ps[1] + t.ascent, 0), e.translate(0, -t.ls, 0), t.j){
                case 1:
                    e.translate(t.justifyOffset + (t.boxWidth - t.lineWidths[r1]), 0, 0);
                    break;
                case 2:
                    e.translate(t.justifyOffset + (t.boxWidth - t.lineWidths[r1]) / 2, 0, 0);
            }
            e.translate(i, s, 0);
        }, ITextElement.prototype.buildColor = function(t) {
            return "rgb(" + Math.round(255 * t[0]) + "," + Math.round(255 * t[1]) + "," + Math.round(255 * t[2]) + ")";
        }, ITextElement.prototype.emptyProp = new LetterProps, ITextElement.prototype.destroy = function() {}, ITextElement.prototype.validateText = function() {
            (this.textProperty._mdf || this.textProperty._isFirstFrame) && (this.buildNewText(), this.textProperty._isFirstFrame = !1, this.textProperty._mdf = !1);
        };
        var emptyShapeData = {
            shapes: []
        };
        function SVGTextLottieElement(t, e, r1) {
            this.textSpans = [], this.renderType = "svg", this.initElement(t, e, r1);
        }
        function ISolidElement(t, e, r1) {
            this.initElement(t, e, r1);
        }
        function NullElement(t, e, r1) {
            this.initFrame(), this.initBaseData(t, e, r1), this.initFrame(), this.initTransform(t, e, r1), this.initHierarchy();
        }
        function SVGRendererBase() {}
        function ICompElement() {}
        function SVGCompElement(t, e, r1) {
            this.layers = t.layers, this.supports3d = !0, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(t, e, r1), this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this) : {
                _placeholder: !0
            };
        }
        function SVGRenderer(t, e) {
            this.animationItem = t, this.layers = null, this.renderedFrame = -1, this.svgElement = createNS("svg");
            var r1 = "";
            if (e && e.title) {
                var i = createNS("title"), s = createElementID();
                i.setAttribute("id", s), i.textContent = e.title, this.svgElement.appendChild(i), r1 += s;
            }
            if (e && e.description) {
                var a = createNS("desc"), n = createElementID();
                a.setAttribute("id", n), a.textContent = e.description, this.svgElement.appendChild(a), r1 += " " + n;
            }
            r1 && this.svgElement.setAttribute("aria-labelledby", r1);
            var o = createNS("defs");
            this.svgElement.appendChild(o);
            var h = createNS("g");
            this.svgElement.appendChild(h), this.layerElement = h, this.renderConfig = {
                preserveAspectRatio: e && e.preserveAspectRatio || "xMidYMid meet",
                imagePreserveAspectRatio: e && e.imagePreserveAspectRatio || "xMidYMid slice",
                contentVisibility: e && e.contentVisibility || "visible",
                progressiveLoad: e && e.progressiveLoad || !1,
                hideOnTransparent: !(e && !1 === e.hideOnTransparent),
                viewBoxOnly: e && e.viewBoxOnly || !1,
                viewBoxSize: e && e.viewBoxSize || !1,
                className: e && e.className || "",
                id: e && e.id || "",
                focusable: e && e.focusable,
                filterSize: {
                    width: e && e.filterSize && e.filterSize.width || "100%",
                    height: e && e.filterSize && e.filterSize.height || "100%",
                    x: e && e.filterSize && e.filterSize.x || "0%",
                    y: e && e.filterSize && e.filterSize.y || "0%"
                },
                width: e && e.width,
                height: e && e.height,
                runExpressions: !e || void 0 === e.runExpressions || e.runExpressions
            }, this.globalData = {
                _mdf: !1,
                frameNum: -1,
                defs: o,
                renderConfig: this.renderConfig
            }, this.elements = [], this.pendingElements = [], this.destroyed = !1, this.rendererType = "svg";
        }
        function ShapeTransformManager() {
            this.sequences = {}, this.sequenceList = [], this.transform_key_count = 0;
        }
        extendPrototype([
            BaseElement,
            TransformElement,
            SVGBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement,
            ITextElement
        ], SVGTextLottieElement), SVGTextLottieElement.prototype.createContent = function() {
            this.data.singleShape && !this.globalData.fontManager.chars && (this.textContainer = createNS("text"));
        }, SVGTextLottieElement.prototype.buildTextContents = function(t) {
            for(var e = 0, r1 = t.length, i = [], s = ""; e < r1;)t[e] === String.fromCharCode(13) || t[e] === String.fromCharCode(3) ? (i.push(s), s = "") : s += t[e], e += 1;
            return i.push(s), i;
        }, SVGTextLottieElement.prototype.buildShapeData = function(t, e) {
            if (t.shapes && t.shapes.length) {
                var r1 = t.shapes[0];
                if (r1.it) {
                    var i = r1.it[r1.it.length - 1];
                    i.s && (i.s.k[0] = e, i.s.k[1] = e);
                }
            }
            return t;
        }, SVGTextLottieElement.prototype.buildNewText = function() {
            var t, e;
            this.addDynamicProperty(this);
            var r1 = this.textProperty.currentData;
            this.renderedLetters = createSizedArray(r1 ? r1.l.length : 0), r1.fc ? this.layerElement.setAttribute("fill", this.buildColor(r1.fc)) : this.layerElement.setAttribute("fill", "rgba(0,0,0,0)"), r1.sc && (this.layerElement.setAttribute("stroke", this.buildColor(r1.sc)), this.layerElement.setAttribute("stroke-width", r1.sw)), this.layerElement.setAttribute("font-size", r1.finalSize);
            var i = this.globalData.fontManager.getFontByName(r1.f);
            if (i.fClass) this.layerElement.setAttribute("class", i.fClass);
            else {
                this.layerElement.setAttribute("font-family", i.fFamily);
                var s = r1.fWeight, a = r1.fStyle;
                this.layerElement.setAttribute("font-style", a), this.layerElement.setAttribute("font-weight", s);
            }
            this.layerElement.setAttribute("aria-label", r1.t);
            var n, o = r1.l || [], h = !!this.globalData.fontManager.chars;
            e = o.length;
            var l = this.mHelper, p = this.data.singleShape, c = 0, f = 0, u = !0, d = .001 * r1.tr * r1.finalSize;
            if (!p || h || r1.sz) {
                var m, y = this.textSpans.length;
                for(t = 0; t < e; t += 1){
                    if (this.textSpans[t] || (this.textSpans[t] = {
                        span: null,
                        childSpan: null,
                        glyph: null
                    }), !h || !p || 0 === t) {
                        if (n = y > t ? this.textSpans[t].span : createNS(h ? "g" : "text"), y <= t) {
                            if (n.setAttribute("stroke-linecap", "butt"), n.setAttribute("stroke-linejoin", "round"), n.setAttribute("stroke-miterlimit", "4"), this.textSpans[t].span = n, h) {
                                var g = createNS("g");
                                n.appendChild(g), this.textSpans[t].childSpan = g;
                            }
                            this.textSpans[t].span = n, this.layerElement.appendChild(n);
                        }
                        n.style.display = "inherit";
                    }
                    if (l.reset(), p && (o[t].n && (c = -d, f += r1.yOffset, f += u ? 1 : 0, u = !1), this.applyTextPropertiesToMatrix(r1, l, o[t].line, c, f), c += o[t].l || 0, c += d), h) {
                        var v;
                        if (1 === (m = this.globalData.fontManager.getCharData(r1.finalText[t], i.fStyle, this.globalData.fontManager.getFontByName(r1.f).fFamily)).t) v = new SVGCompElement(m.data, this.globalData, this);
                        else {
                            var b = emptyShapeData;
                            m.data && m.data.shapes && (b = this.buildShapeData(m.data, r1.finalSize)), v = new SVGShapeElement(b, this.globalData, this);
                        }
                        if (this.textSpans[t].glyph) {
                            var _ = this.textSpans[t].glyph;
                            this.textSpans[t].childSpan.removeChild(_.layerElement), _.destroy();
                        }
                        this.textSpans[t].glyph = v, v._debug = !0, v.prepareFrame(0), v.renderFrame(), this.textSpans[t].childSpan.appendChild(v.layerElement), 1 === m.t && this.textSpans[t].childSpan.setAttribute("transform", "scale(" + r1.finalSize / 100 + "," + r1.finalSize / 100 + ")");
                    } else p && n.setAttribute("transform", "translate(" + l.props[12] + "," + l.props[13] + ")"), n.textContent = o[t].val, n.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve");
                }
                p && n && n.setAttribute("d", "");
            } else {
                var P = this.textContainer, S = "start";
                switch(r1.j){
                    case 1:
                        S = "end";
                        break;
                    case 2:
                        S = "middle";
                        break;
                    default:
                        S = "start";
                }
                P.setAttribute("text-anchor", S), P.setAttribute("letter-spacing", d);
                var E = this.buildTextContents(r1.finalText);
                for(e = E.length, f = r1.ps ? r1.ps[1] + r1.ascent : 0, t = 0; t < e; t += 1)(n = this.textSpans[t].span || createNS("tspan")).textContent = E[t], n.setAttribute("x", 0), n.setAttribute("y", f), n.style.display = "inherit", P.appendChild(n), this.textSpans[t] || (this.textSpans[t] = {
                    span: null,
                    glyph: null
                }), this.textSpans[t].span = n, f += r1.finalLineHeight;
                this.layerElement.appendChild(P);
            }
            for(; t < this.textSpans.length;)this.textSpans[t].span.style.display = "none", t += 1;
            this._sizeChanged = !0;
        }, SVGTextLottieElement.prototype.sourceRectAtTime = function() {
            if (this.prepareFrame(this.comp.renderedFrame - this.data.st), this.renderInnerContent(), this._sizeChanged) {
                this._sizeChanged = !1;
                var t = this.layerElement.getBBox();
                this.bbox = {
                    top: t.y,
                    left: t.x,
                    width: t.width,
                    height: t.height
                };
            }
            return this.bbox;
        }, SVGTextLottieElement.prototype.getValue = function() {
            var t, e, r1 = this.textSpans.length;
            for(this.renderedFrame = this.comp.renderedFrame, t = 0; t < r1; t += 1)(e = this.textSpans[t].glyph) && (e.prepareFrame(this.comp.renderedFrame - this.data.st), e._mdf && (this._mdf = !0));
        }, SVGTextLottieElement.prototype.renderInnerContent = function() {
            if (this.validateText(), (!this.data.singleShape || this._mdf) && (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag)) {
                var t, e;
                this._sizeChanged = !0;
                var r1, i, s, a = this.textAnimator.renderedLetters, n = this.textProperty.currentData.l;
                for(e = n.length, t = 0; t < e; t += 1)n[t].n || (r1 = a[t], i = this.textSpans[t].span, (s = this.textSpans[t].glyph) && s.renderFrame(), r1._mdf.m && i.setAttribute("transform", r1.m), r1._mdf.o && i.setAttribute("opacity", r1.o), r1._mdf.sw && i.setAttribute("stroke-width", r1.sw), r1._mdf.sc && i.setAttribute("stroke", r1.sc), r1._mdf.fc && i.setAttribute("fill", r1.fc));
            }
        }, extendPrototype([
            IImageElement
        ], ISolidElement), ISolidElement.prototype.createContent = function() {
            var t = createNS("rect");
            t.setAttribute("width", this.data.sw), t.setAttribute("height", this.data.sh), t.setAttribute("fill", this.data.sc), this.layerElement.appendChild(t);
        }, NullElement.prototype.prepareFrame = function(t) {
            this.prepareProperties(t, !0);
        }, NullElement.prototype.renderFrame = function() {}, NullElement.prototype.getBaseElement = function() {
            return null;
        }, NullElement.prototype.destroy = function() {}, NullElement.prototype.sourceRectAtTime = function() {}, NullElement.prototype.hide = function() {}, extendPrototype([
            BaseElement,
            TransformElement,
            HierarchyElement,
            FrameElement
        ], NullElement), extendPrototype([
            BaseRenderer
        ], SVGRendererBase), SVGRendererBase.prototype.createNull = function(t) {
            return new NullElement(t, this.globalData, this);
        }, SVGRendererBase.prototype.createShape = function(t) {
            return new SVGShapeElement(t, this.globalData, this);
        }, SVGRendererBase.prototype.createText = function(t) {
            return new SVGTextLottieElement(t, this.globalData, this);
        }, SVGRendererBase.prototype.createImage = function(t) {
            return new IImageElement(t, this.globalData, this);
        }, SVGRendererBase.prototype.createSolid = function(t) {
            return new ISolidElement(t, this.globalData, this);
        }, SVGRendererBase.prototype.configAnimation = function(t) {
            this.svgElement.setAttribute("xmlns", "http://www.w3.org/2000/svg"), this.svgElement.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink"), this.renderConfig.viewBoxSize ? this.svgElement.setAttribute("viewBox", this.renderConfig.viewBoxSize) : this.svgElement.setAttribute("viewBox", "0 0 " + t.w + " " + t.h), this.renderConfig.viewBoxOnly || (this.svgElement.setAttribute("width", t.w), this.svgElement.setAttribute("height", t.h), this.svgElement.style.width = "100%", this.svgElement.style.height = "100%", this.svgElement.style.transform = "translate3d(0,0,0)", this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility), this.renderConfig.width && this.svgElement.setAttribute("width", this.renderConfig.width), this.renderConfig.height && this.svgElement.setAttribute("height", this.renderConfig.height), this.renderConfig.className && this.svgElement.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.svgElement.setAttribute("id", this.renderConfig.id), void 0 !== this.renderConfig.focusable && this.svgElement.setAttribute("focusable", this.renderConfig.focusable), this.svgElement.setAttribute("preserveAspectRatio", this.renderConfig.preserveAspectRatio), this.animationItem.wrapper.appendChild(this.svgElement);
            var e = this.globalData.defs;
            this.setupGlobalData(t, e), this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.data = t;
            var r1 = createNS("clipPath"), i = createNS("rect");
            i.setAttribute("width", t.w), i.setAttribute("height", t.h), i.setAttribute("x", 0), i.setAttribute("y", 0);
            var s = createElementID();
            r1.setAttribute("id", s), r1.appendChild(i), this.layerElement.setAttribute("clip-path", "url(" + getLocationHref() + "#" + s + ")"), e.appendChild(r1), this.layers = t.layers, this.elements = createSizedArray(t.layers.length);
        }, SVGRendererBase.prototype.destroy = function() {
            var t;
            this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.layerElement = null, this.globalData.defs = null;
            var e = this.layers ? this.layers.length : 0;
            for(t = 0; t < e; t += 1)this.elements[t] && this.elements[t].destroy && this.elements[t].destroy();
            this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
        }, SVGRendererBase.prototype.updateContainerSize = function() {}, SVGRendererBase.prototype.findIndexByInd = function(t) {
            var e = 0, r1 = this.layers.length;
            for(e = 0; e < r1; e += 1)if (this.layers[e].ind === t) return e;
            return -1;
        }, SVGRendererBase.prototype.buildItem = function(t) {
            var e = this.elements;
            if (!e[t] && 99 !== this.layers[t].ty) {
                e[t] = !0;
                var r1 = this.createItem(this.layers[t]);
                if (e[t] = r1, getExpressionsPlugin() && (0 === this.layers[t].ty && this.globalData.projectInterface.registerComposition(r1), r1.initExpressions()), this.appendElementInPos(r1, t), this.layers[t].tt) {
                    var i = "tp" in this.layers[t] ? this.findIndexByInd(this.layers[t].tp) : t - 1;
                    if (-1 === i) return;
                    if (this.elements[i] && !0 !== this.elements[i]) {
                        var s = e[i].getMatte(this.layers[t].tt);
                        r1.setMatte(s);
                    } else this.buildItem(i), this.addPendingElement(r1);
                }
            }
        }, SVGRendererBase.prototype.checkPendingElements = function() {
            for(; this.pendingElements.length;){
                var t = this.pendingElements.pop();
                if (t.checkParenting(), t.data.tt) for(var e = 0, r1 = this.elements.length; e < r1;){
                    if (this.elements[e] === t) {
                        var i = "tp" in t.data ? this.findIndexByInd(t.data.tp) : e - 1, s = this.elements[i].getMatte(this.layers[e].tt);
                        t.setMatte(s);
                        break;
                    }
                    e += 1;
                }
            }
        }, SVGRendererBase.prototype.renderFrame = function(t) {
            if (this.renderedFrame !== t && !this.destroyed) {
                var e;
                null === t ? t = this.renderedFrame : this.renderedFrame = t, this.globalData.frameNum = t, this.globalData.frameId += 1, this.globalData.projectInterface.currentFrame = t, this.globalData._mdf = !1;
                var r1 = this.layers.length;
                for(this.completeLayers || this.checkLayers(t), e = r1 - 1; e >= 0; e -= 1)(this.completeLayers || this.elements[e]) && this.elements[e].prepareFrame(t - this.layers[e].st);
                if (this.globalData._mdf) for(e = 0; e < r1; e += 1)(this.completeLayers || this.elements[e]) && this.elements[e].renderFrame();
            }
        }, SVGRendererBase.prototype.appendElementInPos = function(t, e) {
            var r1 = t.getBaseElement();
            if (r1) {
                for(var i, s = 0; s < e;)this.elements[s] && !0 !== this.elements[s] && this.elements[s].getBaseElement() && (i = this.elements[s].getBaseElement()), s += 1;
                i ? this.layerElement.insertBefore(r1, i) : this.layerElement.appendChild(r1);
            }
        }, SVGRendererBase.prototype.hide = function() {
            this.layerElement.style.display = "none";
        }, SVGRendererBase.prototype.show = function() {
            this.layerElement.style.display = "block";
        }, extendPrototype([
            BaseElement,
            TransformElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement
        ], ICompElement), ICompElement.prototype.initElement = function(t, e, r1) {
            this.initFrame(), this.initBaseData(t, e, r1), this.initTransform(t, e, r1), this.initRenderable(), this.initHierarchy(), this.initRendererElement(), this.createContainerElements(), this.createRenderableComponents(), !this.data.xt && e.progressiveLoad || this.buildAllItems(), this.hide();
        }, ICompElement.prototype.prepareFrame = function(t) {
            if (this._mdf = !1, this.prepareRenderableFrame(t), this.prepareProperties(t, this.isInRange), this.isInRange || this.data.xt) {
                if (this.tm._placeholder) this.renderedFrame = t / this.data.sr;
                else {
                    var e = this.tm.v;
                    e === this.data.op && (e = this.data.op - 1), this.renderedFrame = e;
                }
                var r1, i = this.elements.length;
                for(this.completeLayers || this.checkLayers(this.renderedFrame), r1 = i - 1; r1 >= 0; r1 -= 1)(this.completeLayers || this.elements[r1]) && (this.elements[r1].prepareFrame(this.renderedFrame - this.layers[r1].st), this.elements[r1]._mdf && (this._mdf = !0));
            }
        }, ICompElement.prototype.renderInnerContent = function() {
            var t, e = this.layers.length;
            for(t = 0; t < e; t += 1)(this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
        }, ICompElement.prototype.setElements = function(t) {
            this.elements = t;
        }, ICompElement.prototype.getElements = function() {
            return this.elements;
        }, ICompElement.prototype.destroyElements = function() {
            var t, e = this.layers.length;
            for(t = 0; t < e; t += 1)this.elements[t] && this.elements[t].destroy();
        }, ICompElement.prototype.destroy = function() {
            this.destroyElements(), this.destroyBaseElement();
        }, extendPrototype([
            SVGRendererBase,
            ICompElement,
            SVGBaseElement
        ], SVGCompElement), SVGCompElement.prototype.createComp = function(t) {
            return new SVGCompElement(t, this.globalData, this);
        }, extendPrototype([
            SVGRendererBase
        ], SVGRenderer), SVGRenderer.prototype.createComp = function(t) {
            return new SVGCompElement(t, this.globalData, this);
        }, ShapeTransformManager.prototype = {
            addTransformSequence: function(t) {
                var e, r1 = t.length, i = "_";
                for(e = 0; e < r1; e += 1)i += t[e].transform.key + "_";
                var s = this.sequences[i];
                return s || (s = {
                    transforms: [].concat(t),
                    finalTransform: new Matrix,
                    _mdf: !1
                }, this.sequences[i] = s, this.sequenceList.push(s)), s;
            },
            processSequence: function(t, e) {
                for(var r1 = 0, i = t.transforms.length, s = e; r1 < i && !e;){
                    if (t.transforms[r1].transform.mProps._mdf) {
                        s = !0;
                        break;
                    }
                    r1 += 1;
                }
                if (s) for(t.finalTransform.reset(), r1 = i - 1; r1 >= 0; r1 -= 1)t.finalTransform.multiply(t.transforms[r1].transform.mProps.v);
                t._mdf = s;
            },
            processSequences: function(t) {
                var e, r1 = this.sequenceList.length;
                for(e = 0; e < r1; e += 1)this.processSequence(this.sequenceList[e], t);
            },
            getNewKey: function() {
                return this.transform_key_count += 1, "_" + this.transform_key_count;
            }
        };
        var lumaLoader = function() {
            var t = "__lottie_element_luma_buffer", e = null, r1 = null, i = null;
            function s() {
                var s, a, n;
                e || (s = createNS("svg"), a = createNS("filter"), n = createNS("feColorMatrix"), a.setAttribute("id", t), n.setAttribute("type", "matrix"), n.setAttribute("color-interpolation-filters", "sRGB"), n.setAttribute("values", "0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0"), a.appendChild(n), s.appendChild(a), s.setAttribute("id", t + "_svg"), featureSupport.svgLumaHidden && (s.style.display = "none"), i = s, document.body.appendChild(i), e = createTag("canvas"), (r1 = e.getContext("2d")).filter = "url(#" + t + ")", r1.fillStyle = "rgba(0,0,0,0)", r1.fillRect(0, 0, 1, 1));
            }
            return {
                load: s,
                get: function(i) {
                    return e || s(), e.width = i.width, e.height = i.height, r1.filter = "url(#" + t + ")", e;
                }
            };
        };
        function createCanvas(t, e) {
            if (featureSupport.offscreenCanvas) return new OffscreenCanvas(t, e);
            var r1 = createTag("canvas");
            return r1.width = t, r1.height = e, r1;
        }
        var assetLoader = {
            loadLumaCanvas: lumaLoader.load,
            getLumaCanvas: lumaLoader.get,
            createCanvas: createCanvas
        }, registeredEffects = {};
        function CVEffects(t) {
            var e, r1, i = t.data.ef ? t.data.ef.length : 0;
            for(this.filters = [], e = 0; e < i; e += 1){
                r1 = null;
                var s = t.data.ef[e].ty;
                registeredEffects[s] && (r1 = new registeredEffects[s].effect(t.effectsManager.effectElements[e], t)), r1 && this.filters.push(r1);
            }
            this.filters.length && t.addRenderableComponent(this);
        }
        function registerEffect(t, e) {
            registeredEffects[t] = {
                effect: e
            };
        }
        function CVMaskElement(t, e) {
            var r1;
            this.data = t, this.element = e, this.masksProperties = this.data.masksProperties || [], this.viewData = createSizedArray(this.masksProperties.length);
            var i = this.masksProperties.length, s = !1;
            for(r1 = 0; r1 < i; r1 += 1)"n" !== this.masksProperties[r1].mode && (s = !0), this.viewData[r1] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[r1], 3);
            this.hasMasks = s, s && this.element.addRenderableComponent(this);
        }
        function CVBaseElement() {}
        CVEffects.prototype.renderFrame = function(t) {
            var e, r1 = this.filters.length;
            for(e = 0; e < r1; e += 1)this.filters[e].renderFrame(t);
        }, CVEffects.prototype.getEffects = function(t) {
            var e, r1 = this.filters.length, i = [];
            for(e = 0; e < r1; e += 1)this.filters[e].type === t && i.push(this.filters[e]);
            return i;
        }, CVMaskElement.prototype.renderFrame = function() {
            if (this.hasMasks) {
                var t, e, r1, i, s = this.element.finalTransform.mat, a = this.element.canvasContext, n = this.masksProperties.length;
                for(a.beginPath(), t = 0; t < n; t += 1)if ("n" !== this.masksProperties[t].mode) {
                    var o;
                    this.masksProperties[t].inv && (a.moveTo(0, 0), a.lineTo(this.element.globalData.compSize.w, 0), a.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h), a.lineTo(0, this.element.globalData.compSize.h), a.lineTo(0, 0)), i = this.viewData[t].v, e = s.applyToPointArray(i.v[0][0], i.v[0][1], 0), a.moveTo(e[0], e[1]);
                    var h = i._length;
                    for(o = 1; o < h; o += 1)r1 = s.applyToTriplePoints(i.o[o - 1], i.i[o], i.v[o]), a.bezierCurveTo(r1[0], r1[1], r1[2], r1[3], r1[4], r1[5]);
                    r1 = s.applyToTriplePoints(i.o[o - 1], i.i[0], i.v[0]), a.bezierCurveTo(r1[0], r1[1], r1[2], r1[3], r1[4], r1[5]);
                }
                this.element.globalData.renderer.save(!0), a.clip();
            }
        }, CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty, CVMaskElement.prototype.destroy = function() {
            this.element = null;
        };
        var operationsMap = {
            1: "source-in",
            2: "source-out",
            3: "source-in",
            4: "source-out"
        };
        function CVShapeData(t, e, r1, i) {
            this.styledShapes = [], this.tr = [
                0,
                0,
                0,
                0,
                0,
                0
            ];
            var s, a = 4;
            "rc" === e.ty ? a = 5 : "el" === e.ty ? a = 6 : "sr" === e.ty && (a = 7), this.sh = ShapePropertyFactory.getShapeProp(t, e, a, t);
            var n, o = r1.length;
            for(s = 0; s < o; s += 1)r1[s].closed || (n = {
                transforms: i.addTransformSequence(r1[s].transforms),
                trNodes: []
            }, this.styledShapes.push(n), r1[s].elements.push(n));
        }
        function CVShapeElement(t, e, r1) {
            this.shapes = [], this.shapesData = t.shapes, this.stylesList = [], this.itemsData = [], this.prevViewData = [], this.shapeModifiers = [], this.processedElements = [], this.transformsManager = new ShapeTransformManager, this.initElement(t, e, r1);
        }
        function CVTextElement(t, e, r1) {
            this.textSpans = [], this.yOffset = 0, this.fillColorAnim = !1, this.strokeColorAnim = !1, this.strokeWidthAnim = !1, this.stroke = !1, this.fill = !1, this.justifyOffset = 0, this.currentRender = null, this.renderType = "canvas", this.values = {
                fill: "rgba(0,0,0,0)",
                stroke: "rgba(0,0,0,0)",
                sWidth: 0,
                fValue: ""
            }, this.initElement(t, e, r1);
        }
        function CVImageElement(t, e, r1) {
            this.assetData = e.getAssetData(t.refId), this.img = e.imageLoader.getAsset(this.assetData), this.initElement(t, e, r1);
        }
        function CVSolidElement(t, e, r1) {
            this.initElement(t, e, r1);
        }
        function CanvasRendererBase() {}
        function CanvasContext() {
            this.opacity = -1, this.transform = createTypedArray("float32", 16), this.fillStyle = "", this.strokeStyle = "", this.lineWidth = "", this.lineCap = "", this.lineJoin = "", this.miterLimit = "", this.id = Math.random();
        }
        function CVContextData() {
            var t;
            for(this.stack = [], this.cArrPos = 0, this.cTr = new Matrix, t = 0; t < 15; t += 1){
                var e = new CanvasContext;
                this.stack[t] = e;
            }
            this._length = 15, this.nativeContext = null, this.transformMat = new Matrix, this.currentOpacity = 1, this.currentFillStyle = "", this.appliedFillStyle = "", this.currentStrokeStyle = "", this.appliedStrokeStyle = "", this.currentLineWidth = "", this.appliedLineWidth = "", this.currentLineCap = "", this.appliedLineCap = "", this.currentLineJoin = "", this.appliedLineJoin = "", this.appliedMiterLimit = "", this.currentMiterLimit = "";
        }
        function CVCompElement(t, e, r1) {
            this.completeLayers = !1, this.layers = t.layers, this.pendingElements = [], this.elements = createSizedArray(this.layers.length), this.initElement(t, e, r1), this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this) : {
                _placeholder: !0
            };
        }
        function CanvasRenderer(t, e) {
            this.animationItem = t, this.renderConfig = {
                clearCanvas: !e || void 0 === e.clearCanvas || e.clearCanvas,
                context: e && e.context || null,
                progressiveLoad: e && e.progressiveLoad || !1,
                preserveAspectRatio: e && e.preserveAspectRatio || "xMidYMid meet",
                imagePreserveAspectRatio: e && e.imagePreserveAspectRatio || "xMidYMid slice",
                contentVisibility: e && e.contentVisibility || "visible",
                className: e && e.className || "",
                id: e && e.id || "",
                runExpressions: !e || void 0 === e.runExpressions || e.runExpressions
            }, this.renderConfig.dpr = e && e.dpr || 1, this.animationItem.wrapper && (this.renderConfig.dpr = e && e.dpr || window.devicePixelRatio || 1), this.renderedFrame = -1, this.globalData = {
                frameNum: -1,
                _mdf: !1,
                renderConfig: this.renderConfig,
                currentGlobalAlpha: -1
            }, this.contextData = new CVContextData, this.elements = [], this.pendingElements = [], this.transformMat = new Matrix, this.completeLayers = !1, this.rendererType = "canvas", this.renderConfig.clearCanvas && (this.ctxTransform = this.contextData.transform.bind(this.contextData), this.ctxOpacity = this.contextData.opacity.bind(this.contextData), this.ctxFillStyle = this.contextData.fillStyle.bind(this.contextData), this.ctxStrokeStyle = this.contextData.strokeStyle.bind(this.contextData), this.ctxLineWidth = this.contextData.lineWidth.bind(this.contextData), this.ctxLineCap = this.contextData.lineCap.bind(this.contextData), this.ctxLineJoin = this.contextData.lineJoin.bind(this.contextData), this.ctxMiterLimit = this.contextData.miterLimit.bind(this.contextData), this.ctxFill = this.contextData.fill.bind(this.contextData), this.ctxFillRect = this.contextData.fillRect.bind(this.contextData), this.ctxStroke = this.contextData.stroke.bind(this.contextData), this.save = this.contextData.save.bind(this.contextData));
        }
        function HBaseElement() {}
        function HSolidElement(t, e, r1) {
            this.initElement(t, e, r1);
        }
        function HShapeElement(t, e, r1) {
            this.shapes = [], this.shapesData = t.shapes, this.stylesList = [], this.shapeModifiers = [], this.itemsData = [], this.processedElements = [], this.animatedContents = [], this.shapesContainer = createNS("g"), this.initElement(t, e, r1), this.prevViewData = [], this.currentBBox = {
                x: 999999,
                y: -999999,
                h: 0,
                w: 0
            };
        }
        function HTextElement(t, e, r1) {
            this.textSpans = [], this.textPaths = [], this.currentBBox = {
                x: 999999,
                y: -999999,
                h: 0,
                w: 0
            }, this.renderType = "svg", this.isMasked = !1, this.initElement(t, e, r1);
        }
        function HCameraElement(t, e, r1) {
            this.initFrame(), this.initBaseData(t, e, r1), this.initHierarchy();
            var i = PropertyFactory.getProp;
            if (this.pe = i(this, t.pe, 0, 0, this), t.ks.p.s ? (this.px = i(this, t.ks.p.x, 1, 0, this), this.py = i(this, t.ks.p.y, 1, 0, this), this.pz = i(this, t.ks.p.z, 1, 0, this)) : this.p = i(this, t.ks.p, 1, 0, this), t.ks.a && (this.a = i(this, t.ks.a, 1, 0, this)), t.ks.or.k.length && t.ks.or.k[0].to) {
                var s, a = t.ks.or.k.length;
                for(s = 0; s < a; s += 1)t.ks.or.k[s].to = null, t.ks.or.k[s].ti = null;
            }
            this.or = i(this, t.ks.or, 1, degToRads, this), this.or.sh = !0, this.rx = i(this, t.ks.rx, 0, degToRads, this), this.ry = i(this, t.ks.ry, 0, degToRads, this), this.rz = i(this, t.ks.rz, 0, degToRads, this), this.mat = new Matrix, this._prevMat = new Matrix, this._isFirstFrame = !0, this.finalTransform = {
                mProp: this
            };
        }
        function HImageElement(t, e, r1) {
            this.assetData = e.getAssetData(t.refId), this.initElement(t, e, r1);
        }
        function HybridRendererBase(t, e) {
            this.animationItem = t, this.layers = null, this.renderedFrame = -1, this.renderConfig = {
                className: e && e.className || "",
                imagePreserveAspectRatio: e && e.imagePreserveAspectRatio || "xMidYMid slice",
                hideOnTransparent: !(e && !1 === e.hideOnTransparent),
                filterSize: {
                    width: e && e.filterSize && e.filterSize.width || "400%",
                    height: e && e.filterSize && e.filterSize.height || "400%",
                    x: e && e.filterSize && e.filterSize.x || "-100%",
                    y: e && e.filterSize && e.filterSize.y || "-100%"
                }
            }, this.globalData = {
                _mdf: !1,
                frameNum: -1,
                renderConfig: this.renderConfig
            }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
        }
        function HCompElement(t, e, r1) {
            this.layers = t.layers, this.supports3d = !t.hasMask, this.completeLayers = !1, this.pendingElements = [], this.elements = this.layers ? createSizedArray(this.layers.length) : [], this.initElement(t, e, r1), this.tm = t.tm ? PropertyFactory.getProp(this, t.tm, 0, e.frameRate, this) : {
                _placeholder: !0
            };
        }
        function HybridRenderer(t, e) {
            this.animationItem = t, this.layers = null, this.renderedFrame = -1, this.renderConfig = {
                className: e && e.className || "",
                imagePreserveAspectRatio: e && e.imagePreserveAspectRatio || "xMidYMid slice",
                hideOnTransparent: !(e && !1 === e.hideOnTransparent),
                filterSize: {
                    width: e && e.filterSize && e.filterSize.width || "400%",
                    height: e && e.filterSize && e.filterSize.height || "400%",
                    x: e && e.filterSize && e.filterSize.x || "-100%",
                    y: e && e.filterSize && e.filterSize.y || "-100%"
                },
                runExpressions: !e || void 0 === e.runExpressions || e.runExpressions
            }, this.globalData = {
                _mdf: !1,
                frameNum: -1,
                renderConfig: this.renderConfig
            }, this.pendingElements = [], this.elements = [], this.threeDElements = [], this.destroyed = !1, this.camera = null, this.supports3d = !0, this.rendererType = "html";
        }
        CVBaseElement.prototype = {
            createElements: function() {},
            initRendererElement: function() {},
            createContainerElements: function() {
                if (this.data.tt >= 1) {
                    this.buffers = [];
                    var t = this.globalData.canvasContext, e = assetLoader.createCanvas(t.canvas.width, t.canvas.height);
                    this.buffers.push(e);
                    var r1 = assetLoader.createCanvas(t.canvas.width, t.canvas.height);
                    this.buffers.push(r1), this.data.tt >= 3 && !document._isProxy && assetLoader.loadLumaCanvas();
                }
                this.canvasContext = this.globalData.canvasContext, this.transformCanvas = this.globalData.transformCanvas, this.renderableEffectsManager = new CVEffects(this), this.searchEffectTransforms();
            },
            createContent: function() {},
            setBlendMode: function() {
                var t = this.globalData;
                if (t.blendMode !== this.data.bm) {
                    t.blendMode = this.data.bm;
                    var e = getBlendMode(this.data.bm);
                    t.canvasContext.globalCompositeOperation = e;
                }
            },
            createRenderableComponents: function() {
                this.maskManager = new CVMaskElement(this.data, this), this.transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
            },
            hideElement: function() {
                this.hidden || this.isInRange && !this.isTransparent || (this.hidden = !0);
            },
            showElement: function() {
                this.isInRange && !this.isTransparent && (this.hidden = !1, this._isFirstFrame = !0, this.maskManager._isFirstFrame = !0);
            },
            clearCanvas: function(t) {
                t.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w * this.transformCanvas.sx, this.transformCanvas.h * this.transformCanvas.sy);
            },
            prepareLayer: function() {
                if (this.data.tt >= 1) {
                    var t = this.buffers[0].getContext("2d");
                    this.clearCanvas(t), t.drawImage(this.canvasContext.canvas, 0, 0), this.currentTransform = this.canvasContext.getTransform(), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.setTransform(this.currentTransform);
                }
            },
            exitLayer: function() {
                if (this.data.tt >= 1) {
                    var t = this.buffers[1], e = t.getContext("2d");
                    if (this.clearCanvas(e), e.drawImage(this.canvasContext.canvas, 0, 0), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.setTransform(this.currentTransform), this.comp.getElementById("tp" in this.data ? this.data.tp : this.data.ind - 1).renderFrame(!0), this.canvasContext.setTransform(1, 0, 0, 1, 0, 0), this.data.tt >= 3 && !document._isProxy) {
                        var r1 = assetLoader.getLumaCanvas(this.canvasContext.canvas);
                        r1.getContext("2d").drawImage(this.canvasContext.canvas, 0, 0), this.clearCanvas(this.canvasContext), this.canvasContext.drawImage(r1, 0, 0);
                    }
                    this.canvasContext.globalCompositeOperation = operationsMap[this.data.tt], this.canvasContext.drawImage(t, 0, 0), this.canvasContext.globalCompositeOperation = "destination-over", this.canvasContext.drawImage(this.buffers[0], 0, 0), this.canvasContext.setTransform(this.currentTransform), this.canvasContext.globalCompositeOperation = "source-over";
                }
            },
            renderFrame: function(t) {
                if (!this.hidden && !this.data.hd && (1 !== this.data.td || t)) {
                    this.renderTransform(), this.renderRenderable(), this.renderLocalTransform(), this.setBlendMode();
                    var e = 0 === this.data.ty;
                    this.prepareLayer(), this.globalData.renderer.save(e), this.globalData.renderer.ctxTransform(this.finalTransform.localMat.props), this.globalData.renderer.ctxOpacity(this.finalTransform.localOpacity), this.renderInnerContent(), this.globalData.renderer.restore(e), this.exitLayer(), this.maskManager.hasMasks && this.globalData.renderer.restore(!0), this._isFirstFrame && (this._isFirstFrame = !1);
                }
            },
            destroy: function() {
                this.canvasContext = null, this.data = null, this.globalData = null, this.maskManager.destroy();
            },
            mHelper: new Matrix
        }, CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement, CVBaseElement.prototype.show = CVBaseElement.prototype.showElement, CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated, extendPrototype([
            BaseElement,
            TransformElement,
            CVBaseElement,
            IShapeElement,
            HierarchyElement,
            FrameElement,
            RenderableElement
        ], CVShapeElement), CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement, CVShapeElement.prototype.transformHelper = {
            opacity: 1,
            _opMdf: !1
        }, CVShapeElement.prototype.dashResetter = [], CVShapeElement.prototype.createContent = function() {
            this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []);
        }, CVShapeElement.prototype.createStyleElement = function(t, e) {
            var r1 = {
                data: t,
                type: t.ty,
                preTransforms: this.transformsManager.addTransformSequence(e),
                transforms: [],
                elements: [],
                closed: !0 === t.hd
            }, i = {};
            if ("fl" === t.ty || "st" === t.ty ? (i.c = PropertyFactory.getProp(this, t.c, 1, 255, this), i.c.k || (r1.co = "rgb(" + bmFloor(i.c.v[0]) + "," + bmFloor(i.c.v[1]) + "," + bmFloor(i.c.v[2]) + ")")) : "gf" !== t.ty && "gs" !== t.ty || (i.s = PropertyFactory.getProp(this, t.s, 1, null, this), i.e = PropertyFactory.getProp(this, t.e, 1, null, this), i.h = PropertyFactory.getProp(this, t.h || {
                k: 0
            }, 0, .01, this), i.a = PropertyFactory.getProp(this, t.a || {
                k: 0
            }, 0, degToRads, this), i.g = new GradientProperty(this, t.g, this)), i.o = PropertyFactory.getProp(this, t.o, 0, .01, this), "st" === t.ty || "gs" === t.ty) {
                if (r1.lc = lineCapEnum[t.lc || 2], r1.lj = lineJoinEnum[t.lj || 2], 1 == t.lj && (r1.ml = t.ml), i.w = PropertyFactory.getProp(this, t.w, 0, null, this), i.w.k || (r1.wi = i.w.v), t.d) {
                    var s = new DashProperty(this, t.d, "canvas", this);
                    i.d = s, i.d.k || (r1.da = i.d.dashArray, r1.do = i.d.dashoffset[0]);
                }
            } else r1.r = 2 === t.r ? "evenodd" : "nonzero";
            return this.stylesList.push(r1), i.style = r1, i;
        }, CVShapeElement.prototype.createGroupElement = function() {
            return {
                it: [],
                prevViewData: []
            };
        }, CVShapeElement.prototype.createTransformElement = function(t) {
            return {
                transform: {
                    opacity: 1,
                    _opMdf: !1,
                    key: this.transformsManager.getNewKey(),
                    op: PropertyFactory.getProp(this, t.o, 0, .01, this),
                    mProps: TransformPropertyFactory.getTransformProperty(this, t, this)
                }
            };
        }, CVShapeElement.prototype.createShapeElement = function(t) {
            var e = new CVShapeData(this, t, this.stylesList, this.transformsManager);
            return this.shapes.push(e), this.addShapeToModifiers(e), e;
        }, CVShapeElement.prototype.reloadShapes = function() {
            var t;
            this._isFirstFrame = !0;
            var e = this.itemsData.length;
            for(t = 0; t < e; t += 1)this.prevViewData[t] = this.itemsData[t];
            for(this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, !0, []), e = this.dynamicProperties.length, t = 0; t < e; t += 1)this.dynamicProperties[t].getValue();
            this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame);
        }, CVShapeElement.prototype.addTransformToStyleList = function(t) {
            var e, r1 = this.stylesList.length;
            for(e = 0; e < r1; e += 1)this.stylesList[e].closed || this.stylesList[e].transforms.push(t);
        }, CVShapeElement.prototype.removeTransformFromStyleList = function() {
            var t, e = this.stylesList.length;
            for(t = 0; t < e; t += 1)this.stylesList[t].closed || this.stylesList[t].transforms.pop();
        }, CVShapeElement.prototype.closeStyles = function(t) {
            var e, r1 = t.length;
            for(e = 0; e < r1; e += 1)t[e].closed = !0;
        }, CVShapeElement.prototype.searchShapes = function(t, e, r1, i, s) {
            var a, n, o, h, l, p, c = t.length - 1, f = [], u = [], d = [].concat(s);
            for(a = c; a >= 0; a -= 1){
                if ((h = this.searchProcessedElement(t[a])) ? e[a] = r1[h - 1] : t[a]._shouldRender = i, "fl" === t[a].ty || "st" === t[a].ty || "gf" === t[a].ty || "gs" === t[a].ty) h ? e[a].style.closed = !1 : e[a] = this.createStyleElement(t[a], d), f.push(e[a].style);
                else if ("gr" === t[a].ty) {
                    if (h) for(o = e[a].it.length, n = 0; n < o; n += 1)e[a].prevViewData[n] = e[a].it[n];
                    else e[a] = this.createGroupElement(t[a]);
                    this.searchShapes(t[a].it, e[a].it, e[a].prevViewData, i, d);
                } else "tr" === t[a].ty ? (h || (p = this.createTransformElement(t[a]), e[a] = p), d.push(e[a]), this.addTransformToStyleList(e[a])) : "sh" === t[a].ty || "rc" === t[a].ty || "el" === t[a].ty || "sr" === t[a].ty ? h || (e[a] = this.createShapeElement(t[a])) : "tm" === t[a].ty || "rd" === t[a].ty || "pb" === t[a].ty || "zz" === t[a].ty || "op" === t[a].ty ? (h ? (l = e[a]).closed = !1 : ((l = ShapeModifiers.getModifier(t[a].ty)).init(this, t[a]), e[a] = l, this.shapeModifiers.push(l)), u.push(l)) : "rp" === t[a].ty && (h ? (l = e[a]).closed = !0 : (l = ShapeModifiers.getModifier(t[a].ty), e[a] = l, l.init(this, t, a, e), this.shapeModifiers.push(l), i = !1), u.push(l));
                this.addProcessedElement(t[a], a + 1);
            }
            for(this.removeTransformFromStyleList(), this.closeStyles(f), c = u.length, a = 0; a < c; a += 1)u[a].closed = !0;
        }, CVShapeElement.prototype.renderInnerContent = function() {
            this.transformHelper.opacity = 1, this.transformHelper._opMdf = !1, this.renderModifiers(), this.transformsManager.processSequences(this._isFirstFrame), this.renderShape(this.transformHelper, this.shapesData, this.itemsData, !0);
        }, CVShapeElement.prototype.renderShapeTransform = function(t, e) {
            (t._opMdf || e.op._mdf || this._isFirstFrame) && (e.opacity = t.opacity, e.opacity *= e.op.v, e._opMdf = !0);
        }, CVShapeElement.prototype.drawLayer = function() {
            var t, e, r1, i, s, a, n, o, h, l = this.stylesList.length, p = this.globalData.renderer, c = this.globalData.canvasContext;
            for(t = 0; t < l; t += 1)if (("st" !== (o = (h = this.stylesList[t]).type) && "gs" !== o || 0 !== h.wi) && h.data._shouldRender && 0 !== h.coOp && 0 !== this.globalData.currentGlobalAlpha) {
                for(p.save(), a = h.elements, "st" === o || "gs" === o ? (p.ctxStrokeStyle("st" === o ? h.co : h.grd), p.ctxLineWidth(h.wi), p.ctxLineCap(h.lc), p.ctxLineJoin(h.lj), p.ctxMiterLimit(h.ml || 0)) : p.ctxFillStyle("fl" === o ? h.co : h.grd), p.ctxOpacity(h.coOp), "st" !== o && "gs" !== o && c.beginPath(), p.ctxTransform(h.preTransforms.finalTransform.props), r1 = a.length, e = 0; e < r1; e += 1){
                    for("st" !== o && "gs" !== o || (c.beginPath(), h.da && (c.setLineDash(h.da), c.lineDashOffset = h.do)), s = (n = a[e].trNodes).length, i = 0; i < s; i += 1)"m" === n[i].t ? c.moveTo(n[i].p[0], n[i].p[1]) : "c" === n[i].t ? c.bezierCurveTo(n[i].pts[0], n[i].pts[1], n[i].pts[2], n[i].pts[3], n[i].pts[4], n[i].pts[5]) : c.closePath();
                    "st" !== o && "gs" !== o || (p.ctxStroke(), h.da && c.setLineDash(this.dashResetter));
                }
                "st" !== o && "gs" !== o && this.globalData.renderer.ctxFill(h.r), p.restore();
            }
        }, CVShapeElement.prototype.renderShape = function(t, e, r1, i) {
            var s, a;
            for(a = t, s = e.length - 1; s >= 0; s -= 1)"tr" === e[s].ty ? (a = r1[s].transform, this.renderShapeTransform(t, a)) : "sh" === e[s].ty || "el" === e[s].ty || "rc" === e[s].ty || "sr" === e[s].ty ? this.renderPath(e[s], r1[s]) : "fl" === e[s].ty ? this.renderFill(e[s], r1[s], a) : "st" === e[s].ty ? this.renderStroke(e[s], r1[s], a) : "gf" === e[s].ty || "gs" === e[s].ty ? this.renderGradientFill(e[s], r1[s], a) : "gr" === e[s].ty ? this.renderShape(a, e[s].it, r1[s].it) : e[s].ty;
            i && this.drawLayer();
        }, CVShapeElement.prototype.renderStyledShape = function(t, e) {
            if (this._isFirstFrame || e._mdf || t.transforms._mdf) {
                var r1, i, s, a = t.trNodes, n = e.paths, o = n._length;
                a.length = 0;
                var h = t.transforms.finalTransform;
                for(s = 0; s < o; s += 1){
                    var l = n.shapes[s];
                    if (l && l.v) {
                        for(i = l._length, r1 = 1; r1 < i; r1 += 1)1 === r1 && a.push({
                            t: "m",
                            p: h.applyToPointArray(l.v[0][0], l.v[0][1], 0)
                        }), a.push({
                            t: "c",
                            pts: h.applyToTriplePoints(l.o[r1 - 1], l.i[r1], l.v[r1])
                        });
                        1 === i && a.push({
                            t: "m",
                            p: h.applyToPointArray(l.v[0][0], l.v[0][1], 0)
                        }), l.c && i && (a.push({
                            t: "c",
                            pts: h.applyToTriplePoints(l.o[r1 - 1], l.i[0], l.v[0])
                        }), a.push({
                            t: "z"
                        }));
                    }
                }
                t.trNodes = a;
            }
        }, CVShapeElement.prototype.renderPath = function(t, e) {
            if (!0 !== t.hd && t._shouldRender) {
                var r1, i = e.styledShapes.length;
                for(r1 = 0; r1 < i; r1 += 1)this.renderStyledShape(e.styledShapes[r1], e.sh);
            }
        }, CVShapeElement.prototype.renderFill = function(t, e, r1) {
            var i = e.style;
            (e.c._mdf || this._isFirstFrame) && (i.co = "rgb(" + bmFloor(e.c.v[0]) + "," + bmFloor(e.c.v[1]) + "," + bmFloor(e.c.v[2]) + ")"), (e.o._mdf || r1._opMdf || this._isFirstFrame) && (i.coOp = e.o.v * r1.opacity);
        }, CVShapeElement.prototype.renderGradientFill = function(t, e, r1) {
            var i, s = e.style;
            if (!s.grd || e.g._mdf || e.s._mdf || e.e._mdf || 1 !== t.t && (e.h._mdf || e.a._mdf)) {
                var a, n = this.globalData.canvasContext, o = e.s.v, h = e.e.v;
                if (1 === t.t) i = n.createLinearGradient(o[0], o[1], h[0], h[1]);
                else {
                    var l = Math.sqrt(Math.pow(o[0] - h[0], 2) + Math.pow(o[1] - h[1], 2)), p = Math.atan2(h[1] - o[1], h[0] - o[0]), c = e.h.v;
                    c >= 1 ? c = .99 : c <= -1 && (c = -0.99);
                    var f = l * c, u = Math.cos(p + e.a.v) * f + o[0], d = Math.sin(p + e.a.v) * f + o[1];
                    i = n.createRadialGradient(u, d, 0, o[0], o[1], l);
                }
                var m = t.g.p, y = e.g.c, g = 1;
                for(a = 0; a < m; a += 1)e.g._hasOpacity && e.g._collapsable && (g = e.g.o[2 * a + 1]), i.addColorStop(y[4 * a] / 100, "rgba(" + y[4 * a + 1] + "," + y[4 * a + 2] + "," + y[4 * a + 3] + "," + g + ")");
                s.grd = i;
            }
            s.coOp = e.o.v * r1.opacity;
        }, CVShapeElement.prototype.renderStroke = function(t, e, r1) {
            var i = e.style, s = e.d;
            s && (s._mdf || this._isFirstFrame) && (i.da = s.dashArray, i.do = s.dashoffset[0]), (e.c._mdf || this._isFirstFrame) && (i.co = "rgb(" + bmFloor(e.c.v[0]) + "," + bmFloor(e.c.v[1]) + "," + bmFloor(e.c.v[2]) + ")"), (e.o._mdf || r1._opMdf || this._isFirstFrame) && (i.coOp = e.o.v * r1.opacity), (e.w._mdf || this._isFirstFrame) && (i.wi = e.w.v);
        }, CVShapeElement.prototype.destroy = function() {
            this.shapesData = null, this.globalData = null, this.canvasContext = null, this.stylesList.length = 0, this.itemsData.length = 0;
        }, extendPrototype([
            BaseElement,
            TransformElement,
            CVBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableElement,
            ITextElement
        ], CVTextElement), CVTextElement.prototype.tHelper = createTag("canvas").getContext("2d"), CVTextElement.prototype.buildNewText = function() {
            var t = this.textProperty.currentData;
            this.renderedLetters = createSizedArray(t.l ? t.l.length : 0);
            var e = !1;
            t.fc ? (e = !0, this.values.fill = this.buildColor(t.fc)) : this.values.fill = "rgba(0,0,0,0)", this.fill = e;
            var r1 = !1;
            t.sc && (r1 = !0, this.values.stroke = this.buildColor(t.sc), this.values.sWidth = t.sw);
            var i, s, a, n, o, h, l, p, c, f, u, d, m = this.globalData.fontManager.getFontByName(t.f), y = t.l, g = this.mHelper;
            this.stroke = r1, this.values.fValue = t.finalSize + "px " + this.globalData.fontManager.getFontByName(t.f).fFamily, s = t.finalText.length;
            var v = this.data.singleShape, b = .001 * t.tr * t.finalSize, _ = 0, P = 0, S = !0, E = 0;
            for(i = 0; i < s; i += 1){
                n = (a = this.globalData.fontManager.getCharData(t.finalText[i], m.fStyle, this.globalData.fontManager.getFontByName(t.f).fFamily)) && a.data || {}, g.reset(), v && y[i].n && (_ = -b, P += t.yOffset, P += S ? 1 : 0, S = !1), c = (l = n.shapes ? n.shapes[0].it : []).length, g.scale(t.finalSize / 100, t.finalSize / 100), v && this.applyTextPropertiesToMatrix(t, g, y[i].line, _, P), u = createSizedArray(c - 1);
                var x = 0;
                for(p = 0; p < c; p += 1)if ("sh" === l[p].ty) {
                    for(h = l[p].ks.k.i.length, f = l[p].ks.k, d = [], o = 1; o < h; o += 1)1 === o && d.push(g.applyToX(f.v[0][0], f.v[0][1], 0), g.applyToY(f.v[0][0], f.v[0][1], 0)), d.push(g.applyToX(f.o[o - 1][0], f.o[o - 1][1], 0), g.applyToY(f.o[o - 1][0], f.o[o - 1][1], 0), g.applyToX(f.i[o][0], f.i[o][1], 0), g.applyToY(f.i[o][0], f.i[o][1], 0), g.applyToX(f.v[o][0], f.v[o][1], 0), g.applyToY(f.v[o][0], f.v[o][1], 0));
                    d.push(g.applyToX(f.o[o - 1][0], f.o[o - 1][1], 0), g.applyToY(f.o[o - 1][0], f.o[o - 1][1], 0), g.applyToX(f.i[0][0], f.i[0][1], 0), g.applyToY(f.i[0][0], f.i[0][1], 0), g.applyToX(f.v[0][0], f.v[0][1], 0), g.applyToY(f.v[0][0], f.v[0][1], 0)), u[x] = d, x += 1;
                }
                v && (_ += y[i].l, _ += b), this.textSpans[E] ? this.textSpans[E].elem = u : this.textSpans[E] = {
                    elem: u
                }, E += 1;
            }
        }, CVTextElement.prototype.renderInnerContent = function() {
            var t, e, r1, i, s, a;
            this.validateText(), this.canvasContext.font = this.values.fValue, this.globalData.renderer.ctxLineCap("butt"), this.globalData.renderer.ctxLineJoin("miter"), this.globalData.renderer.ctxMiterLimit(4), this.data.singleShape || this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
            var n, o = this.textAnimator.renderedLetters, h = this.textProperty.currentData.l;
            e = h.length;
            var l, p, c = null, f = null, u = null, d = this.globalData.renderer;
            for(t = 0; t < e; t += 1)if (!h[t].n) {
                if ((n = o[t]) && (d.save(), d.ctxTransform(n.p), d.ctxOpacity(n.o)), this.fill) {
                    for(n && n.fc ? c !== n.fc && (d.ctxFillStyle(n.fc), c = n.fc) : c !== this.values.fill && (c = this.values.fill, d.ctxFillStyle(this.values.fill)), i = (l = this.textSpans[t].elem).length, this.globalData.canvasContext.beginPath(), r1 = 0; r1 < i; r1 += 1)for(a = (p = l[r1]).length, this.globalData.canvasContext.moveTo(p[0], p[1]), s = 2; s < a; s += 6)this.globalData.canvasContext.bezierCurveTo(p[s], p[s + 1], p[s + 2], p[s + 3], p[s + 4], p[s + 5]);
                    this.globalData.canvasContext.closePath(), d.ctxFill();
                }
                if (this.stroke) {
                    for(n && n.sw ? u !== n.sw && (u = n.sw, d.ctxLineWidth(n.sw)) : u !== this.values.sWidth && (u = this.values.sWidth, d.ctxLineWidth(this.values.sWidth)), n && n.sc ? f !== n.sc && (f = n.sc, d.ctxStrokeStyle(n.sc)) : f !== this.values.stroke && (f = this.values.stroke, d.ctxStrokeStyle(this.values.stroke)), i = (l = this.textSpans[t].elem).length, this.globalData.canvasContext.beginPath(), r1 = 0; r1 < i; r1 += 1)for(a = (p = l[r1]).length, this.globalData.canvasContext.moveTo(p[0], p[1]), s = 2; s < a; s += 6)this.globalData.canvasContext.bezierCurveTo(p[s], p[s + 1], p[s + 2], p[s + 3], p[s + 4], p[s + 5]);
                    this.globalData.canvasContext.closePath(), d.ctxStroke();
                }
                n && this.globalData.renderer.restore();
            }
        }, extendPrototype([
            BaseElement,
            TransformElement,
            CVBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableElement
        ], CVImageElement), CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVImageElement.prototype.createContent = function() {
            if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
                var t = createTag("canvas");
                t.width = this.assetData.w, t.height = this.assetData.h;
                var e, r1, i = t.getContext("2d"), s = this.img.width, a = this.img.height, n = s / a, o = this.assetData.w / this.assetData.h, h = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;
                n > o && "xMidYMid slice" === h || n < o && "xMidYMid slice" !== h ? e = (r1 = a) * o : r1 = (e = s) / o, i.drawImage(this.img, (s - e) / 2, (a - r1) / 2, e, r1, 0, 0, this.assetData.w, this.assetData.h), this.img = t;
            }
        }, CVImageElement.prototype.renderInnerContent = function() {
            this.canvasContext.drawImage(this.img, 0, 0);
        }, CVImageElement.prototype.destroy = function() {
            this.img = null;
        }, extendPrototype([
            BaseElement,
            TransformElement,
            CVBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableElement
        ], CVSolidElement), CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement, CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame, CVSolidElement.prototype.renderInnerContent = function() {
            this.globalData.renderer.ctxFillStyle(this.data.sc), this.globalData.renderer.ctxFillRect(0, 0, this.data.sw, this.data.sh);
        }, extendPrototype([
            BaseRenderer
        ], CanvasRendererBase), CanvasRendererBase.prototype.createShape = function(t) {
            return new CVShapeElement(t, this.globalData, this);
        }, CanvasRendererBase.prototype.createText = function(t) {
            return new CVTextElement(t, this.globalData, this);
        }, CanvasRendererBase.prototype.createImage = function(t) {
            return new CVImageElement(t, this.globalData, this);
        }, CanvasRendererBase.prototype.createSolid = function(t) {
            return new CVSolidElement(t, this.globalData, this);
        }, CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, CanvasRendererBase.prototype.ctxTransform = function(t) {
            1 === t[0] && 0 === t[1] && 0 === t[4] && 1 === t[5] && 0 === t[12] && 0 === t[13] || this.canvasContext.transform(t[0], t[1], t[4], t[5], t[12], t[13]);
        }, CanvasRendererBase.prototype.ctxOpacity = function(t) {
            this.canvasContext.globalAlpha *= t < 0 ? 0 : t;
        }, CanvasRendererBase.prototype.ctxFillStyle = function(t) {
            this.canvasContext.fillStyle = t;
        }, CanvasRendererBase.prototype.ctxStrokeStyle = function(t) {
            this.canvasContext.strokeStyle = t;
        }, CanvasRendererBase.prototype.ctxLineWidth = function(t) {
            this.canvasContext.lineWidth = t;
        }, CanvasRendererBase.prototype.ctxLineCap = function(t) {
            this.canvasContext.lineCap = t;
        }, CanvasRendererBase.prototype.ctxLineJoin = function(t) {
            this.canvasContext.lineJoin = t;
        }, CanvasRendererBase.prototype.ctxMiterLimit = function(t) {
            this.canvasContext.miterLimit = t;
        }, CanvasRendererBase.prototype.ctxFill = function(t) {
            this.canvasContext.fill(t);
        }, CanvasRendererBase.prototype.ctxFillRect = function(t, e, r1, i) {
            this.canvasContext.fillRect(t, e, r1, i);
        }, CanvasRendererBase.prototype.ctxStroke = function() {
            this.canvasContext.stroke();
        }, CanvasRendererBase.prototype.reset = function() {
            this.renderConfig.clearCanvas ? this.contextData.reset() : this.canvasContext.restore();
        }, CanvasRendererBase.prototype.save = function() {
            this.canvasContext.save();
        }, CanvasRendererBase.prototype.restore = function(t) {
            this.renderConfig.clearCanvas ? (t && (this.globalData.blendMode = "source-over"), this.contextData.restore(t)) : this.canvasContext.restore();
        }, CanvasRendererBase.prototype.configAnimation = function(t) {
            if (this.animationItem.wrapper) {
                this.animationItem.container = createTag("canvas");
                var e = this.animationItem.container.style;
                e.width = "100%", e.height = "100%";
                var r1 = "0px 0px 0px";
                e.transformOrigin = r1, e.mozTransformOrigin = r1, e.webkitTransformOrigin = r1, e["-webkit-transform"] = r1, e.contentVisibility = this.renderConfig.contentVisibility, this.animationItem.wrapper.appendChild(this.animationItem.container), this.canvasContext = this.animationItem.container.getContext("2d"), this.renderConfig.className && this.animationItem.container.setAttribute("class", this.renderConfig.className), this.renderConfig.id && this.animationItem.container.setAttribute("id", this.renderConfig.id);
            } else this.canvasContext = this.renderConfig.context;
            this.contextData.setContext(this.canvasContext), this.data = t, this.layers = t.layers, this.transformCanvas = {
                w: t.w,
                h: t.h,
                sx: 0,
                sy: 0,
                tx: 0,
                ty: 0
            }, this.setupGlobalData(t, document.body), this.globalData.canvasContext = this.canvasContext, this.globalData.renderer = this, this.globalData.isDashed = !1, this.globalData.progressiveLoad = this.renderConfig.progressiveLoad, this.globalData.transformCanvas = this.transformCanvas, this.elements = createSizedArray(t.layers.length), this.updateContainerSize();
        }, CanvasRendererBase.prototype.updateContainerSize = function(t, e) {
            var r1, i, s, a;
            if (this.reset(), t ? (r1 = t, i = e, this.canvasContext.canvas.width = r1, this.canvasContext.canvas.height = i) : (this.animationItem.wrapper && this.animationItem.container ? (r1 = this.animationItem.wrapper.offsetWidth, i = this.animationItem.wrapper.offsetHeight) : (r1 = this.canvasContext.canvas.width, i = this.canvasContext.canvas.height), this.canvasContext.canvas.width = r1 * this.renderConfig.dpr, this.canvasContext.canvas.height = i * this.renderConfig.dpr), -1 !== this.renderConfig.preserveAspectRatio.indexOf("meet") || -1 !== this.renderConfig.preserveAspectRatio.indexOf("slice")) {
                var n = this.renderConfig.preserveAspectRatio.split(" "), o = n[1] || "meet", h = n[0] || "xMidYMid", l = h.substr(0, 4), p = h.substr(4);
                s = r1 / i, (a = this.transformCanvas.w / this.transformCanvas.h) > s && "meet" === o || a < s && "slice" === o ? (this.transformCanvas.sx = r1 / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = r1 / (this.transformCanvas.w / this.renderConfig.dpr)) : (this.transformCanvas.sx = i / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.sy = i / (this.transformCanvas.h / this.renderConfig.dpr)), this.transformCanvas.tx = "xMid" === l && (a < s && "meet" === o || a > s && "slice" === o) ? (r1 - this.transformCanvas.w * (i / this.transformCanvas.h)) / 2 * this.renderConfig.dpr : "xMax" === l && (a < s && "meet" === o || a > s && "slice" === o) ? (r1 - this.transformCanvas.w * (i / this.transformCanvas.h)) * this.renderConfig.dpr : 0, this.transformCanvas.ty = "YMid" === p && (a > s && "meet" === o || a < s && "slice" === o) ? (i - this.transformCanvas.h * (r1 / this.transformCanvas.w)) / 2 * this.renderConfig.dpr : "YMax" === p && (a > s && "meet" === o || a < s && "slice" === o) ? (i - this.transformCanvas.h * (r1 / this.transformCanvas.w)) * this.renderConfig.dpr : 0;
            } else "none" === this.renderConfig.preserveAspectRatio ? (this.transformCanvas.sx = r1 / (this.transformCanvas.w / this.renderConfig.dpr), this.transformCanvas.sy = i / (this.transformCanvas.h / this.renderConfig.dpr), this.transformCanvas.tx = 0, this.transformCanvas.ty = 0) : (this.transformCanvas.sx = this.renderConfig.dpr, this.transformCanvas.sy = this.renderConfig.dpr, this.transformCanvas.tx = 0, this.transformCanvas.ty = 0);
            this.transformCanvas.props = [
                this.transformCanvas.sx,
                0,
                0,
                0,
                0,
                this.transformCanvas.sy,
                0,
                0,
                0,
                0,
                1,
                0,
                this.transformCanvas.tx,
                this.transformCanvas.ty,
                0,
                1
            ], this.ctxTransform(this.transformCanvas.props), this.canvasContext.beginPath(), this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h), this.canvasContext.closePath(), this.canvasContext.clip(), this.renderFrame(this.renderedFrame, !0);
        }, CanvasRendererBase.prototype.destroy = function() {
            var t;
            for(this.renderConfig.clearCanvas && this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), t = (this.layers ? this.layers.length : 0) - 1; t >= 0; t -= 1)this.elements[t] && this.elements[t].destroy && this.elements[t].destroy();
            this.elements.length = 0, this.globalData.canvasContext = null, this.animationItem.container = null, this.destroyed = !0;
        }, CanvasRendererBase.prototype.renderFrame = function(t, e) {
            if ((this.renderedFrame !== t || !0 !== this.renderConfig.clearCanvas || e) && !this.destroyed && -1 !== t) {
                var r1;
                this.renderedFrame = t, this.globalData.frameNum = t - this.animationItem._isFirstFrame, this.globalData.frameId += 1, this.globalData._mdf = !this.renderConfig.clearCanvas || e, this.globalData.projectInterface.currentFrame = t;
                var i = this.layers.length;
                for(this.completeLayers || this.checkLayers(t), r1 = i - 1; r1 >= 0; r1 -= 1)(this.completeLayers || this.elements[r1]) && this.elements[r1].prepareFrame(t - this.layers[r1].st);
                if (this.globalData._mdf) {
                    for(!0 === this.renderConfig.clearCanvas ? this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h) : this.save(), r1 = i - 1; r1 >= 0; r1 -= 1)(this.completeLayers || this.elements[r1]) && this.elements[r1].renderFrame();
                    !0 !== this.renderConfig.clearCanvas && this.restore();
                }
            }
        }, CanvasRendererBase.prototype.buildItem = function(t) {
            var e = this.elements;
            if (!e[t] && 99 !== this.layers[t].ty) {
                var r1 = this.createItem(this.layers[t], this, this.globalData);
                e[t] = r1, r1.initExpressions();
            }
        }, CanvasRendererBase.prototype.checkPendingElements = function() {
            for(; this.pendingElements.length;)this.pendingElements.pop().checkParenting();
        }, CanvasRendererBase.prototype.hide = function() {
            this.animationItem.container.style.display = "none";
        }, CanvasRendererBase.prototype.show = function() {
            this.animationItem.container.style.display = "block";
        }, CVContextData.prototype.duplicate = function() {
            var t = 2 * this._length, e = 0;
            for(e = this._length; e < t; e += 1)this.stack[e] = new CanvasContext;
            this._length = t;
        }, CVContextData.prototype.reset = function() {
            this.cArrPos = 0, this.cTr.reset(), this.stack[this.cArrPos].opacity = 1;
        }, CVContextData.prototype.restore = function(t) {
            this.cArrPos -= 1;
            var e, r1 = this.stack[this.cArrPos], i = r1.transform, s = this.cTr.props;
            for(e = 0; e < 16; e += 1)s[e] = i[e];
            if (t) {
                this.nativeContext.restore();
                var a = this.stack[this.cArrPos + 1];
                this.appliedFillStyle = a.fillStyle, this.appliedStrokeStyle = a.strokeStyle, this.appliedLineWidth = a.lineWidth, this.appliedLineCap = a.lineCap, this.appliedLineJoin = a.lineJoin, this.appliedMiterLimit = a.miterLimit;
            }
            this.nativeContext.setTransform(i[0], i[1], i[4], i[5], i[12], i[13]), (t || -1 !== r1.opacity && this.currentOpacity !== r1.opacity) && (this.nativeContext.globalAlpha = r1.opacity, this.currentOpacity = r1.opacity), this.currentFillStyle = r1.fillStyle, this.currentStrokeStyle = r1.strokeStyle, this.currentLineWidth = r1.lineWidth, this.currentLineCap = r1.lineCap, this.currentLineJoin = r1.lineJoin, this.currentMiterLimit = r1.miterLimit;
        }, CVContextData.prototype.save = function(t) {
            t && this.nativeContext.save();
            var e = this.cTr.props;
            this._length <= this.cArrPos && this.duplicate();
            var r1, i = this.stack[this.cArrPos];
            for(r1 = 0; r1 < 16; r1 += 1)i.transform[r1] = e[r1];
            this.cArrPos += 1;
            var s = this.stack[this.cArrPos];
            s.opacity = i.opacity, s.fillStyle = i.fillStyle, s.strokeStyle = i.strokeStyle, s.lineWidth = i.lineWidth, s.lineCap = i.lineCap, s.lineJoin = i.lineJoin, s.miterLimit = i.miterLimit;
        }, CVContextData.prototype.setOpacity = function(t) {
            this.stack[this.cArrPos].opacity = t;
        }, CVContextData.prototype.setContext = function(t) {
            this.nativeContext = t;
        }, CVContextData.prototype.fillStyle = function(t) {
            this.stack[this.cArrPos].fillStyle !== t && (this.currentFillStyle = t, this.stack[this.cArrPos].fillStyle = t);
        }, CVContextData.prototype.strokeStyle = function(t) {
            this.stack[this.cArrPos].strokeStyle !== t && (this.currentStrokeStyle = t, this.stack[this.cArrPos].strokeStyle = t);
        }, CVContextData.prototype.lineWidth = function(t) {
            this.stack[this.cArrPos].lineWidth !== t && (this.currentLineWidth = t, this.stack[this.cArrPos].lineWidth = t);
        }, CVContextData.prototype.lineCap = function(t) {
            this.stack[this.cArrPos].lineCap !== t && (this.currentLineCap = t, this.stack[this.cArrPos].lineCap = t);
        }, CVContextData.prototype.lineJoin = function(t) {
            this.stack[this.cArrPos].lineJoin !== t && (this.currentLineJoin = t, this.stack[this.cArrPos].lineJoin = t);
        }, CVContextData.prototype.miterLimit = function(t) {
            this.stack[this.cArrPos].miterLimit !== t && (this.currentMiterLimit = t, this.stack[this.cArrPos].miterLimit = t);
        }, CVContextData.prototype.transform = function(t) {
            this.transformMat.cloneFromProps(t);
            var e = this.cTr;
            this.transformMat.multiply(e), e.cloneFromProps(this.transformMat.props);
            var r1 = e.props;
            this.nativeContext.setTransform(r1[0], r1[1], r1[4], r1[5], r1[12], r1[13]);
        }, CVContextData.prototype.opacity = function(t) {
            var e = this.stack[this.cArrPos].opacity;
            e *= t < 0 ? 0 : t, this.stack[this.cArrPos].opacity !== e && (this.currentOpacity !== t && (this.nativeContext.globalAlpha = t, this.currentOpacity = t), this.stack[this.cArrPos].opacity = e);
        }, CVContextData.prototype.fill = function(t) {
            this.appliedFillStyle !== this.currentFillStyle && (this.appliedFillStyle = this.currentFillStyle, this.nativeContext.fillStyle = this.appliedFillStyle), this.nativeContext.fill(t);
        }, CVContextData.prototype.fillRect = function(t, e, r1, i) {
            this.appliedFillStyle !== this.currentFillStyle && (this.appliedFillStyle = this.currentFillStyle, this.nativeContext.fillStyle = this.appliedFillStyle), this.nativeContext.fillRect(t, e, r1, i);
        }, CVContextData.prototype.stroke = function() {
            this.appliedStrokeStyle !== this.currentStrokeStyle && (this.appliedStrokeStyle = this.currentStrokeStyle, this.nativeContext.strokeStyle = this.appliedStrokeStyle), this.appliedLineWidth !== this.currentLineWidth && (this.appliedLineWidth = this.currentLineWidth, this.nativeContext.lineWidth = this.appliedLineWidth), this.appliedLineCap !== this.currentLineCap && (this.appliedLineCap = this.currentLineCap, this.nativeContext.lineCap = this.appliedLineCap), this.appliedLineJoin !== this.currentLineJoin && (this.appliedLineJoin = this.currentLineJoin, this.nativeContext.lineJoin = this.appliedLineJoin), this.appliedMiterLimit !== this.currentMiterLimit && (this.appliedMiterLimit = this.currentMiterLimit, this.nativeContext.miterLimit = this.appliedMiterLimit), this.nativeContext.stroke();
        }, extendPrototype([
            CanvasRendererBase,
            ICompElement,
            CVBaseElement
        ], CVCompElement), CVCompElement.prototype.renderInnerContent = function() {
            var t, e = this.canvasContext;
            for(e.beginPath(), e.moveTo(0, 0), e.lineTo(this.data.w, 0), e.lineTo(this.data.w, this.data.h), e.lineTo(0, this.data.h), e.lineTo(0, 0), e.clip(), t = this.layers.length - 1; t >= 0; t -= 1)(this.completeLayers || this.elements[t]) && this.elements[t].renderFrame();
        }, CVCompElement.prototype.destroy = function() {
            var t;
            for(t = this.layers.length - 1; t >= 0; t -= 1)this.elements[t] && this.elements[t].destroy();
            this.layers = null, this.elements = null;
        }, CVCompElement.prototype.createComp = function(t) {
            return new CVCompElement(t, this.globalData, this);
        }, extendPrototype([
            CanvasRendererBase
        ], CanvasRenderer), CanvasRenderer.prototype.createComp = function(t) {
            return new CVCompElement(t, this.globalData, this);
        }, HBaseElement.prototype = {
            checkBlendMode: function() {},
            initRendererElement: function() {
                this.baseElement = createTag(this.data.tg || "div"), this.data.hasMask ? (this.svgElement = createNS("svg"), this.layerElement = createNS("g"), this.maskedElement = this.layerElement, this.svgElement.appendChild(this.layerElement), this.baseElement.appendChild(this.svgElement)) : this.layerElement = this.baseElement, styleDiv(this.baseElement);
            },
            createContainerElements: function() {
                this.renderableEffectsManager = new CVEffects(this), this.transformedElement = this.baseElement, this.maskedElement = this.layerElement, this.data.ln && this.layerElement.setAttribute("id", this.data.ln), this.data.cl && this.layerElement.setAttribute("class", this.data.cl), 0 !== this.data.bm && this.setBlendMode();
            },
            renderElement: function() {
                var t = this.transformedElement ? this.transformedElement.style : {};
                if (this.finalTransform._matMdf) {
                    var e = this.finalTransform.mat.toCSS();
                    t.transform = e, t.webkitTransform = e;
                }
                this.finalTransform._opMdf && (t.opacity = this.finalTransform.mProp.o.v);
            },
            renderFrame: function() {
                this.data.hd || this.hidden || (this.renderTransform(), this.renderRenderable(), this.renderElement(), this.renderInnerContent(), this._isFirstFrame && (this._isFirstFrame = !1));
            },
            destroy: function() {
                this.layerElement = null, this.transformedElement = null, this.matteElement && (this.matteElement = null), this.maskManager && (this.maskManager.destroy(), this.maskManager = null);
            },
            createRenderableComponents: function() {
                this.maskManager = new MaskElement(this.data, this, this.globalData);
            },
            addEffects: function() {},
            setMatte: function() {}
        }, HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement, HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy, HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting, extendPrototype([
            BaseElement,
            TransformElement,
            HBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement
        ], HSolidElement), HSolidElement.prototype.createContent = function() {
            var t;
            this.data.hasMask ? ((t = createNS("rect")).setAttribute("width", this.data.sw), t.setAttribute("height", this.data.sh), t.setAttribute("fill", this.data.sc), this.svgElement.setAttribute("width", this.data.sw), this.svgElement.setAttribute("height", this.data.sh)) : ((t = createTag("div")).style.width = this.data.sw + "px", t.style.height = this.data.sh + "px", t.style.backgroundColor = this.data.sc), this.layerElement.appendChild(t);
        }, extendPrototype([
            BaseElement,
            TransformElement,
            HSolidElement,
            SVGShapeElement,
            HBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableElement
        ], HShapeElement), HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent, HShapeElement.prototype.createContent = function() {
            var t;
            if (this.baseElement.style.fontSize = 0, this.data.hasMask) this.layerElement.appendChild(this.shapesContainer), t = this.svgElement;
            else {
                t = createNS("svg");
                var e = this.comp.data ? this.comp.data : this.globalData.compSize;
                t.setAttribute("width", e.w), t.setAttribute("height", e.h), t.appendChild(this.shapesContainer), this.layerElement.appendChild(t);
            }
            this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], !0), this.filterUniqueShapes(), this.shapeCont = t;
        }, HShapeElement.prototype.getTransformedPoint = function(t, e) {
            var r1, i = t.length;
            for(r1 = 0; r1 < i; r1 += 1)e = t[r1].mProps.v.applyToPointArray(e[0], e[1], 0);
            return e;
        }, HShapeElement.prototype.calculateShapeBoundingBox = function(t, e) {
            var r1, i, s, a, n, o = t.sh.v, h = t.transformers, l = o._length;
            if (!(l <= 1)) {
                for(r1 = 0; r1 < l - 1; r1 += 1)i = this.getTransformedPoint(h, o.v[r1]), s = this.getTransformedPoint(h, o.o[r1]), a = this.getTransformedPoint(h, o.i[r1 + 1]), n = this.getTransformedPoint(h, o.v[r1 + 1]), this.checkBounds(i, s, a, n, e);
                o.c && (i = this.getTransformedPoint(h, o.v[r1]), s = this.getTransformedPoint(h, o.o[r1]), a = this.getTransformedPoint(h, o.i[0]), n = this.getTransformedPoint(h, o.v[0]), this.checkBounds(i, s, a, n, e));
            }
        }, HShapeElement.prototype.checkBounds = function(t, e, r1, i, s) {
            this.getBoundsOfCurve(t, e, r1, i);
            var a = this.shapeBoundingBox;
            s.x = bmMin(a.left, s.x), s.xMax = bmMax(a.right, s.xMax), s.y = bmMin(a.top, s.y), s.yMax = bmMax(a.bottom, s.yMax);
        }, HShapeElement.prototype.shapeBoundingBox = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, HShapeElement.prototype.tempBoundingBox = {
            x: 0,
            xMax: 0,
            y: 0,
            yMax: 0,
            width: 0,
            height: 0
        }, HShapeElement.prototype.getBoundsOfCurve = function(t, e, r1, i) {
            for(var s, a, n, o, h, l, p, c = [
                [
                    t[0],
                    i[0]
                ],
                [
                    t[1],
                    i[1]
                ]
            ], f = 0; f < 2; ++f)a = 6 * t[f] - 12 * e[f] + 6 * r1[f], s = -3 * t[f] + 9 * e[f] - 9 * r1[f] + 3 * i[f], n = 3 * e[f] - 3 * t[f], a |= 0, n |= 0, 0 == (s |= 0) && 0 === a || (0 === s ? (o = -n / a) > 0 && o < 1 && c[f].push(this.calculateF(o, t, e, r1, i, f)) : (h = a * a - 4 * n * s) >= 0 && ((l = (-a + bmSqrt(h)) / (2 * s)) > 0 && l < 1 && c[f].push(this.calculateF(l, t, e, r1, i, f)), (p = (-a - bmSqrt(h)) / (2 * s)) > 0 && p < 1 && c[f].push(this.calculateF(p, t, e, r1, i, f))));
            this.shapeBoundingBox.left = bmMin.apply(null, c[0]), this.shapeBoundingBox.top = bmMin.apply(null, c[1]), this.shapeBoundingBox.right = bmMax.apply(null, c[0]), this.shapeBoundingBox.bottom = bmMax.apply(null, c[1]);
        }, HShapeElement.prototype.calculateF = function(t, e, r1, i, s, a) {
            return bmPow(1 - t, 3) * e[a] + 3 * bmPow(1 - t, 2) * t * r1[a] + 3 * (1 - t) * bmPow(t, 2) * i[a] + bmPow(t, 3) * s[a];
        }, HShapeElement.prototype.calculateBoundingBox = function(t, e) {
            var r1, i = t.length;
            for(r1 = 0; r1 < i; r1 += 1)t[r1] && t[r1].sh ? this.calculateShapeBoundingBox(t[r1], e) : t[r1] && t[r1].it ? this.calculateBoundingBox(t[r1].it, e) : t[r1] && t[r1].style && t[r1].w && this.expandStrokeBoundingBox(t[r1].w, e);
        }, HShapeElement.prototype.expandStrokeBoundingBox = function(t, e) {
            var r1 = 0;
            if (t.keyframes) {
                for(var i = 0; i < t.keyframes.length; i += 1){
                    var s = t.keyframes[i].s;
                    s > r1 && (r1 = s);
                }
                r1 *= t.mult;
            } else r1 = t.v * t.mult;
            e.x -= r1, e.xMax += r1, e.y -= r1, e.yMax += r1;
        }, HShapeElement.prototype.currentBoxContains = function(t) {
            return this.currentBBox.x <= t.x && this.currentBBox.y <= t.y && this.currentBBox.width + this.currentBBox.x >= t.x + t.width && this.currentBBox.height + this.currentBBox.y >= t.y + t.height;
        }, HShapeElement.prototype.renderInnerContent = function() {
            if (this._renderShapeFrame(), !this.hidden && (this._isFirstFrame || this._mdf)) {
                var t = this.tempBoundingBox, e = 999999;
                if (t.x = e, t.xMax = -e, t.y = e, t.yMax = -e, this.calculateBoundingBox(this.itemsData, t), t.width = t.xMax < t.x ? 0 : t.xMax - t.x, t.height = t.yMax < t.y ? 0 : t.yMax - t.y, this.currentBoxContains(t)) return;
                var r1 = !1;
                if (this.currentBBox.w !== t.width && (this.currentBBox.w = t.width, this.shapeCont.setAttribute("width", t.width), r1 = !0), this.currentBBox.h !== t.height && (this.currentBBox.h = t.height, this.shapeCont.setAttribute("height", t.height), r1 = !0), r1 || this.currentBBox.x !== t.x || this.currentBBox.y !== t.y) {
                    this.currentBBox.w = t.width, this.currentBBox.h = t.height, this.currentBBox.x = t.x, this.currentBBox.y = t.y, this.shapeCont.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h);
                    var i = this.shapeCont.style, s = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
                    i.transform = s, i.webkitTransform = s;
                }
            }
        }, extendPrototype([
            BaseElement,
            TransformElement,
            HBaseElement,
            HierarchyElement,
            FrameElement,
            RenderableDOMElement,
            ITextElement
        ], HTextElement), HTextElement.prototype.createContent = function() {
            if (this.isMasked = this.checkMasks(), this.isMasked) {
                this.renderType = "svg", this.compW = this.comp.data.w, this.compH = this.comp.data.h, this.svgElement.setAttribute("width", this.compW), this.svgElement.setAttribute("height", this.compH);
                var t = createNS("g");
                this.maskedElement.appendChild(t), this.innerElem = t;
            } else this.renderType = "html", this.innerElem = this.layerElement;
            this.checkParenting();
        }, HTextElement.prototype.buildNewText = function() {
            var t = this.textProperty.currentData;
            this.renderedLetters = createSizedArray(t.l ? t.l.length : 0);
            var e = this.innerElem.style, r1 = t.fc ? this.buildColor(t.fc) : "rgba(0,0,0,0)";
            e.fill = r1, e.color = r1, t.sc && (e.stroke = this.buildColor(t.sc), e.strokeWidth = t.sw + "px");
            var i, s, a = this.globalData.fontManager.getFontByName(t.f);
            if (!this.globalData.fontManager.chars) {
                if (e.fontSize = t.finalSize + "px", e.lineHeight = t.finalSize + "px", a.fClass) this.innerElem.className = a.fClass;
                else {
                    e.fontFamily = a.fFamily;
                    var n = t.fWeight, o = t.fStyle;
                    e.fontStyle = o, e.fontWeight = n;
                }
            }
            var h, l, p, c = t.l;
            s = c.length;
            var f, u = this.mHelper, d = "", m = 0;
            for(i = 0; i < s; i += 1){
                if (this.globalData.fontManager.chars ? (this.textPaths[m] ? h = this.textPaths[m] : ((h = createNS("path")).setAttribute("stroke-linecap", lineCapEnum[1]), h.setAttribute("stroke-linejoin", lineJoinEnum[2]), h.setAttribute("stroke-miterlimit", "4")), this.isMasked || (this.textSpans[m] ? p = (l = this.textSpans[m]).children[0] : ((l = createTag("div")).style.lineHeight = 0, (p = createNS("svg")).appendChild(h), styleDiv(l)))) : this.isMasked ? h = this.textPaths[m] ? this.textPaths[m] : createNS("text") : this.textSpans[m] ? (l = this.textSpans[m], h = this.textPaths[m]) : (styleDiv(l = createTag("span")), styleDiv(h = createTag("span")), l.appendChild(h)), this.globalData.fontManager.chars) {
                    var y, g = this.globalData.fontManager.getCharData(t.finalText[i], a.fStyle, this.globalData.fontManager.getFontByName(t.f).fFamily);
                    if (y = g ? g.data : null, u.reset(), y && y.shapes && y.shapes.length && (f = y.shapes[0].it, u.scale(t.finalSize / 100, t.finalSize / 100), d = this.createPathShape(u, f), h.setAttribute("d", d)), this.isMasked) this.innerElem.appendChild(h);
                    else {
                        if (this.innerElem.appendChild(l), y && y.shapes) {
                            document.body.appendChild(p);
                            var v = p.getBBox();
                            p.setAttribute("width", v.width + 2), p.setAttribute("height", v.height + 2), p.setAttribute("viewBox", v.x - 1 + " " + (v.y - 1) + " " + (v.width + 2) + " " + (v.height + 2));
                            var b = p.style, _ = "translate(" + (v.x - 1) + "px," + (v.y - 1) + "px)";
                            b.transform = _, b.webkitTransform = _, c[i].yOffset = v.y - 1;
                        } else p.setAttribute("width", 1), p.setAttribute("height", 1);
                        l.appendChild(p);
                    }
                } else if (h.textContent = c[i].val, h.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space", "preserve"), this.isMasked) this.innerElem.appendChild(h);
                else {
                    this.innerElem.appendChild(l);
                    var P = h.style, S = "translate3d(0," + -t.finalSize / 1.2 + "px,0)";
                    P.transform = S, P.webkitTransform = S;
                }
                this.isMasked ? this.textSpans[m] = h : this.textSpans[m] = l, this.textSpans[m].style.display = "block", this.textPaths[m] = h, m += 1;
            }
            for(; m < this.textSpans.length;)this.textSpans[m].style.display = "none", m += 1;
        }, HTextElement.prototype.renderInnerContent = function() {
            var t;
            if (this.validateText(), this.data.singleShape) {
                if (!this._isFirstFrame && !this.lettersChangedFlag) return;
                if (this.isMasked && this.finalTransform._matMdf) {
                    this.svgElement.setAttribute("viewBox", -this.finalTransform.mProp.p.v[0] + " " + -this.finalTransform.mProp.p.v[1] + " " + this.compW + " " + this.compH), t = this.svgElement.style;
                    var e = "translate(" + -this.finalTransform.mProp.p.v[0] + "px," + -this.finalTransform.mProp.p.v[1] + "px)";
                    t.transform = e, t.webkitTransform = e;
                }
            }
            if (this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag), this.lettersChangedFlag || this.textAnimator.lettersChangedFlag) {
                var r1, i, s, a, n, o = 0, h = this.textAnimator.renderedLetters, l = this.textProperty.currentData.l;
                for(i = l.length, r1 = 0; r1 < i; r1 += 1)l[r1].n ? o += 1 : (a = this.textSpans[r1], n = this.textPaths[r1], s = h[o], o += 1, s._mdf.m && (this.isMasked ? a.setAttribute("transform", s.m) : (a.style.webkitTransform = s.m, a.style.transform = s.m)), a.style.opacity = s.o, s.sw && s._mdf.sw && n.setAttribute("stroke-width", s.sw), s.sc && s._mdf.sc && n.setAttribute("stroke", s.sc), s.fc && s._mdf.fc && (n.setAttribute("fill", s.fc), n.style.color = s.fc));
                if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
                    var p = this.innerElem.getBBox();
                    if (this.currentBBox.w !== p.width && (this.currentBBox.w = p.width, this.svgElement.setAttribute("width", p.width)), this.currentBBox.h !== p.height && (this.currentBBox.h = p.height, this.svgElement.setAttribute("height", p.height)), this.currentBBox.w !== p.width + 2 || this.currentBBox.h !== p.height + 2 || this.currentBBox.x !== p.x - 1 || this.currentBBox.y !== p.y - 1) {
                        this.currentBBox.w = p.width + 2, this.currentBBox.h = p.height + 2, this.currentBBox.x = p.x - 1, this.currentBBox.y = p.y - 1, this.svgElement.setAttribute("viewBox", this.currentBBox.x + " " + this.currentBBox.y + " " + this.currentBBox.w + " " + this.currentBBox.h), t = this.svgElement.style;
                        var c = "translate(" + this.currentBBox.x + "px," + this.currentBBox.y + "px)";
                        t.transform = c, t.webkitTransform = c;
                    }
                }
            }
        }, extendPrototype([
            BaseElement,
            FrameElement,
            HierarchyElement
        ], HCameraElement), HCameraElement.prototype.setup = function() {
            var t, e, r1, i, s = this.comp.threeDElements.length;
            for(t = 0; t < s; t += 1)if ("3d" === (e = this.comp.threeDElements[t]).type) {
                r1 = e.perspectiveElem.style, i = e.container.style;
                var a = this.pe.v + "px", n = "0px 0px 0px", o = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
                r1.perspective = a, r1.webkitPerspective = a, i.transformOrigin = n, i.mozTransformOrigin = n, i.webkitTransformOrigin = n, r1.transform = o, r1.webkitTransform = o;
            }
        }, HCameraElement.prototype.createElements = function() {}, HCameraElement.prototype.hide = function() {}, HCameraElement.prototype.renderFrame = function() {
            var t, e, r1 = this._isFirstFrame;
            if (this.hierarchy) for(e = this.hierarchy.length, t = 0; t < e; t += 1)r1 = this.hierarchy[t].finalTransform.mProp._mdf || r1;
            if (r1 || this.pe._mdf || this.p && this.p._mdf || this.px && (this.px._mdf || this.py._mdf || this.pz._mdf) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || this.a && this.a._mdf) {
                if (this.mat.reset(), this.hierarchy) for(t = e = this.hierarchy.length - 1; t >= 0; t -= 1){
                    var i = this.hierarchy[t].finalTransform.mProp;
                    this.mat.translate(-i.p.v[0], -i.p.v[1], i.p.v[2]), this.mat.rotateX(-i.or.v[0]).rotateY(-i.or.v[1]).rotateZ(i.or.v[2]), this.mat.rotateX(-i.rx.v).rotateY(-i.ry.v).rotateZ(i.rz.v), this.mat.scale(1 / i.s.v[0], 1 / i.s.v[1], 1 / i.s.v[2]), this.mat.translate(i.a.v[0], i.a.v[1], i.a.v[2]);
                }
                if (this.p ? this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]) : this.mat.translate(-this.px.v, -this.py.v, this.pz.v), this.a) {
                    var s;
                    s = this.p ? [
                        this.p.v[0] - this.a.v[0],
                        this.p.v[1] - this.a.v[1],
                        this.p.v[2] - this.a.v[2]
                    ] : [
                        this.px.v - this.a.v[0],
                        this.py.v - this.a.v[1],
                        this.pz.v - this.a.v[2]
                    ];
                    var a = Math.sqrt(Math.pow(s[0], 2) + Math.pow(s[1], 2) + Math.pow(s[2], 2)), n = [
                        s[0] / a,
                        s[1] / a,
                        s[2] / a
                    ], o = Math.sqrt(n[2] * n[2] + n[0] * n[0]), h = Math.atan2(n[1], o), l = Math.atan2(n[0], -n[2]);
                    this.mat.rotateY(l).rotateX(-h);
                }
                this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v), this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]), this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0), this.mat.translate(0, 0, this.pe.v);
                var p = !this._prevMat.equals(this.mat);
                if ((p || this.pe._mdf) && this.comp.threeDElements) {
                    var c, f, u;
                    for(e = this.comp.threeDElements.length, t = 0; t < e; t += 1)if ("3d" === (c = this.comp.threeDElements[t]).type) {
                        if (p) {
                            var d = this.mat.toCSS();
                            (u = c.container.style).transform = d, u.webkitTransform = d;
                        }
                        this.pe._mdf && ((f = c.perspectiveElem.style).perspective = this.pe.v + "px", f.webkitPerspective = this.pe.v + "px");
                    }
                    this.mat.clone(this._prevMat);
                }
            }
            this._isFirstFrame = !1;
        }, HCameraElement.prototype.prepareFrame = function(t) {
            this.prepareProperties(t, !0);
        }, HCameraElement.prototype.destroy = function() {}, HCameraElement.prototype.getBaseElement = function() {
            return null;
        }, extendPrototype([
            BaseElement,
            TransformElement,
            HBaseElement,
            HSolidElement,
            HierarchyElement,
            FrameElement,
            RenderableElement
        ], HImageElement), HImageElement.prototype.createContent = function() {
            var t = this.globalData.getAssetsPath(this.assetData), e = new Image;
            this.data.hasMask ? (this.imageElem = createNS("image"), this.imageElem.setAttribute("width", this.assetData.w + "px"), this.imageElem.setAttribute("height", this.assetData.h + "px"), this.imageElem.setAttributeNS("http://www.w3.org/1999/xlink", "href", t), this.layerElement.appendChild(this.imageElem), this.baseElement.setAttribute("width", this.assetData.w), this.baseElement.setAttribute("height", this.assetData.h)) : this.layerElement.appendChild(e), e.crossOrigin = "anonymous", e.src = t, this.data.ln && this.baseElement.setAttribute("id", this.data.ln);
        }, extendPrototype([
            BaseRenderer
        ], HybridRendererBase), HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem, HybridRendererBase.prototype.checkPendingElements = function() {
            for(; this.pendingElements.length;)this.pendingElements.pop().checkParenting();
        }, HybridRendererBase.prototype.appendElementInPos = function(t, e) {
            var r1 = t.getBaseElement();
            if (r1) {
                var i = this.layers[e];
                if (i.ddd && this.supports3d) this.addTo3dContainer(r1, e);
                else if (this.threeDElements) this.addTo3dContainer(r1, e);
                else {
                    for(var s, a, n = 0; n < e;)this.elements[n] && !0 !== this.elements[n] && this.elements[n].getBaseElement && (a = this.elements[n], s = (this.layers[n].ddd ? this.getThreeDContainerByPos(n) : a.getBaseElement()) || s), n += 1;
                    s ? i.ddd && this.supports3d || this.layerElement.insertBefore(r1, s) : i.ddd && this.supports3d || this.layerElement.appendChild(r1);
                }
            }
        }, HybridRendererBase.prototype.createShape = function(t) {
            return this.supports3d ? new HShapeElement(t, this.globalData, this) : new SVGShapeElement(t, this.globalData, this);
        }, HybridRendererBase.prototype.createText = function(t) {
            return this.supports3d ? new HTextElement(t, this.globalData, this) : new SVGTextLottieElement(t, this.globalData, this);
        }, HybridRendererBase.prototype.createCamera = function(t) {
            return this.camera = new HCameraElement(t, this.globalData, this), this.camera;
        }, HybridRendererBase.prototype.createImage = function(t) {
            return this.supports3d ? new HImageElement(t, this.globalData, this) : new IImageElement(t, this.globalData, this);
        }, HybridRendererBase.prototype.createSolid = function(t) {
            return this.supports3d ? new HSolidElement(t, this.globalData, this) : new ISolidElement(t, this.globalData, this);
        }, HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull, HybridRendererBase.prototype.getThreeDContainerByPos = function(t) {
            for(var e = 0, r1 = this.threeDElements.length; e < r1;){
                if (this.threeDElements[e].startPos <= t && this.threeDElements[e].endPos >= t) return this.threeDElements[e].perspectiveElem;
                e += 1;
            }
            return null;
        }, HybridRendererBase.prototype.createThreeDContainer = function(t, e) {
            var r1, i, s = createTag("div");
            styleDiv(s);
            var a = createTag("div");
            if (styleDiv(a), "3d" === e) {
                (r1 = s.style).width = this.globalData.compSize.w + "px", r1.height = this.globalData.compSize.h + "px";
                var n = "50% 50%";
                r1.webkitTransformOrigin = n, r1.mozTransformOrigin = n, r1.transformOrigin = n;
                var o = "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)";
                (i = a.style).transform = o, i.webkitTransform = o;
            }
            s.appendChild(a);
            var h = {
                container: a,
                perspectiveElem: s,
                startPos: t,
                endPos: t,
                type: e
            };
            return this.threeDElements.push(h), h;
        }, HybridRendererBase.prototype.build3dContainers = function() {
            var t, e, r1 = this.layers.length, i = "";
            for(t = 0; t < r1; t += 1)this.layers[t].ddd && 3 !== this.layers[t].ty ? ("3d" !== i && (i = "3d", e = this.createThreeDContainer(t, "3d")), e.endPos = Math.max(e.endPos, t)) : ("2d" !== i && (i = "2d", e = this.createThreeDContainer(t, "2d")), e.endPos = Math.max(e.endPos, t));
            for(t = (r1 = this.threeDElements.length) - 1; t >= 0; t -= 1)this.resizerElem.appendChild(this.threeDElements[t].perspectiveElem);
        }, HybridRendererBase.prototype.addTo3dContainer = function(t, e) {
            for(var r1 = 0, i = this.threeDElements.length; r1 < i;){
                if (e <= this.threeDElements[r1].endPos) {
                    for(var s, a = this.threeDElements[r1].startPos; a < e;)this.elements[a] && this.elements[a].getBaseElement && (s = this.elements[a].getBaseElement()), a += 1;
                    s ? this.threeDElements[r1].container.insertBefore(t, s) : this.threeDElements[r1].container.appendChild(t);
                    break;
                }
                r1 += 1;
            }
        }, HybridRendererBase.prototype.configAnimation = function(t) {
            var e = createTag("div"), r1 = this.animationItem.wrapper, i = e.style;
            i.width = t.w + "px", i.height = t.h + "px", this.resizerElem = e, styleDiv(e), i.transformStyle = "flat", i.mozTransformStyle = "flat", i.webkitTransformStyle = "flat", this.renderConfig.className && e.setAttribute("class", this.renderConfig.className), r1.appendChild(e), i.overflow = "hidden";
            var s = createNS("svg");
            s.setAttribute("width", "1"), s.setAttribute("height", "1"), styleDiv(s), this.resizerElem.appendChild(s);
            var a = createNS("defs");
            s.appendChild(a), this.data = t, this.setupGlobalData(t, s), this.globalData.defs = a, this.layers = t.layers, this.layerElement = this.resizerElem, this.build3dContainers(), this.updateContainerSize();
        }, HybridRendererBase.prototype.destroy = function() {
            var t;
            this.animationItem.wrapper && (this.animationItem.wrapper.innerText = ""), this.animationItem.container = null, this.globalData.defs = null;
            var e = this.layers ? this.layers.length : 0;
            for(t = 0; t < e; t += 1)this.elements[t] && this.elements[t].destroy && this.elements[t].destroy();
            this.elements.length = 0, this.destroyed = !0, this.animationItem = null;
        }, HybridRendererBase.prototype.updateContainerSize = function() {
            var t, e, r1, i, s = this.animationItem.wrapper.offsetWidth, a = this.animationItem.wrapper.offsetHeight, n = s / a;
            this.globalData.compSize.w / this.globalData.compSize.h > n ? (t = s / this.globalData.compSize.w, e = s / this.globalData.compSize.w, r1 = 0, i = (a - this.globalData.compSize.h * (s / this.globalData.compSize.w)) / 2) : (t = a / this.globalData.compSize.h, e = a / this.globalData.compSize.h, r1 = (s - this.globalData.compSize.w * (a / this.globalData.compSize.h)) / 2, i = 0);
            var o = this.resizerElem.style;
            o.webkitTransform = "matrix3d(" + t + ",0,0,0,0," + e + ",0,0,0,0,1,0," + r1 + "," + i + ",0,1)", o.transform = o.webkitTransform;
        }, HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame, HybridRendererBase.prototype.hide = function() {
            this.resizerElem.style.display = "none";
        }, HybridRendererBase.prototype.show = function() {
            this.resizerElem.style.display = "block";
        }, HybridRendererBase.prototype.initItems = function() {
            if (this.buildAllItems(), this.camera) this.camera.setup();
            else {
                var t, e = this.globalData.compSize.w, r1 = this.globalData.compSize.h, i = this.threeDElements.length;
                for(t = 0; t < i; t += 1){
                    var s = this.threeDElements[t].perspectiveElem.style;
                    s.webkitPerspective = Math.sqrt(Math.pow(e, 2) + Math.pow(r1, 2)) + "px", s.perspective = s.webkitPerspective;
                }
            }
        }, HybridRendererBase.prototype.searchExtraCompositions = function(t) {
            var e, r1 = t.length, i = createTag("div");
            for(e = 0; e < r1; e += 1)if (t[e].xt) {
                var s = this.createComp(t[e], i, this.globalData.comp, null);
                s.initExpressions(), this.globalData.projectInterface.registerComposition(s);
            }
        }, extendPrototype([
            HybridRendererBase,
            ICompElement,
            HBaseElement
        ], HCompElement), HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements, HCompElement.prototype.createContainerElements = function() {
            this._createBaseContainerElements(), this.data.hasMask ? (this.svgElement.setAttribute("width", this.data.w), this.svgElement.setAttribute("height", this.data.h), this.transformedElement = this.baseElement) : this.transformedElement = this.layerElement;
        }, HCompElement.prototype.addTo3dContainer = function(t, e) {
            for(var r1, i = 0; i < e;)this.elements[i] && this.elements[i].getBaseElement && (r1 = this.elements[i].getBaseElement()), i += 1;
            r1 ? this.layerElement.insertBefore(t, r1) : this.layerElement.appendChild(t);
        }, HCompElement.prototype.createComp = function(t) {
            return this.supports3d ? new HCompElement(t, this.globalData, this) : new SVGCompElement(t, this.globalData, this);
        }, extendPrototype([
            HybridRendererBase
        ], HybridRenderer), HybridRenderer.prototype.createComp = function(t) {
            return this.supports3d ? new HCompElement(t, this.globalData, this) : new SVGCompElement(t, this.globalData, this);
        };
        var CompExpressionInterface = function(t) {
            function e(e) {
                for(var r1 = 0, i = t.layers.length; r1 < i;){
                    if (t.layers[r1].nm === e || t.layers[r1].ind === e) return t.elements[r1].layerInterface;
                    r1 += 1;
                }
                return null;
            }
            return Object.defineProperty(e, "_name", {
                value: t.data.nm
            }), e.layer = e, e.pixelAspect = 1, e.height = t.data.h || t.globalData.compSize.h, e.width = t.data.w || t.globalData.compSize.w, e.pixelAspect = 1, e.frameDuration = 1 / t.globalData.frameRate, e.displayStartTime = 0, e.numLayers = t.layers.length, e;
        };
        function _typeof$2(t) {
            return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, _typeof$2(t);
        }
        function seedRandom(t, e) {
            var r1 = this, i = 256, s = e.pow(i, 6), a = e.pow(2, 52), n = 2 * a, o = 255;
            function h(t) {
                var e, r1 = t.length, s = this, a = 0, n = s.i = s.j = 0, h = s.S = [];
                for(r1 || (t = [
                    r1++
                ]); a < i;)h[a] = a++;
                for(a = 0; a < i; a++)h[a] = h[n = o & n + t[a % r1] + (e = h[a])], h[n] = e;
                s.g = function(t) {
                    for(var e, r1 = 0, a = s.i, n = s.j, h = s.S; t--;)e = h[a = o & a + 1], r1 = r1 * i + h[o & (h[a] = h[n = o & n + e]) + (h[n] = e)];
                    return s.i = a, s.j = n, r1;
                };
            }
            function l(t, e) {
                return e.i = t.i, e.j = t.j, e.S = t.S.slice(), e;
            }
            function p(t, e) {
                var r1, i = [], s = _typeof$2(t);
                if (e && "object" == s) for(r1 in t)try {
                    i.push(p(t[r1], e - 1));
                } catch (t) {}
                return i.length ? i : "string" == s ? t : t + "\0";
            }
            function c(t, e) {
                for(var r1, i = t + "", s = 0; s < i.length;)e[o & s] = o & (r1 ^= 19 * e[o & s]) + i.charCodeAt(s++);
                return f(e);
            }
            function f(t) {
                return String.fromCharCode.apply(0, t);
            }
            e.seedrandom = function(o, u, d) {
                var m = [], y = c(p((u = !0 === u ? {
                    entropy: !0
                } : u || {}).entropy ? [
                    o,
                    f(t)
                ] : null === o ? function() {
                    try {
                        var e = new Uint8Array(i);
                        return (r1.crypto || r1.msCrypto).getRandomValues(e), f(e);
                    } catch (e) {
                        var s = r1.navigator, a = s && s.plugins;
                        return [
                            +new Date,
                            r1,
                            a,
                            r1.screen,
                            f(t)
                        ];
                    }
                }() : o, 3), m), g = new h(m), v = function() {
                    for(var t = g.g(6), e = s, r1 = 0; t < a;)t = (t + r1) * i, e *= i, r1 = g.g(1);
                    for(; t >= n;)t /= 2, e /= 2, r1 >>>= 1;
                    return (t + r1) / e;
                };
                return v.int32 = function() {
                    return 0 | g.g(4);
                }, v.quick = function() {
                    return g.g(4) / 4294967296;
                }, v.double = v, c(f(g.S), t), (u.pass || d || function(t, r1, i, s) {
                    return s && (s.S && l(s, g), t.state = function() {
                        return l(g, {});
                    }), i ? (e.random = t, r1) : t;
                })(v, y, "global" in u ? u.global : this == e, u.state);
            }, c(e.random(), t);
        }
        function initialize$2(t) {
            seedRandom([], t);
        }
        var propTypes = {
            SHAPE: "shape"
        };
        function _typeof$1(t) {
            return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, _typeof$1(t);
        }
        var ExpressionManager = function() {
            var ob = {}, Math1 = BMMath, window1 = null, document1 = null, XMLHttpRequest1 = null, fetch1 = null, frames = null, _lottieGlobal = {};
            function resetFrame() {
                _lottieGlobal = {};
            }
            function $bm_isInstanceOfArray(t) {
                return t.constructor === Array || t.constructor === Float32Array;
            }
            function isNumerable(t, e) {
                return "number" === t || e instanceof Number || "boolean" === t || "string" === t;
            }
            function $bm_neg(t) {
                var e = _typeof$1(t);
                if ("number" === e || t instanceof Number || "boolean" === e) return -t;
                if ($bm_isInstanceOfArray(t)) {
                    var r1, i = t.length, s = [];
                    for(r1 = 0; r1 < i; r1 += 1)s[r1] = -t[r1];
                    return s;
                }
                return t.propType ? t.v : -t;
            }
            initialize$2(BMMath);
            var easeInBez = BezierFactory.getBezierEasing(.333, 0, .833, .833, "easeIn").get, easeOutBez = BezierFactory.getBezierEasing(.167, .167, .667, 1, "easeOut").get, easeInOutBez = BezierFactory.getBezierEasing(.33, 0, .667, 1, "easeInOut").get;
            function sum(t, e) {
                var r1 = _typeof$1(t), i = _typeof$1(e);
                if (isNumerable(r1, t) && isNumerable(i, e) || "string" === r1 || "string" === i) return t + e;
                if ($bm_isInstanceOfArray(t) && isNumerable(i, e)) return (t = t.slice(0))[0] += e, t;
                if (isNumerable(r1, t) && $bm_isInstanceOfArray(e)) return (e = e.slice(0))[0] = t + e[0], e;
                if ($bm_isInstanceOfArray(t) && $bm_isInstanceOfArray(e)) {
                    for(var s = 0, a = t.length, n = e.length, o = []; s < a || s < n;)("number" == typeof t[s] || t[s] instanceof Number) && ("number" == typeof e[s] || e[s] instanceof Number) ? o[s] = t[s] + e[s] : o[s] = void 0 === e[s] ? t[s] : t[s] || e[s], s += 1;
                    return o;
                }
                return 0;
            }
            var add = sum;
            function sub(t, e) {
                var r1 = _typeof$1(t), i = _typeof$1(e);
                if (isNumerable(r1, t) && isNumerable(i, e)) return "string" === r1 && (t = parseInt(t, 10)), "string" === i && (e = parseInt(e, 10)), t - e;
                if ($bm_isInstanceOfArray(t) && isNumerable(i, e)) return (t = t.slice(0))[0] -= e, t;
                if (isNumerable(r1, t) && $bm_isInstanceOfArray(e)) return (e = e.slice(0))[0] = t - e[0], e;
                if ($bm_isInstanceOfArray(t) && $bm_isInstanceOfArray(e)) {
                    for(var s = 0, a = t.length, n = e.length, o = []; s < a || s < n;)("number" == typeof t[s] || t[s] instanceof Number) && ("number" == typeof e[s] || e[s] instanceof Number) ? o[s] = t[s] - e[s] : o[s] = void 0 === e[s] ? t[s] : t[s] || e[s], s += 1;
                    return o;
                }
                return 0;
            }
            function mul(t, e) {
                var r1, i, s, a = _typeof$1(t), n = _typeof$1(e);
                if (isNumerable(a, t) && isNumerable(n, e)) return t * e;
                if ($bm_isInstanceOfArray(t) && isNumerable(n, e)) {
                    for(s = t.length, r1 = createTypedArray("float32", s), i = 0; i < s; i += 1)r1[i] = t[i] * e;
                    return r1;
                }
                if (isNumerable(a, t) && $bm_isInstanceOfArray(e)) {
                    for(s = e.length, r1 = createTypedArray("float32", s), i = 0; i < s; i += 1)r1[i] = t * e[i];
                    return r1;
                }
                return 0;
            }
            function div(t, e) {
                var r1, i, s, a = _typeof$1(t), n = _typeof$1(e);
                if (isNumerable(a, t) && isNumerable(n, e)) return t / e;
                if ($bm_isInstanceOfArray(t) && isNumerable(n, e)) {
                    for(s = t.length, r1 = createTypedArray("float32", s), i = 0; i < s; i += 1)r1[i] = t[i] / e;
                    return r1;
                }
                if (isNumerable(a, t) && $bm_isInstanceOfArray(e)) {
                    for(s = e.length, r1 = createTypedArray("float32", s), i = 0; i < s; i += 1)r1[i] = t / e[i];
                    return r1;
                }
                return 0;
            }
            function mod(t, e) {
                return "string" == typeof t && (t = parseInt(t, 10)), "string" == typeof e && (e = parseInt(e, 10)), t % e;
            }
            var $bm_sum = sum, $bm_sub = sub, $bm_mul = mul, $bm_div = div, $bm_mod = mod;
            function clamp(t, e, r1) {
                if (e > r1) {
                    var i = r1;
                    r1 = e, e = i;
                }
                return Math1.min(Math1.max(t, e), r1);
            }
            function radiansToDegrees(t) {
                return t / degToRads;
            }
            var radians_to_degrees = radiansToDegrees;
            function degreesToRadians(t) {
                return t * degToRads;
            }
            var degrees_to_radians = radiansToDegrees, helperLengthArray = [
                0,
                0,
                0,
                0,
                0,
                0
            ];
            function length(t, e) {
                if ("number" == typeof t || t instanceof Number) return e = e || 0, Math1.abs(t - e);
                var r1;
                e || (e = helperLengthArray);
                var i = Math1.min(t.length, e.length), s = 0;
                for(r1 = 0; r1 < i; r1 += 1)s += Math1.pow(e[r1] - t[r1], 2);
                return Math1.sqrt(s);
            }
            function normalize(t) {
                return div(t, length(t));
            }
            function rgbToHsl(t) {
                var e, r1, i = t[0], s = t[1], a = t[2], n = Math1.max(i, s, a), o = Math1.min(i, s, a), h = (n + o) / 2;
                if (n === o) e = 0, r1 = 0;
                else {
                    var l = n - o;
                    switch(r1 = h > .5 ? l / (2 - n - o) : l / (n + o), n){
                        case i:
                            e = (s - a) / l + (s < a ? 6 : 0);
                            break;
                        case s:
                            e = (a - i) / l + 2;
                            break;
                        case a:
                            e = (i - s) / l + 4;
                    }
                    e /= 6;
                }
                return [
                    e,
                    r1,
                    h,
                    t[3]
                ];
            }
            function hue2rgb(t, e, r1) {
                return r1 < 0 && (r1 += 1), r1 > 1 && (r1 -= 1), r1 < 1 / 6 ? t + 6 * (e - t) * r1 : r1 < .5 ? e : r1 < 2 / 3 ? t + (e - t) * (2 / 3 - r1) * 6 : t;
            }
            function hslToRgb(t) {
                var e, r1, i, s = t[0], a = t[1], n = t[2];
                if (0 === a) e = n, i = n, r1 = n;
                else {
                    var o = n < .5 ? n * (1 + a) : n + a - n * a, h = 2 * n - o;
                    e = hue2rgb(h, o, s + 1 / 3), r1 = hue2rgb(h, o, s), i = hue2rgb(h, o, s - 1 / 3);
                }
                return [
                    e,
                    r1,
                    i,
                    t[3]
                ];
            }
            function linear(t, e, r1, i, s) {
                if (void 0 !== i && void 0 !== s || (i = e, s = r1, e = 0, r1 = 1), r1 < e) {
                    var a = r1;
                    r1 = e, e = a;
                }
                if (t <= e) return i;
                if (t >= r1) return s;
                var n, o = r1 === e ? 0 : (t - e) / (r1 - e);
                if (!i.length) return i + (s - i) * o;
                var h = i.length, l = createTypedArray("float32", h);
                for(n = 0; n < h; n += 1)l[n] = i[n] + (s[n] - i[n]) * o;
                return l;
            }
            function random(t, e) {
                if (void 0 === e && (void 0 === t ? (t = 0, e = 1) : (e = t, t = void 0)), e.length) {
                    var r1, i = e.length;
                    t || (t = createTypedArray("float32", i));
                    var s = createTypedArray("float32", i), a = BMMath.random();
                    for(r1 = 0; r1 < i; r1 += 1)s[r1] = t[r1] + a * (e[r1] - t[r1]);
                    return s;
                }
                return void 0 === t && (t = 0), t + BMMath.random() * (e - t);
            }
            function createPath(t, e, r1, i) {
                var s, a = t.length, n = shapePool.newElement();
                n.setPathData(!!i, a);
                var o, h, l = [
                    0,
                    0
                ];
                for(s = 0; s < a; s += 1)o = e && e[s] ? e[s] : l, h = r1 && r1[s] ? r1[s] : l, n.setTripleAt(t[s][0], t[s][1], h[0] + t[s][0], h[1] + t[s][1], o[0] + t[s][0], o[1] + t[s][1], s, !0);
                return n;
            }
            function initiateExpression(elem, data, property) {
                function noOp(t) {
                    return t;
                }
                if (!elem.globalData.renderConfig.runExpressions) return noOp;
                var val = data.x, needsVelocity = /velocity(?![\w\d])/.test(val), _needsRandom = -1 !== val.indexOf("random"), elemType = elem.data.ty, transform, $bm_transform, content, effect, thisProperty = property;
                thisProperty.valueAtTime = thisProperty.getValueAtTime, Object.defineProperty(thisProperty, "value", {
                    get: function() {
                        return thisProperty.v;
                    }
                }), elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate, elem.comp.displayStartTime = 0;
                var inPoint = elem.data.ip / elem.comp.globalData.frameRate, outPoint = elem.data.op / elem.comp.globalData.frameRate, width = elem.data.sw ? elem.data.sw : 0, height = elem.data.sh ? elem.data.sh : 0, name = elem.data.nm, loopIn, loop_in, loopOut, loop_out, smooth, toWorld, fromWorld, fromComp, toComp, fromCompToSurface, position, rotation, anchorPoint, scale, thisLayer, thisComp, mask, valueAtTime, velocityAtTime, scoped_bm_rt, expression_function = eval("[function _expression_function(){" + val + ";scoped_bm_rt=$bm_rt}]")[0], numKeys = property.kf ? data.k.length : 0, active = !this.data || !0 !== this.data.hd, wiggle = (function(t, e) {
                    var r1, i, s = this.pv.length ? this.pv.length : 1, a = createTypedArray("float32", s), n = Math1.floor(5 * time);
                    for(r1 = 0, i = 0; r1 < n;){
                        for(i = 0; i < s; i += 1)a[i] += -e + 2 * e * BMMath.random();
                        r1 += 1;
                    }
                    var o = 5 * time, h = o - Math1.floor(o), l = createTypedArray("float32", s);
                    if (s > 1) {
                        for(i = 0; i < s; i += 1)l[i] = this.pv[i] + a[i] + (-e + 2 * e * BMMath.random()) * h;
                        return l;
                    }
                    return this.pv + a[0] + (-e + 2 * e * BMMath.random()) * h;
                }).bind(this);
                function loopInDuration(t, e) {
                    return loopIn(t, e, !0);
                }
                function loopOutDuration(t, e) {
                    return loopOut(t, e, !0);
                }
                thisProperty.loopIn && (loopIn = thisProperty.loopIn.bind(thisProperty), loop_in = loopIn), thisProperty.loopOut && (loopOut = thisProperty.loopOut.bind(thisProperty), loop_out = loopOut), thisProperty.smooth && (smooth = thisProperty.smooth.bind(thisProperty)), this.getValueAtTime && (valueAtTime = this.getValueAtTime.bind(this)), this.getVelocityAtTime && (velocityAtTime = this.getVelocityAtTime.bind(this));
                var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface), time, velocity, value, text, textIndex, textTotal, selectorValue;
                function lookAt(t, e) {
                    var r1 = [
                        e[0] - t[0],
                        e[1] - t[1],
                        e[2] - t[2]
                    ], i = Math1.atan2(r1[0], Math1.sqrt(r1[1] * r1[1] + r1[2] * r1[2])) / degToRads;
                    return [
                        -Math1.atan2(r1[1], r1[2]) / degToRads,
                        i,
                        0
                    ];
                }
                function easeOut(t, e, r1, i, s) {
                    return applyEase(easeOutBez, t, e, r1, i, s);
                }
                function easeIn(t, e, r1, i, s) {
                    return applyEase(easeInBez, t, e, r1, i, s);
                }
                function ease(t, e, r1, i, s) {
                    return applyEase(easeInOutBez, t, e, r1, i, s);
                }
                function applyEase(t, e, r1, i, s, a) {
                    void 0 === s ? (s = r1, a = i) : e = (e - r1) / (i - r1), e > 1 ? e = 1 : e < 0 && (e = 0);
                    var n = t(e);
                    if ($bm_isInstanceOfArray(s)) {
                        var o, h = s.length, l = createTypedArray("float32", h);
                        for(o = 0; o < h; o += 1)l[o] = (a[o] - s[o]) * n + s[o];
                        return l;
                    }
                    return (a - s) * n + s;
                }
                function nearestKey(t) {
                    var e, r1, i, s = data.k.length;
                    if (data.k.length && "number" != typeof data.k[0]) {
                        if (r1 = -1, (t *= elem.comp.globalData.frameRate) < data.k[0].t) r1 = 1, i = data.k[0].t;
                        else {
                            for(e = 0; e < s - 1; e += 1){
                                if (t === data.k[e].t) {
                                    r1 = e + 1, i = data.k[e].t;
                                    break;
                                }
                                if (t > data.k[e].t && t < data.k[e + 1].t) {
                                    t - data.k[e].t > data.k[e + 1].t - t ? (r1 = e + 2, i = data.k[e + 1].t) : (r1 = e + 1, i = data.k[e].t);
                                    break;
                                }
                            }
                            -1 === r1 && (r1 = e + 1, i = data.k[e].t);
                        }
                    } else r1 = 0, i = 0;
                    var a = {};
                    return a.index = r1, a.time = i / elem.comp.globalData.frameRate, a;
                }
                function key(t) {
                    var e, r1, i;
                    if (!data.k.length || "number" == typeof data.k[0]) throw new Error("The property has no keyframe at index " + t);
                    t -= 1, e = {
                        time: data.k[t].t / elem.comp.globalData.frameRate,
                        value: []
                    };
                    var s = Object.prototype.hasOwnProperty.call(data.k[t], "s") ? data.k[t].s : data.k[t - 1].e;
                    for(i = s.length, r1 = 0; r1 < i; r1 += 1)e[r1] = s[r1], e.value[r1] = s[r1];
                    return e;
                }
                function framesToTime(t, e) {
                    return e || (e = elem.comp.globalData.frameRate), t / e;
                }
                function timeToFrames(t, e) {
                    return t || 0 === t || (t = time), e || (e = elem.comp.globalData.frameRate), t * e;
                }
                function seedRandom(t) {
                    BMMath.seedrandom(randSeed + t);
                }
                function sourceRectAtTime() {
                    return elem.sourceRectAtTime();
                }
                function substring(t, e) {
                    return "string" == typeof value ? void 0 === e ? value.substring(t) : value.substring(t, e) : "";
                }
                function substr(t, e) {
                    return "string" == typeof value ? void 0 === e ? value.substr(t) : value.substr(t, e) : "";
                }
                function posterizeTime(t) {
                    time = 0 === t ? 0 : Math1.floor(time * t) / t, value = valueAtTime(time);
                }
                var index = elem.data.ind, hasParent = !(!elem.hierarchy || !elem.hierarchy.length), parent, randSeed = Math1.floor(1e6 * Math1.random()), globalData = elem.globalData;
                function executeExpression(t) {
                    return value = t, this.frameExpressionId === elem.globalData.frameId && "textSelector" !== this.propType ? value : ("textSelector" === this.propType && (textIndex = this.textIndex, textTotal = this.textTotal, selectorValue = this.selectorValue), thisLayer || (text = elem.layerInterface.text, thisLayer = elem.layerInterface, thisComp = elem.comp.compInterface, toWorld = thisLayer.toWorld.bind(thisLayer), fromWorld = thisLayer.fromWorld.bind(thisLayer), fromComp = thisLayer.fromComp.bind(thisLayer), toComp = thisLayer.toComp.bind(thisLayer), mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null, fromCompToSurface = fromComp), transform || (transform = elem.layerInterface("ADBE Transform Group"), $bm_transform = transform, transform && (anchorPoint = transform.anchorPoint)), 4 !== elemType || content || (content = thisLayer("ADBE Root Vectors Group")), effect || (effect = thisLayer(4)), (hasParent = !(!elem.hierarchy || !elem.hierarchy.length)) && !parent && (parent = elem.hierarchy[0].layerInterface), time = this.comp.renderedFrame / this.comp.globalData.frameRate, _needsRandom && seedRandom(randSeed + time), needsVelocity && (velocity = velocityAtTime(time)), expression_function(), this.frameExpressionId = elem.globalData.frameId, scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt);
                }
                return executeExpression.__preventDeadCodeRemoval = [
                    $bm_transform,
                    anchorPoint,
                    time,
                    velocity,
                    inPoint,
                    outPoint,
                    width,
                    height,
                    name,
                    loop_in,
                    loop_out,
                    smooth,
                    toComp,
                    fromCompToSurface,
                    toWorld,
                    fromWorld,
                    mask,
                    position,
                    rotation,
                    scale,
                    thisComp,
                    numKeys,
                    active,
                    wiggle,
                    loopInDuration,
                    loopOutDuration,
                    comp,
                    lookAt,
                    easeOut,
                    easeIn,
                    ease,
                    nearestKey,
                    key,
                    text,
                    textIndex,
                    textTotal,
                    selectorValue,
                    framesToTime,
                    timeToFrames,
                    sourceRectAtTime,
                    substring,
                    substr,
                    posterizeTime,
                    index,
                    globalData
                ], executeExpression;
            }
            return ob.initiateExpression = initiateExpression, ob.__preventDeadCodeRemoval = [
                window1,
                document1,
                XMLHttpRequest1,
                fetch1,
                frames,
                $bm_neg,
                add,
                $bm_sum,
                $bm_sub,
                $bm_mul,
                $bm_div,
                $bm_mod,
                clamp,
                radians_to_degrees,
                degreesToRadians,
                degrees_to_radians,
                normalize,
                rgbToHsl,
                hslToRgb,
                linear,
                random,
                createPath,
                _lottieGlobal
            ], ob.resetFrame = resetFrame, ob;
        }(), Expressions = function() {
            var t = {
                initExpressions: function(t) {
                    var e = 0, r1 = [];
                    t.renderer.compInterface = CompExpressionInterface(t.renderer), t.renderer.globalData.projectInterface.registerComposition(t.renderer), t.renderer.globalData.pushExpression = function() {
                        e += 1;
                    }, t.renderer.globalData.popExpression = function() {
                        0 == (e -= 1) && function() {
                            var t, e = r1.length;
                            for(t = 0; t < e; t += 1)r1[t].release();
                            r1.length = 0;
                        }();
                    }, t.renderer.globalData.registerExpressionProperty = function(t) {
                        -1 === r1.indexOf(t) && r1.push(t);
                    };
                }
            };
            return t.resetFrame = ExpressionManager.resetFrame, t;
        }(), MaskManagerInterface = function() {
            function t(t, e) {
                this._mask = t, this._data = e;
            }
            return Object.defineProperty(t.prototype, "maskPath", {
                get: function() {
                    return this._mask.prop.k && this._mask.prop.getValue(), this._mask.prop;
                }
            }), Object.defineProperty(t.prototype, "maskOpacity", {
                get: function() {
                    return this._mask.op.k && this._mask.op.getValue(), 100 * this._mask.op.v;
                }
            }), function(e) {
                var r1, i = createSizedArray(e.viewData.length), s = e.viewData.length;
                for(r1 = 0; r1 < s; r1 += 1)i[r1] = new t(e.viewData[r1], e.masksProperties[r1]);
                return function(t) {
                    for(r1 = 0; r1 < s;){
                        if (e.masksProperties[r1].nm === t) return i[r1];
                        r1 += 1;
                    }
                    return null;
                };
            };
        }(), ExpressionPropertyInterface = function() {
            var t = {
                pv: 0,
                v: 0,
                mult: 1
            }, e = {
                pv: [
                    0,
                    0,
                    0
                ],
                v: [
                    0,
                    0,
                    0
                ],
                mult: 1
            };
            function r1(t, e, r1) {
                Object.defineProperty(t, "velocity", {
                    get: function() {
                        return e.getVelocityAtTime(e.comp.currentFrame);
                    }
                }), t.numKeys = e.keyframes ? e.keyframes.length : 0, t.key = function(i) {
                    if (!t.numKeys) return 0;
                    var s = "";
                    s = "s" in e.keyframes[i - 1] ? e.keyframes[i - 1].s : "e" in e.keyframes[i - 2] ? e.keyframes[i - 2].e : e.keyframes[i - 2].s;
                    var a = "unidimensional" === r1 ? new Number(s) : Object.assign({}, s);
                    return a.time = e.keyframes[i - 1].t / e.elem.comp.globalData.frameRate, a.value = "unidimensional" === r1 ? s[0] : s, a;
                }, t.valueAtTime = e.getValueAtTime, t.speedAtTime = e.getSpeedAtTime, t.velocityAtTime = e.getVelocityAtTime, t.propertyGroup = e.propertyGroup;
            }
            function i() {
                return t;
            }
            return function(s) {
                return s ? "unidimensional" === s.propType ? function(e) {
                    e && "pv" in e || (e = t);
                    var i = 1 / e.mult, s = e.pv * i, a = new Number(s);
                    return a.value = s, r1(a, e, "unidimensional"), function() {
                        return e.k && e.getValue(), s = e.v * i, a.value !== s && ((a = new Number(s)).value = s, r1(a, e, "unidimensional")), a;
                    };
                }(s) : function(t) {
                    t && "pv" in t || (t = e);
                    var i = 1 / t.mult, s = t.data && t.data.l || t.pv.length, a = createTypedArray("float32", s), n = createTypedArray("float32", s);
                    return a.value = n, r1(a, t, "multidimensional"), function() {
                        t.k && t.getValue();
                        for(var e = 0; e < s; e += 1)n[e] = t.v[e] * i, a[e] = n[e];
                        return a;
                    };
                }(s) : i;
            };
        }(), TransformExpressionInterface = function(t) {
            function e(t) {
                switch(t){
                    case "scale":
                    case "Scale":
                    case "ADBE Scale":
                    case 6:
                        return e.scale;
                    case "rotation":
                    case "Rotation":
                    case "ADBE Rotation":
                    case "ADBE Rotate Z":
                    case 10:
                        return e.rotation;
                    case "ADBE Rotate X":
                        return e.xRotation;
                    case "ADBE Rotate Y":
                        return e.yRotation;
                    case "position":
                    case "Position":
                    case "ADBE Position":
                    case 2:
                        return e.position;
                    case "ADBE Position_0":
                        return e.xPosition;
                    case "ADBE Position_1":
                        return e.yPosition;
                    case "ADBE Position_2":
                        return e.zPosition;
                    case "anchorPoint":
                    case "AnchorPoint":
                    case "Anchor Point":
                    case "ADBE AnchorPoint":
                    case 1:
                        return e.anchorPoint;
                    case "opacity":
                    case "Opacity":
                    case 11:
                        return e.opacity;
                    default:
                        return null;
                }
            }
            var r1, i, s, a;
            return Object.defineProperty(e, "rotation", {
                get: ExpressionPropertyInterface(t.r || t.rz)
            }), Object.defineProperty(e, "zRotation", {
                get: ExpressionPropertyInterface(t.rz || t.r)
            }), Object.defineProperty(e, "xRotation", {
                get: ExpressionPropertyInterface(t.rx)
            }), Object.defineProperty(e, "yRotation", {
                get: ExpressionPropertyInterface(t.ry)
            }), Object.defineProperty(e, "scale", {
                get: ExpressionPropertyInterface(t.s)
            }), t.p ? a = ExpressionPropertyInterface(t.p) : (r1 = ExpressionPropertyInterface(t.px), i = ExpressionPropertyInterface(t.py), t.pz && (s = ExpressionPropertyInterface(t.pz))), Object.defineProperty(e, "position", {
                get: function() {
                    return t.p ? a() : [
                        r1(),
                        i(),
                        s ? s() : 0
                    ];
                }
            }), Object.defineProperty(e, "xPosition", {
                get: ExpressionPropertyInterface(t.px)
            }), Object.defineProperty(e, "yPosition", {
                get: ExpressionPropertyInterface(t.py)
            }), Object.defineProperty(e, "zPosition", {
                get: ExpressionPropertyInterface(t.pz)
            }), Object.defineProperty(e, "anchorPoint", {
                get: ExpressionPropertyInterface(t.a)
            }), Object.defineProperty(e, "opacity", {
                get: ExpressionPropertyInterface(t.o)
            }), Object.defineProperty(e, "skew", {
                get: ExpressionPropertyInterface(t.sk)
            }), Object.defineProperty(e, "skewAxis", {
                get: ExpressionPropertyInterface(t.sa)
            }), Object.defineProperty(e, "orientation", {
                get: ExpressionPropertyInterface(t.or)
            }), e;
        }, LayerExpressionInterface = function() {
            function t(t) {
                var e = new Matrix;
                return void 0 !== t ? this._elem.finalTransform.mProp.getValueAtTime(t).clone(e) : this._elem.finalTransform.mProp.applyToMatrix(e), e;
            }
            function e(t, e) {
                var r1 = this.getMatrix(e);
                return r1.props[12] = 0, r1.props[13] = 0, r1.props[14] = 0, this.applyPoint(r1, t);
            }
            function r1(t, e) {
                var r1 = this.getMatrix(e);
                return this.applyPoint(r1, t);
            }
            function i(t, e) {
                var r1 = this.getMatrix(e);
                return r1.props[12] = 0, r1.props[13] = 0, r1.props[14] = 0, this.invertPoint(r1, t);
            }
            function s(t, e) {
                var r1 = this.getMatrix(e);
                return this.invertPoint(r1, t);
            }
            function a(t, e) {
                if (this._elem.hierarchy && this._elem.hierarchy.length) {
                    var r1, i = this._elem.hierarchy.length;
                    for(r1 = 0; r1 < i; r1 += 1)this._elem.hierarchy[r1].finalTransform.mProp.applyToMatrix(t);
                }
                return t.applyToPointArray(e[0], e[1], e[2] || 0);
            }
            function n(t, e) {
                if (this._elem.hierarchy && this._elem.hierarchy.length) {
                    var r1, i = this._elem.hierarchy.length;
                    for(r1 = 0; r1 < i; r1 += 1)this._elem.hierarchy[r1].finalTransform.mProp.applyToMatrix(t);
                }
                return t.inversePoint(e);
            }
            function o(t) {
                var e = new Matrix;
                if (e.reset(), this._elem.finalTransform.mProp.applyToMatrix(e), this._elem.hierarchy && this._elem.hierarchy.length) {
                    var r1, i = this._elem.hierarchy.length;
                    for(r1 = 0; r1 < i; r1 += 1)this._elem.hierarchy[r1].finalTransform.mProp.applyToMatrix(e);
                    return e.inversePoint(t);
                }
                return e.inversePoint(t);
            }
            function h() {
                return [
                    1,
                    1,
                    1,
                    1
                ];
            }
            return function(l) {
                var p;
                function c(t) {
                    switch(t){
                        case "ADBE Root Vectors Group":
                        case "Contents":
                        case 2:
                            return c.shapeInterface;
                        case 1:
                        case 6:
                        case "Transform":
                        case "transform":
                        case "ADBE Transform Group":
                            return p;
                        case 4:
                        case "ADBE Effect Parade":
                        case "effects":
                        case "Effects":
                            return c.effect;
                        case "ADBE Text Properties":
                            return c.textInterface;
                        default:
                            return null;
                    }
                }
                c.getMatrix = t, c.invertPoint = n, c.applyPoint = a, c.toWorld = r1, c.toWorldVec = e, c.fromWorld = s, c.fromWorldVec = i, c.toComp = r1, c.fromComp = o, c.sampleImage = h, c.sourceRectAtTime = l.sourceRectAtTime.bind(l), c._elem = l;
                var f = getDescriptor(p = TransformExpressionInterface(l.finalTransform.mProp), "anchorPoint");
                return Object.defineProperties(c, {
                    hasParent: {
                        get: function() {
                            return l.hierarchy.length;
                        }
                    },
                    parent: {
                        get: function() {
                            return l.hierarchy[0].layerInterface;
                        }
                    },
                    rotation: getDescriptor(p, "rotation"),
                    scale: getDescriptor(p, "scale"),
                    position: getDescriptor(p, "position"),
                    opacity: getDescriptor(p, "opacity"),
                    anchorPoint: f,
                    anchor_point: f,
                    transform: {
                        get: function() {
                            return p;
                        }
                    },
                    active: {
                        get: function() {
                            return l.isInRange;
                        }
                    }
                }), c.startTime = l.data.st, c.index = l.data.ind, c.source = l.data.refId, c.height = 0 === l.data.ty ? l.data.h : 100, c.width = 0 === l.data.ty ? l.data.w : 100, c.inPoint = l.data.ip / l.comp.globalData.frameRate, c.outPoint = l.data.op / l.comp.globalData.frameRate, c._name = l.data.nm, c.registerMaskInterface = function(t) {
                    c.mask = new MaskManagerInterface(t, l);
                }, c.registerEffectsInterface = function(t) {
                    c.effect = t;
                }, c;
            };
        }(), propertyGroupFactory = function(t, e) {
            return function(r1) {
                return (r1 = void 0 === r1 ? 1 : r1) <= 0 ? t : e(r1 - 1);
            };
        }, PropertyInterface = function(t, e) {
            var r1 = {
                _name: t
            };
            return function(t) {
                return (t = void 0 === t ? 1 : t) <= 0 ? r1 : e(t - 1);
            };
        }, EffectsExpressionInterface = function() {
            var t = {
                createEffectsInterface: function(t, r1) {
                    if (t.effectsManager) {
                        var i, s = [], a = t.data.ef, n = t.effectsManager.effectElements.length;
                        for(i = 0; i < n; i += 1)s.push(e(a[i], t.effectsManager.effectElements[i], r1, t));
                        var o = t.data.ef || [], h = function(t) {
                            for(i = 0, n = o.length; i < n;){
                                if (t === o[i].nm || t === o[i].mn || t === o[i].ix) return s[i];
                                i += 1;
                            }
                            return null;
                        };
                        return Object.defineProperty(h, "numProperties", {
                            get: function() {
                                return o.length;
                            }
                        }), h;
                    }
                    return null;
                }
            };
            function e(t, i, s, a) {
                function n(e) {
                    for(var r1 = t.ef, i = 0, s = r1.length; i < s;){
                        if (e === r1[i].nm || e === r1[i].mn || e === r1[i].ix) return 5 === r1[i].ty ? l[i] : l[i]();
                        i += 1;
                    }
                    throw new Error;
                }
                var o, h = propertyGroupFactory(n, s), l = [], p = t.ef.length;
                for(o = 0; o < p; o += 1)5 === t.ef[o].ty ? l.push(e(t.ef[o], i.effectElements[o], i.effectElements[o].propertyGroup, a)) : l.push(r1(i.effectElements[o], t.ef[o].ty, a, h));
                return "ADBE Color Control" === t.mn && Object.defineProperty(n, "color", {
                    get: function() {
                        return l[0]();
                    }
                }), Object.defineProperties(n, {
                    numProperties: {
                        get: function() {
                            return t.np;
                        }
                    },
                    _name: {
                        value: t.nm
                    },
                    propertyGroup: {
                        value: h
                    }
                }), n.enabled = 0 !== t.en, n.active = n.enabled, n;
            }
            function r1(t, e, r1, i) {
                var s = ExpressionPropertyInterface(t.p);
                return t.p.setGroupProperty && t.p.setGroupProperty(PropertyInterface("", i)), function() {
                    return 10 === e ? r1.comp.compInterface(t.p.v) : s();
                };
            }
            return t;
        }(), ShapePathInterface = function(t, e, r1) {
            var i = e.sh;
            function s(t) {
                return "Shape" === t || "shape" === t || "Path" === t || "path" === t || "ADBE Vector Shape" === t || 2 === t ? s.path : null;
            }
            var a = propertyGroupFactory(s, r1);
            return i.setGroupProperty(PropertyInterface("Path", a)), Object.defineProperties(s, {
                path: {
                    get: function() {
                        return i.k && i.getValue(), i;
                    }
                },
                shape: {
                    get: function() {
                        return i.k && i.getValue(), i;
                    }
                },
                _name: {
                    value: t.nm
                },
                ix: {
                    value: t.ix
                },
                propertyIndex: {
                    value: t.ix
                },
                mn: {
                    value: t.mn
                },
                propertyGroup: {
                    value: r1
                }
            }), s;
        }, ShapeExpressionInterface = function() {
            function t(t, n, f) {
                var u, d = [], m = t ? t.length : 0;
                for(u = 0; u < m; u += 1)"gr" === t[u].ty ? d.push(e(t[u], n[u], f)) : "fl" === t[u].ty ? d.push(r1(t[u], n[u], f)) : "st" === t[u].ty ? d.push(s(t[u], n[u], f)) : "tm" === t[u].ty ? d.push(a(t[u], n[u], f)) : "tr" === t[u].ty || ("el" === t[u].ty ? d.push(o(t[u], n[u], f)) : "sr" === t[u].ty ? d.push(h(t[u], n[u], f)) : "sh" === t[u].ty ? d.push(ShapePathInterface(t[u], n[u], f)) : "rc" === t[u].ty ? d.push(l(t[u], n[u], f)) : "rd" === t[u].ty ? d.push(p(t[u], n[u], f)) : "rp" === t[u].ty ? d.push(c(t[u], n[u], f)) : "gf" === t[u].ty ? d.push(i(t[u], n[u], f)) : d.push((t[u], n[u], function() {
                    return null;
                })));
                return d;
            }
            function e(e, r1, i) {
                var s = function(t) {
                    switch(t){
                        case "ADBE Vectors Group":
                        case "Contents":
                        case 2:
                            return s.content;
                        default:
                            return s.transform;
                    }
                };
                s.propertyGroup = propertyGroupFactory(s, i);
                var a = function(e, r1, i) {
                    var s, a = function(t) {
                        for(var e = 0, r1 = s.length; e < r1;){
                            if (s[e]._name === t || s[e].mn === t || s[e].propertyIndex === t || s[e].ix === t || s[e].ind === t) return s[e];
                            e += 1;
                        }
                        return "number" == typeof t ? s[t - 1] : null;
                    };
                    a.propertyGroup = propertyGroupFactory(a, i), s = t(e.it, r1.it, a.propertyGroup), a.numProperties = s.length;
                    var o = n(e.it[e.it.length - 1], r1.it[r1.it.length - 1], a.propertyGroup);
                    return a.transform = o, a.propertyIndex = e.cix, a._name = e.nm, a;
                }(e, r1, s.propertyGroup), o = n(e.it[e.it.length - 1], r1.it[r1.it.length - 1], s.propertyGroup);
                return s.content = a, s.transform = o, Object.defineProperty(s, "_name", {
                    get: function() {
                        return e.nm;
                    }
                }), s.numProperties = e.np, s.propertyIndex = e.ix, s.nm = e.nm, s.mn = e.mn, s;
            }
            function r1(t, e, r1) {
                function i(t) {
                    return "Color" === t || "color" === t ? i.color : "Opacity" === t || "opacity" === t ? i.opacity : null;
                }
                return Object.defineProperties(i, {
                    color: {
                        get: ExpressionPropertyInterface(e.c)
                    },
                    opacity: {
                        get: ExpressionPropertyInterface(e.o)
                    },
                    _name: {
                        value: t.nm
                    },
                    mn: {
                        value: t.mn
                    }
                }), e.c.setGroupProperty(PropertyInterface("Color", r1)), e.o.setGroupProperty(PropertyInterface("Opacity", r1)), i;
            }
            function i(t, e, r1) {
                function i(t) {
                    return "Start Point" === t || "start point" === t ? i.startPoint : "End Point" === t || "end point" === t ? i.endPoint : "Opacity" === t || "opacity" === t ? i.opacity : null;
                }
                return Object.defineProperties(i, {
                    startPoint: {
                        get: ExpressionPropertyInterface(e.s)
                    },
                    endPoint: {
                        get: ExpressionPropertyInterface(e.e)
                    },
                    opacity: {
                        get: ExpressionPropertyInterface(e.o)
                    },
                    type: {
                        get: function() {
                            return "a";
                        }
                    },
                    _name: {
                        value: t.nm
                    },
                    mn: {
                        value: t.mn
                    }
                }), e.s.setGroupProperty(PropertyInterface("Start Point", r1)), e.e.setGroupProperty(PropertyInterface("End Point", r1)), e.o.setGroupProperty(PropertyInterface("Opacity", r1)), i;
            }
            function s(t, e, r1) {
                var i, s = propertyGroupFactory(l, r1), a = propertyGroupFactory(h, s);
                function n(r1) {
                    Object.defineProperty(h, t.d[r1].nm, {
                        get: ExpressionPropertyInterface(e.d.dataProps[r1].p)
                    });
                }
                var o = t.d ? t.d.length : 0, h = {};
                for(i = 0; i < o; i += 1)n(i), e.d.dataProps[i].p.setGroupProperty(a);
                function l(t) {
                    return "Color" === t || "color" === t ? l.color : "Opacity" === t || "opacity" === t ? l.opacity : "Stroke Width" === t || "stroke width" === t ? l.strokeWidth : null;
                }
                return Object.defineProperties(l, {
                    color: {
                        get: ExpressionPropertyInterface(e.c)
                    },
                    opacity: {
                        get: ExpressionPropertyInterface(e.o)
                    },
                    strokeWidth: {
                        get: ExpressionPropertyInterface(e.w)
                    },
                    dash: {
                        get: function() {
                            return h;
                        }
                    },
                    _name: {
                        value: t.nm
                    },
                    mn: {
                        value: t.mn
                    }
                }), e.c.setGroupProperty(PropertyInterface("Color", s)), e.o.setGroupProperty(PropertyInterface("Opacity", s)), e.w.setGroupProperty(PropertyInterface("Stroke Width", s)), l;
            }
            function a(t, e, r1) {
                function i(e) {
                    return e === t.e.ix || "End" === e || "end" === e ? i.end : e === t.s.ix ? i.start : e === t.o.ix ? i.offset : null;
                }
                var s = propertyGroupFactory(i, r1);
                return i.propertyIndex = t.ix, e.s.setGroupProperty(PropertyInterface("Start", s)), e.e.setGroupProperty(PropertyInterface("End", s)), e.o.setGroupProperty(PropertyInterface("Offset", s)), i.propertyIndex = t.ix, i.propertyGroup = r1, Object.defineProperties(i, {
                    start: {
                        get: ExpressionPropertyInterface(e.s)
                    },
                    end: {
                        get: ExpressionPropertyInterface(e.e)
                    },
                    offset: {
                        get: ExpressionPropertyInterface(e.o)
                    },
                    _name: {
                        value: t.nm
                    }
                }), i.mn = t.mn, i;
            }
            function n(t, e, r1) {
                function i(e) {
                    return t.a.ix === e || "Anchor Point" === e ? i.anchorPoint : t.o.ix === e || "Opacity" === e ? i.opacity : t.p.ix === e || "Position" === e ? i.position : t.r.ix === e || "Rotation" === e || "ADBE Vector Rotation" === e ? i.rotation : t.s.ix === e || "Scale" === e ? i.scale : t.sk && t.sk.ix === e || "Skew" === e ? i.skew : t.sa && t.sa.ix === e || "Skew Axis" === e ? i.skewAxis : null;
                }
                var s = propertyGroupFactory(i, r1);
                return e.transform.mProps.o.setGroupProperty(PropertyInterface("Opacity", s)), e.transform.mProps.p.setGroupProperty(PropertyInterface("Position", s)), e.transform.mProps.a.setGroupProperty(PropertyInterface("Anchor Point", s)), e.transform.mProps.s.setGroupProperty(PropertyInterface("Scale", s)), e.transform.mProps.r.setGroupProperty(PropertyInterface("Rotation", s)), e.transform.mProps.sk && (e.transform.mProps.sk.setGroupProperty(PropertyInterface("Skew", s)), e.transform.mProps.sa.setGroupProperty(PropertyInterface("Skew Angle", s))), e.transform.op.setGroupProperty(PropertyInterface("Opacity", s)), Object.defineProperties(i, {
                    opacity: {
                        get: ExpressionPropertyInterface(e.transform.mProps.o)
                    },
                    position: {
                        get: ExpressionPropertyInterface(e.transform.mProps.p)
                    },
                    anchorPoint: {
                        get: ExpressionPropertyInterface(e.transform.mProps.a)
                    },
                    scale: {
                        get: ExpressionPropertyInterface(e.transform.mProps.s)
                    },
                    rotation: {
                        get: ExpressionPropertyInterface(e.transform.mProps.r)
                    },
                    skew: {
                        get: ExpressionPropertyInterface(e.transform.mProps.sk)
                    },
                    skewAxis: {
                        get: ExpressionPropertyInterface(e.transform.mProps.sa)
                    },
                    _name: {
                        value: t.nm
                    }
                }), i.ty = "tr", i.mn = t.mn, i.propertyGroup = r1, i;
            }
            function o(t, e, r1) {
                function i(e) {
                    return t.p.ix === e ? i.position : t.s.ix === e ? i.size : null;
                }
                var s = propertyGroupFactory(i, r1);
                i.propertyIndex = t.ix;
                var a = "tm" === e.sh.ty ? e.sh.prop : e.sh;
                return a.s.setGroupProperty(PropertyInterface("Size", s)), a.p.setGroupProperty(PropertyInterface("Position", s)), Object.defineProperties(i, {
                    size: {
                        get: ExpressionPropertyInterface(a.s)
                    },
                    position: {
                        get: ExpressionPropertyInterface(a.p)
                    },
                    _name: {
                        value: t.nm
                    }
                }), i.mn = t.mn, i;
            }
            function h(t, e, r1) {
                function i(e) {
                    return t.p.ix === e ? i.position : t.r.ix === e ? i.rotation : t.pt.ix === e ? i.points : t.or.ix === e || "ADBE Vector Star Outer Radius" === e ? i.outerRadius : t.os.ix === e ? i.outerRoundness : !t.ir || t.ir.ix !== e && "ADBE Vector Star Inner Radius" !== e ? t.is && t.is.ix === e ? i.innerRoundness : null : i.innerRadius;
                }
                var s = propertyGroupFactory(i, r1), a = "tm" === e.sh.ty ? e.sh.prop : e.sh;
                return i.propertyIndex = t.ix, a.or.setGroupProperty(PropertyInterface("Outer Radius", s)), a.os.setGroupProperty(PropertyInterface("Outer Roundness", s)), a.pt.setGroupProperty(PropertyInterface("Points", s)), a.p.setGroupProperty(PropertyInterface("Position", s)), a.r.setGroupProperty(PropertyInterface("Rotation", s)), t.ir && (a.ir.setGroupProperty(PropertyInterface("Inner Radius", s)), a.is.setGroupProperty(PropertyInterface("Inner Roundness", s))), Object.defineProperties(i, {
                    position: {
                        get: ExpressionPropertyInterface(a.p)
                    },
                    rotation: {
                        get: ExpressionPropertyInterface(a.r)
                    },
                    points: {
                        get: ExpressionPropertyInterface(a.pt)
                    },
                    outerRadius: {
                        get: ExpressionPropertyInterface(a.or)
                    },
                    outerRoundness: {
                        get: ExpressionPropertyInterface(a.os)
                    },
                    innerRadius: {
                        get: ExpressionPropertyInterface(a.ir)
                    },
                    innerRoundness: {
                        get: ExpressionPropertyInterface(a.is)
                    },
                    _name: {
                        value: t.nm
                    }
                }), i.mn = t.mn, i;
            }
            function l(t, e, r1) {
                function i(e) {
                    return t.p.ix === e ? i.position : t.r.ix === e ? i.roundness : t.s.ix === e || "Size" === e || "ADBE Vector Rect Size" === e ? i.size : null;
                }
                var s = propertyGroupFactory(i, r1), a = "tm" === e.sh.ty ? e.sh.prop : e.sh;
                return i.propertyIndex = t.ix, a.p.setGroupProperty(PropertyInterface("Position", s)), a.s.setGroupProperty(PropertyInterface("Size", s)), a.r.setGroupProperty(PropertyInterface("Rotation", s)), Object.defineProperties(i, {
                    position: {
                        get: ExpressionPropertyInterface(a.p)
                    },
                    roundness: {
                        get: ExpressionPropertyInterface(a.r)
                    },
                    size: {
                        get: ExpressionPropertyInterface(a.s)
                    },
                    _name: {
                        value: t.nm
                    }
                }), i.mn = t.mn, i;
            }
            function p(t, e, r1) {
                function i(e) {
                    return t.r.ix === e || "Round Corners 1" === e ? i.radius : null;
                }
                var s = propertyGroupFactory(i, r1), a = e;
                return i.propertyIndex = t.ix, a.rd.setGroupProperty(PropertyInterface("Radius", s)), Object.defineProperties(i, {
                    radius: {
                        get: ExpressionPropertyInterface(a.rd)
                    },
                    _name: {
                        value: t.nm
                    }
                }), i.mn = t.mn, i;
            }
            function c(t, e, r1) {
                function i(e) {
                    return t.c.ix === e || "Copies" === e ? i.copies : t.o.ix === e || "Offset" === e ? i.offset : null;
                }
                var s = propertyGroupFactory(i, r1), a = e;
                return i.propertyIndex = t.ix, a.c.setGroupProperty(PropertyInterface("Copies", s)), a.o.setGroupProperty(PropertyInterface("Offset", s)), Object.defineProperties(i, {
                    copies: {
                        get: ExpressionPropertyInterface(a.c)
                    },
                    offset: {
                        get: ExpressionPropertyInterface(a.o)
                    },
                    _name: {
                        value: t.nm
                    }
                }), i.mn = t.mn, i;
            }
            return function(e, r1, i) {
                var s;
                function a(t) {
                    if ("number" == typeof t) return 0 === (t = void 0 === t ? 1 : t) ? i : s[t - 1];
                    for(var e = 0, r1 = s.length; e < r1;){
                        if (s[e]._name === t) return s[e];
                        e += 1;
                    }
                    return null;
                }
                return a.propertyGroup = propertyGroupFactory(a, function() {
                    return i;
                }), s = t(e, r1, a.propertyGroup), a.numProperties = s.length, a._name = "Contents", a;
            };
        }(), TextExpressionInterface = function(t) {
            var e;
            function r1(t) {
                return "ADBE Text Document" === t ? r1.sourceText : null;
            }
            return Object.defineProperty(r1, "sourceText", {
                get: function() {
                    t.textProperty.getValue();
                    var r1 = t.textProperty.currentData.t;
                    return e && r1 === e.value || ((e = new String(r1)).value = r1 || new String(r1), Object.defineProperty(e, "style", {
                        get: function() {
                            return {
                                fillColor: t.textProperty.currentData.fc
                            };
                        }
                    })), e;
                }
            }), r1;
        };
        function _typeof(t) {
            return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                return typeof t;
            } : function(t) {
                return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
            }, _typeof(t);
        }
        var FootageInterface = (dataInterfaceFactory = function(t) {
            function e(t) {
                return "Outline" === t ? e.outlineInterface() : null;
            }
            return e._name = "Outline", e.outlineInterface = function(t) {
                var e = "", r1 = t.getFootageData();
                function i(t) {
                    if (r1[t]) return e = t, "object" === _typeof(r1 = r1[t]) ? i : r1;
                    var s = t.indexOf(e);
                    if (-1 !== s) {
                        var a = parseInt(t.substr(s + e.length), 10);
                        return "object" === _typeof(r1 = r1[a]) ? i : r1;
                    }
                    return "";
                }
                return function() {
                    return e = "", r1 = t.getFootageData(), i;
                };
            }(t), e;
        }, function(t) {
            function e(t) {
                return "Data" === t ? e.dataInterface : null;
            }
            return e._name = "Data", e.dataInterface = dataInterfaceFactory(t), e;
        }), dataInterfaceFactory, interfaces = {
            layer: LayerExpressionInterface,
            effects: EffectsExpressionInterface,
            comp: CompExpressionInterface,
            shape: ShapeExpressionInterface,
            text: TextExpressionInterface,
            footage: FootageInterface
        };
        function getInterface(t) {
            return interfaces[t] || null;
        }
        var expressionHelpers = {
            searchExpressions: function(t, e, r1) {
                e.x && (r1.k = !0, r1.x = !0, r1.initiateExpression = ExpressionManager.initiateExpression, r1.effectsSequence.push(r1.initiateExpression(t, e, r1).bind(r1)));
            },
            getSpeedAtTime: function(t) {
                var e = this.getValueAtTime(t), r1 = this.getValueAtTime(t + -0.01), i = 0;
                if (e.length) {
                    var s;
                    for(s = 0; s < e.length; s += 1)i += Math.pow(r1[s] - e[s], 2);
                    i = 100 * Math.sqrt(i);
                } else i = 0;
                return i;
            },
            getVelocityAtTime: function(t) {
                if (void 0 !== this.vel) return this.vel;
                var e, r1, i = -0.001, s = this.getValueAtTime(t), a = this.getValueAtTime(t + i);
                if (s.length) for(e = createTypedArray("float32", s.length), r1 = 0; r1 < s.length; r1 += 1)e[r1] = (a[r1] - s[r1]) / i;
                else e = (a - s) / i;
                return e;
            },
            getValueAtTime: function(t) {
                return t *= this.elem.globalData.frameRate, (t -= this.offsetTime) !== this._cachingAtTime.lastFrame && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < t ? this._cachingAtTime.lastIndex : 0, this._cachingAtTime.value = this.interpolateValue(t, this._cachingAtTime), this._cachingAtTime.lastFrame = t), this._cachingAtTime.value;
            },
            getStaticValueAtTime: function() {
                return this.pv;
            },
            setGroupProperty: function(t) {
                this.propertyGroup = t;
            }
        };
        function addPropertyDecorator() {
            function t(t, e, r1) {
                if (!this.k || !this.keyframes) return this.pv;
                t = t ? t.toLowerCase() : "";
                var i, s, a, n, o, h = this.comp.renderedFrame, l = this.keyframes, p = l[l.length - 1].t;
                if (h <= p) return this.pv;
                if (r1 ? s = p - (i = e ? Math.abs(p - this.elem.comp.globalData.frameRate * e) : Math.max(0, p - this.elem.data.ip)) : ((!e || e > l.length - 1) && (e = l.length - 1), i = p - (s = l[l.length - 1 - e].t)), "pingpong" === t) {
                    if (Math.floor((h - s) / i) % 2 != 0) return this.getValueAtTime((i - (h - s) % i + s) / this.comp.globalData.frameRate, 0);
                } else {
                    if ("offset" === t) {
                        var c = this.getValueAtTime(s / this.comp.globalData.frameRate, 0), f = this.getValueAtTime(p / this.comp.globalData.frameRate, 0), u = this.getValueAtTime(((h - s) % i + s) / this.comp.globalData.frameRate, 0), d = Math.floor((h - s) / i);
                        if (this.pv.length) {
                            for(n = (o = new Array(c.length)).length, a = 0; a < n; a += 1)o[a] = (f[a] - c[a]) * d + u[a];
                            return o;
                        }
                        return (f - c) * d + u;
                    }
                    if ("continue" === t) {
                        var m = this.getValueAtTime(p / this.comp.globalData.frameRate, 0), y = this.getValueAtTime((p - .001) / this.comp.globalData.frameRate, 0);
                        if (this.pv.length) {
                            for(n = (o = new Array(m.length)).length, a = 0; a < n; a += 1)o[a] = m[a] + (m[a] - y[a]) * ((h - p) / this.comp.globalData.frameRate) / 5e-4;
                            return o;
                        }
                        return m + (h - p) / .001 * (m - y);
                    }
                }
                return this.getValueAtTime(((h - s) % i + s) / this.comp.globalData.frameRate, 0);
            }
            function e(t, e, r1) {
                if (!this.k) return this.pv;
                t = t ? t.toLowerCase() : "";
                var i, s, a, n, o, h = this.comp.renderedFrame, l = this.keyframes, p = l[0].t;
                if (h >= p) return this.pv;
                if (r1 ? s = p + (i = e ? Math.abs(this.elem.comp.globalData.frameRate * e) : Math.max(0, this.elem.data.op - p)) : ((!e || e > l.length - 1) && (e = l.length - 1), i = (s = l[e].t) - p), "pingpong" === t) {
                    if (Math.floor((p - h) / i) % 2 == 0) return this.getValueAtTime(((p - h) % i + p) / this.comp.globalData.frameRate, 0);
                } else {
                    if ("offset" === t) {
                        var c = this.getValueAtTime(p / this.comp.globalData.frameRate, 0), f = this.getValueAtTime(s / this.comp.globalData.frameRate, 0), u = this.getValueAtTime((i - (p - h) % i + p) / this.comp.globalData.frameRate, 0), d = Math.floor((p - h) / i) + 1;
                        if (this.pv.length) {
                            for(n = (o = new Array(c.length)).length, a = 0; a < n; a += 1)o[a] = u[a] - (f[a] - c[a]) * d;
                            return o;
                        }
                        return u - (f - c) * d;
                    }
                    if ("continue" === t) {
                        var m = this.getValueAtTime(p / this.comp.globalData.frameRate, 0), y = this.getValueAtTime((p + .001) / this.comp.globalData.frameRate, 0);
                        if (this.pv.length) {
                            for(n = (o = new Array(m.length)).length, a = 0; a < n; a += 1)o[a] = m[a] + (m[a] - y[a]) * (p - h) / .001;
                            return o;
                        }
                        return m + (m - y) * (p - h) / .001;
                    }
                }
                return this.getValueAtTime((i - ((p - h) % i + p)) / this.comp.globalData.frameRate, 0);
            }
            function r1(t, e) {
                if (!this.k) return this.pv;
                if (t = .5 * (t || .4), (e = Math.floor(e || 5)) <= 1) return this.pv;
                var r1, i, s = this.comp.renderedFrame / this.comp.globalData.frameRate, a = s - t, n = e > 1 ? (s + t - a) / (e - 1) : 1, o = 0, h = 0;
                for(r1 = this.pv.length ? createTypedArray("float32", this.pv.length) : 0; o < e;){
                    if (i = this.getValueAtTime(a + o * n), this.pv.length) for(h = 0; h < this.pv.length; h += 1)r1[h] += i[h];
                    else r1 += i;
                    o += 1;
                }
                if (this.pv.length) for(h = 0; h < this.pv.length; h += 1)r1[h] /= e;
                else r1 /= e;
                return r1;
            }
            function i(t) {
                this._transformCachingAtTime || (this._transformCachingAtTime = {
                    v: new Matrix
                });
                var e = this._transformCachingAtTime.v;
                if (e.cloneFromProps(this.pre.props), this.appliedTransformations < 1) {
                    var r1 = this.a.getValueAtTime(t);
                    e.translate(-r1[0] * this.a.mult, -r1[1] * this.a.mult, r1[2] * this.a.mult);
                }
                if (this.appliedTransformations < 2) {
                    var i = this.s.getValueAtTime(t);
                    e.scale(i[0] * this.s.mult, i[1] * this.s.mult, i[2] * this.s.mult);
                }
                if (this.sk && this.appliedTransformations < 3) {
                    var s = this.sk.getValueAtTime(t), a = this.sa.getValueAtTime(t);
                    e.skewFromAxis(-s * this.sk.mult, a * this.sa.mult);
                }
                if (this.r && this.appliedTransformations < 4) {
                    var n = this.r.getValueAtTime(t);
                    e.rotate(-n * this.r.mult);
                } else if (!this.r && this.appliedTransformations < 4) {
                    var o = this.rz.getValueAtTime(t), h = this.ry.getValueAtTime(t), l = this.rx.getValueAtTime(t), p = this.or.getValueAtTime(t);
                    e.rotateZ(-o * this.rz.mult).rotateY(h * this.ry.mult).rotateX(l * this.rx.mult).rotateZ(-p[2] * this.or.mult).rotateY(p[1] * this.or.mult).rotateX(p[0] * this.or.mult);
                }
                if (this.data.p && this.data.p.s) {
                    var c = this.px.getValueAtTime(t), f = this.py.getValueAtTime(t);
                    if (this.data.p.z) {
                        var u = this.pz.getValueAtTime(t);
                        e.translate(c * this.px.mult, f * this.py.mult, -u * this.pz.mult);
                    } else e.translate(c * this.px.mult, f * this.py.mult, 0);
                } else {
                    var d = this.p.getValueAtTime(t);
                    e.translate(d[0] * this.p.mult, d[1] * this.p.mult, -d[2] * this.p.mult);
                }
                return e;
            }
            function s() {
                return this.v.clone(new Matrix);
            }
            var a = TransformPropertyFactory.getTransformProperty;
            TransformPropertyFactory.getTransformProperty = function(t, e, r1) {
                var n = a(t, e, r1);
                return n.dynamicProperties.length ? n.getValueAtTime = i.bind(n) : n.getValueAtTime = s.bind(n), n.setGroupProperty = expressionHelpers.setGroupProperty, n;
            };
            var n = PropertyFactory.getProp;
            PropertyFactory.getProp = function(i, s, a, o, h) {
                var l = n(i, s, a, o, h);
                l.kf ? l.getValueAtTime = expressionHelpers.getValueAtTime.bind(l) : l.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(l), l.setGroupProperty = expressionHelpers.setGroupProperty, l.loopOut = t, l.loopIn = e, l.smooth = r1, l.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(l), l.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(l), l.numKeys = 1 === s.a ? s.k.length : 0, l.propertyIndex = s.ix;
                var p = 0;
                return 0 !== a && (p = createTypedArray("float32", 1 === s.a ? s.k[0].s.length : s.k.length)), l._cachingAtTime = {
                    lastFrame: initialDefaultFrame,
                    lastIndex: 0,
                    value: p
                }, expressionHelpers.searchExpressions(i, s, l), l.k && h.addDynamicProperty(l), l;
            };
            var o = ShapePropertyFactory.getConstructorFunction(), h = ShapePropertyFactory.getKeyframedConstructorFunction();
            function l() {}
            l.prototype = {
                vertices: function(t, e) {
                    this.k && this.getValue();
                    var r1, i = this.v;
                    void 0 !== e && (i = this.getValueAtTime(e, 0));
                    var s = i._length, a = i[t], n = i.v, o = createSizedArray(s);
                    for(r1 = 0; r1 < s; r1 += 1)o[r1] = "i" === t || "o" === t ? [
                        a[r1][0] - n[r1][0],
                        a[r1][1] - n[r1][1]
                    ] : [
                        a[r1][0],
                        a[r1][1]
                    ];
                    return o;
                },
                points: function(t) {
                    return this.vertices("v", t);
                },
                inTangents: function(t) {
                    return this.vertices("i", t);
                },
                outTangents: function(t) {
                    return this.vertices("o", t);
                },
                isClosed: function() {
                    return this.v.c;
                },
                pointOnPath: function(t, e) {
                    var r1 = this.v;
                    void 0 !== e && (r1 = this.getValueAtTime(e, 0)), this._segmentsLength || (this._segmentsLength = bez.getSegmentsLength(r1));
                    for(var i, s = this._segmentsLength, a = s.lengths, n = s.totalLength * t, o = 0, h = a.length, l = 0; o < h;){
                        if (l + a[o].addedLength > n) {
                            var p = o, c = r1.c && o === h - 1 ? 0 : o + 1, f = (n - l) / a[o].addedLength;
                            i = bez.getPointInSegment(r1.v[p], r1.v[c], r1.o[p], r1.i[c], f, a[o]);
                            break;
                        }
                        l += a[o].addedLength, o += 1;
                    }
                    return i || (i = r1.c ? [
                        r1.v[0][0],
                        r1.v[0][1]
                    ] : [
                        r1.v[r1._length - 1][0],
                        r1.v[r1._length - 1][1]
                    ]), i;
                },
                vectorOnPath: function(t, e, r1) {
                    1 == t ? t = this.v.c : 0 == t && (t = .999);
                    var i = this.pointOnPath(t, e), s = this.pointOnPath(t + .001, e), a = s[0] - i[0], n = s[1] - i[1], o = Math.sqrt(Math.pow(a, 2) + Math.pow(n, 2));
                    return 0 === o ? [
                        0,
                        0
                    ] : "tangent" === r1 ? [
                        a / o,
                        n / o
                    ] : [
                        -n / o,
                        a / o
                    ];
                },
                tangentOnPath: function(t, e) {
                    return this.vectorOnPath(t, e, "tangent");
                },
                normalOnPath: function(t, e) {
                    return this.vectorOnPath(t, e, "normal");
                },
                setGroupProperty: expressionHelpers.setGroupProperty,
                getValueAtTime: expressionHelpers.getStaticValueAtTime
            }, extendPrototype([
                l
            ], o), extendPrototype([
                l
            ], h), h.prototype.getValueAtTime = function(t) {
                return this._cachingAtTime || (this._cachingAtTime = {
                    shapeValue: shapePool.clone(this.pv),
                    lastIndex: 0,
                    lastTime: initialDefaultFrame
                }), t *= this.elem.globalData.frameRate, (t -= this.offsetTime) !== this._cachingAtTime.lastTime && (this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < t ? this._caching.lastIndex : 0, this._cachingAtTime.lastTime = t, this.interpolateShape(t, this._cachingAtTime.shapeValue, this._cachingAtTime)), this._cachingAtTime.shapeValue;
            }, h.prototype.initiateExpression = ExpressionManager.initiateExpression;
            var p = ShapePropertyFactory.getShapeProp;
            ShapePropertyFactory.getShapeProp = function(t, e, r1, i, s) {
                var a = p(t, e, r1, i, s);
                return a.propertyIndex = e.ix, a.lock = !1, 3 === r1 ? expressionHelpers.searchExpressions(t, e.pt, a) : 4 === r1 && expressionHelpers.searchExpressions(t, e.ks, a), a.k && t.addDynamicProperty(a), a;
            };
        }
        function initialize$1() {
            addPropertyDecorator();
        }
        function addDecorator() {
            TextProperty.prototype.getExpressionValue = function(t, e) {
                var r1 = this.calculateExpression(e);
                if (t.t !== r1) {
                    var i = {};
                    return this.copyData(i, t), i.t = r1.toString(), i.__complete = !1, i;
                }
                return t;
            }, TextProperty.prototype.searchProperty = function() {
                var t = this.searchKeyframes(), e = this.searchExpressions();
                return this.kf = t || e, this.kf;
            }, TextProperty.prototype.searchExpressions = function() {
                return this.data.d.x ? (this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this), this.addEffect(this.getExpressionValue.bind(this)), !0) : null;
            };
        }
        function initialize() {
            addDecorator();
        }
        function SVGComposableEffect() {}
        SVGComposableEffect.prototype = {
            createMergeNode: function(t, e) {
                var r1, i, s = createNS("feMerge");
                for(s.setAttribute("result", t), i = 0; i < e.length; i += 1)(r1 = createNS("feMergeNode")).setAttribute("in", e[i]), s.appendChild(r1), s.appendChild(r1);
                return s;
            }
        };
        var linearFilterValue = "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0";
        function SVGTintFilter(t, e, r1, i, s) {
            this.filterManager = e;
            var a = createNS("feColorMatrix");
            a.setAttribute("type", "matrix"), a.setAttribute("color-interpolation-filters", "linearRGB"), a.setAttribute("values", linearFilterValue + " 1 0"), this.linearFilter = a, a.setAttribute("result", i + "_tint_1"), t.appendChild(a), (a = createNS("feColorMatrix")).setAttribute("type", "matrix"), a.setAttribute("color-interpolation-filters", "sRGB"), a.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), a.setAttribute("result", i + "_tint_2"), t.appendChild(a), this.matrixFilter = a;
            var n = this.createMergeNode(i, [
                s,
                i + "_tint_1",
                i + "_tint_2"
            ]);
            t.appendChild(n);
        }
        function SVGFillFilter(t, e, r1, i) {
            this.filterManager = e;
            var s = createNS("feColorMatrix");
            s.setAttribute("type", "matrix"), s.setAttribute("color-interpolation-filters", "sRGB"), s.setAttribute("values", "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"), s.setAttribute("result", i), t.appendChild(s), this.matrixFilter = s;
        }
        function SVGStrokeEffect(t, e, r1) {
            this.initialized = !1, this.filterManager = e, this.elem = r1, this.paths = [];
        }
        function SVGTritoneFilter(t, e, r1, i) {
            this.filterManager = e;
            var s = createNS("feColorMatrix");
            s.setAttribute("type", "matrix"), s.setAttribute("color-interpolation-filters", "linearRGB"), s.setAttribute("values", "0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"), t.appendChild(s);
            var a = createNS("feComponentTransfer");
            a.setAttribute("color-interpolation-filters", "sRGB"), a.setAttribute("result", i), this.matrixFilter = a;
            var n = createNS("feFuncR");
            n.setAttribute("type", "table"), a.appendChild(n), this.feFuncR = n;
            var o = createNS("feFuncG");
            o.setAttribute("type", "table"), a.appendChild(o), this.feFuncG = o;
            var h = createNS("feFuncB");
            h.setAttribute("type", "table"), a.appendChild(h), this.feFuncB = h, t.appendChild(a);
        }
        function SVGProLevelsFilter(t, e, r1, i) {
            this.filterManager = e;
            var s = this.filterManager.effectElements, a = createNS("feComponentTransfer");
            (s[10].p.k || 0 !== s[10].p.v || s[11].p.k || 1 !== s[11].p.v || s[12].p.k || 1 !== s[12].p.v || s[13].p.k || 0 !== s[13].p.v || s[14].p.k || 1 !== s[14].p.v) && (this.feFuncR = this.createFeFunc("feFuncR", a)), (s[17].p.k || 0 !== s[17].p.v || s[18].p.k || 1 !== s[18].p.v || s[19].p.k || 1 !== s[19].p.v || s[20].p.k || 0 !== s[20].p.v || s[21].p.k || 1 !== s[21].p.v) && (this.feFuncG = this.createFeFunc("feFuncG", a)), (s[24].p.k || 0 !== s[24].p.v || s[25].p.k || 1 !== s[25].p.v || s[26].p.k || 1 !== s[26].p.v || s[27].p.k || 0 !== s[27].p.v || s[28].p.k || 1 !== s[28].p.v) && (this.feFuncB = this.createFeFunc("feFuncB", a)), (s[31].p.k || 0 !== s[31].p.v || s[32].p.k || 1 !== s[32].p.v || s[33].p.k || 1 !== s[33].p.v || s[34].p.k || 0 !== s[34].p.v || s[35].p.k || 1 !== s[35].p.v) && (this.feFuncA = this.createFeFunc("feFuncA", a)), (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) && (a.setAttribute("color-interpolation-filters", "sRGB"), t.appendChild(a)), (s[3].p.k || 0 !== s[3].p.v || s[4].p.k || 1 !== s[4].p.v || s[5].p.k || 1 !== s[5].p.v || s[6].p.k || 0 !== s[6].p.v || s[7].p.k || 1 !== s[7].p.v) && ((a = createNS("feComponentTransfer")).setAttribute("color-interpolation-filters", "sRGB"), a.setAttribute("result", i), t.appendChild(a), this.feFuncRComposed = this.createFeFunc("feFuncR", a), this.feFuncGComposed = this.createFeFunc("feFuncG", a), this.feFuncBComposed = this.createFeFunc("feFuncB", a));
        }
        function SVGDropShadowEffect(t, e, r1, i, s) {
            var a = e.container.globalData.renderConfig.filterSize, n = e.data.fs || a;
            t.setAttribute("x", n.x || a.x), t.setAttribute("y", n.y || a.y), t.setAttribute("width", n.width || a.width), t.setAttribute("height", n.height || a.height), this.filterManager = e;
            var o = createNS("feGaussianBlur");
            o.setAttribute("in", "SourceAlpha"), o.setAttribute("result", i + "_drop_shadow_1"), o.setAttribute("stdDeviation", "0"), this.feGaussianBlur = o, t.appendChild(o);
            var h = createNS("feOffset");
            h.setAttribute("dx", "25"), h.setAttribute("dy", "0"), h.setAttribute("in", i + "_drop_shadow_1"), h.setAttribute("result", i + "_drop_shadow_2"), this.feOffset = h, t.appendChild(h);
            var l = createNS("feFlood");
            l.setAttribute("flood-color", "#00ff00"), l.setAttribute("flood-opacity", "1"), l.setAttribute("result", i + "_drop_shadow_3"), this.feFlood = l, t.appendChild(l);
            var p = createNS("feComposite");
            p.setAttribute("in", i + "_drop_shadow_3"), p.setAttribute("in2", i + "_drop_shadow_2"), p.setAttribute("operator", "in"), p.setAttribute("result", i + "_drop_shadow_4"), t.appendChild(p);
            var c = this.createMergeNode(i, [
                i + "_drop_shadow_4",
                s
            ]);
            t.appendChild(c);
        }
        extendPrototype([
            SVGComposableEffect
        ], SVGTintFilter), SVGTintFilter.prototype.renderFrame = function(t) {
            if (t || this.filterManager._mdf) {
                var e = this.filterManager.effectElements[0].p.v, r1 = this.filterManager.effectElements[1].p.v, i = this.filterManager.effectElements[2].p.v / 100;
                this.linearFilter.setAttribute("values", linearFilterValue + " " + i + " 0"), this.matrixFilter.setAttribute("values", r1[0] - e[0] + " 0 0 0 " + e[0] + " " + (r1[1] - e[1]) + " 0 0 0 " + e[1] + " " + (r1[2] - e[2]) + " 0 0 0 " + e[2] + " 0 0 0 1 0");
            }
        }, SVGFillFilter.prototype.renderFrame = function(t) {
            if (t || this.filterManager._mdf) {
                var e = this.filterManager.effectElements[2].p.v, r1 = this.filterManager.effectElements[6].p.v;
                this.matrixFilter.setAttribute("values", "0 0 0 0 " + e[0] + " 0 0 0 0 " + e[1] + " 0 0 0 0 " + e[2] + " 0 0 0 " + r1 + " 0");
            }
        }, SVGStrokeEffect.prototype.initialize = function() {
            var t, e, r1, i, s = this.elem.layerElement.children || this.elem.layerElement.childNodes;
            for(1 === this.filterManager.effectElements[1].p.v ? (i = this.elem.maskManager.masksProperties.length, r1 = 0) : i = 1 + (r1 = this.filterManager.effectElements[0].p.v - 1), (e = createNS("g")).setAttribute("fill", "none"), e.setAttribute("stroke-linecap", "round"), e.setAttribute("stroke-dashoffset", 1); r1 < i; r1 += 1)t = createNS("path"), e.appendChild(t), this.paths.push({
                p: t,
                m: r1
            });
            if (3 === this.filterManager.effectElements[10].p.v) {
                var a = createNS("mask"), n = createElementID();
                a.setAttribute("id", n), a.setAttribute("mask-type", "alpha"), a.appendChild(e), this.elem.globalData.defs.appendChild(a);
                var o = createNS("g");
                for(o.setAttribute("mask", "url(" + getLocationHref() + "#" + n + ")"); s[0];)o.appendChild(s[0]);
                this.elem.layerElement.appendChild(o), this.masker = a, e.setAttribute("stroke", "#fff");
            } else if (1 === this.filterManager.effectElements[10].p.v || 2 === this.filterManager.effectElements[10].p.v) {
                if (2 === this.filterManager.effectElements[10].p.v) for(s = this.elem.layerElement.children || this.elem.layerElement.childNodes; s.length;)this.elem.layerElement.removeChild(s[0]);
                this.elem.layerElement.appendChild(e), this.elem.layerElement.removeAttribute("mask"), e.setAttribute("stroke", "#fff");
            }
            this.initialized = !0, this.pathMasker = e;
        }, SVGStrokeEffect.prototype.renderFrame = function(t) {
            var e;
            this.initialized || this.initialize();
            var r1, i, s = this.paths.length;
            for(e = 0; e < s; e += 1)if (-1 !== this.paths[e].m && (r1 = this.elem.maskManager.viewData[this.paths[e].m], i = this.paths[e].p, (t || this.filterManager._mdf || r1.prop._mdf) && i.setAttribute("d", r1.lastPath), t || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || r1.prop._mdf)) {
                var a;
                if (0 !== this.filterManager.effectElements[7].p.v || 100 !== this.filterManager.effectElements[8].p.v) {
                    var n = .01 * Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v), o = .01 * Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v), h = i.getTotalLength();
                    a = "0 0 0 " + h * n + " ";
                    var l, p = h * (o - n), c = 1 + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v * .01, f = Math.floor(p / c);
                    for(l = 0; l < f; l += 1)a += "1 " + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v * .01 + " ";
                    a += "0 " + 10 * h + " 0 0";
                } else a = "1 " + 2 * this.filterManager.effectElements[4].p.v * this.filterManager.effectElements[9].p.v * .01;
                i.setAttribute("stroke-dasharray", a);
            }
            if ((t || this.filterManager.effectElements[4].p._mdf) && this.pathMasker.setAttribute("stroke-width", 2 * this.filterManager.effectElements[4].p.v), (t || this.filterManager.effectElements[6].p._mdf) && this.pathMasker.setAttribute("opacity", this.filterManager.effectElements[6].p.v), (1 === this.filterManager.effectElements[10].p.v || 2 === this.filterManager.effectElements[10].p.v) && (t || this.filterManager.effectElements[3].p._mdf)) {
                var u = this.filterManager.effectElements[3].p.v;
                this.pathMasker.setAttribute("stroke", "rgb(" + bmFloor(255 * u[0]) + "," + bmFloor(255 * u[1]) + "," + bmFloor(255 * u[2]) + ")");
            }
        }, SVGTritoneFilter.prototype.renderFrame = function(t) {
            if (t || this.filterManager._mdf) {
                var e = this.filterManager.effectElements[0].p.v, r1 = this.filterManager.effectElements[1].p.v, i = this.filterManager.effectElements[2].p.v, s = i[0] + " " + r1[0] + " " + e[0], a = i[1] + " " + r1[1] + " " + e[1], n = i[2] + " " + r1[2] + " " + e[2];
                this.feFuncR.setAttribute("tableValues", s), this.feFuncG.setAttribute("tableValues", a), this.feFuncB.setAttribute("tableValues", n);
            }
        }, SVGProLevelsFilter.prototype.createFeFunc = function(t, e) {
            var r1 = createNS(t);
            return r1.setAttribute("type", "table"), e.appendChild(r1), r1;
        }, SVGProLevelsFilter.prototype.getTableValue = function(t, e, r1, i, s) {
            for(var a, n, o = 0, h = Math.min(t, e), l = Math.max(t, e), p = Array.call(null, {
                length: 256
            }), c = 0, f = s - i, u = e - t; o <= 256;)n = (a = o / 256) <= h ? u < 0 ? s : i : a >= l ? u < 0 ? i : s : i + f * Math.pow((a - t) / u, 1 / r1), p[c] = n, c += 1, o += 256 / 255;
            return p.join(" ");
        }, SVGProLevelsFilter.prototype.renderFrame = function(t) {
            if (t || this.filterManager._mdf) {
                var e, r1 = this.filterManager.effectElements;
                this.feFuncRComposed && (t || r1[3].p._mdf || r1[4].p._mdf || r1[5].p._mdf || r1[6].p._mdf || r1[7].p._mdf) && (e = this.getTableValue(r1[3].p.v, r1[4].p.v, r1[5].p.v, r1[6].p.v, r1[7].p.v), this.feFuncRComposed.setAttribute("tableValues", e), this.feFuncGComposed.setAttribute("tableValues", e), this.feFuncBComposed.setAttribute("tableValues", e)), this.feFuncR && (t || r1[10].p._mdf || r1[11].p._mdf || r1[12].p._mdf || r1[13].p._mdf || r1[14].p._mdf) && (e = this.getTableValue(r1[10].p.v, r1[11].p.v, r1[12].p.v, r1[13].p.v, r1[14].p.v), this.feFuncR.setAttribute("tableValues", e)), this.feFuncG && (t || r1[17].p._mdf || r1[18].p._mdf || r1[19].p._mdf || r1[20].p._mdf || r1[21].p._mdf) && (e = this.getTableValue(r1[17].p.v, r1[18].p.v, r1[19].p.v, r1[20].p.v, r1[21].p.v), this.feFuncG.setAttribute("tableValues", e)), this.feFuncB && (t || r1[24].p._mdf || r1[25].p._mdf || r1[26].p._mdf || r1[27].p._mdf || r1[28].p._mdf) && (e = this.getTableValue(r1[24].p.v, r1[25].p.v, r1[26].p.v, r1[27].p.v, r1[28].p.v), this.feFuncB.setAttribute("tableValues", e)), this.feFuncA && (t || r1[31].p._mdf || r1[32].p._mdf || r1[33].p._mdf || r1[34].p._mdf || r1[35].p._mdf) && (e = this.getTableValue(r1[31].p.v, r1[32].p.v, r1[33].p.v, r1[34].p.v, r1[35].p.v), this.feFuncA.setAttribute("tableValues", e));
            }
        }, extendPrototype([
            SVGComposableEffect
        ], SVGDropShadowEffect), SVGDropShadowEffect.prototype.renderFrame = function(t) {
            if (t || this.filterManager._mdf) {
                if ((t || this.filterManager.effectElements[4].p._mdf) && this.feGaussianBlur.setAttribute("stdDeviation", this.filterManager.effectElements[4].p.v / 4), t || this.filterManager.effectElements[0].p._mdf) {
                    var e = this.filterManager.effectElements[0].p.v;
                    this.feFlood.setAttribute("flood-color", rgbToHex(Math.round(255 * e[0]), Math.round(255 * e[1]), Math.round(255 * e[2])));
                }
                if ((t || this.filterManager.effectElements[1].p._mdf) && this.feFlood.setAttribute("flood-opacity", this.filterManager.effectElements[1].p.v / 255), t || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
                    var r1 = this.filterManager.effectElements[3].p.v, i = (this.filterManager.effectElements[2].p.v - 90) * degToRads, s = r1 * Math.cos(i), a = r1 * Math.sin(i);
                    this.feOffset.setAttribute("dx", s), this.feOffset.setAttribute("dy", a);
                }
            }
        };
        var _svgMatteSymbols = [];
        function SVGMatte3Effect(t, e, r1) {
            this.initialized = !1, this.filterManager = e, this.filterElem = t, this.elem = r1, r1.matteElement = createNS("g"), r1.matteElement.appendChild(r1.layerElement), r1.matteElement.appendChild(r1.transformedElement), r1.baseElement = r1.matteElement;
        }
        function SVGGaussianBlurEffect(t, e, r1, i) {
            t.setAttribute("x", "-100%"), t.setAttribute("y", "-100%"), t.setAttribute("width", "300%"), t.setAttribute("height", "300%"), this.filterManager = e;
            var s = createNS("feGaussianBlur");
            s.setAttribute("result", i), t.appendChild(s), this.feGaussianBlur = s;
        }
        function TransformEffect() {}
        function SVGTransformEffect(t, e) {
            this.init(e);
        }
        function CVTransformEffect(t) {
            this.init(t);
        }
        return SVGMatte3Effect.prototype.findSymbol = function(t) {
            for(var e = 0, r1 = _svgMatteSymbols.length; e < r1;){
                if (_svgMatteSymbols[e] === t) return _svgMatteSymbols[e];
                e += 1;
            }
            return null;
        }, SVGMatte3Effect.prototype.replaceInParent = function(t, e) {
            var r1 = t.layerElement.parentNode;
            if (r1) {
                for(var i, s = r1.children, a = 0, n = s.length; a < n && s[a] !== t.layerElement;)a += 1;
                a <= n - 2 && (i = s[a + 1]);
                var o = createNS("use");
                o.setAttribute("href", "#" + e), i ? r1.insertBefore(o, i) : r1.appendChild(o);
            }
        }, SVGMatte3Effect.prototype.setElementAsMask = function(t, e) {
            if (!this.findSymbol(e)) {
                var r1 = createElementID(), i = createNS("mask");
                i.setAttribute("id", e.layerId), i.setAttribute("mask-type", "alpha"), _svgMatteSymbols.push(e);
                var s = t.globalData.defs;
                s.appendChild(i);
                var a = createNS("symbol");
                a.setAttribute("id", r1), this.replaceInParent(e, r1), a.appendChild(e.layerElement), s.appendChild(a);
                var n = createNS("use");
                n.setAttribute("href", "#" + r1), i.appendChild(n), e.data.hd = !1, e.show();
            }
            t.setMatte(e.layerId);
        }, SVGMatte3Effect.prototype.initialize = function() {
            for(var t = this.filterManager.effectElements[0].p.v, e = this.elem.comp.elements, r1 = 0, i = e.length; r1 < i;)e[r1] && e[r1].data.ind === t && this.setElementAsMask(this.elem, e[r1]), r1 += 1;
            this.initialized = !0;
        }, SVGMatte3Effect.prototype.renderFrame = function() {
            this.initialized || this.initialize();
        }, SVGGaussianBlurEffect.prototype.renderFrame = function(t) {
            if (t || this.filterManager._mdf) {
                var e = .3 * this.filterManager.effectElements[0].p.v, r1 = this.filterManager.effectElements[1].p.v, i = 3 == r1 ? 0 : e, s = 2 == r1 ? 0 : e;
                this.feGaussianBlur.setAttribute("stdDeviation", i + " " + s);
                var a = 1 == this.filterManager.effectElements[2].p.v ? "wrap" : "duplicate";
                this.feGaussianBlur.setAttribute("edgeMode", a);
            }
        }, TransformEffect.prototype.init = function(t) {
            this.effectsManager = t, this.type = effectTypes.TRANSFORM_EFFECT, this.matrix = new Matrix, this.opacity = -1, this._mdf = !1, this._opMdf = !1;
        }, TransformEffect.prototype.renderFrame = function(t) {
            if (this._opMdf = !1, this._mdf = !1, t || this.effectsManager._mdf) {
                var e = this.effectsManager.effectElements, r1 = e[0].p.v, i = e[1].p.v, s = 1 === e[2].p.v, a = e[3].p.v, n = s ? a : e[4].p.v, o = e[5].p.v, h = e[6].p.v, l = e[7].p.v;
                this.matrix.reset(), this.matrix.translate(-r1[0], -r1[1], r1[2]), this.matrix.scale(.01 * n, .01 * a, 1), this.matrix.rotate(-l * degToRads), this.matrix.skewFromAxis(-o * degToRads, (h + 90) * degToRads), this.matrix.translate(i[0], i[1], 0), this._mdf = !0, this.opacity !== e[8].p.v && (this.opacity = e[8].p.v, this._opMdf = !0);
            }
        }, extendPrototype([
            TransformEffect
        ], SVGTransformEffect), extendPrototype([
            TransformEffect
        ], CVTransformEffect), registerRenderer("canvas", CanvasRenderer), registerRenderer("html", HybridRenderer), registerRenderer("svg", SVGRenderer), ShapeModifiers.registerModifier("tm", TrimModifier), ShapeModifiers.registerModifier("pb", PuckerAndBloatModifier), ShapeModifiers.registerModifier("rp", RepeaterModifier), ShapeModifiers.registerModifier("rd", RoundCornersModifier), ShapeModifiers.registerModifier("zz", ZigZagModifier), ShapeModifiers.registerModifier("op", OffsetPathModifier), setExpressionsPlugin(Expressions), setExpressionInterfaces(getInterface), initialize$1(), initialize(), registerEffect$1(20, SVGTintFilter, !0), registerEffect$1(21, SVGFillFilter, !0), registerEffect$1(22, SVGStrokeEffect, !1), registerEffect$1(23, SVGTritoneFilter, !0), registerEffect$1(24, SVGProLevelsFilter, !0), registerEffect$1(25, SVGDropShadowEffect, !0), registerEffect$1(28, SVGMatte3Effect, !1), registerEffect$1(29, SVGGaussianBlurEffect, !0), registerEffect$1(35, SVGTransformEffect, !1), registerEffect(35, CVTransformEffect), lottie;
    }, module.exports = factory());
})(lottie$1, lottie$1.exports);
var lottie = lottie$1.exports, _templateObject$1, styles = r$3(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral([
    "\n  * {\n    box-sizing: border-box;\n  }\n\n  :host {\n    --lottie-player-toolbar-height: 35px;\n    --lottie-player-toolbar-background-color: transparent;\n    --lottie-player-toolbar-icon-color: #999;\n    --lottie-player-toolbar-icon-hover-color: #222;\n    --lottie-player-toolbar-icon-active-color: #555;\n    --lottie-player-seeker-track-color: #ccc;\n    --lottie-player-seeker-thumb-color: rgba(0, 107, 120, 0.8);\n    --lottie-player-seeker-display: block;\n\n    display: block;\n    width: 100%;\n    height: 100%;\n  }\n\n  .main {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    width: 100%;\n  }\n\n  .animation {\n    width: 100%;\n    height: 100%;\n    display: flex;\n  }\n  .animation.controls {\n    height: calc(100% - 35px);\n  }\n\n  .toolbar {\n    display: flex;\n    align-items: center;\n    justify-items: center;\n    background-color: var(--lottie-player-toolbar-background-color);\n    margin: 0 5px;\n    height: 35px;\n  }\n\n  .toolbar button {\n    cursor: pointer;\n    fill: var(--lottie-player-toolbar-icon-color);\n    display: flex;\n    background: none;\n    border: 0;\n    padding: 0;\n    outline: none;\n    height: 100%;\n  }\n\n  .toolbar button:hover {\n    fill: var(--lottie-player-toolbar-icon-hover-color);\n  }\n\n  .toolbar button.active {\n    fill: var(--lottie-player-toolbar-icon-active-color);\n  }\n\n  .toolbar button.active:hover {\n    fill: var(--lottie-player-toolbar-icon-hover-color);\n  }\n\n  .toolbar button:focus {\n    outline: 1px dotted var(--lottie-player-toolbar-icon-active-color);\n  }\n\n  .toolbar button svg {\n  }\n\n  .toolbar button.disabled svg {\n    display: none;\n  }\n\n  .seeker {\n    -webkit-appearance: none;\n    width: 95%;\n    outline: none;\n    background-color: var(--lottie-player-toolbar-background-color);\n    display: var(--lottie-player-seeker-display);\n  }\n\n  .seeker::-webkit-slider-runnable-track {\n    width: 100%;\n    height: 5px;\n    cursor: pointer;\n    background: var(--lottie-player-seeker-track-color);\n    border-radius: 3px;\n  }\n  .seeker::-webkit-slider-thumb {\n    height: 15px;\n    width: 15px;\n    border-radius: 50%;\n    background: var(--lottie-player-seeker-thumb-color);\n    cursor: pointer;\n    -webkit-appearance: none;\n    margin-top: -5px;\n  }\n  .seeker:focus::-webkit-slider-runnable-track {\n    background: #999;\n  }\n  .seeker::-moz-range-track {\n    width: 100%;\n    height: 5px;\n    cursor: pointer;\n    background: var(--lottie-player-seeker-track-color);\n    border-radius: 3px;\n  }\n  .seeker::-moz-range-thumb {\n    height: 15px;\n    width: 15px;\n    border-radius: 50%;\n    background: var(--lottie-player-seeker-thumb-color);\n    cursor: pointer;\n  }\n  .seeker::-ms-track {\n    width: 100%;\n    height: 5px;\n    cursor: pointer;\n    background: transparent;\n    border-color: transparent;\n    color: transparent;\n  }\n  .seeker::-ms-fill-lower {\n    background: var(--lottie-player-seeker-track-color);\n    border-radius: 3px;\n  }\n  .seeker::-ms-fill-upper {\n    background: var(--lottie-player-seeker-track-color);\n    border-radius: 3px;\n  }\n  .seeker::-ms-thumb {\n    border: 0;\n    height: 15px;\n    width: 15px;\n    border-radius: 50%;\n    background: var(--lottie-player-seeker-thumb-color);\n    cursor: pointer;\n  }\n  .seeker:focus::-ms-fill-lower {\n    background: var(--lottie-player-seeker-track-color);\n  }\n  .seeker:focus::-ms-fill-upper {\n    background: var(--lottie-player-seeker-track-color);\n  }\n\n  .error {\n    display: flex;\n    justify-content: center;\n    height: 100%;\n    align-items: center;\n  }\n"
]))), name = "@lottiefiles/lottie-player", version = "2.0.12", description = "Lottie animation and Telegram Sticker player web components.", main = "dist/lottie-player.js", module = "dist/lottie-player.esm.js", types = "dist/lottie-player.d.ts", homepage = "https://lottiefiles.com/web-player", repository = "https://github.com/LottieFiles/lottie-player.git", bugs = "https://github.com/LottieFiles/lottie-player/issues", author = "Jawish Hameed <jawish@lottiefiles.com>", license = "MIT", scripts = {
    start: "npm run cleanup && rollup -c --watch",
    build: "npm run cleanup && npm run build-lottie && npm run build-tgs",
    "build-with-coverage": "npm run cleanup && CODE_COVERAGE=true npm run build-lottie && CODE_COVERAGE=true npm run build-tgs",
    "build-lottie": "rollup -c ",
    "build-tgs": "rollup -c rollup-tgs.config.js",
    "watch-lottie": "npm run cleanup && rollup -c --watch",
    "watch-tgs": "npm run cleanup && rollup -c rollup-tgs.config.js --watch",
    cleanup: "shx rm -rf dist && shx mkdir dist",
    release: "semantic-release",
    lint: "eslint . --ext .ts,.tsx,.js",
    "lint:fix": "eslint . --ext .ts,.tsx,.js --fix",
    serve: "node ./cypress/pages/server.js -p 8000 &",
    "start-cypress": "yarn run cypress run && npx nyc report --reporter=text-summary",
    "run-tests": "yarn run build-with-coverage && yarn run serve && yarn run start-cypress",
    "postrun-tests": "kill $(lsof -t -i:8000)"
}, dependencies = {
    "@types/pako": "^1.0.1",
    lit: "^2.1.2",
    "lottie-web": "^5.12.2",
    pako: "^2.0.4",
    "resize-observer-polyfill": "^1.5.1"
}, devDependencies = {
    "@babel/core": "^7.11.0",
    "@babel/plugin-proposal-class-properties": "^7.10.4",
    "@babel/plugin-proposal-decorators": "^7.10.5",
    "@babel/preset-env": "^7.11.0",
    "@babel/preset-typescript": "^7.10.4",
    "@commitlint/cli": "^16.1.0",
    "@commitlint/config-conventional": "^16.0.0",
    "@cypress/code-coverage": "^3.9.12",
    "@istanbuljs/nyc-config-typescript": "^1.0.2",
    "@rollup/plugin-babel": "^5.1.0",
    "@rollup/plugin-commonjs": "^21.0.1",
    "@rollup/plugin-json": "^6.1.0",
    "@rollup/plugin-node-resolve": "^13.1.3",
    "@semantic-release/changelog": "^6.0.1",
    "@semantic-release/commit-analyzer": "^9.0.2",
    "@semantic-release/git": "^10.0.1",
    "@semantic-release/github": "^8.0.2",
    "@semantic-release/npm": "^9.0.0",
    "@semantic-release/release-notes-generator": "^10.0.3",
    "babel-eslint": "^10.1.0",
    "babel-plugin-istanbul": "^6.1.1",
    cypress: "^9.2.1",
    "cypress-real-events": "^1.6.0",
    eslint: "^7.27.0",
    "eslint-plugin-only-warn": "^1.0.2",
    fastify: "^3.25.3",
    "fastify-static": "^4.5.0",
    husky: ">=4",
    lerna: "^4.0.0",
    "lint-staged": "^12.3.2",
    "parcel-bundler": "^1.12.4",
    prettier: "^2.3.0",
    rollup: "^2.23.0",
    "rollup-plugin-copy": "^3.3.0",
    "rollup-plugin-filesize": "^9.0.2",
    "rollup-plugin-serve": "^1.0.3",
    "rollup-plugin-terser": "^7.0.2",
    "rollup-plugin-typescript2": "^0.31.1",
    "rollup-plugin-uglify": "^6.0.4",
    "rollup-plugin-visualizer": "^5.5.4",
    "semantic-release": "^19.0.2",
    shx: "^0.3.4",
    "source-map-support": "^0.5.21",
    "ts-node": "^10.4.0",
    typescript: "^4.5.5",
    "unicode-canonical-property-names-ecmascript": "^2.0.0"
}, files = [
    "dist/"
], keywords = [
    "lottie",
    "animation",
    "lottiefiles",
    "web component",
    "component",
    "lit-element",
    "player",
    "telegram sticker",
    "tgs"
], browserslist = [
    "> 3%"
], publishConfig = {
    access: "public",
    provenance: !0
}, husky = {
    hooks: {
        "commit-msg": "commitlint -E HUSKY_GIT_PARAMS",
        "pre-commit": "lint-staged"
    }
}, nyc = {
    extends: "@istanbuljs/nyc-config-typescript",
    all: !0
}, packageManager = "yarn@1.22.19+sha1.4ba7fc5c6e704fce2066ecbfb0b0d8976fe62447", _package = {
    name: name,
    version: version,
    description: description,
    main: main,
    module: module,
    types: types,
    homepage: homepage,
    repository: repository,
    bugs: bugs,
    author: author,
    license: license,
    scripts: scripts,
    dependencies: dependencies,
    devDependencies: devDependencies,
    files: files,
    keywords: keywords,
    browserslist: browserslist,
    publishConfig: publishConfig,
    husky: husky,
    "lint-staged": {
        "src/**/*.{css,scss,md}": [
            "prettier --write"
        ],
        "src/**/*.{js,jsx,ts,tsx,json}": [
            "eslint . --ext .ts,.tsx,.js --fix"
        ]
    },
    nyc: nyc,
    packageManager: packageManager
}, _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, PlayerState, PlayMode, PlayerEvents;
function parseSrc(t) {
    if ("object" == typeof t) return t;
    try {
        return JSON.parse(t);
    } catch (e) {
        return new URL(t, window.location.href).toString();
    }
}
function isLottie(t) {
    return [
        "v",
        "ip",
        "op",
        "layers",
        "fr",
        "w",
        "h"
    ].every((e)=>Object.prototype.hasOwnProperty.call(t, e));
}
function fromURL(t) {
    return _fromURL.apply(this, arguments);
}
function _fromURL() {
    return (_fromURL = _asyncToGenerator(function*(t) {
        if ("string" != typeof t) throw new Error("The url value must be a string");
        var e;
        try {
            var r1 = new URL(t), i = yield fetch(r1.toString());
            e = yield i.json();
        } catch (t) {
            throw new Error("An error occurred while trying to load the Lottie file from URL");
        }
        return e;
    })).apply(this, arguments);
}
!function(t) {
    t.Destroyed = "destroyed", t.Error = "error", t.Frozen = "frozen", t.Loading = "loading", t.Paused = "paused", t.Playing = "playing", t.Stopped = "stopped";
}(PlayerState || (PlayerState = {})), function(t) {
    t.Bounce = "bounce", t.Normal = "normal";
}(PlayMode || (PlayMode = {})), function(t) {
    t.Complete = "complete", t.Destroyed = "destroyed", t.Error = "error", t.Frame = "frame", t.Freeze = "freeze", t.Load = "load", t.Loop = "loop", t.Pause = "pause", t.Play = "play", t.Ready = "ready", t.Rendered = "rendered", t.Stop = "stop";
}(PlayerEvents || (PlayerEvents = {}));
var LottiePlayer = class extends s {
    constructor(){
        super(...arguments), this.autoplay = !1, this.background = "transparent", this.controls = !1, this.currentState = PlayerState.Loading, this.description = "Lottie animation", this.direction = 1, this.disableCheck = !1, this.disableShadowDOM = !1, this.hover = !1, this.intermission = 1, this.loop = !1, this.mode = PlayMode.Normal, this.preserveAspectRatio = "xMidYMid meet", this.renderer = "svg", this.speed = 1, this._io = void 0, this._counter = 1, this._onVisibilityChange = ()=>{
            !0 === document.hidden && this.currentState === PlayerState.Playing ? this.freeze() : this.currentState === PlayerState.Frozen && this.play();
        };
    }
    load(t) {
        var e = this;
        return _asyncToGenerator(function*() {
            var r1 = {
                container: e.container,
                loop: !1,
                autoplay: !1,
                renderer: e.renderer,
                rendererSettings: Object.assign({
                    preserveAspectRatio: e.preserveAspectRatio,
                    clearCanvas: !1,
                    progressiveLoad: !0,
                    hideOnTransparent: !0
                }, e.viewBoxSize && {
                    viewBoxSize: e.viewBoxSize
                })
            };
            try {
                var i = parseSrc(t), s = {}, a = "string" == typeof i ? "path" : "animationData";
                e._lottie && e._lottie.destroy(), e.webworkers && lottie$1.exports.useWebWorker(!0), e._lottie = lottie$1.exports.loadAnimation(Object.assign(Object.assign({}, r1), {
                    [a]: i
                })), e._attachEventListeners(), e.disableCheck || ("path" === a ? (s = yield fromURL(i), a = "animationData") : s = i, isLottie(s) || (e.currentState = PlayerState.Error, e.dispatchEvent(new CustomEvent(PlayerEvents.Error))));
            } catch (t) {
                e.currentState = PlayerState.Error, e.dispatchEvent(new CustomEvent(PlayerEvents.Error));
            }
        })();
    }
    getLottie() {
        return this._lottie;
    }
    getVersions() {
        return {
            lottieWebVersion: dependencies["lottie-web"],
            lottiePlayerVersion: version
        };
    }
    play() {
        this._lottie && (this._lottie.play(), this.currentState = PlayerState.Playing, this.dispatchEvent(new CustomEvent(PlayerEvents.Play)));
    }
    pause() {
        this._lottie && (this._lottie.pause(), this.currentState = PlayerState.Paused, this.dispatchEvent(new CustomEvent(PlayerEvents.Pause)));
    }
    stop() {
        this._lottie && (this._counter = 1, this._lottie.stop(), this.currentState = PlayerState.Stopped, this.dispatchEvent(new CustomEvent(PlayerEvents.Stop)));
    }
    destroy() {
        this._lottie && (this._lottie.destroy(), this._lottie = null, this.currentState = PlayerState.Destroyed, this.dispatchEvent(new CustomEvent(PlayerEvents.Destroyed)), this.remove());
    }
    seek(t) {
        if (this._lottie) {
            var e = /^(\d+)(%?)$/.exec(t.toString());
            if (e) {
                var r1 = "%" === e[2] ? this._lottie.totalFrames * Number(e[1]) / 100 : Number(e[1]);
                this.seeker = r1, this.currentState === PlayerState.Playing ? this._lottie.goToAndPlay(r1, !0) : (this._lottie.goToAndStop(r1, !0), this._lottie.pause());
            }
        }
    }
    snapshot() {
        var t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
        if (this.shadowRoot) {
            var e = this.shadowRoot.querySelector(".animation svg"), r1 = (new XMLSerializer).serializeToString(e);
            if (t) {
                var i = document.createElement("a");
                i.href = "data:image/svg+xml;charset=utf-8,".concat(encodeURIComponent(r1)), i.download = "download_".concat(this.seeker, ".svg"), document.body.appendChild(i), i.click(), document.body.removeChild(i);
            }
            return r1;
        }
    }
    setSpeed() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1;
        this._lottie && this._lottie.setSpeed(t);
    }
    setDirection(t) {
        this._lottie && this._lottie.setDirection(t);
    }
    setLooping(t) {
        this._lottie && (this.loop = t, this._lottie.loop = t);
    }
    togglePlay() {
        return this.currentState === PlayerState.Playing ? this.pause() : this.play();
    }
    toggleLooping() {
        this.setLooping(!this.loop);
    }
    resize() {
        this._lottie && this._lottie.resize();
    }
    static get styles() {
        return styles;
    }
    disconnectedCallback() {
        this.isConnected || (this._io && (this._io.disconnect(), this._io = void 0), document.removeEventListener("visibilitychange", this._onVisibilityChange), this.destroy());
    }
    render() {
        var t = this.controls ? "main controls" : "main", e = this.controls ? "animation controls" : "animation";
        return $(_templateObject || (_templateObject = _taggedTemplateLiteral([
            ' <div\n      id="animation-container"\n      class=',
            '\n      lang="en"\n      aria-label=',
            '\n      role="img"\n    >\n      <div\n        id="animation"\n        class=',
            '\n        style="background:',
            ';"\n      >\n        ',
            "\n      </div>\n      ",
            "\n    </div>"
        ])), t, this.description, e, this.background, this.currentState === PlayerState.Error ? $(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([
            '<div class="error">\u26A0\uFE0F</div>'
        ]))) : void 0, this.controls && !this.disableShadowDOM ? this.renderControls() : void 0);
    }
    createRenderRoot() {
        return this.disableShadowDOM && (this.style.display = "block"), this.disableShadowDOM ? this : super.createRenderRoot();
    }
    firstUpdated() {
        "IntersectionObserver" in window && (this._io = new IntersectionObserver((t)=>{
            t[0].isIntersecting ? this.currentState === PlayerState.Frozen && this.play() : this.currentState === PlayerState.Playing && this.freeze();
        }), this._io.observe(this.container)), void 0 !== document.hidden && document.addEventListener("visibilitychange", this._onVisibilityChange), this.src && this.load(this.src), this.dispatchEvent(new CustomEvent(PlayerEvents.Rendered));
    }
    renderControls() {
        var t = this.currentState === PlayerState.Playing, e = this.currentState === PlayerState.Paused, r1 = this.currentState === PlayerState.Stopped;
        return $(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([
            '\n      <div\n        id="lottie-controls"\n        aria-label="lottie-animation-controls"\n        class="toolbar"\n      >\n        <button\n          id="lottie-play-button"\n          @click=',
            "\n          class=",
            '\n          style="align-items:center;"\n          tabindex="0"\n          aria-label="play-pause"\n        >\n          ',
            '\n        </button>\n        <button\n          id="lottie-stop-button"\n          @click=',
            "\n          class=",
            '\n          style="align-items:center;"\n          tabindex="0"\n          aria-label="stop"\n        >\n          <svg width="24" height="24" aria-hidden="true" focusable="false">\n            <path d="M6 6h12v12H6V6z" />\n          </svg>\n        </button>\n        <input\n          id="lottie-seeker-input"\n          class="seeker"\n          type="range"\n          min="0"\n          step="1"\n          max="100"\n          .value=',
            "\n          @input=",
            "\n          @mousedown=",
            "\n          @mouseup=",
            '\n          aria-valuemin="1"\n          aria-valuemax="100"\n          role="slider"\n          aria-valuenow=',
            '\n          tabindex="0"\n          aria-label="lottie-seek-input"\n        />\n        <button\n          id="lottie-loop-toggle"\n          @click=',
            "\n          class=",
            '\n          style="align-items:center;"\n          tabindex="0"\n          aria-label="loop-toggle"\n        >\n          <svg width="24" height="24" aria-hidden="true" focusable="false">\n            <path\n              d="M17.016 17.016v-4.031h1.969v6h-12v3l-3.984-3.984 3.984-3.984v3h10.031zM6.984 6.984v4.031H5.015v-6h12v-3l3.984 3.984-3.984 3.984v-3H6.984z"\n            />\n          </svg>\n        </button>\n      </div>\n    '
        ])), this.togglePlay, t || e ? "active" : "", $(t ? _templateObject4 || (_templateObject4 = _taggedTemplateLiteral([
            '<svg\n                width="24"\n                height="24"\n                aria-hidden="true"\n                focusable="false"\n              >\n                <path\n                  d="M14.016 5.016H18v13.969h-3.984V5.016zM6 18.984V5.015h3.984v13.969H6z"\n                />\n              </svg>'
        ])) : _templateObject5 || (_templateObject5 = _taggedTemplateLiteral([
            '<svg\n                width="24"\n                height="24"\n                aria-hidden="true"\n                focusable="false"\n              >\n                <path d="M8.016 5.016L18.985 12 8.016 18.984V5.015z" />\n              </svg>'
        ]))), this.stop, r1 ? "active" : "", this.seeker, this._handleSeekChange, ()=>{
            this._prevState = this.currentState, this.freeze();
        }, ()=>{
            this._prevState === PlayerState.Playing && this.play();
        }, this.seeker, this.toggleLooping, this.loop ? "active" : "");
    }
    _handleSeekChange(t) {
        if (this._lottie && !isNaN(t.target.value)) {
            var e = t.target.value / 100 * this._lottie.totalFrames;
            this.seek(e);
        }
    }
    _attachEventListeners() {
        this._lottie.addEventListener("enterFrame", ()=>{
            this.seeker = this._lottie.currentFrame / this._lottie.totalFrames * 100, this.dispatchEvent(new CustomEvent(PlayerEvents.Frame, {
                detail: {
                    frame: this._lottie.currentFrame,
                    seeker: this.seeker
                }
            }));
        }), this._lottie.addEventListener("complete", ()=>{
            if (this.currentState === PlayerState.Playing) {
                if (!this.loop || this.count && this._counter >= this.count) {
                    if (this.dispatchEvent(new CustomEvent(PlayerEvents.Complete)), this.mode !== PlayMode.Bounce) return;
                    if (0 === this._lottie.currentFrame) return;
                }
                this.mode === PlayMode.Bounce ? (this.count && (this._counter += .5), setTimeout(()=>{
                    this.dispatchEvent(new CustomEvent(PlayerEvents.Loop)), this.currentState === PlayerState.Playing && (this._lottie.setDirection(-1 * this._lottie.playDirection), this._lottie.play());
                }, this.intermission)) : (this.count && (this._counter += 1), window.setTimeout(()=>{
                    this.dispatchEvent(new CustomEvent(PlayerEvents.Loop)), this.currentState === PlayerState.Playing && (-1 === this.direction ? (this.seek("99%"), this.play()) : (this._lottie.stop(), this._lottie.play()));
                }, this.intermission));
            } else this.dispatchEvent(new CustomEvent(PlayerEvents.Complete));
        }), this._lottie.addEventListener("DOMLoaded", ()=>{
            this.setSpeed(this.speed), this.setDirection(this.direction), this.autoplay && (-1 === this.direction && this.seek("100%"), this.play()), this.dispatchEvent(new CustomEvent(PlayerEvents.Ready));
        }), this._lottie.addEventListener("data_ready", ()=>{
            this.dispatchEvent(new CustomEvent(PlayerEvents.Load));
        }), this._lottie.addEventListener("data_failed", ()=>{
            this.currentState = PlayerState.Error, this.dispatchEvent(new CustomEvent(PlayerEvents.Error));
        }), this.container.addEventListener("mouseenter", ()=>{
            this.hover && this.currentState !== PlayerState.Playing && this.play();
        }), this.container.addEventListener("mouseleave", ()=>{
            this.hover && this.currentState === PlayerState.Playing && this.stop();
        });
    }
    freeze() {
        this._lottie && (this._lottie.pause(), this.currentState = PlayerState.Frozen, this.dispatchEvent(new CustomEvent(PlayerEvents.Freeze)));
    }
};
__decorate([
    e$5({
        type: Boolean
    })
], LottiePlayer.prototype, "autoplay", void 0), __decorate([
    e$5({
        type: String,
        reflect: !0
    })
], LottiePlayer.prototype, "background", void 0), __decorate([
    e$5({
        type: Boolean
    })
], LottiePlayer.prototype, "controls", void 0), __decorate([
    e$5({
        type: Number
    })
], LottiePlayer.prototype, "count", void 0), __decorate([
    e$5({
        type: String
    })
], LottiePlayer.prototype, "currentState", void 0), __decorate([
    e$5({
        type: String
    })
], LottiePlayer.prototype, "description", void 0), __decorate([
    e$5({
        type: Number
    })
], LottiePlayer.prototype, "direction", void 0), __decorate([
    e$5({
        type: Boolean
    })
], LottiePlayer.prototype, "disableCheck", void 0), __decorate([
    e$5({
        type: Boolean
    })
], LottiePlayer.prototype, "disableShadowDOM", void 0), __decorate([
    e$5({
        type: Boolean
    })
], LottiePlayer.prototype, "hover", void 0), __decorate([
    e$5()
], LottiePlayer.prototype, "intermission", void 0), __decorate([
    e$5({
        type: Boolean,
        reflect: !0
    })
], LottiePlayer.prototype, "loop", void 0), __decorate([
    e$5()
], LottiePlayer.prototype, "mode", void 0), __decorate([
    e$5({
        type: String
    })
], LottiePlayer.prototype, "preserveAspectRatio", void 0), __decorate([
    e$5({
        type: String
    })
], LottiePlayer.prototype, "renderer", void 0), __decorate([
    e$5({
        type: String
    })
], LottiePlayer.prototype, "viewBoxSize", void 0), __decorate([
    e$5()
], LottiePlayer.prototype, "seeker", void 0), __decorate([
    e$5({
        type: Number
    })
], LottiePlayer.prototype, "speed", void 0), __decorate([
    e$5({
        type: String
    })
], LottiePlayer.prototype, "src", void 0), __decorate([
    e$5({
        type: Boolean
    })
], LottiePlayer.prototype, "webworkers", void 0), __decorate([
    i(".animation")
], LottiePlayer.prototype, "container", void 0), LottiePlayer = __decorate([
    n$1("lottie-player")
], LottiePlayer);

});

// Imports
var $7d03927386cb1976$exports = {};
/*!
 * Toastify js 1.12.0
 * https://github.com/apvarun/toastify-js
 * @license MIT licensed
 *
 * Copyright (C) 2018 Varun A P
 */ (function(root, factory) {
    if (0, $7d03927386cb1976$exports) $7d03927386cb1976$exports = factory();
    else root.Toastify = factory();
})($7d03927386cb1976$exports, function(global) {
    // Object initialization
    var Toastify = function(options) {
        // Returning a new init object
        return new Toastify.lib.init(options);
    }, // Library version
    version = "1.12.0";
    // Set the default global options
    Toastify.defaults = {
        oldestFirst: true,
        text: "Toastify is awesome!",
        node: undefined,
        duration: 3000,
        selector: undefined,
        callback: function() {},
        destination: undefined,
        newWindow: false,
        close: false,
        gravity: "toastify-top",
        positionLeft: false,
        position: '',
        backgroundColor: '',
        avatar: "",
        className: "",
        stopOnFocus: true,
        onClick: function() {},
        offset: {
            x: 0,
            y: 0
        },
        escapeMarkup: true,
        ariaLive: 'polite',
        style: {
            background: ''
        }
    };
    // Defining the prototype of the object
    Toastify.lib = Toastify.prototype = {
        toastify: version,
        constructor: Toastify,
        // Initializing the object with required parameters
        init: function(options) {
            // Verifying and validating the input object
            if (!options) options = {};
            // Creating the options object
            this.options = {};
            this.toastElement = null;
            // Validating the options
            this.options.text = options.text || Toastify.defaults.text; // Display message
            this.options.node = options.node || Toastify.defaults.node; // Display content as node
            this.options.duration = options.duration === 0 ? 0 : options.duration || Toastify.defaults.duration; // Display duration
            this.options.selector = options.selector || Toastify.defaults.selector; // Parent selector
            this.options.callback = options.callback || Toastify.defaults.callback; // Callback after display
            this.options.destination = options.destination || Toastify.defaults.destination; // On-click destination
            this.options.newWindow = options.newWindow || Toastify.defaults.newWindow; // Open destination in new window
            this.options.close = options.close || Toastify.defaults.close; // Show toast close icon
            this.options.gravity = options.gravity === "bottom" ? "toastify-bottom" : Toastify.defaults.gravity; // toast position - top or bottom
            this.options.positionLeft = options.positionLeft || Toastify.defaults.positionLeft; // toast position - left or right
            this.options.position = options.position || Toastify.defaults.position; // toast position - left or right
            this.options.backgroundColor = options.backgroundColor || Toastify.defaults.backgroundColor; // toast background color
            this.options.avatar = options.avatar || Toastify.defaults.avatar; // img element src - url or a path
            this.options.className = options.className || Toastify.defaults.className; // additional class names for the toast
            this.options.stopOnFocus = options.stopOnFocus === undefined ? Toastify.defaults.stopOnFocus : options.stopOnFocus; // stop timeout on focus
            this.options.onClick = options.onClick || Toastify.defaults.onClick; // Callback after click
            this.options.offset = options.offset || Toastify.defaults.offset; // toast offset
            this.options.escapeMarkup = options.escapeMarkup !== undefined ? options.escapeMarkup : Toastify.defaults.escapeMarkup;
            this.options.ariaLive = options.ariaLive || Toastify.defaults.ariaLive;
            this.options.style = options.style || Toastify.defaults.style;
            if (options.backgroundColor) this.options.style.background = options.backgroundColor;
            // Returning the current object for chaining functions
            return this;
        },
        // Building the DOM element
        buildToast: function() {
            // Validating if the options are defined
            if (!this.options) throw "Toastify is not initialized";
            // Creating the DOM object
            var divElement = document.createElement("div");
            divElement.className = "toastify on " + this.options.className;
            // Positioning toast to left or right or center
            if (!!this.options.position) divElement.className += " toastify-" + this.options.position;
            else // To be depreciated in further versions
            if (this.options.positionLeft === true) {
                divElement.className += " toastify-left";
                console.warn('Property `positionLeft` will be depreciated in further versions. Please use `position` instead.');
            } else // Default position
            divElement.className += " toastify-right";
            // Assigning gravity of element
            divElement.className += " " + this.options.gravity;
            if (this.options.backgroundColor) // This is being deprecated in favor of using the style HTML DOM property
            console.warn('DEPRECATION NOTICE: "backgroundColor" is being deprecated. Please use the "style.background" property.');
            // Loop through our style object and apply styles to divElement
            for(var property in this.options.style)divElement.style[property] = this.options.style[property];
            // Announce the toast to screen readers
            if (this.options.ariaLive) divElement.setAttribute('aria-live', this.options.ariaLive);
            // Adding the toast message/node
            if (this.options.node && this.options.node.nodeType === Node.ELEMENT_NODE) // If we have a valid node, we insert it
            divElement.appendChild(this.options.node);
            else {
                if (this.options.escapeMarkup) divElement.innerText = this.options.text;
                else divElement.innerHTML = this.options.text;
                if (this.options.avatar !== "") {
                    var avatarElement = document.createElement("img");
                    avatarElement.src = this.options.avatar;
                    avatarElement.className = "toastify-avatar";
                    if (this.options.position == "left" || this.options.positionLeft === true) // Adding close icon on the left of content
                    divElement.appendChild(avatarElement);
                    else // Adding close icon on the right of content
                    divElement.insertAdjacentElement("afterbegin", avatarElement);
                }
            }
            // Adding a close icon to the toast
            if (this.options.close === true) {
                // Create a span for close element
                var closeElement = document.createElement("button");
                closeElement.type = "button";
                closeElement.setAttribute("aria-label", "Close");
                closeElement.className = "toast-close";
                closeElement.innerHTML = "&#10006;";
                // Triggering the removal of toast from DOM on close click
                closeElement.addEventListener("click", (function(event) {
                    event.stopPropagation();
                    this.removeElement(this.toastElement);
                    window.clearTimeout(this.toastElement.timeOutValue);
                }).bind(this));
                //Calculating screen width
                var width = window.innerWidth > 0 ? window.innerWidth : screen.width;
                // Adding the close icon to the toast element
                // Display on the right if screen width is less than or equal to 360px
                if ((this.options.position == "left" || this.options.positionLeft === true) && width > 360) // Adding close icon on the left of content
                divElement.insertAdjacentElement("afterbegin", closeElement);
                else // Adding close icon on the right of content
                divElement.appendChild(closeElement);
            }
            // Clear timeout while toast is focused
            if (this.options.stopOnFocus && this.options.duration > 0) {
                var self = this;
                // stop countdown
                divElement.addEventListener("mouseover", function(event) {
                    window.clearTimeout(divElement.timeOutValue);
                });
                // add back the timeout
                divElement.addEventListener("mouseleave", function() {
                    divElement.timeOutValue = window.setTimeout(function() {
                        // Remove the toast from DOM
                        self.removeElement(divElement);
                    }, self.options.duration);
                });
            }
            // Adding an on-click destination path
            if (typeof this.options.destination !== "undefined") divElement.addEventListener("click", (function(event) {
                event.stopPropagation();
                if (this.options.newWindow === true) window.open(this.options.destination, "_blank");
                else window.location = this.options.destination;
            }).bind(this));
            if (typeof this.options.onClick === "function" && typeof this.options.destination === "undefined") divElement.addEventListener("click", (function(event) {
                event.stopPropagation();
                this.options.onClick();
            }).bind(this));
            // Adding offset
            if (typeof this.options.offset === "object") {
                var x = getAxisOffsetAValue("x", this.options);
                var y = getAxisOffsetAValue("y", this.options);
                var xOffset = this.options.position == "left" ? x : "-" + x;
                var yOffset = this.options.gravity == "toastify-top" ? y : "-" + y;
                divElement.style.transform = "translate(" + xOffset + "," + yOffset + ")";
            }
            // Returning the generated element
            return divElement;
        },
        // Displaying the toast
        showToast: function() {
            // Creating the DOM object for the toast
            this.toastElement = this.buildToast();
            // Getting the root element to with the toast needs to be added
            var rootElement;
            if (typeof this.options.selector === "string") rootElement = document.getElementById(this.options.selector);
            else if (this.options.selector instanceof HTMLElement || typeof ShadowRoot !== 'undefined' && this.options.selector instanceof ShadowRoot) rootElement = this.options.selector;
            else rootElement = document.body;
            // Validating if root element is present in DOM
            if (!rootElement) throw "Root element is not defined";
            // Adding the DOM element
            var elementToInsert = Toastify.defaults.oldestFirst ? rootElement.firstChild : rootElement.lastChild;
            rootElement.insertBefore(this.toastElement, elementToInsert);
            // Repositioning the toasts in case multiple toasts are present
            Toastify.reposition();
            if (this.options.duration > 0) this.toastElement.timeOutValue = window.setTimeout((function() {
                // Remove the toast from DOM
                this.removeElement(this.toastElement);
            }).bind(this), this.options.duration); // Binding `this` for function invocation
            // Supporting function chaining
            return this;
        },
        hideToast: function() {
            if (this.toastElement.timeOutValue) clearTimeout(this.toastElement.timeOutValue);
            this.removeElement(this.toastElement);
        },
        // Removing the element from the DOM
        removeElement: function(toastElement) {
            // Hiding the element
            // toastElement.classList.remove("on");
            toastElement.className = toastElement.className.replace(" on", "");
            // Removing the element from DOM after transition end
            window.setTimeout((function() {
                // remove options node if any
                if (this.options.node && this.options.node.parentNode) this.options.node.parentNode.removeChild(this.options.node);
                // Remove the element from the DOM, only when the parent node was not removed before.
                if (toastElement.parentNode) toastElement.parentNode.removeChild(toastElement);
                // Calling the callback function
                this.options.callback.call(toastElement);
                // Repositioning the toasts again
                Toastify.reposition();
            }).bind(this), 400); // Binding `this` for function invocation
        }
    };
    // Positioning the toasts on the DOM
    Toastify.reposition = function() {
        // Top margins with gravity
        var topLeftOffsetSize = {
            top: 15,
            bottom: 15
        };
        var topRightOffsetSize = {
            top: 15,
            bottom: 15
        };
        var offsetSize = {
            top: 15,
            bottom: 15
        };
        // Get all toast messages on the DOM
        var allToasts = document.getElementsByClassName("toastify");
        var classUsed;
        // Modifying the position of each toast element
        for(var i = 0; i < allToasts.length; i++){
            // Getting the applied gravity
            if (containsClass(allToasts[i], "toastify-top") === true) classUsed = "toastify-top";
            else classUsed = "toastify-bottom";
            var height = allToasts[i].offsetHeight;
            classUsed = classUsed.substr(9, classUsed.length - 1);
            // Spacing between toasts
            var offset = 15;
            var width = window.innerWidth > 0 ? window.innerWidth : screen.width;
            // Show toast in center if screen with less than or equal to 360px
            if (width <= 360) {
                // Setting the position
                allToasts[i].style[classUsed] = offsetSize[classUsed] + "px";
                offsetSize[classUsed] += height + offset;
            } else if (containsClass(allToasts[i], "toastify-left") === true) {
                // Setting the position
                allToasts[i].style[classUsed] = topLeftOffsetSize[classUsed] + "px";
                topLeftOffsetSize[classUsed] += height + offset;
            } else {
                // Setting the position
                allToasts[i].style[classUsed] = topRightOffsetSize[classUsed] + "px";
                topRightOffsetSize[classUsed] += height + offset;
            }
        }
        // Supporting function chaining
        return this;
    };
    // Helper function to get offset.
    function getAxisOffsetAValue(axis, options) {
        if (options.offset[axis]) {
            if (isNaN(options.offset[axis])) return options.offset[axis];
            else return options.offset[axis] + 'px';
        }
        return '0px';
    }
    function containsClass(elem, yourClass) {
        if (!elem || typeof yourClass !== "string") return false;
        else if (elem.className && elem.className.trim().split(/\s+/gi).indexOf(yourClass) > -1) return true;
        else return false;
    }
    // Setting up the prototype for the init object
    Toastify.lib.init.prototype = Toastify.lib;
    // Returning the Toastify function to be assigned to the window object/module
    return Toastify;
});


class $19a061ecc5409c94$export$86fbec116b87613f {
    // Prüft ob DOM geladen und führt Callback aus
    static domready(fn) {
        if (document.readyState != 'loading') fn();
        else document.addEventListener('DOMContentLoaded', fn);
    }
    // Liefert Website-URL
    static getUrl(path = '', get_parameter = []) {
        // Parameter initialisieren
        if (typeof path === "undefined") path = "";
        if (typeof get_parameter === "undefined") get_parameter = [];
        // Parameter prüfen
        if (typeof path !== "string") return false;
        if (typeof get_parameter !== "object") return false;
        // Parameter bereinigen
        path = path.trim();
        // URL zusammenstellen
        let url = window.location.protocol + "//" + window.location.hostname;
        if (path.length > 0) url += '/' + path;
        if (typeof get_parameter === "object") {
            url += '?';
            Object.entries(get_parameter).forEach(([key, value])=>{
                value = value.toString();
                if (key.length > 0 && value.length > 0) url += key.trim() + '=' + value.trim() + '&';
            });
            url = url.substring(0, url.length - 1);
        }
        // liefern
        return url;
    }
    // Weiterleitung zu URL
    static gotoUrl(url) {
        window.location = url;
    }
    // Liefert Code der aktuellen Sprache
    static getLang() {
        const $html = document.querySelector('html');
        const lang = $html.getAttribute('lang');
        return lang;
    }
    // Sendebuttons eines Formulars auf Ladestatus setzen
    static setSubmitBtnLoading($form) {
        const $btns = $form.querySelectorAll('button[type=submit]');
        $btns.forEach(($btn)=>{
            $btn.classList.add('loading');
            $btn.setAttribute('disabled', true);
        });
    }
    // Sendebuttons eines Formulars auf Aktiv setzen
    static setSubmitBtnActive($form) {
        const $btns = $form.querySelectorAll('button[type=submit]');
        $btns.forEach(($btn)=>{
            $btn.classList.remove('loading');
            $btn.removeAttribute('disabled');
        });
    }
    static showMsg(msg, className, duration = 3000) {
        (0, (/*@__PURE__*/$parcel$interopDefault($7d03927386cb1976$exports)))({
            text: msg,
            gravity: "bottom",
            position: "right",
            duration: duration,
            className: className
        }).showToast();
    }
}


// Libs
'use strict';
function $93b0f01b05e2607a$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


var $d3c1734dacb01657$exports = {};
// shim for using process in browser
var $d3c1734dacb01657$var$process = $d3c1734dacb01657$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $d3c1734dacb01657$var$cachedSetTimeout;
var $d3c1734dacb01657$var$cachedClearTimeout;
function $d3c1734dacb01657$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $d3c1734dacb01657$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        else $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        else $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    }
})();
function $d3c1734dacb01657$var$runTimeout(fun) {
    if ($d3c1734dacb01657$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedSetTimeout === $d3c1734dacb01657$var$defaultSetTimout || !$d3c1734dacb01657$var$cachedSetTimeout) && setTimeout) {
        $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $d3c1734dacb01657$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $d3c1734dacb01657$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $d3c1734dacb01657$var$runClearTimeout(marker) {
    if ($d3c1734dacb01657$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedClearTimeout === $d3c1734dacb01657$var$defaultClearTimeout || !$d3c1734dacb01657$var$cachedClearTimeout) && clearTimeout) {
        $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $d3c1734dacb01657$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $d3c1734dacb01657$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $d3c1734dacb01657$var$queue = [];
var $d3c1734dacb01657$var$draining = false;
var $d3c1734dacb01657$var$currentQueue;
var $d3c1734dacb01657$var$queueIndex = -1;
function $d3c1734dacb01657$var$cleanUpNextTick() {
    if (!$d3c1734dacb01657$var$draining || !$d3c1734dacb01657$var$currentQueue) return;
    $d3c1734dacb01657$var$draining = false;
    if ($d3c1734dacb01657$var$currentQueue.length) $d3c1734dacb01657$var$queue = $d3c1734dacb01657$var$currentQueue.concat($d3c1734dacb01657$var$queue);
    else $d3c1734dacb01657$var$queueIndex = -1;
    if ($d3c1734dacb01657$var$queue.length) $d3c1734dacb01657$var$drainQueue();
}
function $d3c1734dacb01657$var$drainQueue() {
    if ($d3c1734dacb01657$var$draining) return;
    var timeout = $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$cleanUpNextTick);
    $d3c1734dacb01657$var$draining = true;
    var len = $d3c1734dacb01657$var$queue.length;
    while(len){
        $d3c1734dacb01657$var$currentQueue = $d3c1734dacb01657$var$queue;
        $d3c1734dacb01657$var$queue = [];
        while(++$d3c1734dacb01657$var$queueIndex < len)if ($d3c1734dacb01657$var$currentQueue) $d3c1734dacb01657$var$currentQueue[$d3c1734dacb01657$var$queueIndex].run();
        $d3c1734dacb01657$var$queueIndex = -1;
        len = $d3c1734dacb01657$var$queue.length;
    }
    $d3c1734dacb01657$var$currentQueue = null;
    $d3c1734dacb01657$var$draining = false;
    $d3c1734dacb01657$var$runClearTimeout(timeout);
}
$d3c1734dacb01657$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $d3c1734dacb01657$var$queue.push(new $d3c1734dacb01657$var$Item(fun, args));
    if ($d3c1734dacb01657$var$queue.length === 1 && !$d3c1734dacb01657$var$draining) $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$drainQueue);
};
// v8 likes predictible objects
function $d3c1734dacb01657$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$d3c1734dacb01657$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$d3c1734dacb01657$var$process.title = 'browser';
$d3c1734dacb01657$var$process.browser = true;
$d3c1734dacb01657$var$process.env = {};
$d3c1734dacb01657$var$process.argv = [];
$d3c1734dacb01657$var$process.version = ''; // empty string to avoid regexp issues
$d3c1734dacb01657$var$process.versions = {};
function $d3c1734dacb01657$var$noop() {}
$d3c1734dacb01657$var$process.on = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.addListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.once = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.off = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeAllListeners = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.emit = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependOnceListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.listeners = function(name) {
    return [];
};
$d3c1734dacb01657$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$d3c1734dacb01657$var$process.cwd = function() {
    return '/';
};
$d3c1734dacb01657$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$d3c1734dacb01657$var$process.umask = function() {
    return 0;
};


'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString: $aace3e920a0f1e4d$var$toString } = Object.prototype;
const { getPrototypeOf: $aace3e920a0f1e4d$var$getPrototypeOf } = Object;
const $aace3e920a0f1e4d$var$kindOf = ((cache)=>(thing)=>{
        const str = $aace3e920a0f1e4d$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $aace3e920a0f1e4d$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$aace3e920a0f1e4d$var$kindOf(thing) === type;
};
const $aace3e920a0f1e4d$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $aace3e920a0f1e4d$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $aace3e920a0f1e4d$var$isUndefined = $aace3e920a0f1e4d$var$typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $aace3e920a0f1e4d$var$isBuffer(val) {
    return val !== null && !$aace3e920a0f1e4d$var$isUndefined(val) && val.constructor !== null && !$aace3e920a0f1e4d$var$isUndefined(val.constructor) && $aace3e920a0f1e4d$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $aace3e920a0f1e4d$var$isArrayBuffer = $aace3e920a0f1e4d$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $aace3e920a0f1e4d$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $aace3e920a0f1e4d$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $aace3e920a0f1e4d$var$isString = $aace3e920a0f1e4d$var$typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $aace3e920a0f1e4d$var$isFunction = $aace3e920a0f1e4d$var$typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $aace3e920a0f1e4d$var$isNumber = $aace3e920a0f1e4d$var$typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $aace3e920a0f1e4d$var$isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $aace3e920a0f1e4d$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $aace3e920a0f1e4d$var$isPlainObject = (val)=>{
    if ($aace3e920a0f1e4d$var$kindOf(val) !== 'object') return false;
    const prototype = $aace3e920a0f1e4d$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $aace3e920a0f1e4d$var$isDate = $aace3e920a0f1e4d$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $aace3e920a0f1e4d$var$isFile = $aace3e920a0f1e4d$var$kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $aace3e920a0f1e4d$var$isBlob = $aace3e920a0f1e4d$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $aace3e920a0f1e4d$var$isFileList = $aace3e920a0f1e4d$var$kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $aace3e920a0f1e4d$var$isStream = (val)=>$aace3e920a0f1e4d$var$isObject(val) && $aace3e920a0f1e4d$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $aace3e920a0f1e4d$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === 'function' && thing instanceof FormData || $aace3e920a0f1e4d$var$isFunction(thing.append) && ((kind = $aace3e920a0f1e4d$var$kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && $aace3e920a0f1e4d$var$isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $aace3e920a0f1e4d$var$isURLSearchParams = $aace3e920a0f1e4d$var$kindOfTest('URLSearchParams');
const [$aace3e920a0f1e4d$var$isReadableStream, $aace3e920a0f1e4d$var$isRequest, $aace3e920a0f1e4d$var$isResponse, $aace3e920a0f1e4d$var$isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map($aace3e920a0f1e4d$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $aace3e920a0f1e4d$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $aace3e920a0f1e4d$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($aace3e920a0f1e4d$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $aace3e920a0f1e4d$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $aace3e920a0f1e4d$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : $parcel$global;
})();
const $aace3e920a0f1e4d$var$isContextDefined = (context)=>!$aace3e920a0f1e4d$var$isUndefined(context) && context !== $aace3e920a0f1e4d$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $aace3e920a0f1e4d$var$merge() {
    const { caseless: caseless } = $aace3e920a0f1e4d$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $aace3e920a0f1e4d$var$findKey(result, key) || key;
        if ($aace3e920a0f1e4d$var$isPlainObject(result[targetKey]) && $aace3e920a0f1e4d$var$isPlainObject(val)) result[targetKey] = $aace3e920a0f1e4d$var$merge(result[targetKey], val);
        else if ($aace3e920a0f1e4d$var$isPlainObject(val)) result[targetKey] = $aace3e920a0f1e4d$var$merge({}, val);
        else if ($aace3e920a0f1e4d$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $aace3e920a0f1e4d$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $aace3e920a0f1e4d$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $aace3e920a0f1e4d$var$forEach(b, (val, key)=>{
        if (thisArg && $aace3e920a0f1e4d$var$isFunction(val)) a[key] = (0, $93b0f01b05e2607a$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $aace3e920a0f1e4d$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $aace3e920a0f1e4d$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $aace3e920a0f1e4d$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $aace3e920a0f1e4d$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $aace3e920a0f1e4d$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $aace3e920a0f1e4d$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($aace3e920a0f1e4d$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$aace3e920a0f1e4d$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $aace3e920a0f1e4d$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && $aace3e920a0f1e4d$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $aace3e920a0f1e4d$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $aace3e920a0f1e4d$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $aace3e920a0f1e4d$var$isHTMLForm = $aace3e920a0f1e4d$var$kindOfTest('HTMLFormElement');
const $aace3e920a0f1e4d$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $aace3e920a0f1e4d$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $aace3e920a0f1e4d$var$isRegExp = $aace3e920a0f1e4d$var$kindOfTest('RegExp');
const $aace3e920a0f1e4d$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $aace3e920a0f1e4d$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $aace3e920a0f1e4d$var$freezeMethods = (obj)=>{
    $aace3e920a0f1e4d$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($aace3e920a0f1e4d$var$isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$aace3e920a0f1e4d$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error('Can not rewrite read-only method \'' + name + '\'');
        };
    });
};
const $aace3e920a0f1e4d$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $aace3e920a0f1e4d$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $aace3e920a0f1e4d$var$noop = ()=>{};
const $aace3e920a0f1e4d$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $aace3e920a0f1e4d$var$isSpecCompliantForm(thing) {
    return !!(thing && $aace3e920a0f1e4d$var$isFunction(thing.append) && thing[Symbol.toStringTag] === 'FormData' && thing[Symbol.iterator]);
}
const $aace3e920a0f1e4d$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($aace3e920a0f1e4d$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = $aace3e920a0f1e4d$var$isArray(source) ? [] : {};
                $aace3e920a0f1e4d$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$aace3e920a0f1e4d$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $aace3e920a0f1e4d$var$isAsyncFn = $aace3e920a0f1e4d$var$kindOfTest('AsyncFunction');
const $aace3e920a0f1e4d$var$isThenable = (thing)=>thing && ($aace3e920a0f1e4d$var$isObject(thing) || $aace3e920a0f1e4d$var$isFunction(thing)) && $aace3e920a0f1e4d$var$isFunction(thing.then) && $aace3e920a0f1e4d$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $aace3e920a0f1e4d$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $aace3e920a0f1e4d$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $aace3e920a0f1e4d$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $aace3e920a0f1e4d$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', $aace3e920a0f1e4d$var$isFunction($aace3e920a0f1e4d$var$_global.postMessage));
const $aace3e920a0f1e4d$var$asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind($aace3e920a0f1e4d$var$_global) : typeof $d3c1734dacb01657$exports !== 'undefined' && $d3c1734dacb01657$exports.nextTick || $aace3e920a0f1e4d$var$_setImmediate;
var // *********************
$aace3e920a0f1e4d$export$2e2bcd8739ae039 = {
    isArray: $aace3e920a0f1e4d$var$isArray,
    isArrayBuffer: $aace3e920a0f1e4d$var$isArrayBuffer,
    isBuffer: $aace3e920a0f1e4d$var$isBuffer,
    isFormData: $aace3e920a0f1e4d$var$isFormData,
    isArrayBufferView: $aace3e920a0f1e4d$var$isArrayBufferView,
    isString: $aace3e920a0f1e4d$var$isString,
    isNumber: $aace3e920a0f1e4d$var$isNumber,
    isBoolean: $aace3e920a0f1e4d$var$isBoolean,
    isObject: $aace3e920a0f1e4d$var$isObject,
    isPlainObject: $aace3e920a0f1e4d$var$isPlainObject,
    isReadableStream: $aace3e920a0f1e4d$var$isReadableStream,
    isRequest: $aace3e920a0f1e4d$var$isRequest,
    isResponse: $aace3e920a0f1e4d$var$isResponse,
    isHeaders: $aace3e920a0f1e4d$var$isHeaders,
    isUndefined: $aace3e920a0f1e4d$var$isUndefined,
    isDate: $aace3e920a0f1e4d$var$isDate,
    isFile: $aace3e920a0f1e4d$var$isFile,
    isBlob: $aace3e920a0f1e4d$var$isBlob,
    isRegExp: $aace3e920a0f1e4d$var$isRegExp,
    isFunction: $aace3e920a0f1e4d$var$isFunction,
    isStream: $aace3e920a0f1e4d$var$isStream,
    isURLSearchParams: $aace3e920a0f1e4d$var$isURLSearchParams,
    isTypedArray: $aace3e920a0f1e4d$var$isTypedArray,
    isFileList: $aace3e920a0f1e4d$var$isFileList,
    forEach: $aace3e920a0f1e4d$var$forEach,
    merge: $aace3e920a0f1e4d$var$merge,
    extend: $aace3e920a0f1e4d$var$extend,
    trim: $aace3e920a0f1e4d$var$trim,
    stripBOM: $aace3e920a0f1e4d$var$stripBOM,
    inherits: $aace3e920a0f1e4d$var$inherits,
    toFlatObject: $aace3e920a0f1e4d$var$toFlatObject,
    kindOf: $aace3e920a0f1e4d$var$kindOf,
    kindOfTest: $aace3e920a0f1e4d$var$kindOfTest,
    endsWith: $aace3e920a0f1e4d$var$endsWith,
    toArray: $aace3e920a0f1e4d$var$toArray,
    forEachEntry: $aace3e920a0f1e4d$var$forEachEntry,
    matchAll: $aace3e920a0f1e4d$var$matchAll,
    isHTMLForm: $aace3e920a0f1e4d$var$isHTMLForm,
    hasOwnProperty: $aace3e920a0f1e4d$var$hasOwnProperty,
    hasOwnProp: $aace3e920a0f1e4d$var$hasOwnProperty,
    reduceDescriptors: $aace3e920a0f1e4d$var$reduceDescriptors,
    freezeMethods: $aace3e920a0f1e4d$var$freezeMethods,
    toObjectSet: $aace3e920a0f1e4d$var$toObjectSet,
    toCamelCase: $aace3e920a0f1e4d$var$toCamelCase,
    noop: $aace3e920a0f1e4d$var$noop,
    toFiniteNumber: $aace3e920a0f1e4d$var$toFiniteNumber,
    findKey: $aace3e920a0f1e4d$var$findKey,
    global: $aace3e920a0f1e4d$var$_global,
    isContextDefined: $aace3e920a0f1e4d$var$isContextDefined,
    isSpecCompliantForm: $aace3e920a0f1e4d$var$isSpecCompliantForm,
    toJSONObject: $aace3e920a0f1e4d$var$toJSONObject,
    isAsyncFn: $aace3e920a0f1e4d$var$isAsyncFn,
    isThenable: $aace3e920a0f1e4d$var$isThenable,
    setImmediate: $aace3e920a0f1e4d$var$_setImmediate,
    asap: $aace3e920a0f1e4d$var$asap
};







'use strict';
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $0139f1d30f4d6bd5$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).inherits($0139f1d30f4d6bd5$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $0139f1d30f4d6bd5$var$prototype = $0139f1d30f4d6bd5$var$AxiosError.prototype;
const $0139f1d30f4d6bd5$var$descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
].forEach((code)=>{
    $0139f1d30f4d6bd5$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($0139f1d30f4d6bd5$var$AxiosError, $0139f1d30f4d6bd5$var$descriptors);
Object.defineProperty($0139f1d30f4d6bd5$var$prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
$0139f1d30f4d6bd5$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($0139f1d30f4d6bd5$var$prototype);
    (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== 'isAxiosError';
    });
    $0139f1d30f4d6bd5$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $0139f1d30f4d6bd5$export$2e2bcd8739ae039 = $0139f1d30f4d6bd5$var$AxiosError;


// eslint-disable-next-line strict
var $86ebf0c810395e29$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $0934e0939605d48c$export$a143d493d941bafc;
var $0934e0939605d48c$export$e4cf37d7f6fb9e0a;
var $0934e0939605d48c$export$f99ded8fe4b79145;
var $0934e0939605d48c$export$599f31c3813fae4d;
'use strict';
var $8a0a73e6b73fd0c4$export$a48f0734ac7c2329;
var $8a0a73e6b73fd0c4$export$d622b2ad8d90c771;
var $8a0a73e6b73fd0c4$export$6100ba28696e12de;
'use strict';
$8a0a73e6b73fd0c4$export$a48f0734ac7c2329 = $8a0a73e6b73fd0c4$var$byteLength;
$8a0a73e6b73fd0c4$export$d622b2ad8d90c771 = $8a0a73e6b73fd0c4$var$toByteArray;
$8a0a73e6b73fd0c4$export$6100ba28696e12de = $8a0a73e6b73fd0c4$var$fromByteArray;
var $8a0a73e6b73fd0c4$var$lookup = [];
var $8a0a73e6b73fd0c4$var$revLookup = [];
var $8a0a73e6b73fd0c4$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $8a0a73e6b73fd0c4$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $8a0a73e6b73fd0c4$var$i = 0, $8a0a73e6b73fd0c4$var$len = $8a0a73e6b73fd0c4$var$code.length; $8a0a73e6b73fd0c4$var$i < $8a0a73e6b73fd0c4$var$len; ++$8a0a73e6b73fd0c4$var$i){
    $8a0a73e6b73fd0c4$var$lookup[$8a0a73e6b73fd0c4$var$i] = $8a0a73e6b73fd0c4$var$code[$8a0a73e6b73fd0c4$var$i];
    $8a0a73e6b73fd0c4$var$revLookup[$8a0a73e6b73fd0c4$var$code.charCodeAt($8a0a73e6b73fd0c4$var$i)] = $8a0a73e6b73fd0c4$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$8a0a73e6b73fd0c4$var$revLookup['-'.charCodeAt(0)] = 62;
$8a0a73e6b73fd0c4$var$revLookup['_'.charCodeAt(0)] = 63;
function $8a0a73e6b73fd0c4$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $8a0a73e6b73fd0c4$var$byteLength(b64) {
    var lens = $8a0a73e6b73fd0c4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8a0a73e6b73fd0c4$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8a0a73e6b73fd0c4$var$toByteArray(b64) {
    var tmp;
    var lens = $8a0a73e6b73fd0c4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $8a0a73e6b73fd0c4$var$Arr($8a0a73e6b73fd0c4$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 18 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 2 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 10 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $8a0a73e6b73fd0c4$var$tripletToBase64(num) {
    return $8a0a73e6b73fd0c4$var$lookup[num >> 18 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num >> 12 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num >> 6 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num & 0x3F];
}
function $8a0a73e6b73fd0c4$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($8a0a73e6b73fd0c4$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $8a0a73e6b73fd0c4$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($8a0a73e6b73fd0c4$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($8a0a73e6b73fd0c4$var$lookup[tmp >> 2] + $8a0a73e6b73fd0c4$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($8a0a73e6b73fd0c4$var$lookup[tmp >> 10] + $8a0a73e6b73fd0c4$var$lookup[tmp >> 4 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $998eb38f4d082829$export$aafa59e2e03f2942;
var $998eb38f4d082829$export$68d8715fc104d294;
$998eb38f4d082829$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$998eb38f4d082829$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $0934e0939605d48c$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$0934e0939605d48c$export$a143d493d941bafc = $0934e0939605d48c$var$Buffer;
$0934e0939605d48c$export$e4cf37d7f6fb9e0a = $0934e0939605d48c$var$SlowBuffer;
$0934e0939605d48c$export$f99ded8fe4b79145 = 50;
const $0934e0939605d48c$var$K_MAX_LENGTH = 0x7fffffff;
$0934e0939605d48c$export$599f31c3813fae4d = $0934e0939605d48c$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $0934e0939605d48c$var$Buffer.TYPED_ARRAY_SUPPORT = $0934e0939605d48c$var$typedArraySupport();
if (!$0934e0939605d48c$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $0934e0939605d48c$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($0934e0939605d48c$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$0934e0939605d48c$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($0934e0939605d48c$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$0934e0939605d48c$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $0934e0939605d48c$var$createBuffer(length) {
    if (length > $0934e0939605d48c$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $0934e0939605d48c$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $0934e0939605d48c$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $0934e0939605d48c$var$allocUnsafe(arg);
    }
    return $0934e0939605d48c$var$from(arg, encodingOrOffset, length);
}
$0934e0939605d48c$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $0934e0939605d48c$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $0934e0939605d48c$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $0934e0939605d48c$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($0934e0939605d48c$var$isInstance(value, ArrayBuffer) || value && $0934e0939605d48c$var$isInstance(value.buffer, ArrayBuffer)) return $0934e0939605d48c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($0934e0939605d48c$var$isInstance(value, SharedArrayBuffer) || value && $0934e0939605d48c$var$isInstance(value.buffer, SharedArrayBuffer))) return $0934e0939605d48c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $0934e0939605d48c$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $0934e0939605d48c$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $0934e0939605d48c$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $0934e0939605d48c$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $0934e0939605d48c$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($0934e0939605d48c$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($0934e0939605d48c$var$Buffer, Uint8Array);
function $0934e0939605d48c$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $0934e0939605d48c$var$alloc(size, fill, encoding) {
    $0934e0939605d48c$var$assertSize(size);
    if (size <= 0) return $0934e0939605d48c$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $0934e0939605d48c$var$createBuffer(size).fill(fill, encoding) : $0934e0939605d48c$var$createBuffer(size).fill(fill);
    return $0934e0939605d48c$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $0934e0939605d48c$var$Buffer.alloc = function(size, fill, encoding) {
    return $0934e0939605d48c$var$alloc(size, fill, encoding);
};
function $0934e0939605d48c$var$allocUnsafe(size) {
    $0934e0939605d48c$var$assertSize(size);
    return $0934e0939605d48c$var$createBuffer(size < 0 ? 0 : $0934e0939605d48c$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $0934e0939605d48c$var$Buffer.allocUnsafe = function(size) {
    return $0934e0939605d48c$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $0934e0939605d48c$var$Buffer.allocUnsafeSlow = function(size) {
    return $0934e0939605d48c$var$allocUnsafe(size);
};
function $0934e0939605d48c$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$0934e0939605d48c$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $0934e0939605d48c$var$byteLength(string, encoding) | 0;
    let buf = $0934e0939605d48c$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $0934e0939605d48c$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $0934e0939605d48c$var$checked(array.length) | 0;
    const buf = $0934e0939605d48c$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $0934e0939605d48c$var$fromArrayView(arrayView) {
    if ($0934e0939605d48c$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $0934e0939605d48c$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $0934e0939605d48c$var$fromArrayLike(arrayView);
}
function $0934e0939605d48c$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $0934e0939605d48c$var$Buffer.prototype);
    return buf;
}
function $0934e0939605d48c$var$fromObject(obj) {
    if ($0934e0939605d48c$var$Buffer.isBuffer(obj)) {
        const len = $0934e0939605d48c$var$checked(obj.length) | 0;
        const buf = $0934e0939605d48c$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $0934e0939605d48c$var$numberIsNaN(obj.length)) return $0934e0939605d48c$var$createBuffer(0);
        return $0934e0939605d48c$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $0934e0939605d48c$var$fromArrayLike(obj.data);
}
function $0934e0939605d48c$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $0934e0939605d48c$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $0934e0939605d48c$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $0934e0939605d48c$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $0934e0939605d48c$var$Buffer.alloc(+length);
}
$0934e0939605d48c$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $0934e0939605d48c$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$0934e0939605d48c$var$Buffer.compare = function compare(a, b) {
    if ($0934e0939605d48c$var$isInstance(a, Uint8Array)) a = $0934e0939605d48c$var$Buffer.from(a, a.offset, a.byteLength);
    if ($0934e0939605d48c$var$isInstance(b, Uint8Array)) b = $0934e0939605d48c$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$0934e0939605d48c$var$Buffer.isBuffer(a) || !$0934e0939605d48c$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$0934e0939605d48c$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$0934e0939605d48c$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $0934e0939605d48c$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $0934e0939605d48c$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($0934e0939605d48c$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) buf = $0934e0939605d48c$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $0934e0939605d48c$var$byteLength(string, encoding) {
    if ($0934e0939605d48c$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $0934e0939605d48c$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $0934e0939605d48c$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $0934e0939605d48c$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $0934e0939605d48c$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$0934e0939605d48c$var$Buffer.byteLength = $0934e0939605d48c$var$byteLength;
function $0934e0939605d48c$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $0934e0939605d48c$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $0934e0939605d48c$var$utf8Slice(this, start, end);
        case 'ascii':
            return $0934e0939605d48c$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $0934e0939605d48c$var$latin1Slice(this, start, end);
        case 'base64':
            return $0934e0939605d48c$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $0934e0939605d48c$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$0934e0939605d48c$var$Buffer.prototype._isBuffer = true;
function $0934e0939605d48c$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$0934e0939605d48c$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$0934e0939605d48c$var$swap(this, i, i + 1);
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $0934e0939605d48c$var$swap(this, i, i + 3);
        $0934e0939605d48c$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $0934e0939605d48c$var$swap(this, i, i + 7);
        $0934e0939605d48c$var$swap(this, i + 1, i + 6);
        $0934e0939605d48c$var$swap(this, i + 2, i + 5);
        $0934e0939605d48c$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $0934e0939605d48c$var$utf8Slice(this, 0, length);
    return $0934e0939605d48c$var$slowToString.apply(this, arguments);
};
$0934e0939605d48c$var$Buffer.prototype.toLocaleString = $0934e0939605d48c$var$Buffer.prototype.toString;
$0934e0939605d48c$var$Buffer.prototype.equals = function equals(b) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $0934e0939605d48c$var$Buffer.compare(this, b) === 0;
};
$0934e0939605d48c$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $0934e0939605d48c$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($0934e0939605d48c$var$customInspectSymbol) $0934e0939605d48c$var$Buffer.prototype[$0934e0939605d48c$var$customInspectSymbol] = $0934e0939605d48c$var$Buffer.prototype.inspect;
$0934e0939605d48c$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($0934e0939605d48c$var$isInstance(target, Uint8Array)) target = $0934e0939605d48c$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$0934e0939605d48c$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $0934e0939605d48c$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($0934e0939605d48c$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $0934e0939605d48c$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($0934e0939605d48c$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $0934e0939605d48c$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $0934e0939605d48c$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $0934e0939605d48c$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$0934e0939605d48c$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$0934e0939605d48c$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $0934e0939605d48c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$0934e0939605d48c$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $0934e0939605d48c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $0934e0939605d48c$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($0934e0939605d48c$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $0934e0939605d48c$var$utf8Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $0934e0939605d48c$var$asciiWrite(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$asciiToBytes(string), buf, offset, length);
}
function $0934e0939605d48c$var$base64Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$base64ToBytes(string), buf, offset, length);
}
function $0934e0939605d48c$var$ucs2Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$0934e0939605d48c$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $0934e0939605d48c$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $0934e0939605d48c$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $0934e0939605d48c$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $0934e0939605d48c$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $0934e0939605d48c$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$0934e0939605d48c$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $0934e0939605d48c$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $8a0a73e6b73fd0c4$export$6100ba28696e12de(buf);
    else return $8a0a73e6b73fd0c4$export$6100ba28696e12de(buf.slice(start, end));
}
function $0934e0939605d48c$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $0934e0939605d48c$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $0934e0939605d48c$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $0934e0939605d48c$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $0934e0939605d48c$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $0934e0939605d48c$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $0934e0939605d48c$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $0934e0939605d48c$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$0934e0939605d48c$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $0934e0939605d48c$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $0934e0939605d48c$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$0934e0939605d48c$var$Buffer.prototype.readUintLE = $0934e0939605d48c$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readUintBE = $0934e0939605d48c$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readUint8 = $0934e0939605d48c$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$0934e0939605d48c$var$Buffer.prototype.readUint16LE = $0934e0939605d48c$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$0934e0939605d48c$var$Buffer.prototype.readUint16BE = $0934e0939605d48c$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$0934e0939605d48c$var$Buffer.prototype.readUint32LE = $0934e0939605d48c$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$0934e0939605d48c$var$Buffer.prototype.readUint32BE = $0934e0939605d48c$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$0934e0939605d48c$var$Buffer.prototype.readBigUInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$0934e0939605d48c$var$Buffer.prototype.readBigUInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$0934e0939605d48c$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$0934e0939605d48c$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$0934e0939605d48c$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$0934e0939605d48c$var$Buffer.prototype.readBigInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$0934e0939605d48c$var$Buffer.prototype.readBigInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$0934e0939605d48c$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return $998eb38f4d082829$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$0934e0939605d48c$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return $998eb38f4d082829$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$0934e0939605d48c$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 8, this.length);
    return $998eb38f4d082829$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$0934e0939605d48c$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 8, this.length);
    return $998eb38f4d082829$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $0934e0939605d48c$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$0934e0939605d48c$var$Buffer.prototype.writeUintLE = $0934e0939605d48c$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeUintBE = $0934e0939605d48c$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint8 = $0934e0939605d48c$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint16LE = $0934e0939605d48c$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint16BE = $0934e0939605d48c$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint32LE = $0934e0939605d48c$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint32BE = $0934e0939605d48c$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $0934e0939605d48c$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $0934e0939605d48c$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$0934e0939605d48c$var$Buffer.prototype.writeBigUInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$0934e0939605d48c$var$Buffer.prototype.writeBigUInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$0934e0939605d48c$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeBigInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$0934e0939605d48c$var$Buffer.prototype.writeBigInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $0934e0939605d48c$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $0934e0939605d48c$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $998eb38f4d082829$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$0934e0939605d48c$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeFloat(this, value, offset, true, noAssert);
};
$0934e0939605d48c$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeFloat(this, value, offset, false, noAssert);
};
function $0934e0939605d48c$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $998eb38f4d082829$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$0934e0939605d48c$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeDouble(this, value, offset, true, noAssert);
};
$0934e0939605d48c$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$0934e0939605d48c$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$0934e0939605d48c$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$0934e0939605d48c$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $0934e0939605d48c$var$Buffer.isBuffer(val) ? val : $0934e0939605d48c$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $0934e0939605d48c$var$errors = {};
function $0934e0939605d48c$var$E(sym, getMessage, Base) {
    $0934e0939605d48c$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$0934e0939605d48c$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$0934e0939605d48c$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$0934e0939605d48c$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $0934e0939605d48c$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $0934e0939605d48c$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $0934e0939605d48c$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $0934e0939605d48c$var$checkBounds(buf, offset, byteLength) {
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $0934e0939605d48c$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $0934e0939605d48c$var$checkBounds(buf, offset, byteLength);
}
function $0934e0939605d48c$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $0934e0939605d48c$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $0934e0939605d48c$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $0934e0939605d48c$var$validateNumber(value, type);
        throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $0934e0939605d48c$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $0934e0939605d48c$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $0934e0939605d48c$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($0934e0939605d48c$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $0934e0939605d48c$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $0934e0939605d48c$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $0934e0939605d48c$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $0934e0939605d48c$var$base64ToBytes(str) {
    return $8a0a73e6b73fd0c4$export$d622b2ad8d90c771($0934e0939605d48c$var$base64clean(str));
}
function $0934e0939605d48c$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $0934e0939605d48c$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $0934e0939605d48c$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $0934e0939605d48c$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $0934e0939605d48c$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $0934e0939605d48c$var$BufferBigIntNotDefined : fn;
}
function $0934e0939605d48c$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $fd07b9cb0132c1f6$require$Buffer = $0934e0939605d48c$export$a143d493d941bafc;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $fd07b9cb0132c1f6$var$isVisitable(thing) {
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $fd07b9cb0132c1f6$var$removeBrackets(key) {
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $fd07b9cb0132c1f6$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $fd07b9cb0132c1f6$var$removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $fd07b9cb0132c1f6$var$isFlatArray(arr) {
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(arr) && !arr.some($fd07b9cb0132c1f6$var$isVisitable);
}
const $fd07b9cb0132c1f6$var$predicates = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toFlatObject((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $fd07b9cb0132c1f6$var$toFormData(obj, formData, options) {
    if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $86ebf0c810395e29$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('Blob is not supported. Use a Buffer instead.');
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : $fd07b9cb0132c1f6$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === 'object') {
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(value) && $fd07b9cb0132c1f6$var$isFlatArray(value) || ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFileList(value) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).endsWith(key, '[]')) && (arr = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $fd07b9cb0132c1f6$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $fd07b9cb0132c1f6$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if ($fd07b9cb0132c1f6$var$isVisitable(value)) return true;
        formData.append($fd07b9cb0132c1f6$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($fd07b9cb0132c1f6$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $fd07b9cb0132c1f6$var$isVisitable
    });
    function build(value, path) {
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
var $fd07b9cb0132c1f6$export$2e2bcd8739ae039 = $fd07b9cb0132c1f6$var$toFormData;


'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $344cf8e4292137b6$var$encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $344cf8e4292137b6$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $fd07b9cb0132c1f6$export$2e2bcd8739ae039)(params, this, options);
}
const $344cf8e4292137b6$var$prototype = $344cf8e4292137b6$var$AxiosURLSearchParams.prototype;
$344cf8e4292137b6$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$344cf8e4292137b6$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $344cf8e4292137b6$var$encode);
    } : $344cf8e4292137b6$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
var $344cf8e4292137b6$export$2e2bcd8739ae039 = $344cf8e4292137b6$var$AxiosURLSearchParams;


'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $db2f05ec923f2ee7$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
function $db2f05ec923f2ee7$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $db2f05ec923f2ee7$var$encode;
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $344cf8e4292137b6$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}



'use strict';
class $01c17f80085c95b1$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $01c17f80085c95b1$export$2e2bcd8739ae039 = $01c17f80085c95b1$var$InterceptorManager;





'use strict';
var $3075bac9f30e7782$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






'use strict';
var $a85e5bed82430d61$export$2e2bcd8739ae039 = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, $344cf8e4292137b6$export$2e2bcd8739ae039);


'use strict';
var $46b12d255f217052$export$2e2bcd8739ae039 = typeof FormData !== 'undefined' ? FormData : null;


'use strict';
var $2e4211376cea43e6$export$2e2bcd8739ae039 = typeof Blob !== 'undefined' ? Blob : null;


var $fb24c6d0b2a74508$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $a85e5bed82430d61$export$2e2bcd8739ae039,
        FormData: $46b12d255f217052$export$2e2bcd8739ae039,
        Blob: $2e4211376cea43e6$export$2e2bcd8739ae039
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};


var $232de52881daaba8$exports = {};

$parcel$export($232de52881daaba8$exports, "hasBrowserEnv", () => $232de52881daaba8$export$c4996c4b7b93b0bf);
$parcel$export($232de52881daaba8$exports, "navigator", () => $232de52881daaba8$export$ec7c8efa7f5790ae);
$parcel$export($232de52881daaba8$exports, "hasStandardBrowserEnv", () => $232de52881daaba8$export$c0bcc9250309d66);
$parcel$export($232de52881daaba8$exports, "hasStandardBrowserWebWorkerEnv", () => $232de52881daaba8$export$c81692cf5af97dac);
$parcel$export($232de52881daaba8$exports, "origin", () => $232de52881daaba8$export$f710a83a91838a36);
const $232de52881daaba8$export$c4996c4b7b93b0bf = typeof window !== 'undefined' && typeof document !== 'undefined';
const $232de52881daaba8$export$ec7c8efa7f5790ae = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $232de52881daaba8$export$c0bcc9250309d66 = $232de52881daaba8$export$c4996c4b7b93b0bf && (!$232de52881daaba8$export$ec7c8efa7f5790ae || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf($232de52881daaba8$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $232de52881daaba8$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const $232de52881daaba8$export$f710a83a91838a36 = $232de52881daaba8$export$c4996c4b7b93b0bf && window.location.href || 'http://localhost';


var $852831b4a152a7ad$export$2e2bcd8739ae039 = {
    ...$232de52881daaba8$exports,
    ...(0, $fb24c6d0b2a74508$export$2e2bcd8739ae039)
};


'use strict';
function $aa000567d8bb5ae2$export$2e2bcd8739ae039(data, options) {
    return (0, $fd07b9cb0132c1f6$export$2e2bcd8739ae039)(data, new (0, $852831b4a152a7ad$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $852831b4a152a7ad$export$2e2bcd8739ae039).isNode && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $cb8fe7f388dc4432$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $cb8fe7f388dc4432$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $cb8fe7f388dc4432$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $cb8fe7f388dc4432$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFormData(formData) && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($cb8fe7f388dc4432$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $cb8fe7f388dc4432$export$2e2bcd8739ae039 = $cb8fe7f388dc4432$var$formDataToJSON;


'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $e30871f78dcd7f19$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $e30871f78dcd7f19$var$defaults = {
    transitional: (0, $3075bac9f30e7782$export$2e2bcd8739ae039),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $cb8fe7f388dc4432$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isBuffer(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isStream(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFile(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isBlob(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, $aa000567d8bb5ae2$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $fd07b9cb0132c1f6$export$2e2bcd8739ae039)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return $e30871f78dcd7f19$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $e30871f78dcd7f19$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isResponse(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).from(e, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $852831b4a152a7ad$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $852831b4a152a7ad$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    $e30871f78dcd7f19$var$defaults.headers[method] = {};
});
var $e30871f78dcd7f19$export$2e2bcd8739ae039 = $e30871f78dcd7f19$var$defaults;




'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $36eacf0f5ae88424$var$ignoreDuplicateOf = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $36eacf0f5ae88424$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $36eacf0f5ae88424$var$ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};


'use strict';
const $54e5234108b8e954$var$$internals = Symbol('internals');
function $54e5234108b8e954$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $54e5234108b8e954$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(value) ? value.map($54e5234108b8e954$var$normalizeValue) : String(value);
}
function $54e5234108b8e954$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $54e5234108b8e954$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $54e5234108b8e954$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $54e5234108b8e954$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $54e5234108b8e954$var$buildAccessors(obj, header) {
    const accessorName = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $54e5234108b8e954$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $54e5234108b8e954$var$normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $54e5234108b8e954$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$54e5234108b8e954$var$isValidHeaderName(header)) setHeaders((0, $36eacf0f5ae88424$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isHeaders(header)) for (const [key, value] of header.entries())setHeader(value, key, rewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $54e5234108b8e954$var$normalizeHeader(header);
        if (header) {
            const key = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $54e5234108b8e954$var$parseTokens(value);
                if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = $54e5234108b8e954$var$normalizeHeader(header);
        if (header) {
            const key = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $54e5234108b8e954$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $54e5234108b8e954$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $54e5234108b8e954$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $54e5234108b8e954$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $54e5234108b8e954$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $54e5234108b8e954$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $54e5234108b8e954$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$54e5234108b8e954$var$$internals] = this[$54e5234108b8e954$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $54e5234108b8e954$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $54e5234108b8e954$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$54e5234108b8e954$var$AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).reduceDescriptors($54e5234108b8e954$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).freezeMethods($54e5234108b8e954$var$AxiosHeaders);
var $54e5234108b8e954$export$2e2bcd8739ae039 = $54e5234108b8e954$var$AxiosHeaders;


'use strict';
function $ec027d10dfede142$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $e30871f78dcd7f19$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


'use strict';
function $fbc9c01c5c3dc518$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





'use strict';
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $63b8b72909769bf2$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).call(this, message == null ? 'canceled' : message, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).inherits($63b8b72909769bf2$var$CanceledError, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $63b8b72909769bf2$export$2e2bcd8739ae039 = $63b8b72909769bf2$var$CanceledError;







'use strict';
function $c0e22576f74b8071$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('Request failed with status code ' + response.status, [
        (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





'use strict';
function $9cab09d0d089fc0e$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}




'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $48a8aeed25ee768a$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $48a8aeed25ee768a$export$2e2bcd8739ae039 = $48a8aeed25ee768a$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $bab2be24834f7155$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $bab2be24834f7155$export$2e2bcd8739ae039 = $bab2be24834f7155$var$throttle;



const $a01f222f203440ec$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $48a8aeed25ee768a$export$2e2bcd8739ae039)(50, 250);
    return (0, $bab2be24834f7155$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const $a01f222f203440ec$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $a01f222f203440ec$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $3a08e3bf7b3045fa$export$2e2bcd8739ae039 = (0, $852831b4a152a7ad$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $852831b4a152a7ad$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $852831b4a152a7ad$export$2e2bcd8739ae039).origin), (0, $852831b4a152a7ad$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $852831b4a152a7ad$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $4d3cf801f7fd4dc6$export$2e2bcd8739ae039 = (0, $852831b4a152a7ad$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + '=' + encodeURIComponent(value)
        ];
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isNumber(expires) && cookie.push('expires=' + new Date(expires).toGMTString());
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(path) && cookie.push('path=' + path);
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(domain) && cookie.push('domain=' + domain);
        secure === true && cookie.push('secure');
        document.cookie = cookie.join('; ');
    },
    read (name) {
        const match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


'use strict';
function $05bf269bfca011f3$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


'use strict';
function $7c49e720f6231ba2$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}


'use strict';
function $8ed3292b1f9dccb5$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $05bf269bfca011f3$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && isRelativeUrl || allowAbsoluteUrls == false) return (0, $7c49e720f6231ba2$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




'use strict';
const $20ede3a7e8b675d4$var$headersToObject = (thing)=>thing instanceof (0, $54e5234108b8e954$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $20ede3a7e8b675d4$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(target) && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($20ede3a7e8b675d4$var$headersToObject(a), $20ede3a7e8b675d4$var$headersToObject(b), prop, true)
    };
    (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $f612969e780f42a0$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $db2f05ec923f2ee7$export$2e2bcd8739ae039)((0, $8ed3292b1f9dccb5$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    let contentType;
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $852831b4a152a7ad$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $852831b4a152a7ad$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(';').map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || 'multipart/form-data',
                ...tokens
            ].join('; '));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $852831b4a152a7ad$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $3a08e3bf7b3045fa$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $4d3cf801f7fd4dc6$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $61abd1574bd1dd32$var$isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
var $61abd1574bd1dd32$export$2e2bcd8739ae039 = $61abd1574bd1dd32$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $f612969e780f42a0$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $c0e22576f74b8071$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('Request aborted', (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('Network Error', (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, $3075bac9f30e7782$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ETIMEDOUT : (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $a01f222f203440ec$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $a01f222f203440ec$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $63b8b72909769bf2$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, $9cab09d0d089fc0e$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $852831b4a152a7ad$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('Unsupported protocol ' + protocol + ':', (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $8bc8ab02f7e95517$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039) ? err : new (0, $63b8b72909769bf2$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(`timeout ${timeout} of ms exceeded`, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $8bc8ab02f7e95517$export$2e2bcd8739ae039 = $8bc8ab02f7e95517$var$composeSignals;


const $ac31e9e363273572$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $ac31e9e363273572$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $ac31e9e363273572$var$readStream(iterable))yield* $ac31e9e363273572$export$71b051935044bd5d(chunk, chunkSize);
};
const $ac31e9e363273572$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $ac31e9e363273572$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $ac31e9e363273572$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $4b9898a31eea6843$var$isFetchSupported = typeof fetch === 'function' && typeof Request === 'function' && typeof Response === 'function';
const $4b9898a31eea6843$var$isReadableStreamSupported = $4b9898a31eea6843$var$isFetchSupported && typeof ReadableStream === 'function';
// used only inside the fetch adapter
const $4b9898a31eea6843$var$encodeText = $4b9898a31eea6843$var$isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $4b9898a31eea6843$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $4b9898a31eea6843$var$supportsRequestStream = $4b9898a31eea6843$var$isReadableStreamSupported && $4b9898a31eea6843$var$test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $852831b4a152a7ad$export$2e2bcd8739ae039).origin, {
        body: new ReadableStream(),
        method: 'POST',
        get duplex () {
            duplexAccessed = true;
            return 'half';
        }
    }).headers.has('Content-Type');
    return duplexAccessed && !hasContentType;
});
const $4b9898a31eea6843$var$DEFAULT_CHUNK_SIZE = 65536;
const $4b9898a31eea6843$var$supportsResponseStream = $4b9898a31eea6843$var$isReadableStreamSupported && $4b9898a31eea6843$var$test(()=>(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isReadableStream(new Response('').body));
const $4b9898a31eea6843$var$resolvers = {
    stream: $4b9898a31eea6843$var$supportsResponseStream && ((res)=>res.body)
};
$4b9898a31eea6843$var$isFetchSupported && ((res)=>{
    [
        'text',
        'arrayBuffer',
        'blob',
        'formData',
        'stream'
    ].forEach((type)=>{
        !$4b9898a31eea6843$var$resolvers[type] && ($4b9898a31eea6843$var$resolvers[type] = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $4b9898a31eea6843$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isBlob(body)) return body.size;
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
        const _request = new Request((0, $852831b4a152a7ad$export$2e2bcd8739ae039).origin, {
            method: 'POST',
            body: body
        });
        return (await _request.arrayBuffer()).byteLength;
    }
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + '';
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(body)) return (await $4b9898a31eea6843$var$encodeText(body)).byteLength;
};
const $4b9898a31eea6843$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
    return length == null ? $4b9898a31eea6843$var$getBodyLength(body) : length;
};
var $4b9898a31eea6843$export$2e2bcd8739ae039 = $4b9898a31eea6843$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = 'same-origin', fetchOptions: fetchOptions } = (0, $f612969e780f42a0$export$2e2bcd8739ae039)(config);
    responseType = responseType ? (responseType + '').toLowerCase() : 'text';
    let composedSignal = (0, $8bc8ab02f7e95517$export$2e2bcd8739ae039)([
        signal,
        cancelToken && cancelToken.toAbortSignal()
    ], timeout);
    let request;
    const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
        composedSignal.unsubscribe();
    });
    let requestContentLength;
    try {
        if (onUploadProgress && $4b9898a31eea6843$var$supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await $4b9898a31eea6843$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: 'POST',
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, $a01f222f203440ec$export$d9fadd12586c18d6)(requestContentLength, (0, $a01f222f203440ec$export$c1b28109d46c3592)((0, $a01f222f203440ec$export$5d35863c355a22a9)(onUploadProgress)));
                data = (0, $ac31e9e363273572$export$b0119225647bd83)(_request.body, $4b9898a31eea6843$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
            }
        }
        if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        });
        let response = await fetch(request);
        const isStreamResponse = $4b9898a31eea6843$var$supportsResponseStream && (responseType === 'stream' || responseType === 'response');
        if ($4b9898a31eea6843$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
            const options = {};
            [
                'status',
                'statusText',
                'headers'
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get('content-length'));
            const [onProgress, flush] = onDownloadProgress && (0, $a01f222f203440ec$export$d9fadd12586c18d6)(responseContentLength, (0, $a01f222f203440ec$export$c1b28109d46c3592)((0, $a01f222f203440ec$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
            response = new Response((0, $ac31e9e363273572$export$b0119225647bd83)(response.body, $4b9898a31eea6843$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                unsubscribe && unsubscribe();
            }), options);
        }
        responseType = responseType || 'text';
        let responseData = await $4b9898a31eea6843$var$resolvers[(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey($4b9898a31eea6843$var$resolvers, responseType) || 'text'](response, config);
        !isStreamResponse && unsubscribe && unsubscribe();
        return await new Promise((resolve, reject)=>{
            (0, $c0e22576f74b8071$export$2e2bcd8739ae039)(resolve, reject, {
                data: responseData,
                headers: (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        unsubscribe && unsubscribe();
        if (err && err.name === 'TypeError' && /fetch/i.test(err.message)) throw Object.assign(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('Network Error', (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
    }
});



const $d570c100e0cb7a05$var$knownAdapters = {
    http: (0, $86ebf0c810395e29$export$2e2bcd8739ae039),
    xhr: (0, $61abd1574bd1dd32$export$2e2bcd8739ae039),
    fetch: (0, $4b9898a31eea6843$export$2e2bcd8739ae039)
};
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach($d570c100e0cb7a05$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value: value
        });
    }
});
const $d570c100e0cb7a05$var$renderReason = (reason)=>`- ${reason}`;
const $d570c100e0cb7a05$var$isResolvedHandle = (adapter)=>(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $d570c100e0cb7a05$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$d570c100e0cb7a05$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $d570c100e0cb7a05$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || '#' + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
            let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map($d570c100e0cb7a05$var$renderReason).join('\n') : ' ' + $d570c100e0cb7a05$var$renderReason(reasons[0]) : 'as no adapter specified';
            throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
        }
        return adapter;
    },
    adapters: $d570c100e0cb7a05$var$knownAdapters
};


'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $96666136aaccd2e5$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $63b8b72909769bf2$export$2e2bcd8739ae039)(null, config);
}
function $96666136aaccd2e5$export$2e2bcd8739ae039(config) {
    $96666136aaccd2e5$var$throwIfCancellationRequested(config);
    config.headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $ec027d10dfede142$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, $d570c100e0cb7a05$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $e30871f78dcd7f19$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $96666136aaccd2e5$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $ec027d10dfede142$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $fbc9c01c5c3dc518$export$2e2bcd8739ae039)(reason)) {
            $96666136aaccd2e5$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $ec027d10dfede142$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $4c74d331112ba968$export$a4ad2735b021c132 = "1.8.1";



'use strict';
const $63efb8494987aa98$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    $63efb8494987aa98$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const $63efb8494987aa98$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $63efb8494987aa98$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, $4c74d331112ba968$export$a4ad2735b021c132) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$63efb8494987aa98$var$deprecatedWarnings[opt]) {
            $63efb8494987aa98$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$63efb8494987aa98$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $63efb8494987aa98$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('options must be an object', (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('option ' + opt + ' must be ' + result, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)('Unknown option ' + opt, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $63efb8494987aa98$export$2e2bcd8739ae039 = {
    assertOptions: $63efb8494987aa98$var$assertOptions,
    validators: $63efb8494987aa98$var$validators
};



'use strict';
const $cd0b8e3cbef64068$var$validators = (0, $63efb8494987aa98$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $cd0b8e3cbef64068$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $01c17f80085c95b1$export$2e2bcd8739ae039)(),
            response: new (0, $01c17f80085c95b1$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $63efb8494987aa98$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean),
            forcedJSONParsing: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean),
            clarifyTimeoutError: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $63efb8494987aa98$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $cd0b8e3cbef64068$var$validators.function,
                serialize: $cd0b8e3cbef64068$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $63efb8494987aa98$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $cd0b8e3cbef64068$var$validators.spelling('baseURL'),
            withXsrfToken: $cd0b8e3cbef64068$var$validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $96666136aaccd2e5$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $96666136aaccd2e5$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $8ed3292b1f9dccb5$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $db2f05ec923f2ee7$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $cd0b8e3cbef64068$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $cd0b8e3cbef64068$var$Axios.prototype[method] = generateHTTPMethod();
    $cd0b8e3cbef64068$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
var $cd0b8e3cbef64068$export$2e2bcd8739ae039 = $cd0b8e3cbef64068$var$Axios;







'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $3218dd97b5460664$var$CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $63b8b72909769bf2$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $3218dd97b5460664$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $3218dd97b5460664$export$2e2bcd8739ae039 = $3218dd97b5460664$var$CancelToken;






'use strict';
function $7874d702b64e6994$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



'use strict';
function $16f479813f4fb9c8$export$2e2bcd8739ae039(payload) {
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $edd7ef3f6e3b67e5$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($edd7ef3f6e3b67e5$var$HttpStatusCode).forEach(([key, value])=>{
    $edd7ef3f6e3b67e5$var$HttpStatusCode[value] = key;
});
var $edd7ef3f6e3b67e5$export$2e2bcd8739ae039 = $edd7ef3f6e3b67e5$var$HttpStatusCode;


'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $5d7526a7a1e5b3fb$var$createInstance(defaultConfig) {
    const context = new (0, $cd0b8e3cbef64068$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $93b0f01b05e2607a$export$2e2bcd8739ae039)((0, $cd0b8e3cbef64068$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).extend(instance, (0, $cd0b8e3cbef64068$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $5d7526a7a1e5b3fb$var$createInstance((0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $5d7526a7a1e5b3fb$var$axios = $5d7526a7a1e5b3fb$var$createInstance((0, $e30871f78dcd7f19$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$5d7526a7a1e5b3fb$var$axios.Axios = (0, $cd0b8e3cbef64068$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$5d7526a7a1e5b3fb$var$axios.CanceledError = (0, $63b8b72909769bf2$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.CancelToken = (0, $3218dd97b5460664$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.isCancel = (0, $fbc9c01c5c3dc518$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.VERSION = (0, $4c74d331112ba968$export$a4ad2735b021c132);
$5d7526a7a1e5b3fb$var$axios.toFormData = (0, $fd07b9cb0132c1f6$export$2e2bcd8739ae039);
// Expose AxiosError class
$5d7526a7a1e5b3fb$var$axios.AxiosError = (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$5d7526a7a1e5b3fb$var$axios.Cancel = $5d7526a7a1e5b3fb$var$axios.CanceledError;
// Expose all/spread
$5d7526a7a1e5b3fb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$5d7526a7a1e5b3fb$var$axios.spread = (0, $7874d702b64e6994$export$2e2bcd8739ae039);
// Expose isAxiosError
$5d7526a7a1e5b3fb$var$axios.isAxiosError = (0, $16f479813f4fb9c8$export$2e2bcd8739ae039);
// Expose mergeConfig
$5d7526a7a1e5b3fb$var$axios.mergeConfig = (0, $20ede3a7e8b675d4$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.AxiosHeaders = (0, $54e5234108b8e954$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.formToJSON = (thing)=>(0, $cb8fe7f388dc4432$export$2e2bcd8739ae039)((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$5d7526a7a1e5b3fb$var$axios.getAdapter = (0, $d570c100e0cb7a05$export$2e2bcd8739ae039).getAdapter;
$5d7526a7a1e5b3fb$var$axios.HttpStatusCode = (0, $edd7ef3f6e3b67e5$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.default = $5d7526a7a1e5b3fb$var$axios;
var // this module should only have a default export
$5d7526a7a1e5b3fb$export$2e2bcd8739ae039 = $5d7526a7a1e5b3fb$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $125d1ceb57662f9a$export$1c00760e9e5a4e95, AxiosError: $125d1ceb57662f9a$export$c1fbed17c2f6a328, CanceledError: $125d1ceb57662f9a$export$1ab0c6b20d94fa14, isCancel: $125d1ceb57662f9a$export$3b22524397b493c6, CancelToken: $125d1ceb57662f9a$export$fd08e3cb425f0d61, VERSION: $125d1ceb57662f9a$export$a4ad2735b021c132, all: $125d1ceb57662f9a$export$84bf76cd7afc7469, Cancel: $125d1ceb57662f9a$export$848c9b7ead0df967, isAxiosError: $125d1ceb57662f9a$export$fbafdbe06a5b5a9a, spread: $125d1ceb57662f9a$export$3ae0fd4797ed47c8, toFormData: $125d1ceb57662f9a$export$10ae0d317ea97f8b, AxiosHeaders: $125d1ceb57662f9a$export$4e7d6ff0f3e6520, HttpStatusCode: $125d1ceb57662f9a$export$a972f69c851492b3, formToJSON: $125d1ceb57662f9a$export$86d7c59254d6a2c9, getAdapter: $125d1ceb57662f9a$export$17ddc20a97d669e2, mergeConfig: $125d1ceb57662f9a$export$7ec1ebcfa9d8bd6a } = (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039);


var $dbe7c8f2fb929f48$require$axios = $5d7526a7a1e5b3fb$export$2e2bcd8739ae039;
class $dbe7c8f2fb929f48$export$1e7deca84b429035 {
    #config = {
        headers: {
            'Accept': 'application/json',
            'x-requested-with': 'xmlhttprequest'
        }
    };
    constructor(config){
        // Konfiguration zusammenstellen
        if (config && typeof config === "object") this.#config = {
            ...this.#config,
            ...config
        };
        return this;
    }
    async get(endpoint) {
        return this.#send("get", endpoint, null);
    }
    async put(endpoint, body) {
        return this.#send("put", endpoint, body);
    }
    async post(endpoint, body) {
        return this.#send("post", endpoint, body);
    }
    async delete(endpoint, body) {
        return this.#send("delete", endpoint, body);
    }
    async #send(method, endpoint, body) {
        let options = {
            method: method,
            url: endpoint
        };
        if (body) options.data = body;
        options = {
            ...this.#config,
            ...options
        };
        return new Promise((resolve, reject)=>{
            $dbe7c8f2fb929f48$require$axios.request(options).then((response)=>{
                // No Success
                if (response.data?.success !== true) {
                    let msg = response.data.error_msg ?? "Unknown error";
                    reject({
                        "message": msg,
                        "response": response
                    });
                } else resolve(response.data);
            }).catch((error)=>{
                if (typeof error !== "object") error = {
                    message: error
                };
                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    console.log(error.response.data);
                    console.log(error.response.status);
                    console.log(error.response.headers);
                    error.message = error.message ?? "Server error";
                } else if (error.request) {
                    // The request was made but no response was received
                    console.log(error.request);
                    error.message = error.message ?? "No response";
                }
                reject(error);
            });
        });
    }
}


// Imports

class $06210838c5319423$export$2b77a92f1a5ad772 {
    constructor($ele){
        this.$container = $ele;
        this.id = $ele.id;
        this.$overlay = this.$container.querySelector(".overlay");
        this.$dialog = this.$container.querySelector(".dialog");
        this.$closeBtns = this.$container.querySelectorAll("*[x-close]");
        // Klick auf Öffnungs-Links
        document.querySelectorAll(`*[x-open-slidemodal="${this.id}"]`).forEach(($link)=>{
            $link.addEventListener("click", (event)=>{
                event.preventDefault();
                this.open();
            });
        });
        // Klick auf Schliessen-Links
        document.querySelectorAll(`*[x-close-slidemodal="${this.id}"]`).forEach(($link)=>{
            $link.addEventListener("click", (event)=>{
                event.preventDefault();
                this.close();
            });
        });
    }
    // öffnen
    open() {
        if (!this.$container.classList.contains("open")) {
            // Alle schliessen
            this.closeAll();
            // Event-Listener
            this.close = this.close.bind(this);
            this.$overlay.addEventListener("click", this.close);
            document.addEventListener("keyup", this.close);
            if (this.$closeBtns) this.$closeBtns.forEach(($btn)=>{
                $btn.addEventListener("click", this.close);
            });
            // Body-Scrolling fixieren
            const scrollY = window.scrollY;
            this.$container.addEventListener('transitionend', (event)=>{
                document.body.style.position = 'fixed';
                document.body.style.top = "-" + scrollY + "px";
            }, {
                once: true
            });
            // Event-Trigger
            this.$container.dispatchEvent(new CustomEvent('slidemodal-open', {
                detail: {}
            }));
            // Hidden-Attribut
            this.$container.removeAttribute("hidden");
            const reflow = this.$container.offsetHeight;
            // Klasse hinzufügen
            this.$container.classList.add("open");
            // Focus auf erstes Eingabefeld
            const $input = this.$dialog.querySelector("input,textarea");
            if ($input) setTimeout(()=>{
                $input.focus();
            }, 300);
        }
    }
    // schliessen
    close(event = null) {
        if (this.$container.classList.contains("open")) {
            if (event) {
                if (event.type === "click") event.preventDefault();
                else if (event.type === "keyup") {
                    if (event.key !== "Escape") return;
                }
            }
            // Event-Listener entfernen
            this.$overlay.removeEventListener("click", this.close);
            document.removeEventListener("keyup", this.close);
            if (this.$closeBtns) this.$closeBtns.forEach(($btn)=>{
                $btn.removeEventListener("click", this.close);
            });
            // Body-Scrolling herstellen
            let scrollY = document.body.style.top;
            scrollY = parseInt(scrollY || '0');
            document.documentElement.style.scrollBehavior = "auto";
            document.body.style.position = '';
            document.body.style.top = '';
            window.scrollTo(0, scrollY * -1);
            document.documentElement.style.scrollBehavior = "smooth";
            // Hidden-Attribut
            this.$container.addEventListener('transitionend', (event)=>{
                this.$container.setAttribute("hidden", true);
            }, {
                once: true
            });
            // Klasse entfernen
            this.$container.classList.remove("open");
            // Event-Trigger
            this.$container.dispatchEvent(new CustomEvent('slidemodal-close', {
                detail: {}
            }));
        }
    }
    // alle schliessen
    closeAll() {
        window.SlideModals.forEach((m)=>{
            m.close();
        });
    }
}
// alle SlideModals initialisieren
(0, $19a061ecc5409c94$export$86fbec116b87613f).domready(()=>{
    window.Modals = [];
    const $modals = document.querySelectorAll(".modal");
    $modals.forEach(($ele)=>{
        const id = $ele.id;
        window.Modals[id] = new $06210838c5319423$export$2b77a92f1a5ad772($ele);
    });
});


// Imports

class $43feae324018f8b2$export$b5d5cf8927ab7262 {
    constructor($ele){
        this.$container = $ele;
        this.$input = this.$container.querySelector("input[type=hidden]");
        this.$button = this.$container.querySelector("button");
        // Klick auf Switch
        this.$button.addEventListener("click", (event)=>{
            this.toggle();
        });
        // mit Leertaste umschalten
        document.addEventListener("keyup", (event)=>{
            if (event.key === "Space character" && document.activeElement === this.$container) this.toggle();
        });
        // Status initialisieren
        this.#setStatus();
    }
    toggle() {
        this.$container.classList.toggle("on");
        this.#setStatus();
    }
    #setStatus() {
        const on = this.$container.classList.contains("on");
        // input setzen
        this.$input.value = on;
        // aria setzen
        this.$button.setAttribute("aria-checked", on);
        // event
        this.triggerChange();
    }
    triggerChange() {
        const on = this.$container.classList.contains("on");
        this.$container.dispatchEvent(new CustomEvent('switch-change', {
            detail: {
                checked: on
            }
        }));
    }
}
// alle Switches initialisieren
(0, $19a061ecc5409c94$export$86fbec116b87613f).domready(()=>{
    window.Switches = [];
    const $switches = document.querySelectorAll(".switch");
    $switches.forEach(($ele)=>{
        const s = new $43feae324018f8b2$export$b5d5cf8927ab7262($ele);
        window.Switches.push(s);
    });
});


var $ab98ebfa6dd34a35$exports = {};
/*!
 * clipboard.js v2.0.11
 * https://clipboardjs.com/
 *
 * Licensed MIT © Zeno Rocha
 */ (function webpackUniversalModuleDefinition(root, factory) {
    $ab98ebfa6dd34a35$exports = factory();
})($ab98ebfa6dd34a35$exports, function() {
    return /******/ function() {
        /******/ var __webpack_modules__ = {
            /***/ 686: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                "use strict";
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    "default": function() {
                        return /* binding */ clipboard;
                    }
                });
                // EXTERNAL MODULE: ./node_modules/tiny-emitter/index.js
                var tiny_emitter = __webpack_require__(279);
                var tiny_emitter_default = /*#__PURE__*/ __webpack_require__.n(tiny_emitter);
                // EXTERNAL MODULE: ./node_modules/good-listener/src/listen.js
                var listen = __webpack_require__(370);
                var listen_default = /*#__PURE__*/ __webpack_require__.n(listen);
                // EXTERNAL MODULE: ./node_modules/select/src/select.js
                var src_select = __webpack_require__(817);
                var select_default = /*#__PURE__*/ __webpack_require__.n(src_select);
                /**
 * Executes a given operation type.
 * @param {String} type
 * @return {Boolean}
 */ function command(type) {
                    try {
                        return document.execCommand(type);
                    } catch (err) {
                        return false;
                    }
                }
                /**
 * Cut action wrapper.
 * @param {String|HTMLElement} target
 * @return {String}
 */ var ClipboardActionCut = function ClipboardActionCut(target) {
                    var selectedText = select_default()(target);
                    command('cut');
                    return selectedText;
                };
                /* harmony default export */ var actions_cut = ClipboardActionCut;
                /**
 * Creates a fake textarea element with a value.
 * @param {String} value
 * @return {HTMLElement}
 */ function createFakeElement(value) {
                    var isRTL = document.documentElement.getAttribute('dir') === 'rtl';
                    var fakeElement = document.createElement('textarea'); // Prevent zooming on iOS
                    fakeElement.style.fontSize = '12pt'; // Reset box model
                    fakeElement.style.border = '0';
                    fakeElement.style.padding = '0';
                    fakeElement.style.margin = '0'; // Move element out of screen horizontally
                    fakeElement.style.position = 'absolute';
                    fakeElement.style[isRTL ? 'right' : 'left'] = '-9999px'; // Move element to the same position vertically
                    var yPosition = window.pageYOffset || document.documentElement.scrollTop;
                    fakeElement.style.top = "".concat(yPosition, "px");
                    fakeElement.setAttribute('readonly', '');
                    fakeElement.value = value;
                    return fakeElement;
                }
                /**
 * Create fake copy action wrapper using a fake element.
 * @param {String} target
 * @param {Object} options
 * @return {String}
 */ var fakeCopyAction = function fakeCopyAction(value, options) {
                    var fakeElement = createFakeElement(value);
                    options.container.appendChild(fakeElement);
                    var selectedText = select_default()(fakeElement);
                    command('copy');
                    fakeElement.remove();
                    return selectedText;
                };
                /**
 * Copy action wrapper.
 * @param {String|HTMLElement} target
 * @param {Object} options
 * @return {String}
 */ var ClipboardActionCopy = function ClipboardActionCopy(target) {
                    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                        container: document.body
                    };
                    var selectedText = '';
                    if (typeof target === 'string') selectedText = fakeCopyAction(target, options);
                    else if (target instanceof HTMLInputElement && ![
                        'text',
                        'search',
                        'url',
                        'tel',
                        'password'
                    ].includes(target === null || target === void 0 ? void 0 : target.type)) // If input type doesn't support `setSelectionRange`. Simulate it. https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/setSelectionRange
                    selectedText = fakeCopyAction(target.value, options);
                    else {
                        selectedText = select_default()(target);
                        command('copy');
                    }
                    return selectedText;
                };
                /* harmony default export */ var actions_copy = ClipboardActionCopy;
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else _typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return _typeof(obj);
                }
                /**
 * Inner function which performs selection from either `text` or `target`
 * properties and then executes copy or cut operations.
 * @param {Object} options
 */ var ClipboardActionDefault = function ClipboardActionDefault() {
                    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    // Defines base properties passed from constructor.
                    var _options$action = options.action, action = _options$action === void 0 ? 'copy' : _options$action, container = options.container, target = options.target, text = options.text; // Sets the `action` to be performed which can be either 'copy' or 'cut'.
                    if (action !== 'copy' && action !== 'cut') throw new Error('Invalid "action" value, use either "copy" or "cut"');
                     // Sets the `target` property using an element that will be have its content copied.
                    if (target !== undefined) {
                        if (target && _typeof(target) === 'object' && target.nodeType === 1) {
                            if (action === 'copy' && target.hasAttribute('disabled')) throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                            if (action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                        } else throw new Error('Invalid "target" value, use a valid Element');
                    } // Define selection strategy based on `text` property.
                    if (text) return actions_copy(text, {
                        container: container
                    });
                     // Defines which selection strategy based on `target` property.
                    if (target) return action === 'cut' ? actions_cut(target) : actions_copy(target, {
                        container: container
                    });
                };
                /* harmony default export */ var actions_default = ClipboardActionDefault;
                function clipboard_typeof(obj) {
                    "@babel/helpers - typeof";
                    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") clipboard_typeof = function _typeof(obj) {
                        return typeof obj;
                    };
                    else clipboard_typeof = function _typeof(obj) {
                        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    };
                    return clipboard_typeof(obj);
                }
                function _classCallCheck(instance, Constructor) {
                    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                function _createClass(Constructor, protoProps, staticProps) {
                    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) _defineProperties(Constructor, staticProps);
                    return Constructor;
                }
                function _inherits(subClass, superClass) {
                    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            writable: true,
                            configurable: true
                        }
                    });
                    if (superClass) _setPrototypeOf(subClass, superClass);
                }
                function _setPrototypeOf(o, p) {
                    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                        o.__proto__ = p;
                        return o;
                    };
                    return _setPrototypeOf(o, p);
                }
                function _createSuper(Derived) {
                    var hasNativeReflectConstruct = _isNativeReflectConstruct();
                    return function _createSuperInternal() {
                        var Super = _getPrototypeOf(Derived), result;
                        if (hasNativeReflectConstruct) {
                            var NewTarget = _getPrototypeOf(this).constructor;
                            result = Reflect.construct(Super, arguments, NewTarget);
                        } else result = Super.apply(this, arguments);
                        return _possibleConstructorReturn(this, result);
                    };
                }
                function _possibleConstructorReturn(self, call) {
                    if (call && (clipboard_typeof(call) === "object" || typeof call === "function")) return call;
                    return _assertThisInitialized(self);
                }
                function _assertThisInitialized(self) {
                    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return self;
                }
                function _isNativeReflectConstruct() {
                    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
                    if (Reflect.construct.sham) return false;
                    if (typeof Proxy === "function") return true;
                    try {
                        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                function _getPrototypeOf(o) {
                    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                        return o.__proto__ || Object.getPrototypeOf(o);
                    };
                    return _getPrototypeOf(o);
                }
                /**
 * Helper function to retrieve attribute value.
 * @param {String} suffix
 * @param {Element} element
 */ function getAttributeValue(suffix, element) {
                    var attribute = "data-clipboard-".concat(suffix);
                    if (!element.hasAttribute(attribute)) return;
                    return element.getAttribute(attribute);
                }
                /**
 * Base class which takes one or more elements, adds event listeners to them,
 * and instantiates a new `ClipboardAction` on each click.
 */ var Clipboard = /*#__PURE__*/ function(_Emitter) {
                    _inherits(Clipboard, _Emitter);
                    var _super = _createSuper(Clipboard);
                    /**
   * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
   * @param {Object} options
   */ function Clipboard(trigger, options) {
                        var _this;
                        _classCallCheck(this, Clipboard);
                        _this = _super.call(this);
                        _this.resolveOptions(options);
                        _this.listenClick(trigger);
                        return _this;
                    }
                    /**
   * Defines if attributes would be resolved using internal setter functions
   * or custom functions that were passed in the constructor.
   * @param {Object} options
   */ _createClass(Clipboard, [
                        {
                            key: "resolveOptions",
                            value: function resolveOptions() {
                                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                                this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
                                this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
                                this.text = typeof options.text === 'function' ? options.text : this.defaultText;
                                this.container = clipboard_typeof(options.container) === 'object' ? options.container : document.body;
                            }
                        },
                        {
                            key: "listenClick",
                            value: function listenClick(trigger) {
                                var _this2 = this;
                                this.listener = listen_default()(trigger, 'click', function(e) {
                                    return _this2.onClick(e);
                                });
                            }
                        },
                        {
                            key: "onClick",
                            value: function onClick(e) {
                                var trigger = e.delegateTarget || e.currentTarget;
                                var action = this.action(trigger) || 'copy';
                                var text = actions_default({
                                    action: action,
                                    container: this.container,
                                    target: this.target(trigger),
                                    text: this.text(trigger)
                                }); // Fires an event based on the copy operation result.
                                this.emit(text ? 'success' : 'error', {
                                    action: action,
                                    text: text,
                                    trigger: trigger,
                                    clearSelection: function clearSelection() {
                                        if (trigger) trigger.focus();
                                        window.getSelection().removeAllRanges();
                                    }
                                });
                            }
                        },
                        {
                            key: "defaultAction",
                            value: function defaultAction(trigger) {
                                return getAttributeValue('action', trigger);
                            }
                        },
                        {
                            key: "defaultTarget",
                            value: function defaultTarget(trigger) {
                                var selector = getAttributeValue('target', trigger);
                                if (selector) return document.querySelector(selector);
                            }
                        },
                        {
                            key: "defaultText",
                            /**
     * Default `text` lookup function.
     * @param {Element} trigger
     */ value: function defaultText(trigger) {
                                return getAttributeValue('text', trigger);
                            }
                        },
                        {
                            key: "destroy",
                            value: function destroy() {
                                this.listener.destroy();
                            }
                        }
                    ], [
                        {
                            key: "copy",
                            value: function copy(target) {
                                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                                    container: document.body
                                };
                                return actions_copy(target, options);
                            }
                        },
                        {
                            key: "cut",
                            value: function cut(target) {
                                return actions_cut(target);
                            }
                        },
                        {
                            key: "isSupported",
                            value: function isSupported() {
                                var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
                                    'copy',
                                    'cut'
                                ];
                                var actions = typeof action === 'string' ? [
                                    action
                                ] : action;
                                var support = !!document.queryCommandSupported;
                                actions.forEach(function(action) {
                                    support = support && !!document.queryCommandSupported(action);
                                });
                                return support;
                            }
                        }
                    ]);
                    return Clipboard;
                }(tiny_emitter_default());
                /* harmony default export */ var clipboard = Clipboard;
            /***/ },
            /***/ 828: /***/ function(module1) {
                var DOCUMENT_NODE_TYPE = 9;
                /**
 * A polyfill for Element.matches()
 */ if (typeof Element !== 'undefined' && !Element.prototype.matches) {
                    var proto = Element.prototype;
                    proto.matches = proto.matchesSelector || proto.mozMatchesSelector || proto.msMatchesSelector || proto.oMatchesSelector || proto.webkitMatchesSelector;
                }
                /**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */ function closest(element, selector) {
                    while(element && element.nodeType !== DOCUMENT_NODE_TYPE){
                        if (typeof element.matches === 'function' && element.matches(selector)) return element;
                        element = element.parentNode;
                    }
                }
                module1.exports = closest;
            /***/ },
            /***/ 438: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var closest = __webpack_require__(828);
                /**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */ function _delegate(element, selector, type, callback, useCapture) {
                    var listenerFn = listener.apply(this, arguments);
                    element.addEventListener(type, listenerFn, useCapture);
                    return {
                        destroy: function() {
                            element.removeEventListener(type, listenerFn, useCapture);
                        }
                    };
                }
                /**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */ function delegate(elements, selector, type, callback, useCapture) {
                    // Handle the regular Element usage
                    if (typeof elements.addEventListener === 'function') return _delegate.apply(null, arguments);
                    // Handle Element-less usage, it defaults to global delegation
                    if (typeof type === 'function') // Use `document` as the first parameter, then apply arguments
                    // This is a short way to .unshift `arguments` without running into deoptimizations
                    return _delegate.bind(null, document).apply(null, arguments);
                    // Handle Selector-based usage
                    if (typeof elements === 'string') elements = document.querySelectorAll(elements);
                    // Handle Array-like based usage
                    return Array.prototype.map.call(elements, function(element) {
                        return _delegate(element, selector, type, callback, useCapture);
                    });
                }
                /**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */ function listener(element, selector, type, callback) {
                    return function(e) {
                        e.delegateTarget = closest(e.target, selector);
                        if (e.delegateTarget) callback.call(element, e);
                    };
                }
                module1.exports = delegate;
            /***/ },
            /***/ 879: /***/ function(__unused_webpack_module, exports) {
                /**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.node = function(value) {
                    return value !== undefined && value instanceof HTMLElement && value.nodeType === 1;
                };
                /**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.nodeList = function(value) {
                    var type = Object.prototype.toString.call(value);
                    return value !== undefined && (type === '[object NodeList]' || type === '[object HTMLCollection]') && 'length' in value && (value.length === 0 || exports.node(value[0]));
                };
                /**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.string = function(value) {
                    return typeof value === 'string' || value instanceof String;
                };
                /**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */ exports.fn = function(value) {
                    var type = Object.prototype.toString.call(value);
                    return type === '[object Function]';
                };
            /***/ },
            /***/ 370: /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var is = __webpack_require__(879);
                var delegate = __webpack_require__(438);
                /**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listen(target, type, callback) {
                    if (!target && !type && !callback) throw new Error('Missing required arguments');
                    if (!is.string(type)) throw new TypeError('Second argument must be a String');
                    if (!is.fn(callback)) throw new TypeError('Third argument must be a Function');
                    if (is.node(target)) return listenNode(target, type, callback);
                    else if (is.nodeList(target)) return listenNodeList(target, type, callback);
                    else if (is.string(target)) return listenSelector(target, type, callback);
                    else throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
                }
                /**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listenNode(node, type, callback) {
                    node.addEventListener(type, callback);
                    return {
                        destroy: function() {
                            node.removeEventListener(type, callback);
                        }
                    };
                }
                /**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listenNodeList(nodeList, type, callback) {
                    Array.prototype.forEach.call(nodeList, function(node) {
                        node.addEventListener(type, callback);
                    });
                    return {
                        destroy: function() {
                            Array.prototype.forEach.call(nodeList, function(node) {
                                node.removeEventListener(type, callback);
                            });
                        }
                    };
                }
                /**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */ function listenSelector(selector, type, callback) {
                    return delegate(document.body, selector, type, callback);
                }
                module1.exports = listen;
            /***/ },
            /***/ 817: /***/ function(module1) {
                function select(element) {
                    var selectedText;
                    if (element.nodeName === 'SELECT') {
                        element.focus();
                        selectedText = element.value;
                    } else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
                        var isReadOnly = element.hasAttribute('readonly');
                        if (!isReadOnly) element.setAttribute('readonly', '');
                        element.select();
                        element.setSelectionRange(0, element.value.length);
                        if (!isReadOnly) element.removeAttribute('readonly');
                        selectedText = element.value;
                    } else {
                        if (element.hasAttribute('contenteditable')) element.focus();
                        var selection = window.getSelection();
                        var range = document.createRange();
                        range.selectNodeContents(element);
                        selection.removeAllRanges();
                        selection.addRange(range);
                        selectedText = selection.toString();
                    }
                    return selectedText;
                }
                module1.exports = select;
            /***/ },
            /***/ 279: /***/ function(module1) {
                function E() {
                // Keep this empty so it's easier to inherit from
                // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
                }
                E.prototype = {
                    on: function(name, callback, ctx) {
                        var e = this.e || (this.e = {});
                        (e[name] || (e[name] = [])).push({
                            fn: callback,
                            ctx: ctx
                        });
                        return this;
                    },
                    once: function(name, callback, ctx) {
                        var self = this;
                        function listener() {
                            self.off(name, listener);
                            callback.apply(ctx, arguments);
                        }
                        listener._ = callback;
                        return this.on(name, listener, ctx);
                    },
                    emit: function(name) {
                        var data = [].slice.call(arguments, 1);
                        var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
                        var i = 0;
                        var len = evtArr.length;
                        for(i; i < len; i++)evtArr[i].fn.apply(evtArr[i].ctx, data);
                        return this;
                    },
                    off: function(name, callback) {
                        var e = this.e || (this.e = {});
                        var evts = e[name];
                        var liveEvents = [];
                        if (evts && callback) {
                            for(var i = 0, len = evts.length; i < len; i++)if (evts[i].fn !== callback && evts[i].fn._ !== callback) liveEvents.push(evts[i]);
                        }
                        // Remove event from queue to prevent memory leak
                        // Suggested by https://github.com/lazd
                        // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910
                        liveEvents.length ? e[name] = liveEvents : delete e[name];
                        return this;
                    }
                };
                module1.exports = E;
                module1.exports.TinyEmitter = E;
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ if (__webpack_module_cache__[moduleId]) /******/ return __webpack_module_cache__[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId](module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/compat get default export */ /******/ !function() {
            /******/ // getDefaultExport function for compatibility with non-harmony modules
            /******/ __webpack_require__.n = function(module1) {
                /******/ var getter = module1 && module1.__esModule ? /******/ function() {
                    return module1['default'];
                } : /******/ function() {
                    return module1;
                };
                /******/ __webpack_require__.d(getter, {
                    a: getter
                });
                /******/ return getter;
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/define property getters */ /******/ !function() {
            /******/ // define getter functions for harmony exports
            /******/ __webpack_require__.d = function(exports, definition) {
                /******/ for(var key in definition)/******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ !function() {
            /******/ __webpack_require__.o = function(obj, prop) {
                return Object.prototype.hasOwnProperty.call(obj, prop);
            };
        /******/ }();
        /******/ /************************************************************************/ /******/ // module exports must be returned from runtime so entry inlining is disabled
        /******/ // startup
        /******/ // Load entry module and return exports
        /******/ return __webpack_require__(686);
    /******/ }().default;
});


/**!
* tippy.js v6.3.7
* (c) 2017-2021 atomiks
* MIT License
*/ function $4f30cf0ce50e075e$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}


function $df9341392e6ed7b1$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $d98cb23738a6d9d0$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $d98cb23738a6d9d0$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $d98cb23738a6d9d0$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $83c1fc4c4e58d7dd$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element) || !(0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $83c1fc4c4e58d7dd$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element) || !(0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $83c1fc4c4e58d7dd$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $83c1fc4c4e58d7dd$var$applyStyles,
    effect: $83c1fc4c4e58d7dd$var$effect,
    requires: [
        'computeStyles'
    ]
};


var $7e23bad950468b82$export$8960430cfd85939f = Math.max;
var $7e23bad950468b82$export$96ec731ed4dcb222 = Math.min;
var $7e23bad950468b82$export$2077e0241d6afd3c = Math.round;



function $90ccbd5892233dd2$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $993d40d65cc118cd$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $90ccbd5892233dd2$export$2e2bcd8739ae039)());
}


function $84019ab652aa921b$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $7e23bad950468b82$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $7e23bad950468b82$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(element) ? (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $993d40d65cc118cd$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $68a584be1dc90596$export$2e2bcd8739ae039(node) {
    var win = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $9102221f9e13ae54$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $ca14c6927ef497ac$export$2e2bcd8739ae039(node) {
    if (node === (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node) || !(0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(node)) return (0, $68a584be1dc90596$export$2e2bcd8739ae039)(node);
    else return (0, $9102221f9e13ae54$export$2e2bcd8739ae039)(node);
}






function $433af39bc2fae35d$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $943aee5c7065ad53$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $84019ab652aa921b$export$2e2bcd8739ae039)((0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element)).left + (0, $68a584be1dc90596$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $41cae7042543c5d5$export$2e2bcd8739ae039(element) {
    return (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $18583dfdff147fd4$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $34abf65a06d63352$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $7e23bad950468b82$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $7e23bad950468b82$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $34abf65a06d63352$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(offsetParent) && $34abf65a06d63352$var$isElementScaled(offsetParent);
    var documentElement = (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $18583dfdff147fd4$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $ca14c6927ef497ac$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $943aee5c7065ad53$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $30ced62b744c6cfe$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $17f6a21d28fc02f5$export$2e2bcd8739ae039(element) {
    if ((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $d98cb23738a6d9d0$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $3eb5703c925e0e5d$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(node) && (0, $18583dfdff147fd4$export$2e2bcd8739ae039)(node)) return node;
    return $3eb5703c925e0e5d$export$2e2bcd8739ae039((0, $17f6a21d28fc02f5$export$2e2bcd8739ae039)(node));
}





function $a621d360f1a81b88$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $3eb5703c925e0e5d$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $18583dfdff147fd4$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($a621d360f1a81b88$export$2e2bcd8739ae039((0, $17f6a21d28fc02f5$export$2e2bcd8739ae039)(target)));
}







function $6829c22fb01dde5a$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(element)) >= 0;
}




function $a56b734280245ffb$var$getTrueOffsetParent(element) {
    if (!(0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $a56b734280245ffb$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $90ccbd5892233dd2$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $90ccbd5892233dd2$export$2e2bcd8739ae039)());
    if (isIE && (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $17f6a21d28fc02f5$export$2e2bcd8739ae039)(element);
    if ((0, $d98cb23738a6d9d0$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $a56b734280245ffb$export$2e2bcd8739ae039(element) {
    var window = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(element);
    var offsetParent = $a56b734280245ffb$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $6829c22fb01dde5a$export$2e2bcd8739ae039)(offsetParent) && (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $a56b734280245ffb$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $a56b734280245ffb$var$getContainingBlock(element) || window;
}


var $f5c54167a3c62105$export$1e95b668f3b82d = 'top';
var $f5c54167a3c62105$export$40e543e69a8b3fbb = 'bottom';
var $f5c54167a3c62105$export$79ffe56a765070d2 = 'right';
var $f5c54167a3c62105$export$eabcd2c8791e7bf4 = 'left';
var $f5c54167a3c62105$export$dfb5619354ba860 = 'auto';
var $f5c54167a3c62105$export$aec2ce47c367b8c3 = [
    $f5c54167a3c62105$export$1e95b668f3b82d,
    $f5c54167a3c62105$export$40e543e69a8b3fbb,
    $f5c54167a3c62105$export$79ffe56a765070d2,
    $f5c54167a3c62105$export$eabcd2c8791e7bf4
];
var $f5c54167a3c62105$export$b3571188c770cc5a = 'start';
var $f5c54167a3c62105$export$bd5df0f255a350f8 = 'end';
var $f5c54167a3c62105$export$390fd549c5303b4d = 'clippingParents';
var $f5c54167a3c62105$export$d7b7311ec04a3e8f = 'viewport';
var $f5c54167a3c62105$export$ae5ab1c730825774 = 'popper';
var $f5c54167a3c62105$export$ca50aac9f3ba507f = 'reference';
var $f5c54167a3c62105$export$368f9a87e87fa4e1 = /*#__PURE__*/ $f5c54167a3c62105$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $f5c54167a3c62105$export$b3571188c770cc5a,
        placement + "-" + $f5c54167a3c62105$export$bd5df0f255a350f8
    ]);
}, []);
var $f5c54167a3c62105$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($f5c54167a3c62105$export$aec2ce47c367b8c3, [
    $f5c54167a3c62105$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $f5c54167a3c62105$export$b3571188c770cc5a,
        placement + "-" + $f5c54167a3c62105$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $f5c54167a3c62105$export$421679a7c3d56e = 'beforeRead';
var $f5c54167a3c62105$export$aafa59e2e03f2942 = 'read';
var $f5c54167a3c62105$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $f5c54167a3c62105$export$c65e99957a05207c = 'beforeMain';
var $f5c54167a3c62105$export$f22da7240b7add18 = 'main';
var $f5c54167a3c62105$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $f5c54167a3c62105$export$8d4d2d70e7d46032 = 'beforeWrite';
var $f5c54167a3c62105$export$68d8715fc104d294 = 'write';
var $f5c54167a3c62105$export$70a6e5159acce2e6 = 'afterWrite';
var $f5c54167a3c62105$export$d087d3878fdf71d5 = [
    $f5c54167a3c62105$export$421679a7c3d56e,
    $f5c54167a3c62105$export$aafa59e2e03f2942,
    $f5c54167a3c62105$export$6964f6c886723980,
    $f5c54167a3c62105$export$c65e99957a05207c,
    $f5c54167a3c62105$export$f22da7240b7add18,
    $f5c54167a3c62105$export$bab79516f2d662fe,
    $f5c54167a3c62105$export$8d4d2d70e7d46032,
    $f5c54167a3c62105$export$68d8715fc104d294,
    $f5c54167a3c62105$export$70a6e5159acce2e6
];


function $0baf5472b5ad4a5a$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $0baf5472b5ad4a5a$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $0baf5472b5ad4a5a$var$order(modifiers); // order based on phase
    return (0, $f5c54167a3c62105$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $9b65b878009bf47f$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $46d929ffbbd3136a$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $b3c2fd6800546b4b$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $b3c2fd6800546b4b$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $b3c2fd6800546b4b$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $b3c2fd6800546b4b$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $b3c2fd6800546b4b$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(reference) ? (0, $a621d360f1a81b88$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $a621d360f1a81b88$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $a621d360f1a81b88$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $0baf5472b5ad4a5a$export$2e2bcd8739ae039)((0, $46d929ffbbd3136a$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$b3c2fd6800546b4b$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $34abf65a06d63352$export$2e2bcd8739ae039)(reference, (0, $a56b734280245ffb$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $30ced62b744c6cfe$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9b65b878009bf47f$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$b3c2fd6800546b4b$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $b3c2fd6800546b4b$export$8f7491d57c8f97a9 = /*#__PURE__*/ $b3c2fd6800546b4b$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $ff355aafd082b0cd$var$passive = {
    passive: true
};
function $ff355aafd082b0cd$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $ff355aafd082b0cd$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $ff355aafd082b0cd$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $ff355aafd082b0cd$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $ff355aafd082b0cd$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $ff355aafd082b0cd$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $ff355aafd082b0cd$var$effect,
    data: {}
};



function $afe288682115fde3$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $7b08f0526e425773$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $b518c35b71cf930f$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $03cba2f7a1498b5f$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $afe288682115fde3$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $7b08f0526e425773$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $f5c54167a3c62105$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $f5c54167a3c62105$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $f5c54167a3c62105$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $f5c54167a3c62105$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $b518c35b71cf930f$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $f5c54167a3c62105$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $f5c54167a3c62105$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $e92fb10df1450f31$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $03cba2f7a1498b5f$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $e92fb10df1450f31$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $e92fb10df1450f31$var$popperOffsets,
    data: {}
};










var $c8f8eadcf7685dc5$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $c8f8eadcf7685dc5$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $7e23bad950468b82$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $7e23bad950468b82$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $c8f8eadcf7685dc5$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4);
    var sideY = (0, $f5c54167a3c62105$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $a56b734280245ffb$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(popper);
            if ((0, $41cae7042543c5d5$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $f5c54167a3c62105$export$1e95b668f3b82d) || (placement === (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4) || placement === (0, $f5c54167a3c62105$export$79ffe56a765070d2)) && variation === (0, $f5c54167a3c62105$export$bd5df0f255a350f8)) {
            sideY = (0, $f5c54167a3c62105$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4) || (placement === (0, $f5c54167a3c62105$export$1e95b668f3b82d) || placement === (0, $f5c54167a3c62105$export$40e543e69a8b3fbb)) && variation === (0, $f5c54167a3c62105$export$bd5df0f255a350f8)) {
            sideX = (0, $f5c54167a3c62105$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $c8f8eadcf7685dc5$var$unsetSides);
    var _ref4 = roundOffsets === true ? $c8f8eadcf7685dc5$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $c8f8eadcf7685dc5$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $afe288682115fde3$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $7b08f0526e425773$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $c8f8eadcf7685dc5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $c8f8eadcf7685dc5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $c8f8eadcf7685dc5$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $c8f8eadcf7685dc5$var$computeStyles,
    data: {}
};





function $7c04da2e958a3fe8$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4),
        (0, $f5c54167a3c62105$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4),
        (0, $f5c54167a3c62105$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $7c04da2e958a3fe8$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $f5c54167a3c62105$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $7c04da2e958a3fe8$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $7c04da2e958a3fe8$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $7c04da2e958a3fe8$var$offset
};


var $825ae98fe4f5d029$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $825ae98fe4f5d029$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $825ae98fe4f5d029$var$hash[matched];
    });
}



var $76c023b5f4bd6339$var$hash = {
    start: 'end',
    end: 'start'
};
function $76c023b5f4bd6339$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $76c023b5f4bd6339$var$hash[matched];
    });
}







function $7b0a0ce1fa68929f$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(element);
    var html = (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $993d40d65cc118cd$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $943aee5c7065ad53$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $3e70615fb3e74824$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $68a584be1dc90596$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $7e23bad950468b82$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $7e23bad950468b82$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $943aee5c7065ad53$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $41cae7042543c5d5$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $7e23bad950468b82$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $d63950b756706495$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $d98cb23738a6d9d0$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $b0d5f0927fb8bf5c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $631049efb60e96c6$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $631049efb60e96c6$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $f5c54167a3c62105$export$d7b7311ec04a3e8f) ? (0, $b0d5f0927fb8bf5c$export$2e2bcd8739ae039)((0, $7b0a0ce1fa68929f$export$2e2bcd8739ae039)(element, strategy)) : (0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(clippingParent) ? $631049efb60e96c6$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $b0d5f0927fb8bf5c$export$2e2bcd8739ae039)((0, $3e70615fb3e74824$export$2e2bcd8739ae039)((0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $631049efb60e96c6$var$getClippingParents(element) {
    var clippingParents = (0, $a621d360f1a81b88$export$2e2bcd8739ae039)((0, $17f6a21d28fc02f5$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $41cae7042543c5d5$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element) ? (0, $a56b734280245ffb$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(clippingParent) && (0, $d63950b756706495$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $631049efb60e96c6$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $631049efb60e96c6$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $631049efb60e96c6$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $7e23bad950468b82$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $7e23bad950468b82$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $7e23bad950468b82$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $7e23bad950468b82$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $631049efb60e96c6$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $683c5e26d5f8bfe5$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $387b887da02b7e69$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $683c5e26d5f8bfe5$export$2e2bcd8739ae039)(), paddingObject);
}


function $4d11a6decde23bf9$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $f765731200b57f98$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $f5c54167a3c62105$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $f5c54167a3c62105$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $f5c54167a3c62105$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $387b887da02b7e69$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $4d11a6decde23bf9$export$2e2bcd8739ae039)(padding, (0, $f5c54167a3c62105$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $f5c54167a3c62105$export$ae5ab1c730825774) ? (0, $f5c54167a3c62105$export$ca50aac9f3ba507f) : (0, $f5c54167a3c62105$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $631049efb60e96c6$export$2e2bcd8739ae039)((0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $03cba2f7a1498b5f$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $b0d5f0927fb8bf5c$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $f5c54167a3c62105$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $f5c54167a3c62105$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $f5c54167a3c62105$export$79ffe56a765070d2),
                (0, $f5c54167a3c62105$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $f5c54167a3c62105$export$1e95b668f3b82d),
                (0, $f5c54167a3c62105$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $dbd70d4ba9902caa$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $f5c54167a3c62105$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $7b08f0526e425773$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $f5c54167a3c62105$export$368f9a87e87fa4e1) : (0, $f5c54167a3c62105$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $7b08f0526e425773$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $f5c54167a3c62105$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $afe288682115fde3$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $b1f32a1d9525a032$var$getExpandedFallbackPlacements(placement) {
    if ((0, $afe288682115fde3$export$2e2bcd8739ae039)(placement) === (0, $f5c54167a3c62105$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $825ae98fe4f5d029$export$2e2bcd8739ae039)(placement);
    return [
        (0, $76c023b5f4bd6339$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $76c023b5f4bd6339$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $b1f32a1d9525a032$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $825ae98fe4f5d029$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $b1f32a1d9525a032$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $afe288682115fde3$export$2e2bcd8739ae039)(placement) === (0, $f5c54167a3c62105$export$dfb5619354ba860) ? (0, $dbd70d4ba9902caa$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $7b08f0526e425773$export$2e2bcd8739ae039)(placement) === (0, $f5c54167a3c62105$export$b3571188c770cc5a);
        var isVertical = [
            (0, $f5c54167a3c62105$export$1e95b668f3b82d),
            (0, $f5c54167a3c62105$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $f5c54167a3c62105$export$79ffe56a765070d2) : (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $f5c54167a3c62105$export$40e543e69a8b3fbb) : (0, $f5c54167a3c62105$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $825ae98fe4f5d029$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $825ae98fe4f5d029$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $b1f32a1d9525a032$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $b1f32a1d9525a032$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $d8b68132b61080af$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}



function $b6f0b0266e764faa$export$f28d906d67a997f3(min, value, max) {
    return (0, $7e23bad950468b82$export$8960430cfd85939f)(min, (0, $7e23bad950468b82$export$96ec731ed4dcb222)(value, max));
}
function $b6f0b0266e764faa$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $b6f0b0266e764faa$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $3295dac8746ffe59$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $7b08f0526e425773$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $b518c35b71cf930f$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $d8b68132b61080af$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $f5c54167a3c62105$export$1e95b668f3b82d) : (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $f5c54167a3c62105$export$40e543e69a8b3fbb) : (0, $f5c54167a3c62105$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $f5c54167a3c62105$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $f5c54167a3c62105$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $30ced62b744c6cfe$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $683c5e26d5f8bfe5$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $b6f0b0266e764faa$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $a56b734280245ffb$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $b6f0b0266e764faa$export$f28d906d67a997f3)(tether ? (0, $7e23bad950468b82$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $7e23bad950468b82$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $f5c54167a3c62105$export$1e95b668f3b82d) : (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $f5c54167a3c62105$export$40e543e69a8b3fbb) : (0, $f5c54167a3c62105$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $f5c54167a3c62105$export$1e95b668f3b82d),
            (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $b6f0b0266e764faa$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $b6f0b0266e764faa$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $3295dac8746ffe59$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $3295dac8746ffe59$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};











var $1992f2d714808ab6$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $387b887da02b7e69$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $4d11a6decde23bf9$export$2e2bcd8739ae039)(padding, (0, $f5c54167a3c62105$export$aec2ce47c367b8c3)));
};
function $1992f2d714808ab6$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $b518c35b71cf930f$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4),
        (0, $f5c54167a3c62105$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $1992f2d714808ab6$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $30ced62b744c6cfe$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $f5c54167a3c62105$export$1e95b668f3b82d) : (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $f5c54167a3c62105$export$40e543e69a8b3fbb) : (0, $f5c54167a3c62105$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $a56b734280245ffb$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $b6f0b0266e764faa$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $1992f2d714808ab6$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $d63950b756706495$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $1992f2d714808ab6$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $1992f2d714808ab6$var$arrow,
    effect: $1992f2d714808ab6$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $174d14927bb4f43b$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $174d14927bb4f43b$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $f5c54167a3c62105$export$1e95b668f3b82d),
        (0, $f5c54167a3c62105$export$79ffe56a765070d2),
        (0, $f5c54167a3c62105$export$40e543e69a8b3fbb),
        (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $174d14927bb4f43b$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $174d14927bb4f43b$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $174d14927bb4f43b$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $174d14927bb4f43b$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $174d14927bb4f43b$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $174d14927bb4f43b$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $174d14927bb4f43b$var$hide
};




var $1bf0bf541303046d$export$d34966752335dd47 = [
    (0, $ff355aafd082b0cd$export$2e2bcd8739ae039),
    (0, $e92fb10df1450f31$export$2e2bcd8739ae039),
    (0, $c8f8eadcf7685dc5$export$2e2bcd8739ae039),
    (0, $83c1fc4c4e58d7dd$export$2e2bcd8739ae039),
    (0, $7c04da2e958a3fe8$export$2e2bcd8739ae039),
    (0, $b1f32a1d9525a032$export$2e2bcd8739ae039),
    (0, $3295dac8746ffe59$export$2e2bcd8739ae039),
    (0, $1992f2d714808ab6$export$2e2bcd8739ae039),
    (0, $174d14927bb4f43b$export$2e2bcd8739ae039)
];
var $1bf0bf541303046d$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $b3c2fd6800546b4b$export$ed5e13716264f202)({
    defaultModifiers: $1bf0bf541303046d$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


var $303963c61c829440$export$c96c811c44a42da5 = '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
var $303963c61c829440$var$BOX_CLASS = "tippy-box";
var $303963c61c829440$var$CONTENT_CLASS = "tippy-content";
var $303963c61c829440$var$BACKDROP_CLASS = "tippy-backdrop";
var $303963c61c829440$var$ARROW_CLASS = "tippy-arrow";
var $303963c61c829440$var$SVG_ARROW_CLASS = "tippy-svg-arrow";
var $303963c61c829440$var$TOUCH_OPTIONS = {
    passive: true,
    capture: true
};
var $303963c61c829440$var$TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
    return document.body;
};
function $303963c61c829440$var$hasOwnProperty(obj, key) {
    return ({}).hasOwnProperty.call(obj, key);
}
function $303963c61c829440$var$getValueAtIndexOrReturn(value, index, defaultValue) {
    if (Array.isArray(value)) {
        var v = value[index];
        return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
    }
    return value;
}
function $303963c61c829440$var$isType(value, type) {
    var str = ({}).toString.call(value);
    return str.indexOf('[object') === 0 && str.indexOf(type + "]") > -1;
}
function $303963c61c829440$var$invokeWithArgsOrReturn(value, args) {
    return typeof value === 'function' ? value.apply(void 0, args) : value;
}
function $303963c61c829440$var$debounce(fn, ms) {
    // Avoid wrapping in `setTimeout` if ms is 0 anyway
    if (ms === 0) return fn;
    var timeout;
    return function(arg) {
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            fn(arg);
        }, ms);
    };
}
function $303963c61c829440$var$removeProperties(obj, keys) {
    var clone = Object.assign({}, obj);
    keys.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}
function $303963c61c829440$var$splitBySpaces(value) {
    return value.split(/\s+/).filter(Boolean);
}
function $303963c61c829440$var$normalizeToArray(value) {
    return [].concat(value);
}
function $303963c61c829440$var$pushIfUnique(arr, value) {
    if (arr.indexOf(value) === -1) arr.push(value);
}
function $303963c61c829440$var$unique(arr) {
    return arr.filter(function(item, index) {
        return arr.indexOf(item) === index;
    });
}
function $303963c61c829440$var$getBasePlacement(placement) {
    return placement.split('-')[0];
}
function $303963c61c829440$var$arrayFrom(value) {
    return [].slice.call(value);
}
function $303963c61c829440$var$removeUndefinedProps(obj) {
    return Object.keys(obj).reduce(function(acc, key) {
        if (obj[key] !== undefined) acc[key] = obj[key];
        return acc;
    }, {});
}
function $303963c61c829440$var$div() {
    return document.createElement('div');
}
function $303963c61c829440$var$isElement(value) {
    return [
        'Element',
        'Fragment'
    ].some(function(type) {
        return $303963c61c829440$var$isType(value, type);
    });
}
function $303963c61c829440$var$isNodeList(value) {
    return $303963c61c829440$var$isType(value, 'NodeList');
}
function $303963c61c829440$var$isMouseEvent(value) {
    return $303963c61c829440$var$isType(value, 'MouseEvent');
}
function $303963c61c829440$var$isReferenceElement(value) {
    return !!(value && value._tippy && value._tippy.reference === value);
}
function $303963c61c829440$var$getArrayOfElements(value) {
    if ($303963c61c829440$var$isElement(value)) return [
        value
    ];
    if ($303963c61c829440$var$isNodeList(value)) return $303963c61c829440$var$arrayFrom(value);
    if (Array.isArray(value)) return value;
    return $303963c61c829440$var$arrayFrom(document.querySelectorAll(value));
}
function $303963c61c829440$var$setTransitionDuration(els, value) {
    els.forEach(function(el) {
        if (el) el.style.transitionDuration = value + "ms";
    });
}
function $303963c61c829440$var$setVisibilityState(els, state) {
    els.forEach(function(el) {
        if (el) el.setAttribute('data-state', state);
    });
}
function $303963c61c829440$var$getOwnerDocument(elementOrElements) {
    var _element$ownerDocumen;
    var _normalizeToArray = $303963c61c829440$var$normalizeToArray(elementOrElements), element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body
    return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
}
function $303963c61c829440$var$isCursorOutsideInteractiveBorder(popperTreeData, event) {
    var clientX = event.clientX, clientY = event.clientY;
    return popperTreeData.every(function(_ref) {
        var popperRect = _ref.popperRect, popperState = _ref.popperState, props = _ref.props;
        var interactiveBorder = props.interactiveBorder;
        var basePlacement = $303963c61c829440$var$getBasePlacement(popperState.placement);
        var offsetData = popperState.modifiersData.offset;
        if (!offsetData) return true;
        var topDistance = basePlacement === 'bottom' ? offsetData.top.y : 0;
        var bottomDistance = basePlacement === 'top' ? offsetData.bottom.y : 0;
        var leftDistance = basePlacement === 'right' ? offsetData.left.x : 0;
        var rightDistance = basePlacement === 'left' ? offsetData.right.x : 0;
        var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
        var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
        var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
        var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
        return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
    });
}
function $303963c61c829440$var$updateTransitionEndListener(box, action, listener) {
    var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
    // `webkitTransitionEnd`...
    [
        'transitionend',
        'webkitTransitionEnd'
    ].forEach(function(event) {
        box[method](event, listener);
    });
}
/**
 * Compared to xxx.contains, this function works for dom structures with shadow
 * dom
 */ function $303963c61c829440$var$actualContains(parent, child) {
    var target = child;
    while(target){
        var _target$getRootNode;
        if (parent.contains(target)) return true;
        target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
    }
    return false;
}
var $303963c61c829440$var$currentInput = {
    isTouch: false
};
var $303963c61c829440$var$lastMouseMoveTime = 0;
/**
 * When a `touchstart` event is fired, it's assumed the user is using touch
 * input. We'll bind a `mousemove` event listener to listen for mouse input in
 * the future. This way, the `isTouch` property is fully dynamic and will handle
 * hybrid devices that use a mix of touch + mouse input.
 */ function $303963c61c829440$var$onDocumentTouchStart() {
    if ($303963c61c829440$var$currentInput.isTouch) return;
    $303963c61c829440$var$currentInput.isTouch = true;
    if (window.performance) document.addEventListener('mousemove', $303963c61c829440$var$onDocumentMouseMove);
}
/**
 * When two `mousemove` event are fired consecutively within 20ms, it's assumed
 * the user is using mouse input again. `mousemove` can fire on touch devices as
 * well, but very rarely that quickly.
 */ function $303963c61c829440$var$onDocumentMouseMove() {
    var now = performance.now();
    if (now - $303963c61c829440$var$lastMouseMoveTime < 20) {
        $303963c61c829440$var$currentInput.isTouch = false;
        document.removeEventListener('mousemove', $303963c61c829440$var$onDocumentMouseMove);
    }
    $303963c61c829440$var$lastMouseMoveTime = now;
}
/**
 * When an element is in focus and has a tippy, leaving the tab/window and
 * returning causes it to show again. For mouse users this is unexpected, but
 * for keyboard use it makes sense.
 * TODO: find a better technique to solve this problem
 */ function $303963c61c829440$var$onWindowBlur() {
    var activeElement = document.activeElement;
    if ($303963c61c829440$var$isReferenceElement(activeElement)) {
        var instance = activeElement._tippy;
        if (activeElement.blur && !instance.state.isVisible) activeElement.blur();
    }
}
function $303963c61c829440$var$bindGlobalEventListeners() {
    document.addEventListener('touchstart', $303963c61c829440$var$onDocumentTouchStart, $303963c61c829440$var$TOUCH_OPTIONS);
    window.addEventListener('blur', $303963c61c829440$var$onWindowBlur);
}
var $303963c61c829440$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var $303963c61c829440$var$isIE11 = $303963c61c829440$var$isBrowser ? !!window.msCrypto : false;
function $303963c61c829440$var$createMemoryLeakWarning(method) {
    var txt = method === 'destroy' ? 'n already-' : ' ';
    return [
        method + "() was called on a" + txt + "destroyed instance. This is a no-op but",
        'indicates a potential memory leak.'
    ].join(' ');
}
function $303963c61c829440$var$clean(value) {
    var spacesAndTabs = /[ \t]{2,}/g;
    var lineStartWithSpaces = /^[ \t]*/gm;
    return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
}
function $303963c61c829440$var$getDevMessage(message) {
    return $303963c61c829440$var$clean("\n  %ctippy.js\n\n  %c" + $303963c61c829440$var$clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
}
function $303963c61c829440$var$getFormattedMessage(message) {
    return [
        $303963c61c829440$var$getDevMessage(message),
        'color: #00C584; font-size: 1.3em; font-weight: bold;',
        'line-height: 1.5',
        'color: #a6a095;'
    ];
} // Assume warnings and errors never have the same message
var $303963c61c829440$var$visitedMessages;
function $303963c61c829440$var$resetVisitedMessages() {
    $303963c61c829440$var$visitedMessages = new Set();
}
function $303963c61c829440$var$warnWhen(condition, message) {
    if (condition && !$303963c61c829440$var$visitedMessages.has(message)) {
        var _console;
        $303963c61c829440$var$visitedMessages.add(message);
        (_console = console).warn.apply(_console, $303963c61c829440$var$getFormattedMessage(message));
    }
}
function $303963c61c829440$var$errorWhen(condition, message) {
    if (condition && !$303963c61c829440$var$visitedMessages.has(message)) {
        var _console2;
        $303963c61c829440$var$visitedMessages.add(message);
        (_console2 = console).error.apply(_console2, $303963c61c829440$var$getFormattedMessage(message));
    }
}
function $303963c61c829440$var$validateTargets(targets) {
    var didPassFalsyValue = !targets;
    var didPassPlainObject = Object.prototype.toString.call(targets) === '[object Object]' && !targets.addEventListener;
    $303963c61c829440$var$errorWhen(didPassFalsyValue, [
        'tippy() was passed',
        '`' + String(targets) + '`',
        'as its targets (first) argument. Valid types are: String, Element,',
        'Element[], or NodeList.'
    ].join(' '));
    $303963c61c829440$var$errorWhen(didPassPlainObject, [
        'tippy() was passed a plain object which is not supported as an argument',
        'for virtual positioning. Use props.getReferenceClientRect instead.'
    ].join(' '));
}
var $303963c61c829440$var$pluginProps = {
    animateFill: false,
    followCursor: false,
    inlinePositioning: false,
    sticky: false
};
var $303963c61c829440$var$renderProps = {
    allowHTML: false,
    animation: 'fade',
    arrow: true,
    content: '',
    inertia: false,
    maxWidth: 350,
    role: 'tooltip',
    theme: '',
    zIndex: 9999
};
var $303963c61c829440$var$defaultProps = Object.assign({
    appendTo: $303963c61c829440$var$TIPPY_DEFAULT_APPEND_TO,
    aria: {
        content: 'auto',
        expanded: 'auto'
    },
    delay: 0,
    duration: [
        300,
        250
    ],
    getReferenceClientRect: null,
    hideOnClick: true,
    ignoreAttributes: false,
    interactive: false,
    interactiveBorder: 2,
    interactiveDebounce: 0,
    moveTransition: '',
    offset: [
        0,
        10
    ],
    onAfterUpdate: function onAfterUpdate() {},
    onBeforeUpdate: function onBeforeUpdate() {},
    onCreate: function onCreate() {},
    onDestroy: function onDestroy() {},
    onHidden: function onHidden() {},
    onHide: function onHide() {},
    onMount: function onMount() {},
    onShow: function onShow() {},
    onShown: function onShown() {},
    onTrigger: function onTrigger() {},
    onUntrigger: function onUntrigger() {},
    onClickOutside: function onClickOutside() {},
    placement: 'top',
    plugins: [],
    popperOptions: {},
    render: null,
    showOnCreate: false,
    touch: true,
    trigger: 'mouseenter focus',
    triggerTarget: null
}, $303963c61c829440$var$pluginProps, $303963c61c829440$var$renderProps);
var $303963c61c829440$var$defaultKeys = Object.keys($303963c61c829440$var$defaultProps);
var $303963c61c829440$var$setDefaultProps = function setDefaultProps(partialProps) {
    var keys = Object.keys(partialProps);
    keys.forEach(function(key) {
        $303963c61c829440$var$defaultProps[key] = partialProps[key];
    });
};
function $303963c61c829440$var$getExtendedPassedProps(passedProps) {
    var plugins = passedProps.plugins || [];
    var pluginProps = plugins.reduce(function(acc, plugin) {
        var name = plugin.name, defaultValue = plugin.defaultValue;
        if (name) {
            var _name;
            acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = $303963c61c829440$var$defaultProps[name]) != null ? _name : defaultValue;
        }
        return acc;
    }, {});
    return Object.assign({}, passedProps, pluginProps);
}
function $303963c61c829440$var$getDataAttributeProps(reference, plugins) {
    var propKeys = plugins ? Object.keys($303963c61c829440$var$getExtendedPassedProps(Object.assign({}, $303963c61c829440$var$defaultProps, {
        plugins: plugins
    }))) : $303963c61c829440$var$defaultKeys;
    var props = propKeys.reduce(function(acc, key) {
        var valueAsString = (reference.getAttribute("data-tippy-" + key) || '').trim();
        if (!valueAsString) return acc;
        if (key === 'content') acc[key] = valueAsString;
        else try {
            acc[key] = JSON.parse(valueAsString);
        } catch (e) {
            acc[key] = valueAsString;
        }
        return acc;
    }, {});
    return props;
}
function $303963c61c829440$var$evaluateProps(reference, props) {
    var out = Object.assign({}, props, {
        content: $303963c61c829440$var$invokeWithArgsOrReturn(props.content, [
            reference
        ])
    }, props.ignoreAttributes ? {} : $303963c61c829440$var$getDataAttributeProps(reference, props.plugins));
    out.aria = Object.assign({}, $303963c61c829440$var$defaultProps.aria, out.aria);
    out.aria = {
        expanded: out.aria.expanded === 'auto' ? props.interactive : out.aria.expanded,
        content: out.aria.content === 'auto' ? props.interactive ? null : 'describedby' : out.aria.content
    };
    return out;
}
function $303963c61c829440$var$validateProps(partialProps, plugins) {
    if (partialProps === void 0) partialProps = {};
    if (plugins === void 0) plugins = [];
    var keys = Object.keys(partialProps);
    keys.forEach(function(prop) {
        var nonPluginProps = $303963c61c829440$var$removeProperties($303963c61c829440$var$defaultProps, Object.keys($303963c61c829440$var$pluginProps));
        var didPassUnknownProp = !$303963c61c829440$var$hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`
        if (didPassUnknownProp) didPassUnknownProp = plugins.filter(function(plugin) {
            return plugin.name === prop;
        }).length === 0;
        $303963c61c829440$var$warnWhen(didPassUnknownProp, [
            "`" + prop + "`",
            "is not a valid prop. You may have spelled it incorrectly, or if it's",
            'a plugin, forgot to pass it in an array as props.plugins.',
            '\n\n',
            'All props: https://atomiks.github.io/tippyjs/v6/all-props/\n',
            'Plugins: https://atomiks.github.io/tippyjs/v6/plugins/'
        ].join(' '));
    });
}
var $303963c61c829440$var$innerHTML = function innerHTML() {
    return 'innerHTML';
};
function $303963c61c829440$var$dangerouslySetInnerHTML(element, html) {
    element[$303963c61c829440$var$innerHTML()] = html;
}
function $303963c61c829440$var$createArrowElement(value) {
    var arrow = $303963c61c829440$var$div();
    if (value === true) arrow.className = $303963c61c829440$var$ARROW_CLASS;
    else {
        arrow.className = $303963c61c829440$var$SVG_ARROW_CLASS;
        if ($303963c61c829440$var$isElement(value)) arrow.appendChild(value);
        else $303963c61c829440$var$dangerouslySetInnerHTML(arrow, value);
    }
    return arrow;
}
function $303963c61c829440$var$setContent(content, props) {
    if ($303963c61c829440$var$isElement(props.content)) {
        $303963c61c829440$var$dangerouslySetInnerHTML(content, '');
        content.appendChild(props.content);
    } else if (typeof props.content !== 'function') {
        if (props.allowHTML) $303963c61c829440$var$dangerouslySetInnerHTML(content, props.content);
        else content.textContent = props.content;
    }
}
function $303963c61c829440$var$getChildren(popper) {
    var box = popper.firstElementChild;
    var boxChildren = $303963c61c829440$var$arrayFrom(box.children);
    return {
        box: box,
        content: boxChildren.find(function(node) {
            return node.classList.contains($303963c61c829440$var$CONTENT_CLASS);
        }),
        arrow: boxChildren.find(function(node) {
            return node.classList.contains($303963c61c829440$var$ARROW_CLASS) || node.classList.contains($303963c61c829440$var$SVG_ARROW_CLASS);
        }),
        backdrop: boxChildren.find(function(node) {
            return node.classList.contains($303963c61c829440$var$BACKDROP_CLASS);
        })
    };
}
function $303963c61c829440$var$render(instance) {
    var popper = $303963c61c829440$var$div();
    var box = $303963c61c829440$var$div();
    box.className = $303963c61c829440$var$BOX_CLASS;
    box.setAttribute('data-state', 'hidden');
    box.setAttribute('tabindex', '-1');
    var content = $303963c61c829440$var$div();
    content.className = $303963c61c829440$var$CONTENT_CLASS;
    content.setAttribute('data-state', 'hidden');
    $303963c61c829440$var$setContent(content, instance.props);
    popper.appendChild(box);
    box.appendChild(content);
    onUpdate(instance.props, instance.props);
    function onUpdate(prevProps, nextProps) {
        var _getChildren = $303963c61c829440$var$getChildren(popper), box = _getChildren.box, content = _getChildren.content, arrow = _getChildren.arrow;
        if (nextProps.theme) box.setAttribute('data-theme', nextProps.theme);
        else box.removeAttribute('data-theme');
        if (typeof nextProps.animation === 'string') box.setAttribute('data-animation', nextProps.animation);
        else box.removeAttribute('data-animation');
        if (nextProps.inertia) box.setAttribute('data-inertia', '');
        else box.removeAttribute('data-inertia');
        box.style.maxWidth = typeof nextProps.maxWidth === 'number' ? nextProps.maxWidth + "px" : nextProps.maxWidth;
        if (nextProps.role) box.setAttribute('role', nextProps.role);
        else box.removeAttribute('role');
        if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) $303963c61c829440$var$setContent(content, instance.props);
        if (nextProps.arrow) {
            if (!arrow) box.appendChild($303963c61c829440$var$createArrowElement(nextProps.arrow));
            else if (prevProps.arrow !== nextProps.arrow) {
                box.removeChild(arrow);
                box.appendChild($303963c61c829440$var$createArrowElement(nextProps.arrow));
            }
        } else if (arrow) box.removeChild(arrow);
    }
    return {
        popper: popper,
        onUpdate: onUpdate
    };
} // Runtime check to identify if the render function is the default one; this
// way we can apply default CSS transitions logic and it can be tree-shaken away
$303963c61c829440$var$render.$$tippy = true;
var $303963c61c829440$var$idCounter = 1;
var $303963c61c829440$var$mouseMoveListeners = []; // Used by `hideAll()`
var $303963c61c829440$var$mountedInstances = [];
function $303963c61c829440$var$createTippy(reference, passedProps) {
    var props = $303963c61c829440$var$evaluateProps(reference, Object.assign({}, $303963c61c829440$var$defaultProps, $303963c61c829440$var$getExtendedPassedProps($303963c61c829440$var$removeUndefinedProps(passedProps)))); // ===========================================================================
    // 🔒 Private members
    // ===========================================================================
    var showTimeout;
    var hideTimeout;
    var scheduleHideAnimationFrame;
    var isVisibleFromClick = false;
    var didHideDueToDocumentMouseDown = false;
    var didTouchMove = false;
    var ignoreOnFirstUpdate = false;
    var lastTriggerEvent;
    var currentTransitionEndListener;
    var onFirstUpdate;
    var listeners = [];
    var debouncedOnMouseMove = $303963c61c829440$var$debounce(onMouseMove, props.interactiveDebounce);
    var currentTarget; // ===========================================================================
    // 🔑 Public members
    // ===========================================================================
    var id = $303963c61c829440$var$idCounter++;
    var popperInstance = null;
    var plugins = $303963c61c829440$var$unique(props.plugins);
    var state = {
        // Is the instance currently enabled?
        isEnabled: true,
        // Is the tippy currently showing and not transitioning out?
        isVisible: false,
        // Has the instance been destroyed?
        isDestroyed: false,
        // Is the tippy currently mounted to the DOM?
        isMounted: false,
        // Has the tippy finished transitioning in?
        isShown: false
    };
    var instance = {
        // properties
        id: id,
        reference: reference,
        popper: $303963c61c829440$var$div(),
        popperInstance: popperInstance,
        props: props,
        state: state,
        plugins: plugins,
        // methods
        clearDelayTimeouts: clearDelayTimeouts,
        setProps: setProps,
        setContent: setContent,
        show: show,
        hide: hide,
        hideWithInteractivity: hideWithInteractivity,
        enable: enable,
        disable: disable,
        unmount: unmount,
        destroy: destroy
    }; // TODO: Investigate why this early return causes a TDZ error in the tests —
    // it doesn't seem to happen in the browser
    /* istanbul ignore if */ if (!props.render) return instance;
     // ===========================================================================
    // Initial mutations
    // ===========================================================================
    var _props$render = props.render(instance), popper = _props$render.popper, onUpdate = _props$render.onUpdate;
    popper.setAttribute('data-tippy-root', '');
    popper.id = "tippy-" + instance.id;
    instance.popper = popper;
    reference._tippy = instance;
    popper._tippy = instance;
    var pluginsHooks = plugins.map(function(plugin) {
        return plugin.fn(instance);
    });
    var hasAriaExpanded = reference.hasAttribute('aria-expanded');
    addListeners();
    handleAriaExpandedAttribute();
    handleStyles();
    invokeHook('onCreate', [
        instance
    ]);
    if (props.showOnCreate) scheduleShow();
     // Prevent a tippy with a delay from hiding if the cursor left then returned
    // before it started hiding
    popper.addEventListener('mouseenter', function() {
        if (instance.props.interactive && instance.state.isVisible) instance.clearDelayTimeouts();
    });
    popper.addEventListener('mouseleave', function() {
        if (instance.props.interactive && instance.props.trigger.indexOf('mouseenter') >= 0) getDocument().addEventListener('mousemove', debouncedOnMouseMove);
    });
    return instance; // ===========================================================================
    // 🔒 Private methods
    // ===========================================================================
    function getNormalizedTouchSettings() {
        var touch = instance.props.touch;
        return Array.isArray(touch) ? touch : [
            touch,
            0
        ];
    }
    function getIsCustomTouchBehavior() {
        return getNormalizedTouchSettings()[0] === 'hold';
    }
    function getIsDefaultRenderFn() {
        var _instance$props$rende;
        // @ts-ignore
        return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
    }
    function getCurrentTarget() {
        return currentTarget || reference;
    }
    function getDocument() {
        var parent = getCurrentTarget().parentNode;
        return parent ? $303963c61c829440$var$getOwnerDocument(parent) : document;
    }
    function getDefaultTemplateChildren() {
        return $303963c61c829440$var$getChildren(popper);
    }
    function getDelay(isShow) {
        // For touch or keyboard input, force `0` delay for UX reasons
        // Also if the instance is mounted but not visible (transitioning out),
        // ignore delay
        if (instance.state.isMounted && !instance.state.isVisible || $303963c61c829440$var$currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === 'focus') return 0;
        return $303963c61c829440$var$getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, $303963c61c829440$var$defaultProps.delay);
    }
    function handleStyles(fromHide) {
        if (fromHide === void 0) fromHide = false;
        popper.style.pointerEvents = instance.props.interactive && !fromHide ? '' : 'none';
        popper.style.zIndex = "" + instance.props.zIndex;
    }
    function invokeHook(hook, args, shouldInvokePropsHook) {
        if (shouldInvokePropsHook === void 0) shouldInvokePropsHook = true;
        pluginsHooks.forEach(function(pluginHooks) {
            if (pluginHooks[hook]) pluginHooks[hook].apply(pluginHooks, args);
        });
        if (shouldInvokePropsHook) {
            var _instance$props;
            (_instance$props = instance.props)[hook].apply(_instance$props, args);
        }
    }
    function handleAriaContentAttribute() {
        var aria = instance.props.aria;
        if (!aria.content) return;
        var attr = "aria-" + aria.content;
        var id = popper.id;
        var nodes = $303963c61c829440$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            var currentValue = node.getAttribute(attr);
            if (instance.state.isVisible) node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
            else {
                var nextValue = currentValue && currentValue.replace(id, '').trim();
                if (nextValue) node.setAttribute(attr, nextValue);
                else node.removeAttribute(attr);
            }
        });
    }
    function handleAriaExpandedAttribute() {
        if (hasAriaExpanded || !instance.props.aria.expanded) return;
        var nodes = $303963c61c829440$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            if (instance.props.interactive) node.setAttribute('aria-expanded', instance.state.isVisible && node === getCurrentTarget() ? 'true' : 'false');
            else node.removeAttribute('aria-expanded');
        });
    }
    function cleanupInteractiveMouseListeners() {
        getDocument().removeEventListener('mousemove', debouncedOnMouseMove);
        $303963c61c829440$var$mouseMoveListeners = $303963c61c829440$var$mouseMoveListeners.filter(function(listener) {
            return listener !== debouncedOnMouseMove;
        });
    }
    function onDocumentPress(event) {
        // Moved finger to scroll instead of an intentional tap outside
        if ($303963c61c829440$var$currentInput.isTouch) {
            if (didTouchMove || event.type === 'mousedown') return;
        }
        var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper
        if (instance.props.interactive && $303963c61c829440$var$actualContains(popper, actualTarget)) return;
         // Clicked on the event listeners target
        if ($303963c61c829440$var$normalizeToArray(instance.props.triggerTarget || reference).some(function(el) {
            return $303963c61c829440$var$actualContains(el, actualTarget);
        })) {
            if ($303963c61c829440$var$currentInput.isTouch) return;
            if (instance.state.isVisible && instance.props.trigger.indexOf('click') >= 0) return;
        } else invokeHook('onClickOutside', [
            instance,
            event
        ]);
        if (instance.props.hideOnClick === true) {
            instance.clearDelayTimeouts();
            instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
            // currentTarget. This lets a tippy with `focus` trigger know that it
            // should not show
            didHideDueToDocumentMouseDown = true;
            setTimeout(function() {
                didHideDueToDocumentMouseDown = false;
            }); // The listener gets added in `scheduleShow()`, but this may be hiding it
            // before it shows, and hide()'s early bail-out behavior can prevent it
            // from being cleaned up
            if (!instance.state.isMounted) removeDocumentPress();
        }
    }
    function onTouchMove() {
        didTouchMove = true;
    }
    function onTouchStart() {
        didTouchMove = false;
    }
    function addDocumentPress() {
        var doc = getDocument();
        doc.addEventListener('mousedown', onDocumentPress, true);
        doc.addEventListener('touchend', onDocumentPress, $303963c61c829440$var$TOUCH_OPTIONS);
        doc.addEventListener('touchstart', onTouchStart, $303963c61c829440$var$TOUCH_OPTIONS);
        doc.addEventListener('touchmove', onTouchMove, $303963c61c829440$var$TOUCH_OPTIONS);
    }
    function removeDocumentPress() {
        var doc = getDocument();
        doc.removeEventListener('mousedown', onDocumentPress, true);
        doc.removeEventListener('touchend', onDocumentPress, $303963c61c829440$var$TOUCH_OPTIONS);
        doc.removeEventListener('touchstart', onTouchStart, $303963c61c829440$var$TOUCH_OPTIONS);
        doc.removeEventListener('touchmove', onTouchMove, $303963c61c829440$var$TOUCH_OPTIONS);
    }
    function onTransitionedOut(duration, callback) {
        onTransitionEnd(duration, function() {
            if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) callback();
        });
    }
    function onTransitionedIn(duration, callback) {
        onTransitionEnd(duration, callback);
    }
    function onTransitionEnd(duration, callback) {
        var box = getDefaultTemplateChildren().box;
        function listener(event) {
            if (event.target === box) {
                $303963c61c829440$var$updateTransitionEndListener(box, 'remove', listener);
                callback();
            }
        } // Make callback synchronous if duration is 0
        // `transitionend` won't fire otherwise
        if (duration === 0) return callback();
        $303963c61c829440$var$updateTransitionEndListener(box, 'remove', currentTransitionEndListener);
        $303963c61c829440$var$updateTransitionEndListener(box, 'add', listener);
        currentTransitionEndListener = listener;
    }
    function on(eventType, handler, options) {
        if (options === void 0) options = false;
        var nodes = $303963c61c829440$var$normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            node.addEventListener(eventType, handler, options);
            listeners.push({
                node: node,
                eventType: eventType,
                handler: handler,
                options: options
            });
        });
    }
    function addListeners() {
        if (getIsCustomTouchBehavior()) {
            on('touchstart', onTrigger, {
                passive: true
            });
            on('touchend', onMouseLeave, {
                passive: true
            });
        }
        $303963c61c829440$var$splitBySpaces(instance.props.trigger).forEach(function(eventType) {
            if (eventType === 'manual') return;
            on(eventType, onTrigger);
            switch(eventType){
                case 'mouseenter':
                    on('mouseleave', onMouseLeave);
                    break;
                case 'focus':
                    on($303963c61c829440$var$isIE11 ? 'focusout' : 'blur', onBlurOrFocusOut);
                    break;
                case 'focusin':
                    on('focusout', onBlurOrFocusOut);
                    break;
            }
        });
    }
    function removeListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function onTrigger(event) {
        var _lastTriggerEvent;
        var shouldScheduleClickHide = false;
        if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) return;
        var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === 'focus';
        lastTriggerEvent = event;
        currentTarget = event.currentTarget;
        handleAriaExpandedAttribute();
        if (!instance.state.isVisible && $303963c61c829440$var$isMouseEvent(event)) // If scrolling, `mouseenter` events can be fired if the cursor lands
        // over a new target, but `mousemove` events don't get fired. This
        // causes interactive tooltips to get stuck open until the cursor is
        // moved
        $303963c61c829440$var$mouseMoveListeners.forEach(function(listener) {
            return listener(event);
        });
         // Toggle show/hide when clicking click-triggered tooltips
        if (event.type === 'click' && (instance.props.trigger.indexOf('mouseenter') < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) shouldScheduleClickHide = true;
        else scheduleShow(event);
        if (event.type === 'click') isVisibleFromClick = !shouldScheduleClickHide;
        if (shouldScheduleClickHide && !wasFocused) scheduleHide(event);
    }
    function onMouseMove(event) {
        var target = event.target;
        var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);
        if (event.type === 'mousemove' && isCursorOverReferenceOrPopper) return;
        var popperTreeData = getNestedPopperTree().concat(popper).map(function(popper) {
            var _instance$popperInsta;
            var instance = popper._tippy;
            var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;
            if (state) return {
                popperRect: popper.getBoundingClientRect(),
                popperState: state,
                props: props
            };
            return null;
        }).filter(Boolean);
        if ($303963c61c829440$var$isCursorOutsideInteractiveBorder(popperTreeData, event)) {
            cleanupInteractiveMouseListeners();
            scheduleHide(event);
        }
    }
    function onMouseLeave(event) {
        var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf('click') >= 0 && isVisibleFromClick;
        if (shouldBail) return;
        if (instance.props.interactive) {
            instance.hideWithInteractivity(event);
            return;
        }
        scheduleHide(event);
    }
    function onBlurOrFocusOut(event) {
        if (instance.props.trigger.indexOf('focusin') < 0 && event.target !== getCurrentTarget()) return;
         // If focus was moved to within the popper
        if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) return;
        scheduleHide(event);
    }
    function isEventListenerStopped(event) {
        return $303963c61c829440$var$currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf('touch') >= 0 : false;
    }
    function createPopperInstance() {
        destroyPopperInstance();
        var _instance$props2 = instance.props, popperOptions = _instance$props2.popperOptions, placement = _instance$props2.placement, offset = _instance$props2.offset, getReferenceClientRect = _instance$props2.getReferenceClientRect, moveTransition = _instance$props2.moveTransition;
        var arrow = getIsDefaultRenderFn() ? $303963c61c829440$var$getChildren(popper).arrow : null;
        var computedReference = getReferenceClientRect ? {
            getBoundingClientRect: getReferenceClientRect,
            contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
        } : reference;
        var tippyModifier = {
            name: '$$tippy',
            enabled: true,
            phase: 'beforeWrite',
            requires: [
                'computeStyles'
            ],
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (getIsDefaultRenderFn()) {
                    var _getDefaultTemplateCh = getDefaultTemplateChildren(), box = _getDefaultTemplateCh.box;
                    [
                        'placement',
                        'reference-hidden',
                        'escaped'
                    ].forEach(function(attr) {
                        if (attr === 'placement') box.setAttribute('data-placement', state.placement);
                        else if (state.attributes.popper["data-popper-" + attr]) box.setAttribute("data-" + attr, '');
                        else box.removeAttribute("data-" + attr);
                    });
                    state.attributes.popper = {};
                }
            }
        };
        var modifiers = [
            {
                name: 'offset',
                options: {
                    offset: offset
                }
            },
            {
                name: 'preventOverflow',
                options: {
                    padding: {
                        top: 2,
                        bottom: 2,
                        left: 5,
                        right: 5
                    }
                }
            },
            {
                name: 'flip',
                options: {
                    padding: 5
                }
            },
            {
                name: 'computeStyles',
                options: {
                    adaptive: !moveTransition
                }
            },
            tippyModifier
        ];
        if (getIsDefaultRenderFn() && arrow) modifiers.push({
            name: 'arrow',
            options: {
                element: arrow,
                padding: 3
            }
        });
        modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
        instance.popperInstance = (0, $1bf0bf541303046d$export$8f7491d57c8f97a9)(computedReference, popper, Object.assign({}, popperOptions, {
            placement: placement,
            onFirstUpdate: onFirstUpdate,
            modifiers: modifiers
        }));
    }
    function destroyPopperInstance() {
        if (instance.popperInstance) {
            instance.popperInstance.destroy();
            instance.popperInstance = null;
        }
    }
    function mount() {
        var appendTo = instance.props.appendTo;
        var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
        // it's directly after the reference element so the elements inside the
        // tippy can be tabbed to
        // If there are clipping issues, the user can specify a different appendTo
        // and ensure focus management is handled correctly manually
        var node = getCurrentTarget();
        if (instance.props.interactive && appendTo === $303963c61c829440$var$TIPPY_DEFAULT_APPEND_TO || appendTo === 'parent') parentNode = node.parentNode;
        else parentNode = $303963c61c829440$var$invokeWithArgsOrReturn(appendTo, [
            node
        ]);
         // The popper element needs to exist on the DOM before its position can be
        // updated as Popper needs to read its dimensions
        if (!parentNode.contains(popper)) parentNode.appendChild(popper);
        instance.state.isMounted = true;
        createPopperInstance();
    }
    function getNestedPopperTree() {
        return $303963c61c829440$var$arrayFrom(popper.querySelectorAll('[data-tippy-root]'));
    }
    function scheduleShow(event) {
        instance.clearDelayTimeouts();
        if (event) invokeHook('onTrigger', [
            instance,
            event
        ]);
        addDocumentPress();
        var delay = getDelay(true);
        var _getNormalizedTouchSe = getNormalizedTouchSettings(), touchValue = _getNormalizedTouchSe[0], touchDelay = _getNormalizedTouchSe[1];
        if ($303963c61c829440$var$currentInput.isTouch && touchValue === 'hold' && touchDelay) delay = touchDelay;
        if (delay) showTimeout = setTimeout(function() {
            instance.show();
        }, delay);
        else instance.show();
    }
    function scheduleHide(event) {
        instance.clearDelayTimeouts();
        invokeHook('onUntrigger', [
            instance,
            event
        ]);
        if (!instance.state.isVisible) {
            removeDocumentPress();
            return;
        } // For interactive tippies, scheduleHide is added to a document.body handler
        // from onMouseLeave so must intercept scheduled hides from mousemove/leave
        // events when trigger contains mouseenter and click, and the tip is
        // currently shown as a result of a click.
        if (instance.props.trigger.indexOf('mouseenter') >= 0 && instance.props.trigger.indexOf('click') >= 0 && [
            'mouseleave',
            'mousemove'
        ].indexOf(event.type) >= 0 && isVisibleFromClick) return;
        var delay = getDelay(false);
        if (delay) hideTimeout = setTimeout(function() {
            if (instance.state.isVisible) instance.hide();
        }, delay);
        else // Fixes a `transitionend` problem when it fires 1 frame too
        // late sometimes, we don't want hide() to be called.
        scheduleHideAnimationFrame = requestAnimationFrame(function() {
            instance.hide();
        });
    } // ===========================================================================
    // 🔑 Public methods
    // ===========================================================================
    function enable() {
        instance.state.isEnabled = true;
    }
    function disable() {
        // Disabling the instance should also hide it
        // https://github.com/atomiks/tippy.js-react/issues/106
        instance.hide();
        instance.state.isEnabled = false;
    }
    function clearDelayTimeouts() {
        clearTimeout(showTimeout);
        clearTimeout(hideTimeout);
        cancelAnimationFrame(scheduleHideAnimationFrame);
    }
    function setProps(partialProps) {
        if (instance.state.isDestroyed) return;
        invokeHook('onBeforeUpdate', [
            instance,
            partialProps
        ]);
        removeListeners();
        var prevProps = instance.props;
        var nextProps = $303963c61c829440$var$evaluateProps(reference, Object.assign({}, prevProps, $303963c61c829440$var$removeUndefinedProps(partialProps), {
            ignoreAttributes: true
        }));
        instance.props = nextProps;
        addListeners();
        if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
            cleanupInteractiveMouseListeners();
            debouncedOnMouseMove = $303963c61c829440$var$debounce(onMouseMove, nextProps.interactiveDebounce);
        } // Ensure stale aria-expanded attributes are removed
        if (prevProps.triggerTarget && !nextProps.triggerTarget) $303963c61c829440$var$normalizeToArray(prevProps.triggerTarget).forEach(function(node) {
            node.removeAttribute('aria-expanded');
        });
        else if (nextProps.triggerTarget) reference.removeAttribute('aria-expanded');
        handleAriaExpandedAttribute();
        handleStyles();
        if (onUpdate) onUpdate(prevProps, nextProps);
        if (instance.popperInstance) {
            createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
            // and the nested ones get re-rendered first.
            // https://github.com/atomiks/tippyjs-react/issues/177
            // TODO: find a cleaner / more efficient solution(!)
            getNestedPopperTree().forEach(function(nestedPopper) {
                // React (and other UI libs likely) requires a rAF wrapper as it flushes
                // its work in one
                requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
            });
        }
        invokeHook('onAfterUpdate', [
            instance,
            partialProps
        ]);
    }
    function setContent(content) {
        instance.setProps({
            content: content
        });
    }
    function show() {
        var isAlreadyVisible = instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var isTouchAndTouchDisabled = $303963c61c829440$var$currentInput.isTouch && !instance.props.touch;
        var duration = $303963c61c829440$var$getValueAtIndexOrReturn(instance.props.duration, 0, $303963c61c829440$var$defaultProps.duration);
        if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) return;
         // Normalize `disabled` behavior across browsers.
        // Firefox allows events on disabled elements, but Chrome doesn't.
        // Using a wrapper element (i.e. <span>) is recommended.
        if (getCurrentTarget().hasAttribute('disabled')) return;
        invokeHook('onShow', [
            instance
        ], false);
        if (instance.props.onShow(instance) === false) return;
        instance.state.isVisible = true;
        if (getIsDefaultRenderFn()) popper.style.visibility = 'visible';
        handleStyles();
        addDocumentPress();
        if (!instance.state.isMounted) popper.style.transition = 'none';
         // If flipping to the opposite side after hiding at least once, the
        // animation will use the wrong placement without resetting the duration
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh2 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh2.box, content = _getDefaultTemplateCh2.content;
            $303963c61c829440$var$setTransitionDuration([
                box,
                content
            ], 0);
        }
        onFirstUpdate = function onFirstUpdate() {
            var _instance$popperInsta2;
            if (!instance.state.isVisible || ignoreOnFirstUpdate) return;
            ignoreOnFirstUpdate = true; // reflow
            popper.offsetHeight;
            popper.style.transition = instance.props.moveTransition;
            if (getIsDefaultRenderFn() && instance.props.animation) {
                var _getDefaultTemplateCh3 = getDefaultTemplateChildren(), _box = _getDefaultTemplateCh3.box, _content = _getDefaultTemplateCh3.content;
                $303963c61c829440$var$setTransitionDuration([
                    _box,
                    _content
                ], duration);
                $303963c61c829440$var$setVisibilityState([
                    _box,
                    _content
                ], 'visible');
            }
            handleAriaContentAttribute();
            handleAriaExpandedAttribute();
            $303963c61c829440$var$pushIfUnique($303963c61c829440$var$mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
            // popper has been positioned for the first time
            (_instance$popperInsta2 = instance.popperInstance) == null || _instance$popperInsta2.forceUpdate();
            invokeHook('onMount', [
                instance
            ]);
            if (instance.props.animation && getIsDefaultRenderFn()) onTransitionedIn(duration, function() {
                instance.state.isShown = true;
                invokeHook('onShown', [
                    instance
                ]);
            });
        };
        mount();
    }
    function hide() {
        var isAlreadyHidden = !instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var duration = $303963c61c829440$var$getValueAtIndexOrReturn(instance.props.duration, 1, $303963c61c829440$var$defaultProps.duration);
        if (isAlreadyHidden || isDestroyed || isDisabled) return;
        invokeHook('onHide', [
            instance
        ], false);
        if (instance.props.onHide(instance) === false) return;
        instance.state.isVisible = false;
        instance.state.isShown = false;
        ignoreOnFirstUpdate = false;
        isVisibleFromClick = false;
        if (getIsDefaultRenderFn()) popper.style.visibility = 'hidden';
        cleanupInteractiveMouseListeners();
        removeDocumentPress();
        handleStyles(true);
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh4 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh4.box, content = _getDefaultTemplateCh4.content;
            if (instance.props.animation) {
                $303963c61c829440$var$setTransitionDuration([
                    box,
                    content
                ], duration);
                $303963c61c829440$var$setVisibilityState([
                    box,
                    content
                ], 'hidden');
            }
        }
        handleAriaContentAttribute();
        handleAriaExpandedAttribute();
        if (instance.props.animation) {
            if (getIsDefaultRenderFn()) onTransitionedOut(duration, instance.unmount);
        } else instance.unmount();
    }
    function hideWithInteractivity(event) {
        getDocument().addEventListener('mousemove', debouncedOnMouseMove);
        $303963c61c829440$var$pushIfUnique($303963c61c829440$var$mouseMoveListeners, debouncedOnMouseMove);
        debouncedOnMouseMove(event);
    }
    function unmount() {
        if (instance.state.isVisible) instance.hide();
        if (!instance.state.isMounted) return;
        destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
        // tree by default. This seems mainly for interactive tippies, but we should
        // find a workaround if possible
        getNestedPopperTree().forEach(function(nestedPopper) {
            nestedPopper._tippy.unmount();
        });
        if (popper.parentNode) popper.parentNode.removeChild(popper);
        $303963c61c829440$var$mountedInstances = $303963c61c829440$var$mountedInstances.filter(function(i) {
            return i !== instance;
        });
        instance.state.isMounted = false;
        invokeHook('onHidden', [
            instance
        ]);
    }
    function destroy() {
        if (instance.state.isDestroyed) return;
        instance.clearDelayTimeouts();
        instance.unmount();
        removeListeners();
        delete reference._tippy;
        instance.state.isDestroyed = true;
        invokeHook('onDestroy', [
            instance
        ]);
    }
}
function $303963c61c829440$var$tippy(targets, optionalProps) {
    if (optionalProps === void 0) optionalProps = {};
    var plugins = $303963c61c829440$var$defaultProps.plugins.concat(optionalProps.plugins || []);
    $303963c61c829440$var$bindGlobalEventListeners();
    var passedProps = Object.assign({}, optionalProps, {
        plugins: plugins
    });
    var elements = $303963c61c829440$var$getArrayOfElements(targets);
    var isSingleContentElement, isMoreThanOneReferenceElement;
    var instances = elements.reduce(function(acc, reference) {
        var instance = reference && $303963c61c829440$var$createTippy(reference, passedProps);
        if (instance) acc.push(instance);
        return acc;
    }, []);
    return $303963c61c829440$var$isElement(targets) ? instances[0] : instances;
}
$303963c61c829440$var$tippy.defaultProps = $303963c61c829440$var$defaultProps;
$303963c61c829440$var$tippy.setDefaultProps = $303963c61c829440$var$setDefaultProps;
$303963c61c829440$var$tippy.currentInput = $303963c61c829440$var$currentInput;
var $303963c61c829440$export$a9608aab345f7e75 = function hideAll(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, excludedReferenceOrInstance = _ref.exclude, duration = _ref.duration;
    $303963c61c829440$var$mountedInstances.forEach(function(instance) {
        var isExcluded = false;
        if (excludedReferenceOrInstance) isExcluded = $303963c61c829440$var$isReferenceElement(excludedReferenceOrInstance) ? instance.reference === excludedReferenceOrInstance : instance.popper === excludedReferenceOrInstance.popper;
        if (!isExcluded) {
            var originalDuration = instance.props.duration;
            instance.setProps({
                duration: duration
            });
            instance.hide();
            if (!instance.state.isDestroyed) instance.setProps({
                duration: originalDuration
            });
        }
    });
};
// every time the popper is destroyed (i.e. a new target), removing the styles
// and causing transitions to break for singletons when the console is open, but
// most notably for non-transform styles being used, `gpuAcceleration: false`.
var $303963c61c829440$var$applyStylesModifier = Object.assign({}, (0, $83c1fc4c4e58d7dd$export$2e2bcd8739ae039), {
    effect: function effect(_ref) {
        var state = _ref.state;
        var initialStyles = {
            popper: {
                position: state.options.strategy,
                left: '0',
                top: '0',
                margin: '0'
            },
            arrow: {
                position: 'absolute'
            },
            reference: {}
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
         // intentionally return no cleanup function
    // return () => { ... }
    }
});
var $303963c61c829440$export$374c483667c1ea9b = function createSingleton(tippyInstances, optionalProps) {
    var _optionalProps$popper;
    if (optionalProps === void 0) optionalProps = {};
    var individualInstances = tippyInstances;
    var references = [];
    var triggerTargets = [];
    var currentTarget;
    var overrides = optionalProps.overrides;
    var interceptSetPropsCleanups = [];
    var shownOnCreate = false;
    function setTriggerTargets() {
        triggerTargets = individualInstances.map(function(instance) {
            return $303963c61c829440$var$normalizeToArray(instance.props.triggerTarget || instance.reference);
        }).reduce(function(acc, item) {
            return acc.concat(item);
        }, []);
    }
    function setReferences() {
        references = individualInstances.map(function(instance) {
            return instance.reference;
        });
    }
    function enableInstances(isEnabled) {
        individualInstances.forEach(function(instance) {
            if (isEnabled) instance.enable();
            else instance.disable();
        });
    }
    function interceptSetProps(singleton) {
        return individualInstances.map(function(instance) {
            var originalSetProps = instance.setProps;
            instance.setProps = function(props) {
                originalSetProps(props);
                if (instance.reference === currentTarget) singleton.setProps(props);
            };
            return function() {
                instance.setProps = originalSetProps;
            };
        });
    } // have to pass singleton, as it maybe undefined on first call
    function prepareInstance(singleton, target) {
        var index = triggerTargets.indexOf(target); // bail-out
        if (target === currentTarget) return;
        currentTarget = target;
        var overrideProps = (overrides || []).concat('content').reduce(function(acc, prop) {
            acc[prop] = individualInstances[index].props[prop];
            return acc;
        }, {});
        singleton.setProps(Object.assign({}, overrideProps, {
            getReferenceClientRect: typeof overrideProps.getReferenceClientRect === 'function' ? overrideProps.getReferenceClientRect : function() {
                var _references$index;
                return (_references$index = references[index]) == null ? void 0 : _references$index.getBoundingClientRect();
            }
        }));
    }
    enableInstances(false);
    setReferences();
    setTriggerTargets();
    var plugin = {
        fn: function fn() {
            return {
                onDestroy: function onDestroy() {
                    enableInstances(true);
                },
                onHidden: function onHidden() {
                    currentTarget = null;
                },
                onClickOutside: function onClickOutside(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        currentTarget = null;
                    }
                },
                onShow: function onShow(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        prepareInstance(instance, references[0]);
                    }
                },
                onTrigger: function onTrigger(instance, event) {
                    prepareInstance(instance, event.currentTarget);
                }
            };
        }
    };
    var singleton = $303963c61c829440$var$tippy($303963c61c829440$var$div(), Object.assign({}, $303963c61c829440$var$removeProperties(optionalProps, [
        'overrides'
    ]), {
        plugins: [
            plugin
        ].concat(optionalProps.plugins || []),
        triggerTarget: triggerTargets,
        popperOptions: Object.assign({}, optionalProps.popperOptions, {
            modifiers: [].concat(((_optionalProps$popper = optionalProps.popperOptions) == null ? void 0 : _optionalProps$popper.modifiers) || [], [
                $303963c61c829440$var$applyStylesModifier
            ])
        })
    }));
    var originalShow = singleton.show;
    singleton.show = function(target) {
        originalShow(); // first time, showOnCreate or programmatic call with no params
        // default to showing first instance
        if (!currentTarget && target == null) return prepareInstance(singleton, references[0]);
         // triggered from event (do nothing as prepareInstance already called by onTrigger)
        // programmatic call with no params when already visible (do nothing again)
        if (currentTarget && target == null) return;
         // target is index of instance
        if (typeof target === 'number') return references[target] && prepareInstance(singleton, references[target]);
         // target is a child tippy instance
        if (individualInstances.indexOf(target) >= 0) {
            var ref = target.reference;
            return prepareInstance(singleton, ref);
        } // target is a ReferenceElement
        if (references.indexOf(target) >= 0) return prepareInstance(singleton, target);
    };
    singleton.showNext = function() {
        var first = references[0];
        if (!currentTarget) return singleton.show(0);
        var index = references.indexOf(currentTarget);
        singleton.show(references[index + 1] || first);
    };
    singleton.showPrevious = function() {
        var last = references[references.length - 1];
        if (!currentTarget) return singleton.show(last);
        var index = references.indexOf(currentTarget);
        var target = references[index - 1] || last;
        singleton.show(target);
    };
    var originalSetProps = singleton.setProps;
    singleton.setProps = function(props) {
        overrides = props.overrides || overrides;
        originalSetProps(props);
    };
    singleton.setInstances = function(nextInstances) {
        enableInstances(true);
        interceptSetPropsCleanups.forEach(function(fn) {
            return fn();
        });
        individualInstances = nextInstances;
        enableInstances(false);
        setReferences();
        setTriggerTargets();
        interceptSetPropsCleanups = interceptSetProps(singleton);
        singleton.setProps({
            triggerTarget: triggerTargets
        });
    };
    interceptSetPropsCleanups = interceptSetProps(singleton);
    return singleton;
};
var $303963c61c829440$var$BUBBLING_EVENTS_MAP = {
    mouseover: 'mouseenter',
    focusin: 'focus',
    click: 'click'
};
/**
 * Creates a delegate instance that controls the creation of tippy instances
 * for child elements (`target` CSS selector).
 */ function $303963c61c829440$export$10b1921597150314(targets, props) {
    var listeners = [];
    var childTippyInstances = [];
    var disabled = false;
    var target = props.target;
    var nativeProps = $303963c61c829440$var$removeProperties(props, [
        'target'
    ]);
    var parentProps = Object.assign({}, nativeProps, {
        trigger: 'manual',
        touch: false
    });
    var childProps = Object.assign({
        touch: $303963c61c829440$var$defaultProps.touch
    }, nativeProps, {
        showOnCreate: true
    });
    var returnValue = $303963c61c829440$var$tippy(targets, parentProps);
    var normalizedReturnValue = $303963c61c829440$var$normalizeToArray(returnValue);
    function onTrigger(event) {
        if (!event.target || disabled) return;
        var targetNode = event.target.closest(target);
        if (!targetNode) return;
         // Get relevant trigger with fallbacks:
        // 1. Check `data-tippy-trigger` attribute on target node
        // 2. Fallback to `trigger` passed to `delegate()`
        // 3. Fallback to `defaultProps.trigger`
        var trigger = targetNode.getAttribute('data-tippy-trigger') || props.trigger || $303963c61c829440$var$defaultProps.trigger; // @ts-ignore
        if (targetNode._tippy) return;
        if (event.type === 'touchstart' && typeof childProps.touch === 'boolean') return;
        if (event.type !== 'touchstart' && trigger.indexOf($303963c61c829440$var$BUBBLING_EVENTS_MAP[event.type]) < 0) return;
        var instance = $303963c61c829440$var$tippy(targetNode, childProps);
        if (instance) childTippyInstances = childTippyInstances.concat(instance);
    }
    function on(node, eventType, handler, options) {
        if (options === void 0) options = false;
        node.addEventListener(eventType, handler, options);
        listeners.push({
            node: node,
            eventType: eventType,
            handler: handler,
            options: options
        });
    }
    function addEventListeners(instance) {
        var reference = instance.reference;
        on(reference, 'touchstart', onTrigger, $303963c61c829440$var$TOUCH_OPTIONS);
        on(reference, 'mouseover', onTrigger);
        on(reference, 'focusin', onTrigger);
        on(reference, 'click', onTrigger);
    }
    function removeEventListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function applyMutations(instance) {
        var originalDestroy = instance.destroy;
        var originalEnable = instance.enable;
        var originalDisable = instance.disable;
        instance.destroy = function(shouldDestroyChildInstances) {
            if (shouldDestroyChildInstances === void 0) shouldDestroyChildInstances = true;
            if (shouldDestroyChildInstances) childTippyInstances.forEach(function(instance) {
                instance.destroy();
            });
            childTippyInstances = [];
            removeEventListeners();
            originalDestroy();
        };
        instance.enable = function() {
            originalEnable();
            childTippyInstances.forEach(function(instance) {
                return instance.enable();
            });
            disabled = false;
        };
        instance.disable = function() {
            originalDisable();
            childTippyInstances.forEach(function(instance) {
                return instance.disable();
            });
            disabled = true;
        };
        addEventListeners(instance);
    }
    normalizedReturnValue.forEach(applyMutations);
    return returnValue;
}
var $303963c61c829440$export$dd8ded329c01db79 = {
    name: 'animateFill',
    defaultValue: false,
    fn: function fn(instance) {
        var _instance$props$rende;
        // @ts-ignore
        if (!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy)) return {};
        var _getChildren = $303963c61c829440$var$getChildren(instance.popper), box = _getChildren.box, content = _getChildren.content;
        var backdrop = instance.props.animateFill ? $303963c61c829440$var$createBackdropElement() : null;
        return {
            onCreate: function onCreate() {
                if (backdrop) {
                    box.insertBefore(backdrop, box.firstElementChild);
                    box.setAttribute('data-animatefill', '');
                    box.style.overflow = 'hidden';
                    instance.setProps({
                        arrow: false,
                        animation: 'shift-away'
                    });
                }
            },
            onMount: function onMount() {
                if (backdrop) {
                    var transitionDuration = box.style.transitionDuration;
                    var duration = Number(transitionDuration.replace('ms', '')); // The content should fade in after the backdrop has mostly filled the
                    // tooltip element. `clip-path` is the other alternative but is not
                    // well-supported and is buggy on some devices.
                    content.style.transitionDelay = Math.round(duration / 10) + "ms";
                    backdrop.style.transitionDuration = transitionDuration;
                    $303963c61c829440$var$setVisibilityState([
                        backdrop
                    ], 'visible');
                }
            },
            onShow: function onShow() {
                if (backdrop) backdrop.style.transitionDuration = '0ms';
            },
            onHide: function onHide() {
                if (backdrop) $303963c61c829440$var$setVisibilityState([
                    backdrop
                ], 'hidden');
            }
        };
    }
};
function $303963c61c829440$var$createBackdropElement() {
    var backdrop = $303963c61c829440$var$div();
    backdrop.className = $303963c61c829440$var$BACKDROP_CLASS;
    $303963c61c829440$var$setVisibilityState([
        backdrop
    ], 'hidden');
    return backdrop;
}
var $303963c61c829440$var$mouseCoords = {
    clientX: 0,
    clientY: 0
};
var $303963c61c829440$var$activeInstances = [];
function $303963c61c829440$var$storeMouseCoords(_ref) {
    var clientX = _ref.clientX, clientY = _ref.clientY;
    $303963c61c829440$var$mouseCoords = {
        clientX: clientX,
        clientY: clientY
    };
}
function $303963c61c829440$var$addMouseCoordsListener(doc) {
    doc.addEventListener('mousemove', $303963c61c829440$var$storeMouseCoords);
}
function $303963c61c829440$var$removeMouseCoordsListener(doc) {
    doc.removeEventListener('mousemove', $303963c61c829440$var$storeMouseCoords);
}
var $303963c61c829440$export$ac81526b64504ab6 = {
    name: 'followCursor',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        var doc = $303963c61c829440$var$getOwnerDocument(instance.props.triggerTarget || reference);
        var isInternalUpdate = false;
        var wasFocusEvent = false;
        var isUnmounted = true;
        var prevProps = instance.props;
        function getIsInitialBehavior() {
            return instance.props.followCursor === 'initial' && instance.state.isVisible;
        }
        function addListener() {
            doc.addEventListener('mousemove', onMouseMove);
        }
        function removeListener() {
            doc.removeEventListener('mousemove', onMouseMove);
        }
        function unsetGetReferenceClientRect() {
            isInternalUpdate = true;
            instance.setProps({
                getReferenceClientRect: null
            });
            isInternalUpdate = false;
        }
        function onMouseMove(event) {
            // If the instance is interactive, avoid updating the position unless it's
            // over the reference element
            var isCursorOverReference = event.target ? reference.contains(event.target) : true;
            var followCursor = instance.props.followCursor;
            var clientX = event.clientX, clientY = event.clientY;
            var rect = reference.getBoundingClientRect();
            var relativeX = clientX - rect.left;
            var relativeY = clientY - rect.top;
            if (isCursorOverReference || !instance.props.interactive) instance.setProps({
                // @ts-ignore - unneeded DOMRect properties
                getReferenceClientRect: function getReferenceClientRect() {
                    var rect = reference.getBoundingClientRect();
                    var x = clientX;
                    var y = clientY;
                    if (followCursor === 'initial') {
                        x = rect.left + relativeX;
                        y = rect.top + relativeY;
                    }
                    var top = followCursor === 'horizontal' ? rect.top : y;
                    var right = followCursor === 'vertical' ? rect.right : x;
                    var bottom = followCursor === 'horizontal' ? rect.bottom : y;
                    var left = followCursor === 'vertical' ? rect.left : x;
                    return {
                        width: right - left,
                        height: bottom - top,
                        top: top,
                        right: right,
                        bottom: bottom,
                        left: left
                    };
                }
            });
        }
        function create() {
            if (instance.props.followCursor) {
                $303963c61c829440$var$activeInstances.push({
                    instance: instance,
                    doc: doc
                });
                $303963c61c829440$var$addMouseCoordsListener(doc);
            }
        }
        function destroy() {
            $303963c61c829440$var$activeInstances = $303963c61c829440$var$activeInstances.filter(function(data) {
                return data.instance !== instance;
            });
            if ($303963c61c829440$var$activeInstances.filter(function(data) {
                return data.doc === doc;
            }).length === 0) $303963c61c829440$var$removeMouseCoordsListener(doc);
        }
        return {
            onCreate: create,
            onDestroy: destroy,
            onBeforeUpdate: function onBeforeUpdate() {
                prevProps = instance.props;
            },
            onAfterUpdate: function onAfterUpdate(_, _ref2) {
                var followCursor = _ref2.followCursor;
                if (isInternalUpdate) return;
                if (followCursor !== undefined && prevProps.followCursor !== followCursor) {
                    destroy();
                    if (followCursor) {
                        create();
                        if (instance.state.isMounted && !wasFocusEvent && !getIsInitialBehavior()) addListener();
                    } else {
                        removeListener();
                        unsetGetReferenceClientRect();
                    }
                }
            },
            onMount: function onMount() {
                if (instance.props.followCursor && !wasFocusEvent) {
                    if (isUnmounted) {
                        onMouseMove($303963c61c829440$var$mouseCoords);
                        isUnmounted = false;
                    }
                    if (!getIsInitialBehavior()) addListener();
                }
            },
            onTrigger: function onTrigger(_, event) {
                if ($303963c61c829440$var$isMouseEvent(event)) $303963c61c829440$var$mouseCoords = {
                    clientX: event.clientX,
                    clientY: event.clientY
                };
                wasFocusEvent = event.type === 'focus';
            },
            onHidden: function onHidden() {
                if (instance.props.followCursor) {
                    unsetGetReferenceClientRect();
                    removeListener();
                    isUnmounted = true;
                }
            }
        };
    }
};
function $303963c61c829440$var$getProps(props, modifier) {
    var _props$popperOptions;
    return {
        popperOptions: Object.assign({}, props.popperOptions, {
            modifiers: [].concat((((_props$popperOptions = props.popperOptions) == null ? void 0 : _props$popperOptions.modifiers) || []).filter(function(_ref) {
                var name = _ref.name;
                return name !== modifier.name;
            }), [
                modifier
            ])
        })
    };
}
var $303963c61c829440$export$e2b668424a9c728 = {
    name: 'inlinePositioning',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        function isEnabled() {
            return !!instance.props.inlinePositioning;
        }
        var placement;
        var cursorRectIndex = -1;
        var isInternalUpdate = false;
        var triedPlacements = [];
        var modifier = {
            name: 'tippyInlinePositioning',
            enabled: true,
            phase: 'afterWrite',
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (isEnabled()) {
                    if (triedPlacements.indexOf(state.placement) !== -1) triedPlacements = [];
                    if (placement !== state.placement && triedPlacements.indexOf(state.placement) === -1) {
                        triedPlacements.push(state.placement);
                        instance.setProps({
                            // @ts-ignore - unneeded DOMRect properties
                            getReferenceClientRect: function getReferenceClientRect() {
                                return _getReferenceClientRect(state.placement);
                            }
                        });
                    }
                    placement = state.placement;
                }
            }
        };
        function _getReferenceClientRect(placement) {
            return $303963c61c829440$var$getInlineBoundingClientRect($303963c61c829440$var$getBasePlacement(placement), reference.getBoundingClientRect(), $303963c61c829440$var$arrayFrom(reference.getClientRects()), cursorRectIndex);
        }
        function setInternalProps(partialProps) {
            isInternalUpdate = true;
            instance.setProps(partialProps);
            isInternalUpdate = false;
        }
        function addModifier() {
            if (!isInternalUpdate) setInternalProps($303963c61c829440$var$getProps(instance.props, modifier));
        }
        return {
            onCreate: addModifier,
            onAfterUpdate: addModifier,
            onTrigger: function onTrigger(_, event) {
                if ($303963c61c829440$var$isMouseEvent(event)) {
                    var rects = $303963c61c829440$var$arrayFrom(instance.reference.getClientRects());
                    var cursorRect = rects.find(function(rect) {
                        return rect.left - 2 <= event.clientX && rect.right + 2 >= event.clientX && rect.top - 2 <= event.clientY && rect.bottom + 2 >= event.clientY;
                    });
                    var index = rects.indexOf(cursorRect);
                    cursorRectIndex = index > -1 ? index : cursorRectIndex;
                }
            },
            onHidden: function onHidden() {
                cursorRectIndex = -1;
            }
        };
    }
};
function $303963c61c829440$var$getInlineBoundingClientRect(currentBasePlacement, boundingRect, clientRects, cursorRectIndex) {
    // Not an inline element, or placement is not yet known
    if (clientRects.length < 2 || currentBasePlacement === null) return boundingRect;
     // There are two rects and they are disjoined
    if (clientRects.length === 2 && cursorRectIndex >= 0 && clientRects[0].left > clientRects[1].right) return clientRects[cursorRectIndex] || boundingRect;
    switch(currentBasePlacement){
        case 'top':
        case 'bottom':
            var firstRect = clientRects[0];
            var lastRect = clientRects[clientRects.length - 1];
            var isTop = currentBasePlacement === 'top';
            var top = firstRect.top;
            var bottom = lastRect.bottom;
            var left = isTop ? firstRect.left : lastRect.left;
            var right = isTop ? firstRect.right : lastRect.right;
            var width = right - left;
            var height = bottom - top;
            return {
                top: top,
                bottom: bottom,
                left: left,
                right: right,
                width: width,
                height: height
            };
        case 'left':
        case 'right':
            var minLeft = Math.min.apply(Math, clientRects.map(function(rects) {
                return rects.left;
            }));
            var maxRight = Math.max.apply(Math, clientRects.map(function(rects) {
                return rects.right;
            }));
            var measureRects = clientRects.filter(function(rect) {
                return currentBasePlacement === 'left' ? rect.left === minLeft : rect.right === maxRight;
            });
            var _top = measureRects[0].top;
            var _bottom = measureRects[measureRects.length - 1].bottom;
            var _left = minLeft;
            var _right = maxRight;
            var _width = _right - _left;
            var _height = _bottom - _top;
            return {
                top: _top,
                bottom: _bottom,
                left: _left,
                right: _right,
                width: _width,
                height: _height
            };
        default:
            return boundingRect;
    }
}
var $303963c61c829440$export$4bd4b47501432316 = {
    name: 'sticky',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference, popper = instance.popper;
        function getReference() {
            return instance.popperInstance ? instance.popperInstance.state.elements.reference : reference;
        }
        function shouldCheck(value) {
            return instance.props.sticky === true || instance.props.sticky === value;
        }
        var prevRefRect = null;
        var prevPopRect = null;
        function updatePosition() {
            var currentRefRect = shouldCheck('reference') ? getReference().getBoundingClientRect() : null;
            var currentPopRect = shouldCheck('popper') ? popper.getBoundingClientRect() : null;
            if (currentRefRect && $303963c61c829440$var$areRectsDifferent(prevRefRect, currentRefRect) || currentPopRect && $303963c61c829440$var$areRectsDifferent(prevPopRect, currentPopRect)) {
                if (instance.popperInstance) instance.popperInstance.update();
            }
            prevRefRect = currentRefRect;
            prevPopRect = currentPopRect;
            if (instance.state.isMounted) requestAnimationFrame(updatePosition);
        }
        return {
            onMount: function onMount() {
                if (instance.props.sticky) updatePosition();
            }
        };
    }
};
function $303963c61c829440$var$areRectsDifferent(rectA, rectB) {
    if (rectA && rectB) return rectA.top !== rectB.top || rectA.right !== rectB.right || rectA.bottom !== rectB.bottom || rectA.left !== rectB.left;
    return true;
}
$303963c61c829440$var$tippy.setDefaultProps({
    render: $303963c61c829440$var$render
});
var $303963c61c829440$export$2e2bcd8739ae039 = $303963c61c829440$var$tippy;


parcelRequire("kdaJp");

class $c7e002142218a0a0$export$8b251419efc915eb {
    constructor(){
        const $header = document.querySelector("header");
        // Mobile-Menu open/close
        const $btnsMob = document.querySelectorAll("header .btn-mob");
        if ($btnsMob) $btnsMob.forEach(($btn)=>{
            $btn.addEventListener("click", (event)=>{
                event.stopPropagation();
                if ($header.classList.contains("mob-open")) {
                    let scrollY = document.body.style.top;
                    scrollY = parseInt(scrollY || '0');
                    document.documentElement.style.scrollBehavior = "auto";
                    document.body.style.position = '';
                    document.body.style.top = '';
                    window.scrollTo(0, scrollY * -1);
                    $header.classList.remove("mob-open");
                    document.documentElement.style.scrollBehavior = "smooth";
                } else {
                    const scrollY = window.scrollY;
                    setTimeout(()=>{
                        document.body.style.position = 'fixed';
                        document.body.style.top = "-" + scrollY + "px";
                    }, "200");
                    $header.classList.add("mob-open");
                }
            });
        });
        // Header-Bar gets sticky
        window.addEventListener('scroll', function() {
            const scrollpos = window.scrollY;
            const scrollposCss = parseInt(document.body.style.top || '0');
            if (scrollpos > 200 || Math.abs(scrollposCss) > 200) $header.classList.add("is-fixed");
            else if (!$header.classList.contains("mob-open")) $header.classList.remove("is-fixed");
        });
    }
}
// Initialisierung wenn DOM geladen
(0, $19a061ecc5409c94$export$86fbec116b87613f).domready(()=>{
    if (document.querySelector('header')) new $c7e002142218a0a0$export$8b251419efc915eb();
});




class $cd380679c289a203$export$a06f1c675e846f6f {
    constructor(){
        const $footer = document.querySelector("footer");
        // Einstellungen
        const message_modal_id = "slidemodal-msg";
        const message_url = "https://form.taxi/s/cp6j50yp";
        // Nachricht senden
        const $modalMessage = document.querySelector('#' + message_modal_id);
        if ($modalMessage) {
            const $form = $modalMessage.querySelector('form');
            const $submitBtn = $form.querySelector("button[type=submit]");
            const $inputs = $form.querySelectorAll("input.inpt, textarea.inpt");
            // Status von Sendebutton aktualisieren
            const updateSubmitBtnStatus = function() {
                var isValid = true;
                $inputs.forEach(($i)=>{
                    if ($i.checkValidity() === false) isValid = false;
                });
                if (!isValid) $submitBtn.setAttribute("disabled", "");
                else $submitBtn.removeAttribute("disabled");
            };
            // Sendebutton aktivieren
            $inputs.forEach(($input)=>{
                $input.addEventListener('keyup', (event)=>{
                    updateSubmitBtnStatus();
                });
                $input.addEventListener('change', (event)=>{
                    updateSubmitBtnStatus();
                });
            });
            updateSubmitBtnStatus();
            // Absenden
            $form.addEventListener('submit', (event)=>{
                event.preventDefault();
                const $form = event.currentTarget;
                const formData = new FormData($form);
                // Sendebutton deaktivieren
                (0, $19a061ecc5409c94$export$86fbec116b87613f).setSubmitBtnLoading($form);
                // Senden
                new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post(message_url, formData).then((response)=>{
                    // Modal schliessen
                    window.SlideModals[message_modal_id].close();
                    // Erfolgsmeldung anzeigen
                    const $modal = document.querySelector("#" + message_modal_id);
                    const text = $modal.getAttribute('data-msg-success');
                    (0, $19a061ecc5409c94$export$86fbec116b87613f).showMsg(text, "success");
                    // Formular zurücksetzen
                    $form.reset();
                }).catch((error)=>{
                    (0, $19a061ecc5409c94$export$86fbec116b87613f).showMsg(error.message ?? "Unknown error", "error", 5000);
                }).finally(()=>{
                    // Sendebutton zurücksetzen
                    (0, $19a061ecc5409c94$export$86fbec116b87613f).setSubmitBtnActive($form);
                });
            });
        }
    }
}
// Initialisierung wenn DOM geladen
(0, $19a061ecc5409c94$export$86fbec116b87613f).domready(()=>{
    if (document.querySelector('footer')) new $cd380679c289a203$export$a06f1c675e846f6f();
});



/* particles.js variables with default values */ const $de5a2dd5dfa0954d$var$pJSDefaults = {
    particles: {
        number: {
            value: 20,
            density: {
                enable: true,
                value_area: 800
            }
        },
        color: {
            value: '#e91e63'
        },
        shape: {
            type: 'circle',
            stroke: {
                width: 0,
                color: '#ff0000'
            },
            polygon: {
                nb_sides: 5
            },
            image: {
                src: '',
                width: 100,
                height: 100
            }
        },
        opacity: {
            value: 1,
            random: false,
            anim: {
                enable: false,
                speed: 2,
                opacity_min: 0,
                sync: false
            }
        },
        size: {
            value: 20,
            random: false,
            anim: {
                enable: false,
                speed: 20,
                size_min: 0,
                sync: false
            }
        },
        line_linked: {
            enable: true,
            distance: 100,
            color: '#fff',
            opacity: 1,
            width: 1
        },
        move: {
            enable: true,
            speed: 2,
            direction: 'none',
            random: false,
            straight: false,
            out_mode: 'out',
            bounce: false,
            attract: {
                enable: false,
                rotateX: 3000,
                rotateY: 3000
            }
        },
        array: []
    },
    interactivity: {
        detect_on: 'canvas',
        events: {
            onhover: {
                enable: true,
                mode: 'grab'
            },
            onclick: {
                enable: true,
                mode: 'push'
            },
            resize: true
        },
        modes: {
            grab: {
                distance: 100,
                line_linked: {
                    opacity: 1
                }
            },
            bubble: {
                distance: 200,
                size: 80,
                duration: 0.4
            },
            repulse: {
                distance: 200,
                duration: 0.4
            },
            push: {
                particles_nb: 4
            },
            remove: {
                particles_nb: 2
            }
        },
        mouse: {}
    },
    retina_detect: false,
    fn: {
        interact: {},
        modes: {},
        vendors: {}
    },
    tmp: {}
};
const $de5a2dd5dfa0954d$var$pJS = function(tag_id, params, action) {
    var canvas_el = document.querySelector('#' + tag_id + ' > .particles-js-canvas-el');
    $de5a2dd5dfa0954d$var$pJSDefaults.canvas = {
        el: canvas_el,
        w: canvas_el.offsetWidth,
        h: canvas_el.offsetHeight
    };
    var pJS = $de5a2dd5dfa0954d$var$pJSDefaults;
    /* params settings */ if (params) pJS = $de5a2dd5dfa0954d$var$deepExtend(pJS, params);
    pJS = $de5a2dd5dfa0954d$var$formatpJSObject(pJS, canvas_el);
    /* ---------- pJS - start ------------ */ switch(action){
        case 'refresh':
            console.log('refresh');
            pJS.fn.particlesRefresh();
            break;
        case 'destroy':
            pJS.fn.vendors.destroypJS();
            console.log('destroy');
            break;
        default:
            pJS.fn.vendors.eventsListeners();
            pJS.fn.vendors.start();
            console.log('start');
    }
};
const $de5a2dd5dfa0954d$var$formatpJSObject = (pJS, canvas_el)=>{
    pJS.tmp.obj = {
        size_value: pJS.particles.size.value,
        size_anim_speed: pJS.particles.size.anim.speed,
        move_speed: pJS.particles.move.speed,
        line_linked_distance: pJS.particles.line_linked.distance,
        line_linked_width: pJS.particles.line_linked.width,
        mode_grab_distance: pJS.interactivity.modes.grab.distance,
        mode_bubble_distance: pJS.interactivity.modes.bubble.distance,
        mode_bubble_size: pJS.interactivity.modes.bubble.size,
        mode_repulse_distance: pJS.interactivity.modes.repulse.distance
    };
    pJS.fn.retinaInit = function() {
        if (pJS.retina_detect && window.devicePixelRatio > 1) {
            pJS.canvas.pxratio = window.devicePixelRatio;
            pJS.tmp.retina = true;
        } else {
            pJS.canvas.pxratio = 1;
            pJS.tmp.retina = false;
        }
        pJS.canvas.w = pJS.canvas.el.offsetWidth * pJS.canvas.pxratio;
        pJS.canvas.h = pJS.canvas.el.offsetHeight * pJS.canvas.pxratio;
        pJS.particles.size.value = pJS.tmp.obj.size_value * pJS.canvas.pxratio;
        pJS.particles.size.anim.speed = pJS.tmp.obj.size_anim_speed * pJS.canvas.pxratio;
        pJS.particles.move.speed = pJS.tmp.obj.move_speed * pJS.canvas.pxratio;
        pJS.particles.line_linked.distance = pJS.tmp.obj.line_linked_distance * pJS.canvas.pxratio;
        pJS.interactivity.modes.grab.distance = pJS.tmp.obj.mode_grab_distance * pJS.canvas.pxratio;
        pJS.interactivity.modes.bubble.distance = pJS.tmp.obj.mode_bubble_distance * pJS.canvas.pxratio;
        pJS.particles.line_linked.width = pJS.tmp.obj.line_linked_width * pJS.canvas.pxratio;
        pJS.interactivity.modes.bubble.size = pJS.tmp.obj.mode_bubble_size * pJS.canvas.pxratio;
        pJS.interactivity.modes.repulse.distance = pJS.tmp.obj.mode_repulse_distance * pJS.canvas.pxratio;
    };
    /* ---------- pJS functions - canvas ------------ */ pJS.fn.canvasInit = function() {
        pJS.canvas.ctx = pJS.canvas.el.getContext('2d');
    };
    pJS.fn.canvasSize = function() {
        pJS.canvas.el.width = pJS.canvas.w;
        pJS.canvas.el.height = pJS.canvas.h;
        if (pJS && pJS.interactivity.events.resize) window.addEventListener('resize', function() {
            pJS.canvas.w = pJS.canvas.el.offsetWidth;
            pJS.canvas.h = pJS.canvas.el.offsetHeight;
            /* resize canvas */ if (pJS.tmp.retina) {
                pJS.canvas.w *= pJS.canvas.pxratio;
                pJS.canvas.h *= pJS.canvas.pxratio;
            }
            pJS.canvas.el.width = pJS.canvas.w;
            pJS.canvas.el.height = pJS.canvas.h;
            /* repaint canvas on anim disabled */ if (!pJS.particles.move.enable) {
                pJS.fn.particlesEmpty();
                pJS.fn.particlesCreate();
                pJS.fn.particlesDraw();
                pJS.fn.vendors.densityAutoParticles();
            }
            /* density particles enabled */ pJS.fn.vendors.densityAutoParticles();
        });
    };
    pJS.fn.canvasPaint = function() {
        pJS.canvas.ctx.fillRect(0, 0, pJS.canvas.w, pJS.canvas.h);
    };
    pJS.fn.canvasClear = function() {
        const ctx = pJS.canvas.ctx || pJS.canvas.el.getContext('2d');
        ctx.clearRect(0, 0, pJS.canvas.w, pJS.canvas.h);
    };
    /* --------- pJS functions - particles ----------- */ pJS.fn.particle = function(color, opacity, position) {
        /* size */ this.radius = (pJS.particles.size.random ? Math.random() : 1) * pJS.particles.size.value;
        if (pJS.particles.size.anim.enable) {
            this.size_status = false;
            this.vs = pJS.particles.size.anim.speed / 100;
            if (!pJS.particles.size.anim.sync) this.vs = this.vs * Math.random();
        }
        /* position */ this.x = position ? position.x : Math.random() * pJS.canvas.w;
        this.y = position ? position.y : Math.random() * pJS.canvas.h;
        /* check position  - into the canvas */ if (this.x > pJS.canvas.w - this.radius * 2) this.x = this.x - this.radius;
        else if (this.x < this.radius * 2) this.x = this.x + this.radius;
        if (this.y > pJS.canvas.h - this.radius * 2) this.y = this.y - this.radius;
        else if (this.y < this.radius * 2) this.y = this.y + this.radius;
        /* check position - avoid overlap */ if (pJS.particles.move.bounce) pJS.fn.vendors.checkOverlap(this, position);
        /* color */ this.color = {};
        if (typeof color.value == 'object') {
            if (color.value instanceof Array) {
                var color_selected = color.value[Math.floor(Math.random() * pJS.particles.color.value.length)];
                this.color.rgb = $de5a2dd5dfa0954d$var$hexToRgb(color_selected);
            } else {
                if (color.value.r != undefined && color.value.g != undefined && color.value.b != undefined) this.color.rgb = {
                    r: color.value.r,
                    g: color.value.g,
                    b: color.value.b
                };
                if (color.value.h != undefined && color.value.s != undefined && color.value.l != undefined) this.color.hsl = {
                    h: color.value.h,
                    s: color.value.s,
                    l: color.value.l
                };
            }
        } else if (color.value == 'random') this.color.rgb = {
            r: Math.floor(Math.random() * 256) + 0,
            g: Math.floor(Math.random() * 256) + 0,
            b: Math.floor(Math.random() * 256) + 0
        };
        else if (typeof color.value == 'string') {
            this.color = color;
            this.color.rgb = $de5a2dd5dfa0954d$var$hexToRgb(this.color.value);
        }
        /* opacity */ this.opacity = (pJS.particles.opacity.random ? Math.random() : 1) * pJS.particles.opacity.value;
        if (pJS.particles.opacity.anim.enable) {
            this.opacity_status = false;
            this.vo = pJS.particles.opacity.anim.speed / 100;
            if (!pJS.particles.opacity.anim.sync) this.vo = this.vo * Math.random();
        }
        /* animation - velocity for speed */ var velbase = {};
        switch(pJS.particles.move.direction){
            case 'top':
                velbase = {
                    x: 0,
                    y: -1
                };
                break;
            case 'top-right':
                velbase = {
                    x: 0.5,
                    y: -0.5
                };
                break;
            case 'right':
                velbase = {
                    x: 1,
                    y: -0
                };
                break;
            case 'bottom-right':
                velbase = {
                    x: 0.5,
                    y: 0.5
                };
                break;
            case 'bottom':
                velbase = {
                    x: 0,
                    y: 1
                };
                break;
            case 'bottom-left':
                velbase = {
                    x: -0.5,
                    y: 1
                };
                break;
            case 'left':
                velbase = {
                    x: -1,
                    y: 0
                };
                break;
            case 'top-left':
                velbase = {
                    x: -0.5,
                    y: -0.5
                };
                break;
            default:
                velbase = {
                    x: 0,
                    y: 0
                };
                break;
        }
        if (pJS.particles.move.straight) {
            this.vx = velbase.x;
            this.vy = velbase.y;
            if (pJS.particles.move.random) {
                this.vx = this.vx * Math.random();
                this.vy = this.vy * Math.random();
            }
        } else {
            this.vx = velbase.x + Math.random() - 0.5;
            this.vy = velbase.y + Math.random() - 0.5;
        }
        // var theta = 2.0 * Math.PI * Math.random()
        // this.vx = Math.cos(theta)
        // this.vy = Math.sin(theta)
        this.vx_i = this.vx;
        this.vy_i = this.vy;
        /* if shape is image */ var shape_type = pJS.particles.shape.type;
        if (typeof shape_type == 'object') {
            if (shape_type instanceof Array) {
                var shape_selected = shape_type[Math.floor(Math.random() * shape_type.length)];
                this.shape = shape_selected;
            }
        } else this.shape = shape_type;
        if (this.shape == 'image') {
            var sh = pJS.particles.shape;
            this.img = {
                src: sh.image.src,
                ratio: sh.image.width / sh.image.height
            };
            if (!this.img.ratio) this.img.ratio = 1;
            if (pJS.tmp.img_type == 'svg' && pJS.tmp.source_svg != undefined) {
                pJS.fn.vendors.createSvgImg(this);
                if (pJS.tmp.pushing) this.img.loaded = false;
            }
        }
    };
    pJS.fn.particle.prototype.draw = function() {
        var p = this;
        if (p.radius_bubble != undefined) var radius = p.radius_bubble;
        else var radius = p.radius;
        if (p.opacity_bubble != undefined) var opacity = p.opacity_bubble;
        else var opacity = p.opacity;
        if (p.color.rgb) var color_value = 'rgba(' + p.color.rgb.r + ',' + p.color.rgb.g + ',' + p.color.rgb.b + ',' + opacity + ')';
        else if (p.color.hsl) var color_value = 'hsla(' + p.color.hsl.h + ',' + p.color.hsl.s + '%,' + p.color.hsl.l + '%,' + opacity + ')';
        else var color_value = $de5a2dd5dfa0954d$var$pJSDefaults.particles.color.value;
        pJS.canvas.ctx.fillStyle = color_value;
        pJS.canvas.ctx.beginPath();
        switch(p.shape){
            case 'circle':
                pJS.canvas.ctx.arc(p.x, p.y, radius, 0, Math.PI * 2, false);
                break;
            case 'edge':
                pJS.canvas.ctx.rect(p.x - radius, p.y - radius, radius * 2, radius * 2);
                break;
            case 'triangle':
                pJS.fn.vendors.drawShape(pJS.canvas.ctx, p.x - radius, p.y + radius / 1.66, radius * 2, 3, 2);
                break;
            case 'polygon':
                pJS.fn.vendors.drawShape(pJS.canvas.ctx, p.x - radius / (pJS.particles.shape.polygon.nb_sides / 3.5), p.y - radius / 0.76, radius * 2.66 / (pJS.particles.shape.polygon.nb_sides / 3), pJS.particles.shape.polygon.nb_sides, 1 // sideCountDenominator
                );
                break;
            case 'star':
                pJS.fn.vendors.drawShape(pJS.canvas.ctx, p.x - radius * 2 / (pJS.particles.shape.polygon.nb_sides / 4), p.y - radius / 1.52, radius * 5.32 / (pJS.particles.shape.polygon.nb_sides / 3), pJS.particles.shape.polygon.nb_sides, 2 // sideCountDenominator
                );
                break;
            case 'image':
                function draw() {
                    pJS.canvas.ctx.drawImage(img_obj, p.x - radius, p.y - radius, radius * 2, radius * 2 / p.img.ratio);
                }
                if (pJS.tmp.img_type == 'svg') var img_obj = p.img.obj;
                else var img_obj = pJS.tmp.img_obj;
                if (img_obj) draw();
                break;
        }
        pJS.canvas.ctx.closePath();
        if (pJS.particles.shape.stroke.width > 0) {
            pJS.canvas.ctx.strokeStyle = pJS.particles.shape.stroke.color;
            pJS.canvas.ctx.lineWidth = pJS.particles.shape.stroke.width;
            pJS.canvas.ctx.stroke();
        }
        pJS.canvas.ctx.fill();
    };
    pJS.fn.particlesCreate = function() {
        for(var i = 0; i < pJS.particles.number.value; i++)pJS.particles.array.push(new pJS.fn.particle(pJS.particles.color, pJS.particles.opacity.value));
    };
    pJS.fn.particlesUpdate = function() {
        for(var i = 0; i < pJS.particles.array.length; i++){
            /* the particle */ var p = pJS.particles.array[i];
            // var d = ( dx = pJS.interactivity.mouse.click_pos_x - p.x ) * dx + ( dy = pJS.interactivity.mouse.click_pos_y - p.y ) * dy
            // var f = -BANG_SIZE / d
            // if ( d < BANG_SIZE ) {
            //     var t = Math.atan2( dy, dx )
            //     p.vx = f * Math.cos(t)
            //     p.vy = f * Math.sin(t)
            // }
            /* move the particle */ if (pJS.particles.move.enable) {
                var ms = pJS.particles.move.speed / 2;
                p.x += p.vx * ms;
                p.y += p.vy * ms;
            }
            /* change opacity status */ if (pJS.particles.opacity.anim.enable) {
                if (p.opacity_status == true) {
                    if (p.opacity >= pJS.particles.opacity.value) p.opacity_status = false;
                    p.opacity += p.vo;
                } else {
                    if (p.opacity <= pJS.particles.opacity.anim.opacity_min) p.opacity_status = true;
                    p.opacity -= p.vo;
                }
                if (p.opacity < 0) p.opacity = 0;
            }
            /* change size */ if (pJS.particles.size.anim.enable) {
                if (p.size_status == true) {
                    if (p.radius >= pJS.particles.size.value) p.size_status = false;
                    p.radius += p.vs;
                } else {
                    if (p.radius <= pJS.particles.size.anim.size_min) p.size_status = true;
                    p.radius -= p.vs;
                }
                if (p.radius < 0) p.radius = 0;
            }
            /* change particle position if it is out of canvas */ if (pJS.particles.move.out_mode == 'bounce') var new_pos = {
                x_left: p.radius,
                x_right: pJS.canvas.w,
                y_top: p.radius,
                y_bottom: pJS.canvas.h
            };
            else var new_pos = {
                x_left: -p.radius,
                x_right: pJS.canvas.w + p.radius,
                y_top: -p.radius,
                y_bottom: pJS.canvas.h + p.radius
            };
            if (p.x - p.radius > pJS.canvas.w) {
                p.x = new_pos.x_left;
                p.y = Math.random() * pJS.canvas.h;
            } else if (p.x + p.radius < 0) {
                p.x = new_pos.x_right;
                p.y = Math.random() * pJS.canvas.h;
            }
            if (p.y - p.radius > pJS.canvas.h) {
                p.y = new_pos.y_top;
                p.x = Math.random() * pJS.canvas.w;
            } else if (p.y + p.radius < 0) {
                p.y = new_pos.y_bottom;
                p.x = Math.random() * pJS.canvas.w;
            }
            /* out of canvas modes */ switch(pJS.particles.move.out_mode){
                case 'bounce':
                    if (p.x + p.radius > pJS.canvas.w) p.vx = -p.vx;
                    else if (p.x - p.radius < 0) p.vx = -p.vx;
                    if (p.y + p.radius > pJS.canvas.h) p.vy = -p.vy;
                    else if (p.y - p.radius < 0) p.vy = -p.vy;
                    break;
            }
            /* events */ if ($de5a2dd5dfa0954d$var$isInArray('grab', pJS.interactivity.events.onhover.mode)) pJS.fn.modes.grabParticle(p);
            if ($de5a2dd5dfa0954d$var$isInArray('bubble', pJS.interactivity.events.onhover.mode) || $de5a2dd5dfa0954d$var$isInArray('bubble', pJS.interactivity.events.onclick.mode)) pJS.fn.modes.bubbleParticle(p);
            if ($de5a2dd5dfa0954d$var$isInArray('repulse', pJS.interactivity.events.onhover.mode) || $de5a2dd5dfa0954d$var$isInArray('repulse', pJS.interactivity.events.onclick.mode)) pJS.fn.modes.repulseParticle(p);
            /* interaction auto between particles */ if (pJS.particles.line_linked.enable || pJS.particles.move.attract.enable) for(var j = i + 1; j < pJS.particles.array.length; j++){
                var p2 = pJS.particles.array[j];
                /* link particles */ if (pJS.particles.line_linked.enable) pJS.fn.interact.linkParticles(p, p2);
                /* attract particles */ if (pJS.particles.move.attract.enable) pJS.fn.interact.attractParticles(p, p2);
                /* bounce particles */ if (pJS.particles.move.bounce) pJS.fn.interact.bounceParticles(p, p2);
            }
        }
    };
    pJS.fn.particlesDraw = function() {
        /* clear canvas */ pJS.canvas.ctx.clearRect(0, 0, pJS.canvas.w, pJS.canvas.h);
        /* update each particles param */ pJS.fn.particlesUpdate();
        /* draw each particle */ for(var i = 0; i < pJS.particles.array.length; i++){
            var p = pJS.particles.array[i];
            p.draw();
        }
    };
    pJS.fn.particlesEmpty = function() {
        pJS.particles.array = [];
    };
    pJS.fn.particlesRefresh = function() {
        /* init all */ cancelRequestAnimFrame(pJS.fn.checkAnimFrame);
        cancelRequestAnimFrame(pJS.fn.drawAnimFrame);
        pJS.tmp.source_svg = undefined;
        pJS.tmp.img_obj = undefined;
        pJS.tmp.count_svg = 0;
        pJS.fn.particlesEmpty();
        pJS.fn.canvasClear();
        /* restart */ pJS.fn.vendors.start();
    };
    /* ---------- pJS functions - particles interaction ------------ */ pJS.fn.interact.linkParticles = function(p1, p2) {
        var dx = p1.x - p2.x, dy = p1.y - p2.y, dist = Math.sqrt(dx * dx + dy * dy);
        /* draw a line between p1 and p2 if the distance between them is under the config distance */ if (dist <= pJS.particles.line_linked.distance) {
            var opacity_line = pJS.particles.line_linked.opacity - dist / (1 / pJS.particles.line_linked.opacity) / pJS.particles.line_linked.distance;
            if (opacity_line > 0) {
                /* style */ var color_line = pJS.particles.line_linked.color_rgb_line;
                pJS.canvas.ctx.strokeStyle = 'rgba(' + color_line.r + ',' + color_line.g + ',' + color_line.b + ',' + opacity_line + ')';
                pJS.canvas.ctx.lineWidth = pJS.particles.line_linked.width;
                //pJS.canvas.ctx.lineCap = 'round' /* performance issue */
                /* path */ pJS.canvas.ctx.beginPath();
                pJS.canvas.ctx.moveTo(p1.x, p1.y);
                pJS.canvas.ctx.lineTo(p2.x, p2.y);
                pJS.canvas.ctx.stroke();
                pJS.canvas.ctx.closePath();
            }
        }
    };
    pJS.fn.interact.attractParticles = function(p1, p2) {
        /* condensed particles */ var dx = p1.x - p2.x, dy = p1.y - p2.y, dist = Math.sqrt(dx * dx + dy * dy);
        if (dist <= pJS.particles.line_linked.distance) {
            var ax = dx / (pJS.particles.move.attract.rotateX * 1000), ay = dy / (pJS.particles.move.attract.rotateY * 1000);
            p1.vx -= ax;
            p1.vy -= ay;
            p2.vx += ax;
            p2.vy += ay;
        }
    };
    pJS.fn.interact.bounceParticles = function(p1, p2) {
        var dx = p1.x - p2.x, dy = p1.y - p2.y, dist = Math.sqrt(dx * dx + dy * dy), dist_p = p1.radius + p2.radius;
        if (dist <= dist_p) {
            p1.vx = -p1.vx;
            p1.vy = -p1.vy;
            p2.vx = -p2.vx;
            p2.vy = -p2.vy;
        }
    };
    /* ---------- pJS functions - modes events ------------ */ pJS.fn.modes.pushParticles = function(nb, pos) {
        pJS.tmp.pushing = true;
        for(var i = 0; i < nb; i++){
            pJS.particles.array.push(new pJS.fn.particle(pJS.particles.color, pJS.particles.opacity.value, {
                'x': pos ? pos.pos_x : Math.random() * pJS.canvas.w,
                'y': pos ? pos.pos_y : Math.random() * pJS.canvas.h
            }));
            if (i == nb - 1) {
                if (!pJS.particles.move.enable) pJS.fn.particlesDraw();
                pJS.tmp.pushing = false;
            }
        }
    };
    pJS.fn.modes.removeParticles = function(nb) {
        pJS.particles.array.splice(0, nb);
        if (!pJS.particles.move.enable) pJS.fn.particlesDraw();
    };
    pJS.fn.modes.bubbleParticle = function(p) {
        /* on hover event */ if (pJS.interactivity.events.onhover.enable && $de5a2dd5dfa0954d$var$isInArray('bubble', pJS.interactivity.events.onhover.mode)) {
            var dx_mouse = p.x - pJS.interactivity.mouse.pos_x, dy_mouse = p.y - pJS.interactivity.mouse.pos_y, dist_mouse = Math.sqrt(dx_mouse * dx_mouse + dy_mouse * dy_mouse), ratio = 1 - dist_mouse / pJS.interactivity.modes.bubble.distance;
            function setup() {
                p.opacity_bubble = p.opacity;
                p.radius_bubble = p.radius;
            }
            /* mousemove - check ratio */ if (dist_mouse <= pJS.interactivity.modes.bubble.distance) {
                if (ratio >= 0 && pJS.interactivity.status == 'mousemove') {
                    /* size */ if (pJS.interactivity.modes.bubble.size != pJS.particles.size.value) {
                        if (pJS.interactivity.modes.bubble.size > pJS.particles.size.value) {
                            var size = p.radius + pJS.interactivity.modes.bubble.size * ratio;
                            if (size >= 0) p.radius_bubble = size;
                        } else {
                            var dif = p.radius - pJS.interactivity.modes.bubble.size, size = p.radius - dif * ratio;
                            if (size > 0) p.radius_bubble = size;
                            else p.radius_bubble = 0;
                        }
                    }
                    /* opacity */ if (pJS.interactivity.modes.bubble.opacity != pJS.particles.opacity.value) {
                        if (pJS.interactivity.modes.bubble.opacity > pJS.particles.opacity.value) {
                            var opacity = pJS.interactivity.modes.bubble.opacity * ratio;
                            if (opacity > p.opacity && opacity <= pJS.interactivity.modes.bubble.opacity) p.opacity_bubble = opacity;
                        } else {
                            var opacity = p.opacity - (pJS.particles.opacity.value - pJS.interactivity.modes.bubble.opacity) * ratio;
                            if (opacity < p.opacity && opacity >= pJS.interactivity.modes.bubble.opacity) p.opacity_bubble = opacity;
                        }
                    }
                }
            } else setup();
            /* mouseleave */ if (pJS.interactivity.status == 'mouseleave') setup();
        } else if (pJS.interactivity.events.onclick.enable && $de5a2dd5dfa0954d$var$isInArray('bubble', pJS.interactivity.events.onclick.mode)) {
            if (pJS.tmp.bubble_clicking) {
                var dx_mouse = p.x - pJS.interactivity.mouse.click_pos_x, dy_mouse = p.y - pJS.interactivity.mouse.click_pos_y, dist_mouse = Math.sqrt(dx_mouse * dx_mouse + dy_mouse * dy_mouse), time_spent = (new Date().getTime() - pJS.interactivity.mouse.click_time) / 1000;
                if (time_spent > pJS.interactivity.modes.bubble.duration) pJS.tmp.bubble_duration_end = true;
                if (time_spent > pJS.interactivity.modes.bubble.duration * 2) {
                    pJS.tmp.bubble_clicking = false;
                    pJS.tmp.bubble_duration_end = false;
                }
            }
            function process(bubble_param, particles_param, p_obj_bubble, p_obj, id) {
                if (bubble_param != particles_param) {
                    if (!pJS.tmp.bubble_duration_end) {
                        if (dist_mouse <= pJS.interactivity.modes.bubble.distance) {
                            if (p_obj_bubble != undefined) var obj = p_obj_bubble;
                            else var obj = p_obj;
                            if (obj != bubble_param) {
                                var value = p_obj - time_spent * (p_obj - bubble_param) / pJS.interactivity.modes.bubble.duration;
                                if (id == 'size') p.radius_bubble = value;
                                if (id == 'opacity') p.opacity_bubble = value;
                            }
                        } else {
                            if (id == 'size') p.radius_bubble = undefined;
                            if (id == 'opacity') p.opacity_bubble = undefined;
                        }
                    } else if (p_obj_bubble != undefined) {
                        var value_tmp = p_obj - time_spent * (p_obj - bubble_param) / pJS.interactivity.modes.bubble.duration, dif = bubble_param - value_tmp;
                        value = bubble_param + dif;
                        if (id == 'size') p.radius_bubble = value;
                        if (id == 'opacity') p.opacity_bubble = value;
                    }
                }
            }
            if (pJS.tmp.bubble_clicking) {
                /* size */ process(pJS.interactivity.modes.bubble.size, pJS.particles.size.value, p.radius_bubble, p.radius, 'size');
                /* opacity */ process(pJS.interactivity.modes.bubble.opacity, pJS.particles.opacity.value, p.opacity_bubble, p.opacity, 'opacity');
            }
        }
    };
    pJS.fn.modes.repulseParticle = function(p) {
        if (pJS.interactivity.events.onhover.enable && $de5a2dd5dfa0954d$var$isInArray('repulse', pJS.interactivity.events.onhover.mode) && pJS.interactivity.status == 'mousemove') {
            var dx_mouse = p.x - pJS.interactivity.mouse.pos_x, dy_mouse = p.y - pJS.interactivity.mouse.pos_y, dist_mouse = Math.sqrt(dx_mouse * dx_mouse + dy_mouse * dy_mouse);
            var normVec = {
                x: dx_mouse / dist_mouse,
                y: dy_mouse / dist_mouse
            }, repulseRadius = pJS.interactivity.modes.repulse.distance, velocity = 100, repulseFactor = $de5a2dd5dfa0954d$var$clamp(1 / repulseRadius * (-1 * Math.pow(dist_mouse / repulseRadius, 2) + 1) * repulseRadius * velocity, 0, 50);
            var pos = {
                x: p.x + normVec.x * repulseFactor,
                y: p.y + normVec.y * repulseFactor
            };
            if (pJS.particles.move.out_mode == 'bounce') {
                if (pos.x - p.radius > 0 && pos.x + p.radius < pJS.canvas.w) p.x = pos.x;
                if (pos.y - p.radius > 0 && pos.y + p.radius < pJS.canvas.h) p.y = pos.y;
            } else {
                p.x = pos.x;
                p.y = pos.y;
            }
        } else if (pJS.interactivity.events.onclick.enable && $de5a2dd5dfa0954d$var$isInArray('repulse', pJS.interactivity.events.onclick.mode)) {
            if (!pJS.tmp.repulse_finish) {
                pJS.tmp.repulse_count++;
                if (pJS.tmp.repulse_count == pJS.particles.array.length) pJS.tmp.repulse_finish = true;
            }
            if (pJS.tmp.repulse_clicking) {
                var repulseRadius = Math.pow(pJS.interactivity.modes.repulse.distance / 6, 3);
                var dx = pJS.interactivity.mouse.click_pos_x - p.x, dy = pJS.interactivity.mouse.click_pos_y - p.y, d = dx * dx + dy * dy;
                var force = -repulseRadius / d * 1;
                function process() {
                    var f = Math.atan2(dy, dx);
                    p.vx = force * Math.cos(f);
                    p.vy = force * Math.sin(f);
                    if (pJS.particles.move.out_mode == 'bounce') {
                        var pos = {
                            x: p.x + p.vx,
                            y: p.y + p.vy
                        };
                        if (pos.x + p.radius > pJS.canvas.w) p.vx = -p.vx;
                        else if (pos.x - p.radius < 0) p.vx = -p.vx;
                        if (pos.y + p.radius > pJS.canvas.h) p.vy = -p.vy;
                        else if (pos.y - p.radius < 0) p.vy = -p.vy;
                    }
                }
                // default
                if (d <= repulseRadius) process();
            // bang - slow motion mode
            // if(!pJS.tmp.repulse_finish){
            //   if(d <= repulseRadius){
            //     process()
            //   }
            // }else{
            //   process()
            // }
            } else if (pJS.tmp.repulse_clicking == false) {
                p.vx = p.vx_i;
                p.vy = p.vy_i;
            }
        }
    };
    pJS.fn.modes.grabParticle = function(p) {
        if (pJS.interactivity.events.onhover.enable && pJS.interactivity.status == 'mousemove') {
            var dx_mouse = p.x - pJS.interactivity.mouse.pos_x, dy_mouse = p.y - pJS.interactivity.mouse.pos_y, dist_mouse = Math.sqrt(dx_mouse * dx_mouse + dy_mouse * dy_mouse);
            /* draw a line between the cursor and the particle if the distance between them is under the config distance */ if (dist_mouse <= pJS.interactivity.modes.grab.distance) {
                var opacity_line = pJS.interactivity.modes.grab.line_linked.opacity - dist_mouse / (1 / pJS.interactivity.modes.grab.line_linked.opacity) / pJS.interactivity.modes.grab.distance;
                if (opacity_line > 0) {
                    /* style */ var color_line = pJS.particles.line_linked.color_rgb_line;
                    pJS.canvas.ctx.strokeStyle = 'rgba(' + color_line.r + ',' + color_line.g + ',' + color_line.b + ',' + opacity_line + ')';
                    pJS.canvas.ctx.lineWidth = pJS.particles.line_linked.width;
                    //pJS.canvas.ctx.lineCap = 'round' /* performance issue */
                    /* path */ pJS.canvas.ctx.beginPath();
                    pJS.canvas.ctx.moveTo(p.x, p.y);
                    pJS.canvas.ctx.lineTo(pJS.interactivity.mouse.pos_x, pJS.interactivity.mouse.pos_y);
                    pJS.canvas.ctx.stroke();
                    pJS.canvas.ctx.closePath();
                }
            }
        }
    };
    /* ---------- pJS functions - vendors ------------ */ pJS.fn.vendors.eventsListeners = function() {
        /* events target element */ if (pJS.interactivity.detect_on == 'window') pJS.interactivity.el = window;
        else pJS.interactivity.el = pJS.canvas.el;
        /* detect mouse pos - on hover / click event */ if (pJS.interactivity.events.onhover.enable || pJS.interactivity.events.onclick.enable) {
            /* el on mousemove */ pJS.interactivity.el.addEventListener('mousemove', function(e) {
                if (pJS.interactivity.el == window) var pos_x = e.clientX, pos_y = e.clientY;
                else var pos_x = e.offsetX || e.clientX, pos_y = e.offsetY || e.clientY;
                pJS.interactivity.mouse.pos_x = pos_x;
                pJS.interactivity.mouse.pos_y = pos_y;
                if (pJS.tmp.retina) {
                    pJS.interactivity.mouse.pos_x *= pJS.canvas.pxratio;
                    pJS.interactivity.mouse.pos_y *= pJS.canvas.pxratio;
                }
                pJS.interactivity.status = 'mousemove';
            });
            /* el on onmouseleave */ pJS.interactivity.el.addEventListener('mouseleave', function(e) {
                pJS.interactivity.mouse.pos_x = null;
                pJS.interactivity.mouse.pos_y = null;
                pJS.interactivity.status = 'mouseleave';
            });
        }
        /* on click event */ if (pJS.interactivity.events.onclick.enable) pJS.interactivity.el.addEventListener('click', function() {
            pJS.interactivity.mouse.click_pos_x = pJS.interactivity.mouse.pos_x;
            pJS.interactivity.mouse.click_pos_y = pJS.interactivity.mouse.pos_y;
            pJS.interactivity.mouse.click_time = new Date().getTime();
            if (pJS.interactivity.events.onclick.enable) switch(pJS.interactivity.events.onclick.mode){
                case 'push':
                    if (pJS.particles.move.enable) pJS.fn.modes.pushParticles(pJS.interactivity.modes.push.particles_nb, pJS.interactivity.mouse);
                    else {
                        if (pJS.interactivity.modes.push.particles_nb == 1) pJS.fn.modes.pushParticles(pJS.interactivity.modes.push.particles_nb, pJS.interactivity.mouse);
                        else if (pJS.interactivity.modes.push.particles_nb > 1) pJS.fn.modes.pushParticles(pJS.interactivity.modes.push.particles_nb);
                    }
                    break;
                case 'remove':
                    pJS.fn.modes.removeParticles(pJS.interactivity.modes.remove.particles_nb);
                    break;
                case 'bubble':
                    pJS.tmp.bubble_clicking = true;
                    break;
                case 'repulse':
                    pJS.tmp.repulse_clicking = true;
                    pJS.tmp.repulse_count = 0;
                    pJS.tmp.repulse_finish = false;
                    setTimeout(function() {
                        pJS.tmp.repulse_clicking = false;
                    }, pJS.interactivity.modes.repulse.duration * 1000);
                    break;
            }
        });
    };
    pJS.fn.vendors.densityAutoParticles = function() {
        if (pJS.particles.number.density.enable) {
            /* calc area */ var area = pJS.canvas.el.width * pJS.canvas.el.height / 1000;
            if (pJS.tmp.retina) area = area / (pJS.canvas.pxratio * 2);
            /* calc number of particles based on density area */ var nb_particles = area * pJS.particles.number.value / pJS.particles.number.density.value_area;
            /* add or remove X particles */ var missing_particles = pJS.particles.array.length - nb_particles;
            if (missing_particles < 0) pJS.fn.modes.pushParticles(Math.abs(missing_particles));
            else pJS.fn.modes.removeParticles(missing_particles);
        }
    };
    pJS.fn.vendors.checkOverlap = function(p1, position) {
        for(var i = 0; i < pJS.particles.array.length; i++){
            var p2 = pJS.particles.array[i];
            var dx = p1.x - p2.x, dy = p1.y - p2.y, dist = Math.sqrt(dx * dx + dy * dy);
            if (dist <= p1.radius + p2.radius) {
                p1.x = position ? position.x : Math.random() * pJS.canvas.w;
                p1.y = position ? position.y : Math.random() * pJS.canvas.h;
                pJS.fn.vendors.checkOverlap(p1);
            }
        }
    };
    pJS.fn.vendors.createSvgImg = function(p) {
        /* set color to svg element */ var svgXml = pJS.tmp.source_svg, rgbHex = /#([0-9A-F]{3,6})/gi, coloredSvgXml = svgXml.replace(rgbHex, function(m, r, g, b) {
            if (p.color.rgb) var color_value = 'rgba(' + p.color.rgb.r + ',' + p.color.rgb.g + ',' + p.color.rgb.b + ',' + p.opacity + ')';
            else var color_value = 'hsla(' + p.color.hsl.h + ',' + p.color.hsl.s + '%,' + p.color.hsl.l + '%,' + p.opacity + ')';
            return color_value;
        });
        /* prepare to create img with colored svg */ var svg = new Blob([
            coloredSvgXml
        ], {
            type: 'image/svg+xmlcharset=utf-8'
        }), DOMURL = window.URL || window.webkitURL || window, url = DOMURL.createObjectURL(svg);
        /* create particle img obj */ var img = new Image();
        img.addEventListener('load', function() {
            p.img.obj = img;
            p.img.loaded = true;
            DOMURL.revokeObjectURL(url);
            pJS.tmp.count_svg++;
        });
        img.src = url;
    };
    pJS.fn.vendors.destroypJS = function() {
        cancelAnimationFrame(pJS.fn.drawAnimFrame);
        canvas_el.remove();
        pJSDom = [];
    };
    pJS.fn.vendors.drawShape = function(c, startX, startY, sideLength, sideCountNumerator, sideCountDenominator) {
        // By Programming Thomas - https://programmingthomas.wordpress.com/2013/04/03/n-sided-shapes/
        var sideCount = sideCountNumerator * sideCountDenominator;
        var decimalSides = sideCountNumerator / sideCountDenominator;
        var interiorAngleDegrees = 180 * (decimalSides - 2) / decimalSides;
        var interiorAngle = Math.PI - Math.PI * interiorAngleDegrees / 180 // convert to radians
        ;
        c.save();
        c.beginPath();
        c.translate(startX, startY);
        c.moveTo(0, 0);
        for(var i = 0; i < sideCount; i++){
            c.lineTo(sideLength, 0);
            c.translate(sideLength, 0);
            c.rotate(interiorAngle);
        }
        //c.stroke()
        c.fill();
        c.restore();
    };
    pJS.fn.vendors.exportImg = function() {
        window.open(pJS.canvas.el.toDataURL('image/png'), '_blank');
    };
    pJS.fn.vendors.loadImg = function(type) {
        pJS.tmp.img_error = undefined;
        if (pJS.particles.shape.image.src != '') {
            if (type == 'svg') {
                var xhr = new XMLHttpRequest();
                xhr.open('GET', pJS.particles.shape.image.src);
                xhr.onreadystatechange = function(data) {
                    if (xhr.readyState == 4) {
                        if (xhr.status == 200) {
                            pJS.tmp.source_svg = data.currentTarget.response;
                            pJS.fn.vendors.checkBeforeDraw();
                        } else {
                            console.log('Error pJS - Image not found');
                            pJS.tmp.img_error = true;
                        }
                    }
                };
                xhr.send();
            } else {
                var img = new Image();
                img.addEventListener('load', function() {
                    pJS.tmp.img_obj = img;
                    pJS.fn.vendors.checkBeforeDraw();
                });
                img.src = pJS.particles.shape.image.src;
            }
        } else {
            console.log('Error pJS - No image.src');
            pJS.tmp.img_error = true;
        }
    };
    pJS.fn.vendors.draw = function() {
        if (pJS.particles.shape.type == 'image') {
            if (pJS.tmp.img_type == 'svg') {
                if (pJS.tmp.count_svg >= pJS.particles.number.value) {
                    pJS.fn.particlesDraw();
                    if (!pJS.particles.move.enable) cancelRequestAnimFrame(pJS.fn.drawAnimFrame);
                    else pJS.fn.drawAnimFrame = requestAnimFrame(pJS.fn.vendors.draw);
                } else //console.log('still loading...')
                if (!pJS.tmp.img_error) pJS.fn.drawAnimFrame = requestAnimFrame(pJS.fn.vendors.draw);
            } else {
                if (pJS.tmp.img_obj != undefined) {
                    pJS.fn.particlesDraw();
                    if (!pJS.particles.move.enable) cancelRequestAnimFrame(pJS.fn.drawAnimFrame);
                    else pJS.fn.drawAnimFrame = requestAnimFrame(pJS.fn.vendors.draw);
                } else if (!pJS.tmp.img_error) pJS.fn.drawAnimFrame = requestAnimFrame(pJS.fn.vendors.draw);
            }
        } else {
            pJS.fn.particlesDraw();
            if (!pJS.particles.move.enable) cancelRequestAnimFrame(pJS.fn.drawAnimFrame);
            else pJS.fn.drawAnimFrame = requestAnimFrame(pJS.fn.vendors.draw);
        }
    };
    pJS.fn.vendors.checkBeforeDraw = function() {
        // if shape is image
        if (pJS.particles.shape.type == 'image') {
            if (pJS.tmp.img_type == 'svg' && pJS.tmp.source_svg == undefined) pJS.tmp.checkAnimFrame = requestAnimFrame(check);
            else {
                //console.log('images loaded! cancel check')
                cancelRequestAnimFrame(pJS.tmp.checkAnimFrame);
                if (!pJS.tmp.img_error) {
                    pJS.fn.vendors.setup();
                    pJS.fn.vendors.draw();
                }
            }
        } else {
            pJS.fn.vendors.setup();
            pJS.fn.vendors.draw();
        }
    };
    pJS.fn.vendors.setup = function() {
        /* init canvas + particles */ pJS.fn.retinaInit();
        pJS.fn.canvasInit();
        pJS.fn.canvasSize();
        pJS.fn.canvasPaint();
        pJS.fn.particlesCreate();
        pJS.fn.vendors.densityAutoParticles();
        /* particles.line_linked - convert hex colors to rgb */ pJS.particles.line_linked.color_rgb_line = $de5a2dd5dfa0954d$var$hexToRgb(pJS.particles.line_linked.color);
    };
    pJS.fn.vendors.start = function() {
        if ($de5a2dd5dfa0954d$var$isInArray('image', pJS.particles.shape.type)) {
            pJS.tmp.img_type = pJS.particles.shape.image.src.substr(pJS.particles.shape.image.src.length - 3);
            pJS.fn.vendors.loadImg(pJS.tmp.img_type);
        } else pJS.fn.vendors.checkBeforeDraw();
    };
    return pJS;
};
/* ---------- global functions - vendors ------------ */ const $de5a2dd5dfa0954d$var$deepExtend = function(out) {
    out = out || {};
    for(var i = 1; i < arguments.length; ++i){
        var obj = arguments[i];
        if (!obj) continue;
        for(var key in obj){
            if (!obj.hasOwnProperty(key)) continue;
            // based on https://javascriptweblog.wordpress.com/2011/08/08/fixing-the-javascript-typeof-operator/
            if (Object.prototype.toString.call(obj[key]) === '[object Object]') {
                out[key] = $de5a2dd5dfa0954d$var$deepExtend(out[key], obj[key]);
                continue;
            }
            out[key] = obj[key];
        }
    }
    return out;
};
if (typeof window !== 'undefined') {
    // the variable is defined
    window.requestAnimFrame = function() {
        return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function(callback) {
            window.setTimeout(callback, 1000 / 60);
        };
    }();
    window.cancelRequestAnimFrame = function() {
        return window.cancelAnimationFrame || window.webkitCancelRequestAnimationFrame || window.mozCancelRequestAnimationFrame || window.oCancelRequestAnimationFrame || window.msCancelRequestAnimationFrame || clearTimeout;
    }();
    window.pJSDom = [];
}
function $de5a2dd5dfa0954d$var$hexToRgb(hex) {
    // By Tim Down - http://stackoverflow.com/a/5624139/3493650
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function(m, r, g, b) {
        return r + r + g + g + b + b;
    });
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}
function $de5a2dd5dfa0954d$var$clamp(number, min, max) {
    return Math.min(Math.max(number, min), max);
}
function $de5a2dd5dfa0954d$var$isInArray(value, array) {
    return array.indexOf(value) > -1;
}
/* ---------- particles.js functions - start ------------ */ const $de5a2dd5dfa0954d$var$particlesJS = (tag_id, params, action)=>{
    //console.log(params)
    /* no string id? so it's object params, and set the id with default id */ if (typeof tag_id != 'string') {
        params = tag_id;
        tag_id = 'particles-js';
    }
    /* no id? set the id to default id */ if (!tag_id) tag_id = 'particles-js';
    /* pJS elements */ var pJS_tag = document.getElementById(tag_id), pJS_canvas_class = 'particles-js-canvas-el', exist_canvas = pJS_tag.getElementsByClassName(pJS_canvas_class);
    /* remove canvas if exists into the pJS target tag */ if (exist_canvas.length) while(exist_canvas.length > 0)pJS_tag.removeChild(exist_canvas[0]);
    /* create canvas element */ var canvas_el = document.createElement('canvas');
    canvas_el.className = pJS_canvas_class;
    /* set size canvas */ canvas_el.style.width = "100%";
    canvas_el.style.height = "100%";
    /* append canvas */ var canvas = document.getElementById(tag_id).appendChild(canvas_el);
    /* launch particle.js */ if (canvas != null) pJSDom.push(new $de5a2dd5dfa0954d$var$pJS(tag_id, params));
};
const $de5a2dd5dfa0954d$var$init = (tag_id, config_json, callback)=>{
    if (typeof window !== 'undefined') {
        if (!config_json) {
            $de5a2dd5dfa0954d$var$particlesJS(tag_id, {});
            if (callback) callback();
        } else if (typeof config_json === 'string' || config_json instanceof String) {
            /* load json config */ var xhr = new XMLHttpRequest();
            xhr.open('GET', config_json);
            xhr.onreadystatechange = function(data) {
                if (xhr.readyState == 4) {
                    if (xhr.status == 200) {
                        var params = JSON.parse(data.currentTarget.response);
                        $de5a2dd5dfa0954d$var$particlesJS(tag_id, params);
                        if (callback) callback();
                    } else {
                        console.log('Error pJS - XMLHttpRequest status: ' + xhr.status);
                        console.log('Error pJS - File config not found');
                    }
                }
            };
            xhr.send();
        } else {
            $de5a2dd5dfa0954d$var$particlesJS(tag_id, config_json);
            if (callback) callback();
        }
    }
};
var $de5a2dd5dfa0954d$export$2e2bcd8739ae039 = {
    init: $de5a2dd5dfa0954d$var$init,
    refresh: (tag_id, params)=>{
        $de5a2dd5dfa0954d$var$pJS(tag_id, params, 'refresh');
    },
    destroy: (tag_id)=>{
        $de5a2dd5dfa0954d$var$pJS(tag_id, {}, 'destroy');
    }
};


class $72f7728cc6a1dd5d$export$6955bcca4cd3539f {
    constructor(){
        // Partikel-Animation
        (0, $de5a2dd5dfa0954d$export$2e2bcd8739ae039).init('partani', {
            "particles": {
                "number": {
                    "value": 161,
                    "density": {
                        "enable": true,
                        "value_area": 1025.908125981517
                    }
                },
                "color": {
                    "value": "#fff"
                },
                "shape": {
                    "type": "circle",
                    "stroke": {
                        "width": 0,
                        "color": "#000000"
                    },
                    "polygon": {
                        "nb_sides": 5
                    },
                    "image": {
                        "src": "img/github.svg",
                        "width": 100,
                        "height": 100
                    }
                },
                "opacity": {
                    "value": 0.7,
                    "random": true,
                    "anim": {
                        "enable": false,
                        "speed": 1,
                        "opacity_min": 0.1,
                        "sync": false
                    }
                },
                "size": {
                    "value": 2,
                    "random": true,
                    "anim": {
                        "enable": false,
                        "speed": 5,
                        "size_min": 0.1,
                        "sync": false
                    }
                },
                "line_linked": {
                    "enable": false,
                    "distance": 500,
                    "color": "#ffffff",
                    "opacity": 0.4,
                    "width": 2
                },
                "move": {
                    "enable": true,
                    "speed": 5,
                    "direction": "left",
                    "random": true,
                    "straight": true,
                    "out_mode": "out",
                    "bounce": false,
                    "attract": {
                        "enable": false,
                        "rotateX": 600,
                        "rotateY": 1200
                    }
                }
            },
            "interactivity": {
                "detect_on": "canvas",
                "events": {
                    "onhover": {
                        "enable": false,
                        "mode": "bubble"
                    },
                    "onclick": {
                        "enable": false,
                        "mode": "repulse"
                    },
                    "resize": true
                },
                "modes": {
                    "grab": {
                        "distance": 400,
                        "line_linked": {
                            "opacity": 0.5
                        }
                    },
                    "bubble": {
                        "distance": 400,
                        "size": 4,
                        "duration": 0.3,
                        "opacity": 1,
                        "speed": 3
                    },
                    "repulse": {
                        "distance": 200,
                        "duration": 0.4
                    },
                    "push": {
                        "particles_nb": 4
                    },
                    "remove": {
                        "particles_nb": 2
                    }
                }
            },
            "retina_detect": true
        });
    }
}
// Initialisierung wenn DOM geladen
(0, $19a061ecc5409c94$export$86fbec116b87613f).domready(()=>{
    if (document.querySelector('body').classList.contains('home')) new $72f7728cc6a1dd5d$export$6955bcca4cd3539f();
});




class $cdde92ef676029b3$export$6955bcca4cd3539f {
    constructor(){
        // Paddle initialisieren
        Paddle.Setup({
            vendor: 120516
        });
        // Paddle Checkout
        const $btnsCheckout = document.querySelectorAll('button.paddle-checkout');
        $btnsCheckout.forEach(($btn)=>{
            $btn.addEventListener('click', (event)=>{
                const frequencyValue = document.querySelector('input[name="frequency"]:checked').value;
                const isYearly = frequencyValue == 'annually';
                const $ele = event.currentTarget;
                let productId = 0;
                if (isYearly) productId = parseInt($ele.getAttribute('data-productid-yearly'), 10);
                else productId = parseInt($ele.getAttribute('data-productid-monthly'), 10);
                const account_email = $ele.getAttribute('data-account-email');
                const account_id = parseInt($ele.getAttribute('data-account-id'));
                const locale = $ele.getAttribute('data-locale');
                const timezone = $ele.getAttribute('data-timezone');
                const campaign_origin = $ele.getAttribute('data-campaignorigin');
                const title = $ele.getAttribute('data-title');
                const plan = $ele.getAttribute('data-plan');
                const passthrough = {};
                if (account_id) passthrough.account_id = account_id;
                if (locale) passthrough.lang = locale;
                if (timezone) passthrough.timezone = timezone;
                if (campaign_origin) passthrough.campaign_origin = campaign_origin;
                const para = {
                    product: productId,
                    passthrough: JSON.stringify(passthrough),
                    allowQuantity: false,
                    locale: locale,
                    successCallback: (data)=>{
                        // Weiterleitung zu Seite Order-Processing
                        (0, $19a061ecc5409c94$export$86fbec116b87613f).gotoUrl((0, $19a061ecc5409c94$export$86fbec116b87613f).getUrl('panel/membership/order_processing', {
                            paddle_user_id: data.user.id,
                            to_plan: plan,
                            lang: locale
                        }));
                    }
                };
                if (account_email) para.email = account_email;
                if (title) para.title = title;
                Paddle.Checkout.open(para);
            });
        });
        // Paddle Tarifwechsel
        const $btnsChange = document.querySelectorAll('button.paddle-change');
        $btnsChange.forEach(($btn)=>{
            $btn.addEventListener('click', (event)=>{
                const $ele = event.currentTarget;
                // Attribute übernehmen
                const $btnChangeNow = document.querySelector('#modal-plan-change button.paddle-change-now');
                $btnChangeNow.setAttribute('data-productid-yearly', $ele.getAttribute('data-productid-yearly'));
                $btnChangeNow.setAttribute('data-productid-monthly', $ele.getAttribute('data-productid-monthly'));
                $btnChangeNow.setAttribute('data-subscription-id', $ele.getAttribute('data-subscription-id'));
                // Modal mit Nachfrage zu Tarifwechsel öffnen
                window.Modals['modal-plan-change'].open();
            });
        });
        const $btnChangeNow = document.querySelector('#modal-plan-change button.paddle-change-now');
        if ($btnChangeNow) $btnChangeNow.addEventListener('click', (event)=>{
            const frequencyValue = document.querySelector('input[name="frequency"]:checked').value;
            const isYearly = frequencyValue == 'annually';
            const $ele = event.currentTarget;
            let productId = 0;
            if (isYearly === "true") productId = parseInt($ele.getAttribute('data-productid-yearly'), 10);
            else productId = parseInt($ele.getAttribute('data-productid-monthly'), 10);
            const subscription_id = parseInt($ele.getAttribute('data-subscription-id'), 10);
            // Tarifwechsel per Ajax vornehmen
            const data = new FormData();
            data.append('product_id', productId);
            data.append('subscription_id', subscription_id);
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $19a061ecc5409c94$export$86fbec116b87613f).getUrl('panel/membership/change_paid_plan'), data).then((response)=>{
                window.Modals['modal-plan-change-success'].open();
            }).catch((error)=>{
                alert("Error: " + error.message);
            }).finally(()=>{});
        });
    }
}
// Initialisierung wenn DOM geladen
(0, $19a061ecc5409c94$export$86fbec116b87613f).domready(()=>{
    if (document.querySelector('body').classList.contains('plans')) new $cdde92ef676029b3$export$6955bcca4cd3539f();
});




class $c9b7da326cec7afa$export$6955bcca4cd3539f {
    constructor(){
        // Paddle initialisieren
        Paddle.Setup({
            vendor: 120516
        });
        // Paddle Checkout
        const $btnsCheckout = document.querySelectorAll('button.paddle-checkout');
        $btnsCheckout.forEach(($btn)=>{
            $btn.addEventListener('click', (event)=>{
                const frequencyValue = document.querySelector('input[name="frequency"]:checked').value;
                const isYearly = frequencyValue == 'annually';
                const $ele = event.currentTarget;
                let productId = 0;
                if (isYearly) productId = parseInt($ele.getAttribute('data-productid-yearly'), 10);
                else productId = parseInt($ele.getAttribute('data-productid-monthly'), 10);
                const account_email = $ele.getAttribute('data-account-email');
                const account_id = parseInt($ele.getAttribute('data-account-id'));
                const locale = $ele.getAttribute('data-locale');
                const title = $ele.getAttribute('data-title');
                const plan = $ele.getAttribute('data-plan');
                const passthrough = {};
                passthrough.account_id = account_id;
                passthrough.lang = locale;
                const para = {
                    product: productId,
                    passthrough: JSON.stringify(passthrough),
                    allowQuantity: false,
                    locale: locale,
                    successCallback: (data)=>{
                        // Weiterleitung zu Seite Order-Processing
                        (0, $19a061ecc5409c94$export$86fbec116b87613f).gotoUrl((0, $19a061ecc5409c94$export$86fbec116b87613f).getUrl('panel/membership/order_processing', {
                            paddle_user_id: data.user.id,
                            to_plan: plan,
                            lang: locale
                        }));
                    }
                };
                if (account_email) para.email = account_email;
                if (title) para.title = title;
                Paddle.Checkout.open(para);
            });
        });
        // Paddle Tarifwechsel
        const $btnsChange = document.querySelectorAll('button.paddle-change');
        $btnsChange.forEach(($btn)=>{
            $btn.addEventListener('click', (event)=>{
                const $ele = event.currentTarget;
                // Modal mit Nachfrage zu Tarifwechsel öffnen
                window.Modals['modal-plan-change'].open();
            });
        });
        const $btnChangeNow = document.querySelector('#modal-plan-change button.paddle-change-now');
        if ($btnChangeNow) $btnChangeNow.addEventListener('click', (event)=>{
            const frequencyValue = document.querySelector('input[name="frequency"]:checked').value;
            const isYearly = frequencyValue == 'annually';
            const $ele = event.currentTarget;
            let productId = 0;
            if (isYearly === "true") productId = parseInt($ele.getAttribute('data-productid-yearly'), 10);
            else productId = parseInt($ele.getAttribute('data-productid-monthly'), 10);
            const subscription_id = parseInt($ele.getAttribute('data-subscription-id'), 10);
            const account_id = parseInt($ele.getAttribute('data-account-id'), 10);
            // Tarifwechsel per Ajax vornehmen
            const data = new FormData();
            data.append('product_id', productId);
            data.append('subscription_id', subscription_id);
            data.append('account_id', account_id);
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $19a061ecc5409c94$export$86fbec116b87613f).getUrl('panel/membership/change_paid_plan'), data).then((response)=>{
                window.Modals['modal-plan-change-success'].open();
            }).catch((error)=>{
                alert("Error: " + error.message);
            }).finally(()=>{});
        });
    }
}
// Initialisierung wenn DOM geladen
(0, $19a061ecc5409c94$export$86fbec116b87613f).domready(()=>{
    if (document.querySelector('body').classList.contains('upgrade')) new $c9b7da326cec7afa$export$6955bcca4cd3539f();
});




// Imports

class $d430a6cdea2ccbea$export$b707302f0a0fbd2b {
    constructor($ele){
        this.$container = $ele;
        this.id = $ele.id;
        this.$overlay = this.$container.querySelector(".overlay");
        this.$window = this.$container.querySelector(".window");
        this.$closeBtns = this.$container.querySelectorAll("*[x-close]");
        // Klick auf Öffnungs-Links
        document.querySelectorAll(`*[x-open-slidemodal="${this.id}"]`).forEach(($link)=>{
            $link.addEventListener("click", (event)=>{
                event.preventDefault();
                this.open();
            });
        });
        // Klick auf Schliessen-Links
        document.querySelectorAll(`*[x-close-slidemodal="${this.id}"]`).forEach(($link)=>{
            $link.addEventListener("click", (event)=>{
                event.preventDefault();
                this.close();
            });
        });
    }
    // öffnen
    open() {
        if (!this.$container.classList.contains("open")) {
            // Alle schliessen
            this.closeAll();
            // Event-Listener
            this.close = this.close.bind(this);
            this.$overlay.addEventListener("click", this.close);
            document.addEventListener("keyup", this.close);
            if (this.$closeBtns) this.$closeBtns.forEach(($btn)=>{
                $btn.addEventListener("click", this.close);
            });
            // Body-Scrolling fixieren
            const scrollY = window.scrollY;
            this.$container.addEventListener('transitionend', (event)=>{
                document.body.style.position = 'fixed';
                document.body.style.top = "-" + scrollY + "px";
            }, {
                once: true
            });
            // Event-Trigger
            this.$container.dispatchEvent(new CustomEvent('slidemodal-open', {
                detail: {}
            }));
            // Hidden-Attribut
            this.$container.removeAttribute("hidden");
            const reflow = this.$container.offsetHeight;
            // Klasse hinzufügen
            this.$container.classList.add("open");
            // Focus auf erstes Eingabefeld
            const $input = this.$window.querySelector("input,textarea");
            if ($input) setTimeout(()=>{
                $input.focus();
            }, 300);
        }
    }
    // schliessen
    close(event = null) {
        if (this.$container.classList.contains("open")) {
            if (event) {
                if (event.type === "click") event.preventDefault();
                else if (event.type === "keyup") {
                    if (event.key !== "Escape") return;
                }
            }
            // Event-Listener entfernen
            this.$overlay.removeEventListener("click", this.close);
            document.removeEventListener("keyup", this.close);
            if (this.$closeBtns) this.$closeBtns.forEach(($btn)=>{
                $btn.removeEventListener("click", this.close);
            });
            // Body-Scrolling herstellen
            let scrollY = document.body.style.top;
            scrollY = parseInt(scrollY || '0');
            document.documentElement.style.scrollBehavior = "auto";
            document.body.style.position = '';
            document.body.style.top = '';
            window.scrollTo(0, scrollY * -1);
            document.documentElement.style.scrollBehavior = "smooth";
            // Hidden-Attribut
            this.$container.addEventListener('transitionend', (event)=>{
                this.$container.setAttribute("hidden", true);
            }, {
                once: true
            });
            // Klasse entfernen
            this.$container.classList.remove("open");
            // Event-Trigger
            this.$container.dispatchEvent(new CustomEvent('slidemodal-close', {
                detail: {}
            }));
        }
    }
    // alle schliessen
    closeAll() {
        window.SlideModals.forEach((m)=>{
            m.close();
        });
    }
}
// alle SlideModals initialisieren
(0, $19a061ecc5409c94$export$86fbec116b87613f).domready(()=>{
    window.SlideModals = [];
    const $modals = document.querySelectorAll(".slidemodal");
    $modals.forEach(($ele)=>{
        const id = $ele.id;
        window.SlideModals[id] = new $d430a6cdea2ccbea$export$b707302f0a0fbd2b($ele);
    });
});



class $dd0d50182b083263$export$6955bcca4cd3539f {
    constructor(){
        const $sectionHtml = document.querySelector("section#html");
        if ($sectionHtml) {
            // Elemente
            const $btnSetup = $sectionHtml.querySelector("button.setup-connection");
            const $modalSetup = document.querySelector('#slidemodal-formsetup');
            const $btnCopy = $sectionHtml.querySelector("button.copy");
            const $btnDownload = $sectionHtml.querySelector("button.download");
            const $btnPanel = $sectionHtml.querySelector("button.panel");
            const $areaConnectionInfo = $sectionHtml.querySelector(".connection-info-area");
            const $areaConnectionReady = $sectionHtml.querySelector(".connection-ready-area");
            const $code = $sectionHtml.querySelector(".code");
            // Sendeverbindung einrichten
            if ($modalSetup) {
                // Elemente
                const $form = $modalSetup.querySelector("form");
                const $btnSubmit = $form.querySelector("button[type=submit]");
                const $toastError = $modalSetup.querySelector(".toast.error");
                const $toastErrorText = $toastError.querySelector("p");
                // Status von Sende-Button aktualisieren
                const updateSubmitBtnStatus = function() {
                    $btnSubmit.disabled = !$form.checkValidity();
                };
                updateSubmitBtnStatus();
                // Änderungen an Formularangaben
                $form.addEventListener('change', (event)=>{
                    updateSubmitBtnStatus();
                });
                $form.addEventListener('keyup', (event)=>{
                    updateSubmitBtnStatus();
                });
                // Absenden
                $form.addEventListener('submit', (event)=>{
                    event.preventDefault();
                    const $form = event.currentTarget;
                    // Sendebutton deaktivieren
                    (0, $19a061ecc5409c94$export$86fbec116b87613f).setSubmitBtnLoading($form);
                    // Daten
                    const formData = new FormData($form);
                    // Fehlermeldung ausblenden
                    $toastError.classList.add("hidden");
                    // Senden
                    new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $19a061ecc5409c94$export$86fbec116b87613f).getUrl((0, $19a061ecc5409c94$export$86fbec116b87613f).getLang() + '/submit_formsetup'), formData).then((response)=>{
                        // Modal schliessen
                        window.SlideModals['slidemodal-formsetup'].close();
                        // Erfolgsanzeige
                        $btnPanel.dataset.href = response.form_panel_url;
                        $btnDownload.dataset.href = response.sourcecode_download_url;
                        $areaConnectionInfo.remove();
                        $areaConnectionReady.classList.remove("hidden");
                        const $newaccount = $areaConnectionReady.querySelector(".new-account");
                        if ($newaccount) {
                            if (response.new_account != true) $newaccount.remove();
                        }
                        // Sendeadresse in Code einfügen
                        const codeFragments = $code.querySelectorAll("code *");
                        codeFragments.forEach(($fragment)=>{
                            if ($fragment.textContent == '"SENDING ADDRESS"') $fragment.textContent = '"' + response.form_submission_url + '"';
                        });
                        // Conversion bei Google registrieren
                        window.gtag_report_conversion();
                        // Ziel bei Matomo triggern
                        if (response.new_account == true) _paq.push([
                            'trackGoal',
                            4
                        ]);
                    }).catch((error)=>{
                        $toastErrorText.innerHTML = error.message;
                        $toastError.classList.remove("hidden");
                    }).finally(()=>{
                        // Sendebutton zurücksetzen
                        (0, $19a061ecc5409c94$export$86fbec116b87613f).setSubmitBtnActive($form);
                    });
                });
            }
            // Kopierfunktion
            const templateClipboard = new (0, (/*@__PURE__*/$parcel$interopDefault($ab98ebfa6dd34a35$exports)))($btnCopy, {
                text: function(trigger) {
                    const $code = document.querySelector("section#html .code > pre > code");
                    let text = $code.textContent.trim();
                    return text;
                }
            });
            templateClipboard.on('success', (event)=>{
                event.clearSelection();
                const msg = event.trigger.dataset.successmsg ?? "Copied!";
                (0, $19a061ecc5409c94$export$86fbec116b87613f).showMsg(msg, "success");
            });
            // Button Panel
            $btnPanel.addEventListener('click', (e)=>{
                // URL aufrufen
                const url = $btnPanel.dataset.href;
                window.open(url, "_self");
            });
            // Button Download
            $btnDownload.addEventListener('click', (e)=>{
                // URL aufrufen
                const url = $btnDownload.dataset.href;
                window.open(url, "_self");
            });
        }
    }
}
// Initialisierung wenn DOM geladen
(0, $19a061ecc5409c94$export$86fbec116b87613f).domready(()=>{
    if (document.querySelector('body').classList.contains('formsetup')) new $dd0d50182b083263$export$6955bcca4cd3539f();
});





class $64a4af6198d90356$export$6955bcca4cd3539f {
    constructor(){
        // Sendeadresse anfordern
        const $sectionConnection = document.querySelector("section#connection");
        if ($sectionConnection) {
            // Elemente
            const $contentForm = $sectionConnection.querySelector("#content-form");
            const $form = $contentForm.querySelector("form");
            const $inputFormname = $form.querySelector("input[name=formname]");
            const $inputEmail = $form.querySelector("input[name=email]");
            const $inputTerms = $form.querySelector("input[name=terms_consent]");
            const $switchTerms = $form.querySelector(".switch");
            const $btnSubmit = $form.querySelector("button[type=submit]");
            const $toastError = $contentForm.querySelector(".toast.error");
            const $toastErrorText = $toastError.querySelector("p");
            const $contentSuccess = $sectionConnection.querySelector("#content-success");
            const $contentSuccessText = $contentSuccess.querySelector(".success_msg");
            const $formAddress = $contentSuccess.querySelector(".address pre");
            const $btnCopy = $contentSuccess.querySelector(".address button");
            const linksReplacePanelUrl = document.querySelectorAll(".replace-panel-url");
            // Status von Sende-Button aktualisieren
            const updateSubmitBtnStatus = function() {
                let isValid = false;
                if ($inputFormname.checkValidity() && $inputEmail.checkValidity()) {
                    if (!$switchTerms || $switchTerms.classList.contains("on")) isValid = true;
                }
                if (!isValid) $btnSubmit.setAttribute("disabled", "");
                else $btnSubmit.removeAttribute("disabled");
            };
            // Sende-Button aktivieren
            $inputFormname.addEventListener('keyup', (event)=>{
                updateSubmitBtnStatus();
            });
            $inputFormname.addEventListener('change', (event)=>{
                updateSubmitBtnStatus();
            });
            $inputEmail.addEventListener('keyup', (event)=>{
                updateSubmitBtnStatus();
            });
            $inputEmail.addEventListener('change', (event)=>{
                updateSubmitBtnStatus();
            });
            if ($switchTerms) $switchTerms.addEventListener('switch-change', (event)=>{
                updateSubmitBtnStatus();
            });
            updateSubmitBtnStatus();
            // Absenden
            $form.addEventListener('submit', (event)=>{
                event.preventDefault();
                const $form = event.currentTarget;
                // Sendebutton deaktivieren
                (0, $19a061ecc5409c94$export$86fbec116b87613f).setSubmitBtnLoading($form);
                // Daten
                const formData = new FormData($form);
                // Fehlermeldung ausblenden
                $toastError.classList.add("hidden");
                // Senden
                new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post((0, $19a061ecc5409c94$export$86fbec116b87613f).getUrl((0, $19a061ecc5409c94$export$86fbec116b87613f).getLang() + '/submit_formrequest'), formData).then((response)=>{
                    // Erfolgsanzeige
                    $contentSuccessText.innerHTML = response.info_msg;
                    $formAddress.textContent = response.form_submission_url;
                    linksReplacePanelUrl.forEach(($link)=>{
                        $link.href = response.form_panel_url;
                    });
                    $contentForm.classList.add("hidden");
                    $contentSuccess.classList.remove("hidden");
                    // Ziel bei Matomo triggern
                    if (response.new_account == true) _paq.push([
                        'trackGoal',
                        2
                    ]);
                }).catch((error)=>{
                    $toastErrorText.innerHTML = error.message;
                    $toastError.classList.remove("hidden");
                }).finally(()=>{
                    // Sendebutton zurücksetzen
                    (0, $19a061ecc5409c94$export$86fbec116b87613f).setSubmitBtnActive($form);
                });
            });
            // Kopierfunktion
            const templateClipboard = new (0, (/*@__PURE__*/$parcel$interopDefault($ab98ebfa6dd34a35$exports)))($btnCopy, {
                target: function(trigger) {
                    return $formAddress;
                }
            });
            templateClipboard.on('success', (event)=>{
                event.clearSelection();
                const msg = event.trigger.dataset.successmsg ?? "Copied!";
                (0, $19a061ecc5409c94$export$86fbec116b87613f).showMsg(msg, "success");
            });
        }
    }
}
// Initialisierung wenn DOM geladen
(0, $19a061ecc5409c94$export$86fbec116b87613f).domready(()=>{
    if (document.querySelector('body').classList.contains('formrequest')) new $64a4af6198d90356$export$6955bcca4cd3539f();
});



class $30102f069bfcf7c6$export$6955bcca4cd3539f {
    constructor(){
        // Features Aufklappbereiche
        const $features = document.querySelectorAll("dl.features > div");
        if ($features.length > 0) $features.forEach(($feature)=>{
            const $btn = $feature.querySelector("button");
            const $dd = $feature.querySelector("dd");
            $btn.addEventListener('click', (event)=>{
                // ist geöffnet
                if ($feature.classList.contains('open')) {
                    $feature.classList.add('closing');
                    $btn.setAttribute('aria-expanded', 'false');
                    $dd.style.maxHeight = $dd.scrollHeight + "px";
                    setTimeout(()=>{
                        $dd.style.maxHeight = "0px";
                    }, 1);
                } else {
                    $feature.classList.add('open');
                    $btn.setAttribute('aria-expanded', 'true');
                    $dd.style.maxHeight = "0px";
                    setTimeout(()=>{
                        $dd.style.maxHeight = $dd.scrollHeight + "px";
                    }, 1);
                }
            });
            $dd.addEventListener('transitionend', (event)=>{
                // wurde geschlossen
                if ($feature.classList.contains('closing')) {
                    $feature.classList.remove('open');
                    $feature.classList.remove('closing');
                    $btn.setAttribute('aria-expanded', 'false');
                } else if ($feature.classList.contains('open')) $dd.style.maxHeight = '';
            });
        });
    }
}
// Initialisierung wenn DOM geladen
(0, $19a061ecc5409c94$export$86fbec116b87613f).domready(()=>{
    if (document.querySelector('body').classList.contains('product')) new $30102f069bfcf7c6$export$6955bcca4cd3539f();
});



class $65c19a5a62a000e7$export$6955bcca4cd3539f {
    constructor(){
        // Das Absenden des Template-Formulars unterdrücken
        const $form = document.querySelector('#formcard form');
        if ($form) $form.addEventListener('submit', (e)=>{
            e.preventDefault();
        });
    }
}
// Initialisierung wenn DOM geladen
(0, $19a061ecc5409c94$export$86fbec116b87613f).domready(()=>{
    if (document.querySelector('body').classList.contains('formtemplate')) new $65c19a5a62a000e7$export$6955bcca4cd3539f();
});


// Scroll-Progress
(0, $19a061ecc5409c94$export$86fbec116b87613f).domready(()=>{
    const $progress = document.querySelector("header .progress");
    if ($progress) {
        const h = document.documentElement, b = document.body, st = 'scrollTop', sh = 'scrollHeight';
        window.addEventListener('scroll', (event)=>{
            const percent = Math.round((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight) * 100);
            $progress.style.width = percent + "%";
        });
    }
});
// TOC Scroll-Indicator
(0, $19a061ecc5409c94$export$86fbec116b87613f).domready(()=>{
    const $toc = document.querySelector('.toc');
    if ($toc) {
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                const id = entry.target.getAttribute('id');
                const $a = $toc.querySelector(`li > a[href="#${id}"]`);
                if ($a) {
                    if (entry.intersectionRatio > 0) {
                        $toc.querySelectorAll('li.active').forEach(($e)=>{
                            $e.classList.remove('active');
                        });
                        $a.parentElement.classList.add('active');
                    } else $a.parentElement.classList.remove('active');
                }
            });
        });
        document.querySelectorAll('main section[id], main section h3[id]').forEach((section)=>{
            observer.observe(section);
        });
    }
});
// Quelltext kopieren
(0, $19a061ecc5409c94$export$86fbec116b87613f).domready(()=>{
    const codeClipboard = new (0, (/*@__PURE__*/$parcel$interopDefault($ab98ebfa6dd34a35$exports)))('.code-with-copy > button', {
        target: function(trigger) {
            return trigger.nextElementSibling.firstChild;
        }
    });
    codeClipboard.on('success', (event)=>{
        event.clearSelection();
        const msg = event.trigger.dataset.successmsg ?? "Copied!";
        (0, $19a061ecc5409c94$export$86fbec116b87613f).showMsg(msg, "success");
    });
});
// Tooltips
(0, $19a061ecc5409c94$export$86fbec116b87613f).domready(()=>{
    (0, $303963c61c829440$export$2e2bcd8739ae039)('button[data-tippy-content].tippy-dark', {
        theme: 'dark',
        trigger: 'mouseenter focus'
    });
    (0, $303963c61c829440$export$2e2bcd8739ae039)('button[data-tippy-content].tippy-light', {
        theme: 'light',
        trigger: 'mouseenter focus'
    });
});
// FAQ Bereiche
(0, $19a061ecc5409c94$export$86fbec116b87613f).domready(()=>{
    // FAQs
    const $faqs = document.querySelectorAll("dl.faq > div");
    if ($faqs.length > 0) $faqs.forEach(($faq)=>{
        const $btn = $faq.querySelector("button");
        const $dd = $faq.querySelector("dd");
        $btn.addEventListener('click', (event)=>{
            // ist geöffnet
            if ($faq.classList.contains('open')) {
                $faq.classList.add('closing');
                $btn.setAttribute('aria-expanded', 'false');
                $dd.style.maxHeight = $dd.scrollHeight + "px";
                setTimeout(()=>{
                    $dd.style.maxHeight = "0px";
                }, 1);
            } else {
                $faq.classList.add('open');
                $btn.setAttribute('aria-expanded', 'true');
                $dd.style.maxHeight = "0px";
                setTimeout(()=>{
                    $dd.style.maxHeight = $dd.scrollHeight + "px";
                }, 1);
            }
        });
        $dd.addEventListener('transitionend', (event)=>{
            // wurde geschlossen
            if ($faq.classList.contains('closing')) {
                $faq.classList.remove('open');
                $faq.classList.remove('closing');
                $btn.setAttribute('aria-expanded', 'false');
            } else if ($faq.classList.contains('open')) $dd.style.maxHeight = '';
        });
    });
});
// Feedback Formular
(0, $19a061ecc5409c94$export$86fbec116b87613f).domready(()=>{
    const form_url = "https://form.taxi/s/cp6j50yp";
    const $feedbackForms = document.querySelectorAll("form.feedback");
    if ($feedbackForms.length > 0) $feedbackForms.forEach(($form)=>{
        const $submitBtn = $form.querySelector("button[type=submit]");
        const $inputs = $form.querySelectorAll("input.inpt, textarea.inpt");
        // Status von Sendebutton aktualisieren
        const updateSubmitBtnStatus = function() {
            var isValid = true;
            $inputs.forEach(($i)=>{
                if ($i.checkValidity() === false) isValid = false;
            });
            if (!isValid) $submitBtn.setAttribute("disabled", "");
            else $submitBtn.removeAttribute("disabled");
        };
        // Sendebutton aktivieren
        $inputs.forEach(($input)=>{
            $input.addEventListener('keyup', (event)=>{
                updateSubmitBtnStatus();
            });
            $input.addEventListener('change', (event)=>{
                updateSubmitBtnStatus();
            });
        });
        updateSubmitBtnStatus();
        // Absenden
        $form.addEventListener('submit', (event)=>{
            event.preventDefault();
            const $form = event.currentTarget;
            const formData = new FormData($form);
            // Sendebutton deaktivieren
            (0, $19a061ecc5409c94$export$86fbec116b87613f).setSubmitBtnLoading($form);
            // Senden
            new (0, $dbe7c8f2fb929f48$export$1e7deca84b429035)().post(form_url, formData).then((response)=>{
                // Erfolgsmeldung anzeigen
                const text = $form.getAttribute('data-msg-success');
                (0, $19a061ecc5409c94$export$86fbec116b87613f).showMsg(text, "success");
                // Formular zurücksetzen
                $form.reset();
            }).catch((error)=>{
                (0, $19a061ecc5409c94$export$86fbec116b87613f).showMsg(error.message ?? "Unknown error", "error", 5000);
            }).finally(()=>{
                // Sendebutton zurücksetzen
                (0, $19a061ecc5409c94$export$86fbec116b87613f).setSubmitBtnActive($form);
            });
        });
    });
});
// Matomo
var $74d4c5e4022a7f3b$var$_paq = window._paq = window._paq || [];
$74d4c5e4022a7f3b$var$_paq.push([
    "setDoNotTrack",
    true
], [
    "disableCookies"
], [
    'trackPageView'
], [
    'enableLinkTracking'
]);
(0, $19a061ecc5409c94$export$86fbec116b87613f).domready(()=>{
    const u = "https://matomo.form.taxi/";
    $74d4c5e4022a7f3b$var$_paq.push([
        'setTrackerUrl',
        u + 'matomo.php'
    ], [
        'setSiteId',
        '1'
    ]);
    const $script = document.createElement('script');
    $script.setAttribute('async', true);
    $script.setAttribute('src', u + 'matomo.js');
    const s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore($script, s);
});

})();
//# sourceMappingURL=website.js.map
